var Le = Object.defineProperty, Oe = Object.defineProperties;
var ze = Object.getOwnPropertyDescriptors;
var ce = Object.getOwnPropertySymbols;
var Pe = Object.prototype.hasOwnProperty, Be = Object.prototype.propertyIsEnumerable;
var se = (n, o, t) => o in n ? Le(n, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[o] = t, b = (n, o) => {
  for (var t in o || (o = {}))
    Pe.call(o, t) && se(n, t, o[t]);
  if (ce)
    for (var t of ce(o))
      Be.call(o, t) && se(n, t, o[t]);
  return n;
}, y = (n, o) => Oe(n, ze(o));
import { jsx as e, jsxs as l, Fragment as qe } from "react/jsx-runtime";
import { useState as z, useRef as He } from "react";
import le from "classnames";
import { nanoid as j } from "nanoid";
const Ve = "_buttonsWrapper_1bbr8_132", Fe = "_aboutContainer_1bbr8_165", De = "_textContainer_1bbr8_179", Xe = "_aboutBtn_1bbr8_208", Re = "_imageContainer_1bbr8_214", Ge = "_image_1bbr8_214", Ue = {
  buttonsWrapper: Ve,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1bbr8_138",
  "spaceAfter--small": "_spaceAfter--small_1bbr8_141",
  "spaceAfter--medium": "_spaceAfter--medium_1bbr8_144",
  aboutContainer: Fe,
  textContainer: De,
  aboutBtn: Xe,
  imageContainer: Re,
  image: Ge
}, d = {
  IMAGE: "IMAGE",
  TEXT: "TEXT",
  GROUP: "GROUP",
  SLIDE_SHOW: "SLIDE_SHOW",
  NAV_MENU: "NAV_MENU",
  FORM: "FORM",
  ICON: "ICON",
  LINK: "LINK",
  SOCIAL_LINKS: "SOCIAL_LINKS",
  LOGO: "LOGO",
  RAW: "RAW",
  MAP: "MAP",
  Embed: "Embed",
  HTMLText: "HTML_TEXT",
  VIDEO: "VIDEO",
  CUSTOM_ELEMENT: "CUSTOM_ELEMENT",
  FLUID_ELEMENT: "FLUID_ELEMENT"
}, Je = {
  destination: "external",
  // 'internal'
  target: "current",
  // 'new'
  text: "READ MORE",
  pageId: "",
  href: "#"
}, Qe = {
  destination: "external",
  // 'internal'
  target: "current",
  // 'new'
  text: "المزيد",
  pageId: "",
  href: "#"
}, Ke = {
  section_title: {
    type: d.TEXT,
    fieldId: 17,
    defaultValue: {
      default: "About Us",
      ar: "من نحن"
    }
  },
  section_image: {
    type: d.IMAGE,
    fieldId: 19,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1483706571191-85c0c76b1947?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=79d169c2bf199ce6912f72c20ec301e4&auto=format&fit=crop&w=500&q=80"
    }
  },
  section_image2: {
    type: d.IMAGE,
    fieldId: 42,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1517502884422-41eaead166d4?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=3d8f17ce21e419f0ef0e90dfcbe19911&auto=format&fit=crop&w=500&q=80"
    }
  },
  section_content: {
    type: d.TEXT,
    fieldId: 18,
    defaultValue: {
      default: "Write about your businesses background, including your history, accomplishments and any awards you may have received. Use this section to show your brand’s personality.",
      ar: "اكتب خلفية عن أعمالك، بما في ذلك تاريخك، وإنجازاتك، وأي جوائز قد حصلت عليها. استخدم هذا القسم لعرض ملامح علامتك التجارية."
    }
  },
  section_action: {
    type: d.LINK,
    fieldId: 43,
    defaultValue: {
      default: Je,
      ar: Qe
    }
  }
}, Ze = ({
  Elements: { Text: n, Image: o, Button: t },
  classes: a,
  section_title: i,
  section_content: r,
  section_image: c,
  section_action: s
}) => /* @__PURE__ */ e("section", { className: `${a.aboutContainer} `, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ l("div", { className: a.textContainer, children: [
    /* @__PURE__ */ e(n, { tag: "h1", value: i }),
    /* @__PURE__ */ e(n, { tag: "p", value: r }),
    /* @__PURE__ */ e(t, { className: a.aboutBtn, value: s })
  ] }) }),
  /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ e("div", { className: a.imageContainer, children: /* @__PURE__ */ e(
    o,
    {
      value: c,
      aspectRatio: "1:1.05",
      className: a.image
    }
  ) }) })
] }) }) }), Ye = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ze,
  meta: Ke,
  styles: Ue
}, Symbol.toStringTag, { value: "Module" })), et = "_buttonsWrapper_s7cws_132", tt = "_aboutContainer_s7cws_165", at = "_textContainer_s7cws_180", nt = {
  buttonsWrapper: et,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_s7cws_138",
  "spaceAfter--small": "_spaceAfter--small_s7cws_141",
  "spaceAfter--medium": "_spaceAfter--medium_s7cws_144",
  aboutContainer: tt,
  textContainer: at
}, ot = {
  destination: "external",
  // 'internal'
  target: "current",
  // 'new'
  text: "READ MORE",
  pageId: "",
  href: "#"
}, it = {
  destination: "external",
  // 'internal'
  target: "current",
  // 'new'
  text: "المزيد",
  pageId: "",
  href: "#"
}, lt = {
  section_title: {
    type: d.TEXT,
    fieldId: 17,
    defaultValue: {
      default: "About Us",
      ar: "من نحن"
    }
  },
  section_image: {
    type: d.IMAGE,
    fieldId: 19,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1483706571191-85c0c76b1947?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=79d169c2bf199ce6912f72c20ec301e4&auto=format&fit=crop&w=500&q=80"
    }
  },
  section_image2: {
    type: d.IMAGE,
    fieldId: 42,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1517502884422-41eaead166d4?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=3d8f17ce21e419f0ef0e90dfcbe19911&auto=format&fit=crop&w=500&q=80"
    }
  },
  section_content: {
    type: d.TEXT,
    fieldId: 18,
    defaultValue: {
      default: "Write about your businesses background, including your history, accomplishments and any awards you may have received. Use this section to show your brand’s personality.",
      ar: "اكتب خلفية عن أعمالك، بما في ذلك تاريخك، وإنجازاتك، وأي جوائز قد حصلت عليها. استخدم هذا القسم لعرض ملامح علامتك التجارية."
    }
  },
  section_action: {
    type: d.LINK,
    fieldId: 43,
    defaultValue: {
      default: ot,
      ar: it
    }
  }
}, rt = ({
  Elements: { Text: n },
  classes: o,
  section_title: t,
  section_content: a
}) => /* @__PURE__ */ e("section", { className: `${o.aboutContainer} `, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e("div", { className: "col-md-8 col-12", children: /* @__PURE__ */ l("div", { className: o.textContainer, children: [
  /* @__PURE__ */ e(n, { tag: "h1", value: t }),
  /* @__PURE__ */ e(n, { tag: "p", value: a })
] }) }) }) }) }), ct = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rt,
  meta: lt,
  styles: nt
}, Symbol.toStringTag, { value: "Module" })), st = "_buttonsWrapper_1r8ue_132", dt = "_aboutContainer_1r8ue_165", _t = "_textContainer_1r8ue_182", mt = "_aboutBtn_1r8ue_203", ut = {
  buttonsWrapper: st,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1r8ue_138",
  "spaceAfter--small": "_spaceAfter--small_1r8ue_141",
  "spaceAfter--medium": "_spaceAfter--medium_1r8ue_144",
  aboutContainer: dt,
  textContainer: _t,
  aboutBtn: mt
}, pt = {
  destination: "external",
  // 'internal'
  target: "current",
  // 'new'
  text: "READ MORE",
  pageId: "",
  href: "#"
}, vt = {
  destination: "external",
  // 'internal'
  target: "current",
  // 'new'
  text: "المزيد",
  pageId: "",
  href: "#"
}, ft = {
  section_title: {
    type: d.TEXT,
    fieldId: 17,
    defaultValue: {
      default: "About Us",
      ar: "من نحن"
    }
  },
  section_image: {
    type: d.IMAGE,
    fieldId: 19,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1483706571191-85c0c76b1947?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=79d169c2bf199ce6912f72c20ec301e4&auto=format&fit=crop&w=500&q=80"
    }
  },
  section_image2: {
    type: d.IMAGE,
    fieldId: 42,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1517502884422-41eaead166d4?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=3d8f17ce21e419f0ef0e90dfcbe19911&auto=format&fit=crop&w=500&q=80"
    }
  },
  section_content: {
    type: d.TEXT,
    fieldId: 18,
    defaultValue: {
      default: "Write about your businesses background, including your history, accomplishments and any awards you may have received. Use this section to show your brand’s personality.",
      ar: "اكتب خلفية عن أعمالك، بما في ذلك تاريخك، وإنجازاتك، وأي جوائز قد حصلت عليها. استخدم هذا القسم لعرض ملامح علامتك التجارية."
    }
  },
  section_action: {
    type: d.LINK,
    fieldId: 43,
    defaultValue: {
      default: pt,
      ar: vt
    }
  }
}, gt = ({
  Elements: { Text: n, Button: o },
  classes: t,
  section_title: a,
  section_content: i,
  section_action: r
}) => /* @__PURE__ */ e("section", { className: `${t.aboutContainer} `, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e("div", { className: "col-md-8 col-12", children: /* @__PURE__ */ l("div", { className: t.textContainer, children: [
  /* @__PURE__ */ e(n, { tag: "h1", value: a }),
  /* @__PURE__ */ e(n, { tag: "p", value: i }),
  /* @__PURE__ */ e(o, { className: t.aboutBtn, value: r })
] }) }) }) }) }), ht = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gt,
  meta: ft,
  styles: ut
}, Symbol.toStringTag, { value: "Module" })), bt = "_buttonsWrapper_1jx6v_132", yt = "_sectionContainer_1jx6v_165", $t = "_contactFields_1jx6v_179", Nt = "_fieldsHeader_1jx6v_183", Ct = "_textField_1jx6v_196", xt = "_textareaField_1jx6v_197", It = "_submitButton_1jx6v_203", At = "_mapContainer_1jx6v_219", St = "_map_1jx6v_219", kt = "_actionContainer_1jx6v_226", jt = {
  buttonsWrapper: bt,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1jx6v_138",
  "spaceAfter--small": "_spaceAfter--small_1jx6v_141",
  "spaceAfter--medium": "_spaceAfter--medium_1jx6v_144",
  sectionContainer: yt,
  contactFields: $t,
  fieldsHeader: Nt,
  textField: Ct,
  textareaField: xt,
  submitButton: It,
  mapContainer: At,
  map: St,
  actionContainer: kt
}, wt = {
  action: {
    label: "Send"
  },
  fields: [
    {
      type: "Text",
      name: "name",
      label: "Name"
    },
    {
      type: "Text",
      name: "email",
      label: "Email"
    },
    {
      type: "Text",
      name: "phone",
      label: "Phone"
    },
    {
      type: "Text",
      name: "address",
      label: "address"
    },
    {
      type: "MultiLineText",
      name: "message",
      label: "message"
    }
  ],
  success_message: "Thank you for reaching out, we'll get back to you as soon as possible"
}, Mt = {
  action: {
    label: "إرسال"
  },
  fields: [
    {
      type: "Text",
      name: "name",
      label: "الاسم"
    },
    {
      type: "Text",
      name: "email",
      label: "البريد الإلكتروني"
    },
    {
      type: "Text",
      name: "phone",
      label: "الهاتف"
    },
    {
      type: "Text",
      name: "address",
      label: "العنوان"
    },
    {
      type: "MultiLineText",
      name: "message",
      label: "الرسالة"
    }
  ],
  success_message: "شكرًا لك على التواصل معنا ، وسنوافيك بالرد في أسرع وقت ممكن"
}, Wt = {
  section_title: {
    type: d.TEXT,
    fieldId: 54,
    defaultValue: {
      default: "Contact Us",
      ar: "تواصل معنا"
    }
  },
  section_description: {
    type: d.TEXT,
    fieldId: 55,
    defaultValue: {
      default: "Our team is always available to assist you.",
      ar: "نحن هنا لللإجابة عن استفساراتك و تعليقاتك"
    }
  },
  form: {
    type: d.FORM,
    fieldId: 32,
    defaultValue: {
      default: wt,
      ar: Mt
    }
  },
  section_image: {
    type: d.IMAGE,
    fieldId: 56,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1528260249572-a56fc30084ef?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=0189bb96e70b69a83c49f9e667ff1366&auto=format&fit=crop&w=375&q=80"
    }
  },
  map: {
    type: d.MAP,
    fieldId: 132,
    defaultValue: {
      default: {
        zoom: 15,
        marker: {
          location: {
            lat: 25.814004,
            lng: -80.126808
          }
        },
        mapType: "roadmap"
      }
    }
  },
  phone: {
    type: d.TEXT,
    fieldId: 57,
    defaultValue: {
      default: "1(800) - 374 - 990"
    }
  },
  email: {
    type: d.TEXT,
    fieldId: 58,
    defaultValue: {
      default: "info@business.com"
    }
  },
  address: {
    type: d.TEXT,
    fieldId: 59,
    defaultValue: {
      default: "301 W. 41st Street, Suite 501 Miami Beach, FL 33140",
      ar: "301 غرب شارع رقم 41 - وحدة 501 شاطئ ميامي - فلوريدا - الولايات المتحدة"
    }
  },
  email_icon: {
    type: d.ICON,
    fieldId: 75,
    defaultValue: {
      default: "envelope"
    }
  },
  phone_icon: {
    type: d.ICON,
    fieldId: 73,
    defaultValue: {
      default: "phone"
    }
  },
  address_icon: {
    type: d.ICON,
    fieldId: 77,
    defaultValue: {
      default: "map-marker"
    }
  },
  email_label: {
    type: d.TEXT,
    fieldId: 74,
    defaultValue: {
      default: "Email",
      ar: "البريد اللإلكتروني"
    }
  },
  phone_label: {
    type: d.TEXT,
    fieldId: 72,
    defaultValue: {
      default: "Phone",
      ar: "التليفون"
    }
  },
  address_label: {
    type: d.TEXT,
    fieldId: 76,
    defaultValue: {
      default: "Address",
      ar: "العنوان"
    }
  },
  social_label: {
    type: d.TEXT,
    fieldId: 98,
    defaultValue: {
      default: "Social Media",
      ar: "التواصل الاجتماعي"
    }
  },
  social_links: {
    type: d.SOCIAL_LINKS,
    fieldId: 78,
    defaultValue: {
      default: {
        facebook: "#",
        twitter: "#",
        linkedin: "#",
        instagram: "#",
        snapchat: "#"
      }
    }
  }
}, Et = ({
  Elements: { Form: n, Text: o, Map: t },
  classes: a,
  section_title: i,
  section_description: r,
  form: c,
  map: s
}) => /* @__PURE__ */ e("section", { className: a.sectionContainer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-lg-6", children: /* @__PURE__ */ l("div", { className: a.contactFields, children: [
    /* @__PURE__ */ l("div", { className: a.fieldsHeader, children: [
      /* @__PURE__ */ e(o, { tag: "h1", value: i }),
      /* @__PURE__ */ e(o, { tag: "p", value: r })
    ] }),
    /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(
      n,
      {
        fieldContainerClass: "form-group",
        textareaClass: `form-control ${a.textareaField}`,
        textClass: `form-control ${a.textField}`,
        buttonClass: a.submitButton,
        actionContainerClass: a.actionContainer,
        value: c
      }
    ) })
  ] }) }),
  /* @__PURE__ */ e("div", { className: "col-lg-6", children: /* @__PURE__ */ e("div", { className: a.mapContainer, children: /* @__PURE__ */ e(t, { className: a.map, value: s }) }) })
] }) }) }), Tt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Et,
  meta: Wt,
  styles: jt
}, Symbol.toStringTag, { value: "Module" })), w = {
  UNIVERSAL: "UNIVERSAL",
  SECTION_DATA: "SECTION_DATA"
}, Lt = {
  pages: {
    type: d.NAV_MENU,
    source: w.UNIVERSAL,
    defaultValue: []
  },
  menuItems: {
    type: d.NAV_MENU,
    source: w.UNIVERSAL
  },
  logo: {
    type: d.LOGO,
    fieldId: 91,
    defaultValue: {
      default: {
        url: "https://assets.wuiltsite.com/defaults/google-logo.png",
        size: "medium"
      }
    }
  },
  text: {
    type: d.TEXT,
    fieldId: 70,
    defaultValue: {
      default: "text",
      ar: "كلام"
    }
  },
  copyright_text: {
    type: d.TEXT,
    fieldId: 69,
    defaultValue: {
      default: "© 2018 Creation - One & Multi Page Multipurpose Theme ",
      ar: "© جميع الحقوق محفوظة"
    }
  },
  title_text: {
    type: d.TEXT,
    fieldId: 107,
    defaultValue: {
      default: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
      ar: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium."
    }
  },
  social_links: {
    type: d.SOCIAL_LINKS,
    fieldId: 106,
    defaultValue: {
      default: {
        facebook: "https://facebook.com/",
        twitter: "#",
        instagram: "#",
        snapchat: "#"
      }
    }
  }
}, Ot = "_footer_1lyrn_1", zt = "_footerContent_1lyrn_6", Pt = "_footerLinks_1lyrn_12", Bt = "_navLink_1lyrn_20", qt = "_footerCopyright_1lyrn_26", Ht = "_socialLinks_1lyrn_31", Vt = "_social_1lyrn_31", Ft = "_socialItem_1lyrn_39", Dt = {
  footer: Ot,
  footerContent: zt,
  footerLinks: Pt,
  navLink: Bt,
  footerCopyright: qt,
  socialLinks: Ht,
  social: Vt,
  socialItem: Ft
}, Xt = ({
  Elements: { NavMenu: n, Text: o, Logo: t, SocialLinks: a },
  classes: i,
  pages: r,
  social_links: c,
  copyright_text: s,
  logo: _,
  menuItems: m
}) => /* @__PURE__ */ e("footer", { className: i.footer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: i.footerContent, children: [
  /* @__PURE__ */ e("div", { className: i.footerLogo, children: /* @__PURE__ */ e(t, { pages: r, value: _ }) }),
  /* @__PURE__ */ e(
    n,
    {
      onlyTopLevel: !0,
      pages: r,
      className: i.footerLinks,
      itemClass: i.navItem,
      itemActive: i.active,
      linkClass: i.navLink,
      menuItems: m
    }
  ),
  /* @__PURE__ */ e("div", { className: i.socialLinks, children: /* @__PURE__ */ e(
    a,
    {
      value: c,
      listClass: i.social,
      itemClass: i.socialItem
    }
  ) }),
  /* @__PURE__ */ e("div", { className: i.footerCopyright, children: /* @__PURE__ */ e(o, { tag: "p", value: s }) })
] }) }) }), Rt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xt,
  meta: Lt,
  styles: Dt
}, Symbol.toStringTag, { value: "Module" })), Gt = "_buttonsWrapper_1m8ql_132", Ut = "_sectionContainer_1m8ql_165", Jt = "_sectionTitle_1m8ql_179", Qt = "_item_1m8ql_188", Kt = "_itemImage_1m8ql_192", Zt = {
  buttonsWrapper: Gt,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1m8ql_138",
  "spaceAfter--small": "_spaceAfter--small_1m8ql_141",
  "spaceAfter--medium": "_spaceAfter--medium_1m8ql_144",
  sectionContainer: Ut,
  sectionTitle: Jt,
  item: Qt,
  itemImage: Kt
}, Yt = {
  title: {
    type: d.TEXT,
    fieldId: 92,
    defaultValue: {
      default: "Our Work",
      ar: "اعمالنا"
    }
  },
  description: {
    type: d.TEXT,
    fieldId: 93,
    defaultValue: {
      default: "Browse through our collection of stunning images",
      ar: "أمثلة حيَّة رائعة لأعمالنا"
    }
  },
  primary_button: {
    type: d.LINK,
    fieldId: 215,
    defaultValue: {
      default: {
        destination: "external",
        // 'internal'
        target: "current",
        // 'new'
        text: "Start Now",
        pageId: "",
        href: "#"
      },
      ar: {
        destination: "external",
        // 'internal'
        target: "current",
        // 'new'
        text: "ابدا الان",
        pageId: "",
        href: "#"
      }
    }
  },
  images: {
    type: d.GROUP,
    defaultValue: [
      {
        image: {
          default: "https://images.unsplash.com/photo-1580118586709-50d0a0eea2cb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1268&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1580152040915-ad6ceeaeb8c1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1580142541272-4f6b7e815563?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2851&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1558981822-0c0c5b070026?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1268&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1580197370215-38fdb17dfe8f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1590&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1580124173799-934609852db8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80"
        }
      }
    ],
    values: {
      image: {
        type: d.TEXT,
        fieldId: 94
      }
    }
  }
}, ea = ({ Elements: { Image: n }, classes: o, image: t }) => /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ e("div", { className: o.item, children: /* @__PURE__ */ e(n, { className: o.itemImage, aspectRatio: "16:9", value: t }) }) }), ta = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  title: a,
  images: i
}) => /* @__PURE__ */ e("section", { className: t.sectionContainer, children: /* @__PURE__ */ l("div", { className: "container", children: [
  /* @__PURE__ */ e("div", { className: t.sectionTitle, children: /* @__PURE__ */ e(o, { tag: "h1", value: a }) }),
  /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: ea,
      value: i
    }
  ) })
] }) }), aa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ta,
  meta: Yt,
  styles: Zt
}, Symbol.toStringTag, { value: "Module" })), na = "_buttonsWrapper_nd6rq_132", oa = "_sectionContainer_nd6rq_165", ia = "_sectionTitle_nd6rq_179", la = "_item_nd6rq_188", ra = "_itemImage_nd6rq_191", ca = {
  buttonsWrapper: na,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_nd6rq_138",
  "spaceAfter--small": "_spaceAfter--small_nd6rq_141",
  "spaceAfter--medium": "_spaceAfter--medium_nd6rq_144",
  sectionContainer: oa,
  sectionTitle: ia,
  item: la,
  itemImage: ra
}, sa = {
  title: {
    type: d.TEXT,
    fieldId: 92,
    defaultValue: {
      default: "Our Work",
      ar: "اعمالنا"
    }
  },
  description: {
    type: d.TEXT,
    fieldId: 93,
    defaultValue: {
      default: "Browse through our collection of stunning images",
      ar: "أمثلة حيَّة رائعة لأعمالنا"
    }
  },
  primary_button: {
    type: d.LINK,
    fieldId: 215,
    defaultValue: {
      default: {
        destination: "external",
        // 'internal'
        target: "current",
        // 'new'
        text: "Start Now",
        pageId: "",
        href: "#"
      },
      ar: {
        destination: "external",
        // 'internal'
        target: "current",
        // 'new'
        text: "ابدا الان",
        pageId: "",
        href: "#"
      }
    }
  },
  images: {
    type: d.GROUP,
    defaultValue: [
      {
        image: {
          default: "https://images.unsplash.com/photo-1580118586709-50d0a0eea2cb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1268&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1580152040915-ad6ceeaeb8c1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1580142541272-4f6b7e815563?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2851&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1558981822-0c0c5b070026?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1268&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1580197370215-38fdb17dfe8f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1590&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1580124173799-934609852db8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80"
        }
      }
    ],
    values: {
      image: {
        type: d.TEXT,
        fieldId: 94
      }
    }
  }
}, da = ({ Elements: { Image: n }, classes: o, image: t }) => /* @__PURE__ */ e("div", { className: "col-lg-4 col-md-6", children: /* @__PURE__ */ e("div", { className: o.item, children: /* @__PURE__ */ e(n, { className: o.itemImage, aspectRatio: "16:9", value: t }) }) }), _a = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  title: a,
  images: i
}) => /* @__PURE__ */ e("section", { className: t.sectionContainer, children: /* @__PURE__ */ l("div", { className: "container", children: [
  /* @__PURE__ */ e("div", { className: t.sectionTitle, children: /* @__PURE__ */ e(o, { tag: "h1", value: a }) }),
  /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: da,
      value: i
    }
  ) })
] }) }), ma = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _a,
  meta: sa,
  styles: ca
}, Symbol.toStringTag, { value: "Module" })), ua = {
  title: {
    type: d.TEXT,
    fieldId: 40,
    defaultValue: {
      default: "Page Title",
      ar: "عنوان الصفحة"
    }
  },
  image: {
    type: d.IMAGE,
    fieldId: 41,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1536323760109-ca8c07450053?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=f2822ffa43aba0e2ebb6a1387d49b7c9&auto=format&fit=crop&w=3202&q=80"
    }
  }
}, pa = "_buttonsWrapper_17jhq_132", va = "_header_17jhq_165", fa = "_headerContent_17jhq_168", ga = "_imageContainer_17jhq_192", ha = "_image_17jhq_192", ba = {
  buttonsWrapper: pa,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_17jhq_138",
  "spaceAfter--small": "_spaceAfter--small_17jhq_141",
  "spaceAfter--medium": "_spaceAfter--medium_17jhq_144",
  header: va,
  headerContent: fa,
  imageContainer: ga,
  image: ha
}, ya = ({ Elements: { Text: n, Image: o }, classes: t, title: a, image: i }) => /* @__PURE__ */ e("div", { className: t.header, children: /* @__PURE__ */ l("div", { className: t.headerContent, children: [
  /* @__PURE__ */ e("div", { className: "container text-center", children: /* @__PURE__ */ e(n, { tag: "h1", value: a }) }),
  /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: t.imageContainer, children: /* @__PURE__ */ e(o, { aspectRatio: "2:1", value: i, className: t.image }) }) })
] }) }), $a = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ya,
  meta: ua,
  styles: ba
}, Symbol.toStringTag, { value: "Module" })), Na = "_buttonsWrapper_ex59j_132", Ca = "_heroLogo_ex59j_166", xa = "_burger_ex59j_171", Ia = "_navMenu_ex59j_182", Aa = "_navLink_ex59j_182", Sa = {
  buttonsWrapper: Na,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_ex59j_138",
  "spaceAfter--small": "_spaceAfter--small_ex59j_141",
  "spaceAfter--medium": "_spaceAfter--medium_ex59j_144",
  heroLogo: Ca,
  burger: xa,
  navMenu: Ia,
  navLink: Aa
}, ka = {
  logo: {
    type: d.LOGO,
    fieldId: 86,
    defaultValue: {
      default: {
        url: "https://assets.wuiltsite.com/defaults/evernote-logo.png",
        size: "medium"
      }
    }
  },
  languages: {
    source: w.UNIVERSAL,
    noProcessing: !0
  },
  pages: {
    type: d.NAV_MENU,
    source: w.UNIVERSAL
  },
  menuItems: {
    type: d.NAV_MENU,
    source: w.UNIVERSAL
  },
  phone: {
    type: d.LINK,
    fieldId: 82,
    defaultValue: {
      default: {
        destination: "external",
        target: "current",
        text: "01000200300",
        pageId: "",
        href: "tel:01000200300"
      }
    }
  },
  email: {
    type: d.LINK,
    fieldId: 83,
    defaultValue: {
      default: {
        destination: "external",
        target: "current",
        text: "info@company.com",
        pageId: "",
        href: "mailto:info@company.com"
      }
    }
  },
  email_icon: {
    type: d.ICON,
    fieldId: 88,
    defaultValue: {
      default: "envelope"
    }
  },
  phone_icon: {
    type: d.ICON,
    fieldId: 87,
    defaultValue: {
      default: "phone-square"
    }
  },
  socialLinks: {
    type: d.SOCIAL_LINKS,
    fieldId: 84,
    defaultValue: {
      default: {
        facebook: "#",
        twitter: "#",
        linkedin: "#"
      }
    }
  }
}, ja = ({
  Elements: { DesktopMenu: n, MobileMenu: o, LanguageSwitcher: t, Logo: a },
  classes: i,
  languages: r,
  pages: c,
  logo: s,
  menuItems: _,
  globalNavbarSettings: m
}) => {
  const { backgroundColor: p, navLinksColor: u } = m;
  return /* @__PURE__ */ l(
    "header",
    {
      style: {
        backgroundColor: p,
        padding: "20px 0px"
      },
      children: [
        /* @__PURE__ */ l("div", { className: "row mx-0 px-2 pt-3 justify-content-between justify-content-lg-center", children: [
          /* @__PURE__ */ e("div", { className: "col-auto d-flex d-lg-none pl-0", children: /* @__PURE__ */ e(
            o,
            {
              className: i.mobileMenu,
              logo: s,
              pages: c,
              burgerClass: i.burger,
              languages: r,
              menuItems: _
            }
          ) }),
          /* @__PURE__ */ e("div", { className: `col-auto d-flex ${i.logoContainer} `, children: /* @__PURE__ */ e(a, { pages: c, value: s, className: i.heroLogo }) }),
          /* @__PURE__ */ e("div", { className: "col-auto d-none d-lg-flex justify-content-center align-items-center order-3 ", children: /* @__PURE__ */ e(t, { languages: r, showDivider: !1 }) })
        ] }),
        /* @__PURE__ */ e("div", { className: "row mx-0 align-items-center justify-content-center ", children: /* @__PURE__ */ e("div", { className: "col-auto justify-content-center d-none d-lg-flex flex", children: /* @__PURE__ */ e(
          n,
          {
            className: `d-none d-lg-flex ${i.navMenu}`,
            linkClass: i.navLink,
            pages: c,
            menuItems: _,
            navLinksColor: u
          }
        ) }) })
      ]
    }
  );
}, wa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ja,
  meta: ka,
  styles: Sa
}, Symbol.toStringTag, { value: "Module" })), Ma = "_buttonsWrapper_hd3fb_132", Wa = "_hero_hd3fb_165", Ea = "_heroContent_hd3fb_168", Ta = "_heroText_hd3fb_183", La = "_buttonsContainer_hd3fb_209", Oa = "_primaryButton_hd3fb_221", za = "_secondaryButton_hd3fb_226", Pa = "_imageContainer_hd3fb_237", Ba = "_image_hd3fb_237", qa = "_social_hd3fb_262", Ha = "_socialItem_hd3fb_267", Va = {
  buttonsWrapper: Ma,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_hd3fb_138",
  "spaceAfter--small": "_spaceAfter--small_hd3fb_141",
  "spaceAfter--medium": "_spaceAfter--medium_hd3fb_144",
  hero: Wa,
  heroContent: Ea,
  heroText: Ta,
  buttonsContainer: La,
  primaryButton: Oa,
  secondaryButton: za,
  imageContainer: Pa,
  image: Ba,
  social: qa,
  socialItem: Ha
}, Fa = {
  image: {
    type: d.IMAGE,
    fieldId: 96,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1541362254971-29e9b6af8d05?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=f58b9886fd9017e1ed8d255b6ace511c&auto=format&fit=crop&w=750&q=80"
    }
  },
  socialLinks: {
    type: d.SOCIAL_LINKS,
    fieldId: 84,
    defaultValue: {
      default: {
        facebook: "#",
        twitter: "#",
        linkedin: "#"
      }
    }
  },
  title: {
    type: d.TEXT,
    fieldId: 24,
    defaultValue: {
      default: "Creativity is to think deeper and more Efficiently",
      ar: "الإبداع هو التفكير أعمق و بأكثر كفاءة"
    }
  },
  subtitle: {
    type: d.TEXT,
    fieldId: 25,
    defaultValue: {
      default: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
      ar: "عائد استثمار مرئي ونتائج مستمرة"
    }
  },
  primary_button: {
    type: d.LINK,
    fieldId: 26,
    defaultValue: {
      default: {
        destination: "external",
        // 'internal'
        target: "current",
        // 'new'
        text: "Start Now",
        pageId: "",
        href: "#"
      },
      ar: {
        destination: "external",
        // 'internal'
        target: "current",
        // 'new'
        text: "ابدا الان",
        pageId: "",
        href: "#"
      }
    }
  },
  secondary_button: {
    type: d.LINK,
    fieldId: 27,
    defaultValue: {
      default: {
        destination: "external",
        target: "current",
        text: "Get In Touch",
        pageId: "",
        href: "#"
      },
      ar: {
        destination: "external",
        target: "current",
        text: "تواصل معنا",
        pageId: "",
        href: "#"
      }
    }
  },
  cta_box_title: {
    type: d.TEXT,
    fieldId: 99,
    defaultValue: {
      default: "Learn about our services and join our community today",
      ar: "تعرف على خداماتنا وانضم إلى مجتمعنا اليوم"
    }
  },
  cta_box_subtitle: {
    type: d.TEXT,
    fieldId: 100,
    defaultValue: {
      default: "Feel free to reach out to us for a free consultation",
      ar: "لا تتردد أبدًا في التواصل معنا بشأن أيّ استشارة مجانية"
    }
  },
  foot_note: {
    type: d.TEXT,
    fieldId: 101,
    defaultValue: {
      default: "Learn about our services and join our community today",
      ar: "تقدّرنا بعض العلامات التجارية الكبرى في العالم بخدماتها"
    }
  },
  slideshow: {
    type: d.GROUP,
    values: {
      image: {
        type: d.IMAGE,
        fieldId: 16
      }
    },
    defaultValue: [
      {
        image: {
          default: "https://images.unsplash.com/photo-1516728043722-b394cb2f689e?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=c82882f6f384a30402cc75029d9e7b11&auto=format&fit=crop&w=550&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1494074734099-c4ec0c45687a?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=f18b2bf25abbaeddbe5ea1f9dae1ff85&auto=format&fit=crop&w=3150&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1516728043722-b394cb2f689e?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=c82882f6f384a30402cc75029d9e7b11&auto=format&fit=crop&w=550&q=80"
        }
      }
    ]
  }
}, Da = ({
  classes: n,
  Elements: { Button: o, Text: t, Image: a },
  title: i,
  subtitle: r,
  primary_button: c,
  secondary_button: s,
  image: _
}) => /* @__PURE__ */ e("div", { className: n.hero, children: /* @__PURE__ */ e("div", { className: n.heroContent, children: /* @__PURE__ */ l("div", { className: "container", children: [
  /* @__PURE__ */ l("div", { className: n.heroText, children: [
    /* @__PURE__ */ e(t, { tag: "p", value: r }),
    /* @__PURE__ */ e(t, { tag: "h1", value: i }),
    /* @__PURE__ */ l("div", { className: n.buttonsContainer, children: [
      /* @__PURE__ */ e("div", { className: n.primaryButton, children: /* @__PURE__ */ e(o, { value: c }) }),
      /* @__PURE__ */ e("div", { className: n.secondaryButton, children: /* @__PURE__ */ e(o, { value: s }) })
    ] })
  ] }),
  /* @__PURE__ */ e("div", { className: n.imageContainer, children: /* @__PURE__ */ e(a, { value: _, className: n.image }) })
] }) }) }), Xa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Da,
  meta: Fa,
  styles: Va
}, Symbol.toStringTag, { value: "Module" })), Ra = "_buttonsWrapper_1nkba_132", Ga = "_sectionContainer_1nkba_165", Ua = "_sectionTitle_1nkba_169", Ja = "_imageContainer_1nkba_178", Qa = {
  buttonsWrapper: Ra,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1nkba_138",
  "spaceAfter--small": "_spaceAfter--small_1nkba_141",
  "spaceAfter--medium": "_spaceAfter--medium_1nkba_144",
  sectionContainer: Ga,
  sectionTitle: Ua,
  imageContainer: Ja
}, Ka = {
  section_title: {
    type: d.TEXT,
    fieldId: 65,
    defaultValue: {
      default: "Our Clients",
      ar: "عملائنا"
    }
  },
  section_description: {
    type: d.TEXT,
    fieldId: 66,
    defaultValue: {
      default: "Some of the world’s biggest brands trust us with their services",
      ar: "تقدّرنا بعض العلامات التجارية الكبرى في العالم بخدماتها"
    }
  },
  section_image: {
    type: d.IMAGE,
    fieldId: 68,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1537336097086-38557cfb415e?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=86a0b376544ccfe2ce05f559988ab6a5&auto=format&fit=crop&w=1525&q=80"
    }
  },
  logos: {
    type: d.GROUP,
    values: {
      image: d.IMAGE,
      fieldId: 67
    },
    defaultValue: [
      {
        image: {
          default: "https://assets.wuiltsite.com/defaults/google-logo.png"
        }
      },
      {
        image: {
          default: "https://assets.wuiltsite.com/defaults/facebook-logo.png"
        }
      },
      {
        image: {
          default: "https://assets.wuiltsite.com/defaults/evernote-logo.png"
        }
      },
      {
        image: {
          default: "https://assets.wuiltsite.com/defaults/shutterstock-logo.png"
        }
      },
      {
        image: {
          default: "https://assets.wuiltsite.com/defaults/google-logo.png"
        }
      },
      {
        image: {
          default: "https://assets.wuiltsite.com/defaults/facebook-logo.png"
        }
      },
      {
        image: {
          default: "https://assets.wuiltsite.com/defaults/evernote-logo.png"
        }
      },
      {
        image: {
          default: "https://assets.wuiltsite.com/defaults/shutterstock-logo.png"
        }
      }
    ]
  }
}, Za = ({ Elements: { Image: n }, classes: o, image: t }) => /* @__PURE__ */ e("div", { className: "col-md-4  col-12", children: /* @__PURE__ */ e("div", { className: o.imageContainer, children: /* @__PURE__ */ e(n, { className: o.logoImage, value: t, small: !0 }) }) }), Ya = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  logos: i
}) => /* @__PURE__ */ e("div", { className: t.sectionContainer, children: /* @__PURE__ */ l("div", { className: "container text-md-left text-center", children: [
  /* @__PURE__ */ e("div", { className: t.sectionTitle, children: /* @__PURE__ */ e(o, { tag: "h1", value: a }) }),
  /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(n, { classes: t, Component: Za, value: i }) })
] }) }), en = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ya,
  meta: Ka,
  styles: Qa
}, Symbol.toStringTag, { value: "Module" })), tn = "_buttonsWrapper_o5zv5_132", an = "_services_o5zv5_165", nn = "_item_o5zv5_187", on = "_itemImage_o5zv5_190", ln = "_image_o5zv5_190", rn = "_itemText_o5zv5_193", cn = "_buttons_o5zv5_132", sn = "_itemBtn1_o5zv5_216", dn = "_itemBtn2_o5zv5_217", _n = {
  buttonsWrapper: tn,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_o5zv5_138",
  "spaceAfter--small": "_spaceAfter--small_o5zv5_141",
  "spaceAfter--medium": "_spaceAfter--medium_o5zv5_144",
  services: an,
  item: nn,
  itemImage: on,
  image: ln,
  itemText: rn,
  buttons: cn,
  itemBtn1: sn,
  itemBtn2: dn
}, H = {
  destination: "external",
  // 'internal'
  target: "current",
  // 'new'
  text: "READ MORE",
  pageId: "",
  href: "#"
}, V = {
  destination: "external",
  target: "current",
  text: "المزيد",
  pageId: "",
  href: "#"
}, mn = {
  section_title: {
    type: d.TEXT,
    fieldId: 8,
    defaultValue: {
      default: "Our Services",
      ar: "خدماتُنا"
    }
  },
  section_short_description: {
    type: d.TEXT,
    fieldId: 9,
    defaultValue: {
      default: "We offer top-notch services based on countless years of experience.",
      ar: "نمتلك خبرة طويلة في مجالنا، ولذلك نستطيع تقديم خدمات متميّزة لك."
    }
  },
  section_image: {
    type: d.IMAGE,
    fieldId: 97,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1537646692914-61d73c4d6bad?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=b6e4b4359e874b7537c33c6ec1fe1a4d&auto=format&fit=crop&w=1500&q=80"
    }
  },
  services: {
    type: d.GROUP,
    values: {
      service_icon: { type: d.ICON, fieldId: 45 },
      service_image: { type: d.IMAGE, fieldId: 20 },
      service_title: { type: d.TEXT, fieldId: 10 },
      service_short_description: {
        type: d.TEXT,
        fieldId: 11
      },
      service_details_link: {
        type: d.LINK,
        fieldId: 28
      },
      service_details_link_2: {
        type: d.LINK,
        fieldId: 259
      }
    },
    defaultValue: [
      {
        service_title: {
          default: "SEM Marketing",
          ar: "التسويق عبر محركات البحث"
        },
        service_image: {
          default: "https://images.unsplash.com/photo-1516728043722-b394cb2f689e?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=c82882f6f384a30402cc75029d9e7b11&auto=format&fit=crop&w=550&q=80"
        },
        service_icon: {
          default: "rocket"
        },
        service_short_description: {
          default: "We develop comprehensive PPC and SEO strategies. We’ll provide your AdWords account with continuous PPC support that is monitored to adapt to the evolving industry."
        },
        service_details_link: {
          default: H,
          ar: V
        },
        service_details_link_2: {
          default: H,
          ar: V
        }
      },
      {
        service_title: {
          default: "Content Marketing",
          ar: "تسويق المحتوى"
        },
        service_icon: {
          default: "glass"
        },
        service_image: {
          default: "https://images.unsplash.com/photo-1496902526517-c0f2cb8fdb6a?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=8a8623f526569e949b73c4c7360d4532&auto=format&fit=crop&w=550&q=80"
        },
        service_short_description: {
          default: "Our writers are wordsmiths trained in creating quality content for all aspects of your brand. We’ll take care of your website copy, SEO articles, blog posts, whitepapers and more.",
          ar: ""
        },
        service_details_link: {
          default: H,
          ar: V
        },
        service_details_link_2: {
          default: H,
          ar: V
        }
      },
      {
        service_title: {
          default: "Social Media Marketing",
          ar: "التسويق عبر وسائل التواصل الاجتماعي"
        },
        service_image: {
          default: "https://images.unsplash.com/photo-1519120126473-8be7aedcd6c6?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=a55332dfc236b13f118ef77a36b4052f&auto=format&fit=crop&w=550&q=80"
        },
        service_icon: {
          default: "tv"
        },
        service_short_description: {
          default: "Our team works to expand your social media presence by creating compelling content designed for you. boost your social media audience and develop a strong community around your brand."
        },
        service_details_link: {
          default: H,
          ar: V
        },
        service_details_link_2: {
          default: H,
          ar: V
        }
      }
    ]
  }
}, un = ({
  Elements: { Text: n, Image: o, Button: t },
  classes: a,
  service_image: i,
  service_title: r,
  service_short_description: c,
  service_details_link: s,
  service_details_link_2: _
}) => /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ l("div", { className: a.item, children: [
  /* @__PURE__ */ e("div", { className: a.itemImage, children: /* @__PURE__ */ e(
    o,
    {
      value: i,
      aspectRatio: "2:1.5",
      className: a.image
    }
  ) }),
  /* @__PURE__ */ l("div", { className: a.itemText, children: [
    /* @__PURE__ */ e(n, { tag: "h4", value: r }),
    /* @__PURE__ */ e(n, { tag: "p", value: c }),
    /* @__PURE__ */ l("div", { className: a.buttons, children: [
      /* @__PURE__ */ e(t, { className: a.itemBtn1, value: s }),
      /* @__PURE__ */ e(t, { className: a.itemBtn2, value: _ })
    ] })
  ] })
] }) }), pn = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  services: i
}) => /* @__PURE__ */ e("div", { className: t.services, children: /* @__PURE__ */ l("div", { className: "container", children: [
  /* @__PURE__ */ e("div", { className: t.servicesTitle, children: /* @__PURE__ */ e(o, { tag: "h1", value: a }) }),
  /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: un,
      value: i
    }
  ) })
] }) }), vn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pn,
  meta: mn,
  styles: _n
}, Symbol.toStringTag, { value: "Module" })), de = /* @__PURE__ */ Object.assign({ "./about-01/index.jsx": Ye, "./about-02/index.jsx": ct, "./about-03/index.jsx": ht, "./contact-01/index.jsx": Tt, "./footer-01/index.jsx": Rt, "./gallery-01/index.jsx": aa, "./gallery-02/index.jsx": ma, "./header-01/index.jsx": $a, "./header-home-01/index.jsx": wa, "./hero-01/index.jsx": Xa, "./logos-01/index.jsx": en, "./services-01/index.jsx": vn }), fn = Object.keys(de).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: de[o] }),
  {}
), gn = "_buttonsWrapper_1ozb8_132", hn = "_sectionContainer_1ozb8_165", bn = "_containerImage_1ozb8_168", yn = "_sectionText_1ozb8_174", $n = "_dash_1ozb8_182", Nn = "_sectionBtn_1ozb8_198", Cn = {
  buttonsWrapper: gn,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1ozb8_138",
  "spaceAfter--small": "_spaceAfter--small_1ozb8_141",
  "spaceAfter--medium": "_spaceAfter--medium_1ozb8_144",
  sectionContainer: hn,
  containerImage: bn,
  sectionText: yn,
  dash: $n,
  sectionBtn: Nn
}, xn = {
  destination: "external",
  // 'internal'
  target: "current",
  // 'new'
  text: "READ MORE",
  pageId: "",
  href: "#"
}, In = {
  destination: "external",
  // 'internal'
  target: "current",
  // 'new'
  text: "المزيد",
  pageId: "",
  href: "#"
}, An = {
  section_title: {
    type: d.TEXT,
    fieldId: 17,
    defaultValue: {
      default: "Our Story",
      ar: "من نحن"
    }
  },
  section_image: {
    type: d.IMAGE,
    fieldId: 19,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1483706571191-85c0c76b1947?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=79d169c2bf199ce6912f72c20ec301e4&auto=format&fit=crop&w=500&q=80"
    }
  },
  section_image2: {
    type: d.IMAGE,
    fieldId: 42,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1517502884422-41eaead166d4?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=3d8f17ce21e419f0ef0e90dfcbe19911&auto=format&fit=crop&w=500&q=80"
    }
  },
  section_content: {
    type: d.TEXT,
    fieldId: 18,
    defaultValue: {
      default: `Our primary objective is to be a leading brand in the jewellery and fashion industry and delight our customers by offering luxury wrapped in trust, Damas Egypt now is the leading company in Egypt in the field of Jewellery in terms of size of the investment and the number of branches and quality of the product, we started in Egypt in 1997 by one branch and now we have twenty-one branches across Egypt, We offer a great selection of jewellery in various designs, colors, and sizes.
      Our jewellery stock a wide selection of jewellery made of gold, diamond, and pearls. We offer a service to make custom pieces for clients on demand.
      Our selection of jewellery range in various colors, sizes, and styles to meet the unique needs of the everyday woman. Jewellery has been designed for all occasions. Customers can purchase pre-made jewellery or request a customized piece designed for them at the store, we sell jewellery through four main formats, which are uniquely positioned to address different consumer segment needs.`,
      ar: "اكتب خلفية عن أعمالك، بما في ذلك تاريخك، وإنجازاتك، وأي جوائز قد حصلت عليها. استخدم هذا القسم لعرض ملامح علامتك التجارية."
    }
  },
  section_action: {
    type: d.LINK,
    fieldId: 43,
    defaultValue: {
      default: xn,
      ar: In
    }
  }
}, Sn = ({
  Elements: { BackgroundContainer: n, Text: o, Button: t },
  classes: a,
  section_title: i,
  section_content: r,
  section_image: c,
  section_action: s
}) => /* @__PURE__ */ e("section", { className: "container", children: /* @__PURE__ */ e("div", { className: a.sectionContainer, children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-lg-5", children: /* @__PURE__ */ e(
    n,
    {
      value: c,
      className: a.containerImage
    }
  ) }),
  /* @__PURE__ */ e("div", { className: "col-lg-7", children: /* @__PURE__ */ l("div", { className: a.sectionText, children: [
    /* @__PURE__ */ l("div", { className: "d-flex align-items-center mt-2", children: [
      /* @__PURE__ */ e("span", { className: a.dash }),
      /* @__PURE__ */ e(o, { tag: "h2", value: i })
    ] }),
    /* @__PURE__ */ e(o, { tag: "p", value: r }),
    /* @__PURE__ */ e(t, { value: s, className: a.sectionBtn })
  ] }) })
] }) }) }), kn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Sn,
  meta: An,
  styles: Cn
}, Symbol.toStringTag, { value: "Module" })), jn = "_buttonsWrapper_vbpxj_132", wn = "_sectionContainer_vbpxj_165", Mn = "_sectionHeader_vbpxj_168", Wn = "_dash_vbpxj_171", En = "_contactFields_vbpxj_187", Tn = "_textField_vbpxj_191", Ln = "_textareaField_vbpxj_192", On = "_submitButton_vbpxj_200", zn = "_contactInfo_vbpxj_210", Pn = "_info_vbpxj_210", Bn = "_social_vbpxj_221", qn = "_socialItem_vbpxj_227", Hn = "_actionContainer_vbpxj_246", Vn = {
  buttonsWrapper: jn,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_vbpxj_138",
  "spaceAfter--small": "_spaceAfter--small_vbpxj_141",
  "spaceAfter--medium": "_spaceAfter--medium_vbpxj_144",
  sectionContainer: wn,
  sectionHeader: Mn,
  dash: Wn,
  contactFields: En,
  textField: Tn,
  textareaField: Ln,
  submitButton: On,
  contactInfo: zn,
  info: Pn,
  social: Bn,
  socialItem: qn,
  actionContainer: Hn
}, Fn = {
  action: {
    label: "Send Request"
  },
  fields: [
    {
      type: "Text",
      name: "name",
      label: "Name"
    },
    {
      type: "Text",
      name: "email",
      label: "Email"
    },
    {
      type: "Text",
      name: "phone",
      label: "Phone"
    },
    {
      type: "Text",
      name: "address",
      label: "address"
    },
    {
      type: "MultiLineText",
      name: "message",
      label: "message"
    }
  ],
  success_message: "Thank you for reaching out, we'll get back to you as soon as possible"
}, Dn = {
  action: {
    label: "إرسال"
  },
  fields: [
    {
      type: "Text",
      name: "name",
      label: "الاسم"
    },
    {
      type: "Text",
      name: "email",
      label: "البريد الإلكتروني"
    },
    {
      type: "Text",
      name: "phone",
      label: "الهاتف"
    },
    {
      type: "Text",
      name: "address",
      label: "العنوان"
    },
    {
      type: "MultiLineText",
      name: "message",
      label: "الرسالة"
    }
  ],
  success_message: "شكرًا لك على التواصل معنا ، وسنوافيك بالرد في أسرع وقت ممكن"
}, Xn = {
  section_title: {
    type: d.TEXT,
    fieldId: 54,
    defaultValue: {
      default: "Contact Us",
      ar: "تواصل معنا"
    }
  },
  section_description: {
    type: d.TEXT,
    fieldId: 55,
    defaultValue: {
      default: "Our team is always available to assist you.",
      ar: "نحن هنا لللإجابة عن استفساراتك و تعليقاتك"
    }
  },
  form: {
    type: d.FORM,
    fieldId: 32,
    defaultValue: {
      default: Fn,
      ar: Dn
    }
  },
  section_image: {
    type: d.IMAGE,
    fieldId: 56,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1528260249572-a56fc30084ef?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=0189bb96e70b69a83c49f9e667ff1366&auto=format&fit=crop&w=375&q=80"
    }
  },
  map: {
    type: d.MAP,
    fieldId: 132,
    defaultValue: {
      default: {
        zoom: 15,
        marker: {
          location: {
            lat: 25.814004,
            lng: -80.126808
          }
        },
        mapType: "roadmap"
      }
    }
  },
  phone: {
    type: d.TEXT,
    fieldId: 57,
    defaultValue: {
      default: "1(800) - 374 - 990"
    }
  },
  email: {
    type: d.TEXT,
    fieldId: 58,
    defaultValue: {
      default: "info@business.com"
    }
  },
  address: {
    type: d.TEXT,
    fieldId: 59,
    defaultValue: {
      default: "301 W. 41st Street, Suite 501 Miami Beach, FL 33140",
      ar: "301 غرب شارع رقم 41 - وحدة 501 شاطئ ميامي - فلوريدا - الولايات المتحدة"
    }
  },
  email_icon: {
    type: d.ICON,
    fieldId: 75,
    defaultValue: {
      default: "envelope"
    }
  },
  phone_icon: {
    type: d.ICON,
    fieldId: 73,
    defaultValue: {
      default: "phone"
    }
  },
  address_icon: {
    type: d.ICON,
    fieldId: 77,
    defaultValue: {
      default: "map-marker"
    }
  },
  email_label: {
    type: d.TEXT,
    fieldId: 74,
    defaultValue: {
      default: "Email",
      ar: "البريد اللإلكتروني"
    }
  },
  phone_label: {
    type: d.TEXT,
    fieldId: 72,
    defaultValue: {
      default: "Phone",
      ar: "التليفون"
    }
  },
  address_label: {
    type: d.TEXT,
    fieldId: 76,
    defaultValue: {
      default: "Address",
      ar: "العنوان"
    }
  },
  social_label: {
    type: d.TEXT,
    fieldId: 98,
    defaultValue: {
      default: "Social Media",
      ar: "التواصل الاجتماعي"
    }
  },
  social_links: {
    type: d.SOCIAL_LINKS,
    fieldId: 78,
    defaultValue: {
      default: {
        facebook: "#",
        twitter: "#",
        linkedin: "#",
        instagram: "#",
        snapchat: "#"
      }
    }
  }
}, Rn = ({
  Elements: { Form: n, Text: o, SocialLinks: t },
  classes: a,
  section_title: i,
  section_description: r,
  phone: c,
  phone_label: s,
  email: _,
  email_label: m,
  form: p,
  social_label: u,
  social_links: v
}) => /* @__PURE__ */ e("section", { className: "container", children: /* @__PURE__ */ l("div", { className: a.sectionContainer, children: [
  /* @__PURE__ */ l("div", { className: a.sectionHeader, children: [
    /* @__PURE__ */ l("div", { className: "d-flex align-items-center", children: [
      /* @__PURE__ */ e("span", { className: a.dash }),
      /* @__PURE__ */ e(o, { tag: "h2", value: i })
    ] }),
    /* @__PURE__ */ e(o, { tag: "p", value: r })
  ] }),
  /* @__PURE__ */ l("div", { className: "row", children: [
    /* @__PURE__ */ e("div", { className: "col-lg-6", children: /* @__PURE__ */ e("div", { className: a.contactFields, children: /* @__PURE__ */ e(
      n,
      {
        fieldContainerClass: "form-group",
        textareaClass: `form-control ${a.textareaField}`,
        textClass: `form-control ${a.textField}`,
        buttonClass: a.submitButton,
        actionContainerClass: a.actionContainer,
        value: p
      }
    ) }) }),
    /* @__PURE__ */ e("div", { className: "col-lg-6 mt-4 mt-lg-0", children: /* @__PURE__ */ l("div", { className: a.contactInfo, children: [
      /* @__PURE__ */ l("div", { className: a.info, children: [
        /* @__PURE__ */ e(o, { tag: "h5", value: m }),
        /* @__PURE__ */ e(o, { tag: "p", value: _ })
      ] }),
      /* @__PURE__ */ l("div", { className: a.info, children: [
        /* @__PURE__ */ e(o, { tag: "h5", value: s }),
        /* @__PURE__ */ e(o, { tag: "p", value: c })
      ] }),
      /* @__PURE__ */ l("div", { className: a.info, children: [
        /* @__PURE__ */ e(o, { tag: "h5", value: u }),
        /* @__PURE__ */ e(
          t,
          {
            value: v,
            listClass: a.social,
            itemClass: a.socialItem
          }
        )
      ] })
    ] }) })
  ] })
] }) }), Gn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Rn,
  meta: Xn,
  styles: Vn
}, Symbol.toStringTag, { value: "Module" })), Un = "_buttonsWrapper_177em_132", Jn = "_sectionContainer_177em_165", Qn = "_sectionHeader_177em_168", Kn = "_dash_177em_171", Zn = "_mapContainer_177em_186", Yn = "_map_177em_186", eo = "_contactInfo_177em_205", to = "_info_177em_217", ao = "_contactFields_177em_225", no = "_textField_177em_235", oo = "_textareaField_177em_236", io = "_submitButton_177em_242", lo = "_social_177em_257", ro = "_socialItem_177em_264", co = "_actionContainer_177em_283", so = {
  buttonsWrapper: Un,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_177em_138",
  "spaceAfter--small": "_spaceAfter--small_177em_141",
  "spaceAfter--medium": "_spaceAfter--medium_177em_144",
  sectionContainer: Jn,
  sectionHeader: Qn,
  dash: Kn,
  mapContainer: Zn,
  map: Yn,
  contactInfo: eo,
  info: to,
  contactFields: ao,
  textField: no,
  textareaField: oo,
  submitButton: io,
  social: lo,
  socialItem: ro,
  actionContainer: co
}, _o = {
  action: {
    label: "Send Request"
  },
  fields: [
    {
      type: "Text",
      name: "name",
      label: "Name"
    },
    {
      type: "Text",
      name: "email",
      label: "Email"
    },
    {
      type: "Text",
      name: "phone",
      label: "Phone"
    },
    {
      type: "Text",
      name: "address",
      label: "address"
    },
    {
      type: "MultiLineText",
      name: "message",
      label: "message"
    }
  ],
  success_message: "Thank you for reaching out, we'll get back to you as soon as possible"
}, mo = {
  action: {
    label: "إرسال"
  },
  fields: [
    {
      type: "Text",
      name: "name",
      label: "الاسم"
    },
    {
      type: "Text",
      name: "email",
      label: "البريد الإلكتروني"
    },
    {
      type: "Text",
      name: "phone",
      label: "الهاتف"
    },
    {
      type: "Text",
      name: "address",
      label: "العنوان"
    },
    {
      type: "MultiLineText",
      name: "message",
      label: "الرسالة"
    }
  ],
  success_message: "شكرًا لك على التواصل معنا ، وسنوافيك بالرد في أسرع وقت ممكن"
}, uo = {
  section_title: {
    type: d.TEXT,
    fieldId: 54,
    defaultValue: {
      default: "Contact Us",
      ar: "تواصل معنا"
    }
  },
  section_description: {
    type: d.TEXT,
    fieldId: 55,
    defaultValue: {
      default: "Our team is always available to assist you.",
      ar: "نحن هنا لللإجابة عن استفساراتك و تعليقاتك"
    }
  },
  form: {
    type: d.FORM,
    fieldId: 32,
    defaultValue: {
      default: _o,
      ar: mo
    }
  },
  section_image: {
    type: d.IMAGE,
    fieldId: 56,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1528260249572-a56fc30084ef?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=0189bb96e70b69a83c49f9e667ff1366&auto=format&fit=crop&w=375&q=80"
    }
  },
  map: {
    type: d.MAP,
    fieldId: 132,
    defaultValue: {
      default: {
        zoom: 15,
        marker: {
          location: {
            lat: 25.814004,
            lng: -80.126808
          }
        },
        mapType: "roadmap"
      }
    }
  },
  phone: {
    type: d.TEXT,
    fieldId: 57,
    defaultValue: {
      default: "1(800) - 374 - 990"
    }
  },
  email: {
    type: d.TEXT,
    fieldId: 58,
    defaultValue: {
      default: "info@business.com"
    }
  },
  address: {
    type: d.TEXT,
    fieldId: 59,
    defaultValue: {
      default: "301 W. 41st Street, Suite 501 Miami Beach, FL 33140",
      ar: "301 غرب شارع رقم 41 - وحدة 501 شاطئ ميامي - فلوريدا - الولايات المتحدة"
    }
  },
  email_icon: {
    type: d.ICON,
    fieldId: 75,
    defaultValue: {
      default: "envelope"
    }
  },
  phone_icon: {
    type: d.ICON,
    fieldId: 73,
    defaultValue: {
      default: "phone"
    }
  },
  address_icon: {
    type: d.ICON,
    fieldId: 77,
    defaultValue: {
      default: "map-marker"
    }
  },
  email_label: {
    type: d.TEXT,
    fieldId: 74,
    defaultValue: {
      default: "Email",
      ar: "البريد اللإلكتروني"
    }
  },
  phone_label: {
    type: d.TEXT,
    fieldId: 72,
    defaultValue: {
      default: "Phone",
      ar: "التليفون"
    }
  },
  address_label: {
    type: d.TEXT,
    fieldId: 76,
    defaultValue: {
      default: "Address",
      ar: "العنوان"
    }
  },
  social_label: {
    type: d.TEXT,
    fieldId: 98,
    defaultValue: {
      default: "Social Media",
      ar: "التواصل الاجتماعي"
    }
  },
  social_links: {
    type: d.SOCIAL_LINKS,
    fieldId: 78,
    defaultValue: {
      default: {
        facebook: "#",
        twitter: "#",
        linkedin: "#",
        instagram: "#",
        snapchat: "#"
      }
    }
  }
}, po = ({
  Elements: { Map: n, Form: o, Text: t, SocialLinks: a },
  classes: i,
  section_title: r,
  section_description: c,
  map: s,
  phone: _,
  phone_label: m,
  email: p,
  email_label: u,
  address: v,
  address_label: f,
  form: h,
  social_label: g,
  social_links: N
}) => /* @__PURE__ */ e("section", { className: "container", children: /* @__PURE__ */ l("div", { className: i.sectionContainer, children: [
  /* @__PURE__ */ l("div", { className: i.sectionHeader, children: [
    /* @__PURE__ */ l("div", { className: "d-flex align-items-center", children: [
      /* @__PURE__ */ e("span", { className: i.dash }),
      /* @__PURE__ */ e(t, { tag: "h2", value: r })
    ] }),
    /* @__PURE__ */ e(t, { tag: "p", value: c })
  ] }),
  /* @__PURE__ */ l("div", { className: "row", children: [
    /* @__PURE__ */ e("div", { className: "col-lg-7", children: /* @__PURE__ */ l("div", { className: i.mapContainer, children: [
      /* @__PURE__ */ e(n, { className: i.map, value: s }),
      /* @__PURE__ */ l("div", { className: i.contactInfo, children: [
        /* @__PURE__ */ l("div", { className: i.info, children: [
          /* @__PURE__ */ e(t, { tag: "h5", value: f }),
          /* @__PURE__ */ e(t, { tag: "p", value: v })
        ] }),
        /* @__PURE__ */ l("div", { className: i.info, children: [
          /* @__PURE__ */ e(t, { tag: "h5", value: m }),
          /* @__PURE__ */ e(t, { tag: "p", value: _ })
        ] }),
        /* @__PURE__ */ l("div", { className: i.info, children: [
          /* @__PURE__ */ e(t, { tag: "h5", value: u }),
          /* @__PURE__ */ e(t, { tag: "p", value: p })
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ e("div", { className: "col-lg-5 d-flex align-items-center justify-content-center", children: /* @__PURE__ */ l("div", { className: i.contactFields, children: [
      /* @__PURE__ */ e(
        o,
        {
          fieldContainerClass: "form-group",
          textareaClass: `form-control ${i.textareaField}`,
          textClass: `form-control ${i.textField}`,
          buttonClass: i.submitButton,
          actionContainerClass: i.actionContainer,
          value: h
        }
      ),
      /* @__PURE__ */ e(t, { tag: "h5", value: g }),
      /* @__PURE__ */ e(
        a,
        {
          value: N,
          listClass: i.social,
          itemClass: i.socialItem
        }
      )
    ] }) })
  ] })
] }) }), vo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: po,
  meta: uo,
  styles: so
}, Symbol.toStringTag, { value: "Module" })), F = [
  {
    area: "EL Sagha",
    address: "60 EL Moez Ldin Allah st , Al-Hussein – Al-Azhar",
    phone: "00202 25919291",
    lat: 30.0482149,
    lng: 31.2593817
  },
  {
    area: "Medan EL Gamea",
    address: "10 Haroun Al-Rashid st , Heliopolis",
    phone: "00202 24547556",
    lat: 30.0906874,
    lng: 31.3242091
  },
  {
    area: "EL Korba (1)",
    address: "7 Abou EL-holl st , Heliopolis",
    phone: "00202 26906761",
    lat: 30.0906152,
    lng: 31.3243068
  },
  {
    area: "EL Korba (2)",
    address: "13 EL Thawra st , Heliopolis",
    phone: "00202 26906756",
    lat: 30.0798538,
    lng: 31.3457198
  },
  {
    area: "Golf City Mall",
    address: "EL Obour City – Egypt Ismailia Desert Road – Golf City Mall – Shop No. 25",
    phone: "00202 44828246",
    lat: 30.0745686,
    lng: 30.9472044
  },
  {
    area: "City Stars 1",
    address: "3rd Floor – City Stars Mall – Phase II -Shop No,3245",
    phone: "00202 24802393",
    lat: 30.0728734,
    lng: 31.3436195
  },
  {
    area: "City Stars 2",
    address: "3rd Floor – City Stars Mall – Phase I -Shop No,358A",
    phone: "00202 24802538",
    lat: 30.0728734,
    lng: 31.3436195
  },
  {
    area: "City Center EL Maadi",
    address: "City Center EL-Maadi – Shop No,32",
    phone: "00202 25204475",
    lat: 29.9829927,
    lng: 31.3140946
  },
  {
    area: "EL Maadi",
    address: "216 Degla st – Building 1/2 – Maadi",
    phone: "00202 25210439",
    lat: 29.9658509,
    lng: 31.2775155
  },
  {
    area: "Downtown Mall",
    address: "Ninetieth Street – New Cairo – Downtown Mall – Shop No. 23",
    phone: "00202 23146032",
    lat: 30.018,
    lng: 31.4092233
  },
  {
    area: "Cairo Festival City Mall",
    address: "New Cairo – Cairo Festival City Mall – Unit No. 1-044",
    phone: "002 – 01061125552",
    lat: 30.0290116,
    lng: 31.4064409
  },
  {
    area: "City Center Almaza",
    address: "Unit No E1-33 – City Center Almaza Mall – ElNasr Road",
    phone: "002- 01005050689",
    lat: 30.0696309,
    lng: 31.3629415
  },
  {
    area: "Mall Of Arabia 2",
    address: "LG 56 – Mall of Arabia – Juhayna Square -6 October",
    phone: "01000084380",
    lat: 30.0072411,
    lng: 30.9728776
  },
  {
    area: "Mall of Arabia",
    address: "60/61 G Mall of Arabia – Juhayna Square -6 October",
    phone: "00202 38260032",
    lat: 30.0072411,
    lng: 30.9728776
  },
  {
    area: "Mall of Egypt",
    address: "6th October – Mall of Egypt – Unit No, G065",
    phone: "00202 236120113",
    lat: 29.9718413,
    lng: 31.0145088
  },
  {
    area: "Dandy",
    address: "Km- 28- Egypt Alexandria Desert Road – Dandy Mall – Shop No. 90",
    phone: "00202 35390824",
    lat: 30.0627236,
    lng: 31.0258678
  },
  {
    area: "Soliman Abaza",
    address: "4 Soliman Abaza st – Mohandessin",
    phone: "00202 37614713",
    lat: 30.0489612,
    lng: 31.2027062
  },
  {
    area: "Lobnan",
    address: "3st Lobnan – Mohandessin",
    phone: "02 33471235",
    lat: 30.0552534,
    lng: 31.1989878
  },
  {
    area: "City Center Alexandria",
    address: "Unit No G73 – City Center Mall – Muharram Bek – Alexandria",
    phone: "00203 3680230",
    lat: 31.1678922,
    lng: 29.9313807
  },
  {
    area: "Roshdy",
    address: "168 Ahmed Shawky st – Roshdy – Alexandria",
    phone: "00203 5223560",
    lat: 31.2270538,
    lng: 29.9484534
  },
  {
    area: "Mansoura",
    address: "51 Lel Mashaya EL Soflya st- Mansoura",
    phone: "00205 02200303",
    lat: 31.0459644,
    lng: 31.3596448
  },
  {
    area: "Tanta",
    address: "Mall of Tanta – Unit No. G58 – Elgharbya",
    phone: "01102210225",
    lat: 30.8413235,
    lng: 31.0156059
  }
], fo = "_buttonsWrapper_ex0hu_132", go = "_sectionContainer_ex0hu_165", ho = "_sectionHeader_ex0hu_168", bo = "_dash_ex0hu_171", yo = "_locationInfo_ex0hu_186", $o = "_info_ex0hu_210", No = "_mapContainer_ex0hu_226", Co = "_map_ex0hu_226", xo = "_activeLoc_ex0hu_241", Io = {
  buttonsWrapper: fo,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_ex0hu_138",
  "spaceAfter--small": "_spaceAfter--small_ex0hu_141",
  "spaceAfter--medium": "_spaceAfter--medium_ex0hu_144",
  sectionContainer: go,
  sectionHeader: ho,
  dash: bo,
  locationInfo: yo,
  info: $o,
  mapContainer: No,
  map: Co,
  activeLoc: xo
}, Ao = {
  action: {
    label: "Send Message"
  },
  fields: [
    {
      type: "Text",
      name: "name",
      label: "Name"
    },
    {
      type: "Text",
      name: "email",
      label: "Email"
    },
    {
      type: "Text",
      name: "phone",
      label: "Phone"
    },
    {
      type: "Text",
      name: "address",
      label: "address"
    },
    {
      type: "MultiLineText",
      name: "message",
      label: "message"
    }
  ],
  success_message: "Thank you for reaching out, we'll get back to you as soon as possible"
}, So = {
  action: {
    label: "إرسال"
  },
  fields: [
    {
      type: "Text",
      name: "name",
      label: "الاسم"
    },
    {
      type: "Text",
      name: "email",
      label: "البريد الإلكتروني"
    },
    {
      type: "Text",
      name: "phone",
      label: "الهاتف"
    },
    {
      type: "Text",
      name: "address",
      label: "العنوان"
    },
    {
      type: "MultiLineText",
      name: "message",
      label: "الرسالة"
    }
  ],
  success_message: "شكرًا لك على التواصل معنا ، وسنوافيك بالرد في أسرع وقت ممكن"
}, ko = {
  section_title: {
    type: d.TEXT,
    fieldId: 54,
    defaultValue: {
      default: "Contact Us",
      ar: "تواصل معنا"
    }
  },
  section_description: {
    type: d.TEXT,
    fieldId: 55,
    defaultValue: {
      default: "Our team is always available to assist you.",
      ar: "نحن هنا لللإجابة عن استفساراتك و تعليقاتك"
    }
  },
  form: {
    type: d.FORM,
    fieldId: 32,
    defaultValue: {
      default: Ao,
      ar: So
    }
  },
  section_image: {
    type: d.IMAGE,
    fieldId: 56,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1528260249572-a56fc30084ef?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=0189bb96e70b69a83c49f9e667ff1366&auto=format&fit=crop&w=375&q=80"
    }
  },
  map: {
    type: d.MAP,
    fieldId: 132,
    defaultValue: {
      default: {
        zoom: 15,
        marker: {
          location: {
            lat: 25.814004,
            lng: -80.126808
          }
        },
        mapType: "roadmap"
      }
    }
  },
  phone: {
    type: d.TEXT,
    fieldId: 57,
    defaultValue: {
      default: "1(800) - 374 - 990"
    }
  },
  email: {
    type: d.TEXT,
    fieldId: 58,
    defaultValue: {
      default: "info@business.com"
    }
  },
  address: {
    type: d.TEXT,
    fieldId: 59,
    defaultValue: {
      default: "301 W. 41st Street, Suite 501 Miami Beach, FL 33140",
      ar: "301 غرب شارع رقم 41 - وحدة 501 شاطئ ميامي - فلوريدا - الولايات المتحدة"
    }
  },
  email_icon: {
    type: d.ICON,
    fieldId: 75,
    defaultValue: {
      default: "envelope"
    }
  },
  phone_icon: {
    type: d.ICON,
    fieldId: 73,
    defaultValue: {
      default: "phone"
    }
  },
  address_icon: {
    type: d.ICON,
    fieldId: 77,
    defaultValue: {
      default: "map-marker"
    }
  },
  email_label: {
    type: d.TEXT,
    fieldId: 74,
    defaultValue: {
      default: "Email",
      ar: "البريد اللإلكتروني"
    }
  },
  phone_label: {
    type: d.TEXT,
    fieldId: 72,
    defaultValue: {
      default: "Phone",
      ar: "التليفون"
    }
  },
  address_label: {
    type: d.TEXT,
    fieldId: 76,
    defaultValue: {
      default: "Address",
      ar: "العنوان"
    }
  },
  social_label: {
    type: d.TEXT,
    fieldId: 98,
    defaultValue: {
      default: "Social Media",
      ar: "التواصل الاجتماعي"
    }
  },
  social_links: {
    type: d.SOCIAL_LINKS,
    fieldId: 78,
    defaultValue: {
      default: {
        facebook: "#",
        twitter: "#",
        linkedin: "#",
        instagram: "#",
        snapchat: "#"
      }
    }
  }
}, jo = ({
  Elements: { ViewMap: n, Text: o },
  classes: t,
  section_title: a,
  section_description: i
}) => {
  const [r, c] = z({
    lat: 30.0482149,
    lng: 31.2593817
  }), [s, _] = z(0), [m, p] = z(!1);
  return /* @__PURE__ */ e("section", { className: "container", children: /* @__PURE__ */ l("div", { className: t.sectionContainer, children: [
    /* @__PURE__ */ l("div", { className: t.sectionHeader, children: [
      /* @__PURE__ */ l("div", { className: "d-flex align-items-center", children: [
        /* @__PURE__ */ e("span", { className: t.dash }),
        /* @__PURE__ */ e(o, { tag: "h2", value: a })
      ] }),
      /* @__PURE__ */ e(o, { tag: "p", value: i })
    ] }),
    /* @__PURE__ */ l("div", { className: "row d-none d-lg-flex", children: [
      /* @__PURE__ */ e("div", { className: "col-lg-4 p-lg-0", children: /* @__PURE__ */ l("div", { className: t.locationInfo, children: [
        /* @__PURE__ */ e("h5", { children: "Cairo" }),
        F.map((u, v) => {
          if (v >= 0 && v < 12)
            return /* @__PURE__ */ l(
              "div",
              {
                className: `${t.info} ${s === v && t.activeLoc}`,
                onClick: () => {
                  _(v), c({
                    lat: u.lat,
                    lng: u.lng
                  });
                },
                children: [
                  /* @__PURE__ */ e("h4", { children: u.area }),
                  /* @__PURE__ */ e("p", { children: u.address }),
                  /* @__PURE__ */ e("h6", { children: u.phone })
                ]
              },
              v
            );
        }),
        /* @__PURE__ */ e("h5", { children: "Giza" }),
        F.map((u, v) => {
          if (v >= 12 && v < 18)
            return /* @__PURE__ */ l(
              "div",
              {
                className: `${t.info} ${s === v && t.activeLoc}`,
                onClick: () => {
                  _(v), c({
                    lat: u.lat,
                    lng: u.lng
                  });
                },
                children: [
                  /* @__PURE__ */ e("h4", { children: u.area }),
                  /* @__PURE__ */ e("p", { children: u.address }),
                  /* @__PURE__ */ e("h6", { children: u.phone })
                ]
              },
              v
            );
        }),
        /* @__PURE__ */ e("h5", { children: "Alexandria" }),
        F.map((u, v) => {
          if (v >= 18 && v < 20)
            return /* @__PURE__ */ l(
              "div",
              {
                className: `${t.info} ${s === v && t.activeLoc}`,
                onClick: () => {
                  _(v), c({
                    lat: u.lat,
                    lng: u.lng
                  });
                },
                children: [
                  /* @__PURE__ */ e("h4", { children: u.area }),
                  /* @__PURE__ */ e("p", { children: u.address }),
                  /* @__PURE__ */ e("h6", { children: u.phone })
                ]
              },
              v
            );
        }),
        /* @__PURE__ */ e("h5", { children: "Mansoura" }),
        F.map((u, v) => {
          if (v == 20)
            return /* @__PURE__ */ l(
              "div",
              {
                className: `${t.info} ${s === v && t.activeLoc}`,
                onClick: () => {
                  _(v), c({
                    lat: u.lat,
                    lng: u.lng
                  });
                },
                children: [
                  /* @__PURE__ */ e("h4", { children: u.area }),
                  /* @__PURE__ */ e("p", { children: u.address }),
                  /* @__PURE__ */ e("h6", { children: u.phone })
                ]
              },
              v
            );
        }),
        /* @__PURE__ */ e("h5", { children: "Tanta" }),
        F.map((u, v) => {
          if (v == 21)
            return /* @__PURE__ */ l(
              "div",
              {
                className: `${t.info} ${s === v && t.activeLoc}`,
                onClick: () => {
                  _(v), c({
                    lat: u.lat,
                    lng: u.lng
                  });
                },
                children: [
                  /* @__PURE__ */ e("h4", { children: u.area }),
                  /* @__PURE__ */ e("p", { children: u.address }),
                  /* @__PURE__ */ e("h6", { children: u.phone })
                ]
              },
              v
            );
        })
      ] }) }),
      /* @__PURE__ */ e("div", { className: "col-lg-8 p-lg-0", children: /* @__PURE__ */ e("div", { className: t.mapContainer, children: /* @__PURE__ */ e(
        n,
        {
          className: t.map,
          value: {
            zoom: 15,
            marker: { location: r },
            mapType: "roadmap"
          }
        }
      ) }) })
    ] }),
    /* @__PURE__ */ e("div", { className: "d-lg-none d-block", children: /* @__PURE__ */ e("div", { className: t.locationInfo, children: F.map((u, v) => /* @__PURE__ */ l(qe, { children: [
      /* @__PURE__ */ l(
        "div",
        {
          className: `${t.info} ${s === v && t.activeLoc}`,
          onClick: () => {
            _(v), c({
              lat: u.lat,
              lng: u.lng
            }), p(!0);
          },
          children: [
            /* @__PURE__ */ e("h4", { children: u.area }),
            /* @__PURE__ */ e("p", { children: u.address }),
            /* @__PURE__ */ e("h6", { children: u.phone })
          ]
        }
      ),
      m && s === v && /* @__PURE__ */ e("div", { className: t.mapContainer, children: /* @__PURE__ */ e(
        n,
        {
          className: t.map,
          value: {
            zoom: 15,
            marker: { location: r },
            mapType: "roadmap"
          }
        }
      ) })
    ] })) }) })
  ] }) });
}, wo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jo,
  meta: ko,
  styles: Io
}, Symbol.toStringTag, { value: "Module" })), Mo = "_buttonsWrapper_1qzdk_132", Wo = "_sectionContainer_1qzdk_165", Eo = "_sectionTitle_1qzdk_168", To = "_sectionText_1qzdk_183", Lo = {
  buttonsWrapper: Mo,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1qzdk_138",
  "spaceAfter--small": "_spaceAfter--small_1qzdk_141",
  "spaceAfter--medium": "_spaceAfter--medium_1qzdk_144",
  sectionContainer: Wo,
  sectionTitle: Eo,
  sectionText: To
}, Oo = {
  title: {
    type: d.TEXT,
    fieldId: 22,
    defaultValue: {
      default: "A section for you to write about just anything",
      ar: "قسم لكي تكتب عن أي شيء"
    }
  },
  image: {
    type: d.IMAGE,
    fieldId: 21,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1483706571191-85c0c76b1947?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=79d169c2bf199ce6912f72c20ec301e4&auto=format&fit=crop&w=500&q=80"
    }
  },
  text: {
    type: d.TEXT,
    fieldId: 23,
    defaultValue: {
      default: "Need a place to add in your awards? This is it. Want to include more information about your products, history, or features? This is the spot for that. Use this content section for anything and everything.",
      ar: "هل تريد تضمين المزيد من المعلومات حول منتجاتك أو سجلك أو ميزاتك؟ هذا هو المكان المناسب لذلك. استخدم قسم المحتوى هذا لأي شيء وكل شيء."
    }
  }
}, zo = ({ Elements: { Text: n }, classes: o, title: t, text: a }) => /* @__PURE__ */ e("section", { className: o.sectionContainer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-md-4", children: /* @__PURE__ */ e("div", { className: o.sectionTitle, children: /* @__PURE__ */ e(n, { tag: "h1", value: t }) }) }),
  /* @__PURE__ */ e("div", { className: "col-md-8", children: /* @__PURE__ */ e("div", { className: o.sectionText, children: /* @__PURE__ */ e(n, { tag: "p", value: a }) }) })
] }) }) }), Po = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zo,
  meta: Oo,
  styles: Lo
}, Symbol.toStringTag, { value: "Module" })), Bo = "_buttonsWrapper_kz4fc_132", qo = "_sectionContainer_kz4fc_165", Ho = "_sectionContent_kz4fc_168", Vo = "_imageContainer_kz4fc_173", Fo = "_image_kz4fc_173", Do = "_sectionText_kz4fc_181", Xo = {
  buttonsWrapper: Bo,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_kz4fc_138",
  "spaceAfter--small": "_spaceAfter--small_kz4fc_141",
  "spaceAfter--medium": "_spaceAfter--medium_kz4fc_144",
  sectionContainer: qo,
  sectionContent: Ho,
  imageContainer: Vo,
  image: Fo,
  sectionText: Do
}, Ro = {
  title: {
    type: d.TEXT,
    fieldId: 22,
    defaultValue: {
      default: "A section for you to write about just anything",
      ar: "قسم لكي تكتب عن أي شيء"
    }
  },
  image: {
    type: d.IMAGE,
    fieldId: 21,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1483706571191-85c0c76b1947?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=79d169c2bf199ce6912f72c20ec301e4&auto=format&fit=crop&w=500&q=80"
    }
  },
  text: {
    type: d.TEXT,
    fieldId: 23,
    defaultValue: {
      default: "Need a place to add in your awards? This is it. Want to include more information about your products, history, or features? This is the spot for that. Use this content section for anything and everything.",
      ar: "هل تريد تضمين المزيد من المعلومات حول منتجاتك أو سجلك أو ميزاتك؟ هذا هو المكان المناسب لذلك. استخدم قسم المحتوى هذا لأي شيء وكل شيء."
    }
  }
}, Go = ({
  Elements: { Text: n, Image: o },
  classes: t,
  title: a,
  text: i,
  image: r
}) => /* @__PURE__ */ e("section", { className: t.sectionContainer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ l("div", { className: t.sectionContent, children: [
  /* @__PURE__ */ e("div", { className: t.imageContainer, children: /* @__PURE__ */ e(o, { value: r, className: t.image }) }),
  /* @__PURE__ */ l("div", { className: t.sectionText, children: [
    /* @__PURE__ */ e(n, { tag: "h1", value: a }),
    /* @__PURE__ */ e(n, { tag: "p", value: i })
  ] })
] }) }) }) }), Uo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Go,
  meta: Ro,
  styles: Xo
}, Symbol.toStringTag, { value: "Module" })), Jo = {
  pages: {
    type: d.NAV_MENU,
    source: w.UNIVERSAL,
    defaultValue: []
  },
  menuItems: {
    type: d.NAV_MENU,
    source: w.UNIVERSAL
  },
  logo: {
    type: d.LOGO,
    fieldId: 91,
    defaultValue: {
      default: {
        url: "https://assets.wuiltsite.com/defaults/google-logo.png",
        size: "medium"
      }
    }
  },
  text: {
    type: d.TEXT,
    fieldId: 70,
    defaultValue: {
      default: "text",
      ar: "كلام"
    }
  },
  copyright_text: {
    type: d.TEXT,
    fieldId: 69,
    defaultValue: {
      default: "© 2018 Creation - One & Multi Page Multipurpose Theme ",
      ar: "© جميع الحقوق محفوظة"
    }
  },
  title_text: {
    type: d.TEXT,
    fieldId: 107,
    defaultValue: {
      default: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
      ar: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium."
    }
  },
  social_links: {
    type: d.SOCIAL_LINKS,
    fieldId: 106,
    defaultValue: {
      default: {
        facebook: "https://facebook.com/",
        twitter: "#",
        instagram: "#",
        snapchat: "#"
      }
    }
  }
}, Qo = "_footer_1j0qf_1", Ko = "_footerLogo_1j0qf_6", Zo = "_footerLinks_1j0qf_11", Yo = "_navLink_1j0qf_25", ei = "_footerCopyright_1j0qf_36", ti = "_socialLinks_1j0qf_50", ai = "_social_1j0qf_50", ni = "_socialItem_1j0qf_58", oi = {
  footer: Qo,
  footerLogo: Ko,
  footerLinks: Zo,
  navLink: Yo,
  footerCopyright: ei,
  socialLinks: ti,
  social: ai,
  socialItem: ni
}, ii = ({
  Elements: { NavMenu: n, Text: o, Logo: t, SocialLinks: a },
  classes: i,
  pages: r,
  social_links: c,
  copyright_text: s,
  logo: _,
  menuItems: m
}) => /* @__PURE__ */ e("footer", { className: i.footer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-lg-2", children: /* @__PURE__ */ e("div", { className: i.footerLogo, children: /* @__PURE__ */ e(t, { pages: r, value: _ }) }) }),
  /* @__PURE__ */ l("div", { className: "col-lg-6  justify-content-lg-center  justify-content-start align-items-center", children: [
    /* @__PURE__ */ e(
      n,
      {
        onlyTopLevel: !0,
        pages: r,
        className: i.footerLinks,
        itemClass: i.navItem,
        itemActive: i.active,
        linkClass: i.navLink,
        menuItems: m
      }
    ),
    /* @__PURE__ */ e("div", { className: i.footerCopyright, children: /* @__PURE__ */ e(o, { tag: "p", value: s }) })
  ] }),
  /* @__PURE__ */ e("div", { className: "col-lg-4 d-flex justify-content-lg-center  justify-content-start", children: /* @__PURE__ */ e("div", { className: i.socialLinks, children: /* @__PURE__ */ e(
    a,
    {
      value: c,
      listClass: i.social,
      itemClass: i.socialItem
    }
  ) }) })
] }) }) }), li = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ii,
  meta: Jo,
  styles: oi
}, Symbol.toStringTag, { value: "Module" })), ri = "_buttonsWrapper_1rtos_132", ci = "_sectionContainer_1rtos_165", si = "_sectionHeader_1rtos_171", di = "_dash_1rtos_176", _i = "_galleryContainer_1rtos_187", mi = "_primaryButton_1rtos_201", ui = {
  buttonsWrapper: ri,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1rtos_138",
  "spaceAfter--small": "_spaceAfter--small_1rtos_141",
  "spaceAfter--medium": "_spaceAfter--medium_1rtos_144",
  sectionContainer: ci,
  sectionHeader: si,
  dash: di,
  galleryContainer: _i,
  primaryButton: mi
}, pi = {
  title: {
    type: d.TEXT,
    fieldId: 92,
    defaultValue: {
      default: "Our Work",
      ar: "اعمالنا"
    }
  },
  description: {
    type: d.TEXT,
    fieldId: 93,
    defaultValue: {
      default: "Browse through our collection of stunning images",
      ar: "أمثلة حيَّة رائعة لأعمالنا"
    }
  },
  primary_button: {
    type: d.LINK,
    fieldId: 215,
    defaultValue: {
      default: {
        destination: "external",
        // 'internal'
        target: "current",
        // 'new'
        text: "Start Now",
        pageId: "",
        href: "#"
      },
      ar: {
        destination: "external",
        // 'internal'
        target: "current",
        // 'new'
        text: "ابدا الان",
        pageId: "",
        href: "#"
      }
    }
  },
  images: {
    type: d.GROUP,
    defaultValue: [
      {
        image: {
          default: "https://images.unsplash.com/photo-1580118586709-50d0a0eea2cb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1268&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1580152040915-ad6ceeaeb8c1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1580142541272-4f6b7e815563?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2851&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1558981822-0c0c5b070026?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1268&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1580197370215-38fdb17dfe8f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1590&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1580124173799-934609852db8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80"
        }
      }
    ],
    values: {
      image: {
        type: d.TEXT,
        fieldId: 94
      }
    }
  }
}, vi = ({ Elements: { Image: n }, classes: o, image: t }) => /* @__PURE__ */ e("div", { className: o.item, children: /* @__PURE__ */ e("div", { className: o.imageContainer, children: /* @__PURE__ */ e(n, { className: o.itemImage, aspectRatio: "1:1", value: t }) }) }), fi = ({
  Elements: { RepeatedItems: n, Text: o, Button: t },
  classes: a,
  title: i,
  images: r,
  primary_button: c
}) => /* @__PURE__ */ e("section", { className: a.sectionContainer, children: /* @__PURE__ */ l("div", { className: "container", children: [
  /* @__PURE__ */ l("div", { className: a.sectionHeader, children: [
    /* @__PURE__ */ e("span", { className: a.dash }),
    /* @__PURE__ */ e(o, { tag: "h2", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: a.galleryContainer, children: /* @__PURE__ */ e(
    n,
    {
      classes: a,
      Component: vi,
      value: r
    }
  ) }),
  /* @__PURE__ */ e(t, { value: c, className: a.primaryButton })
] }) }), gi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fi,
  meta: pi,
  styles: ui
}, Symbol.toStringTag, { value: "Module" })), hi = "_heroLogo_1chsu_2", bi = "_social_1chsu_7", yi = "_socialItem_1chsu_12", $i = "_burger_1chsu_20", Ni = "_navMenu_1chsu_30", Ci = "_navLink_1chsu_30", xi = {
  heroLogo: hi,
  social: bi,
  socialItem: yi,
  burger: $i,
  navMenu: Ni,
  navLink: Ci
}, Ii = {
  logo: {
    type: d.LOGO,
    fieldId: 86,
    defaultValue: {
      default: {
        url: "https://assets.wuiltsite.com/defaults/evernote-logo.png",
        size: "medium"
      }
    }
  },
  languages: {
    source: w.UNIVERSAL,
    noProcessing: !0
  },
  pages: {
    type: d.NAV_MENU,
    source: w.UNIVERSAL
  },
  menuItems: {
    type: d.NAV_MENU,
    source: w.UNIVERSAL
  },
  phone: {
    type: d.LINK,
    fieldId: 82,
    defaultValue: {
      default: {
        destination: "external",
        target: "current",
        text: "01000200300",
        pageId: "",
        href: "tel:01000200300"
      }
    }
  },
  email: {
    type: d.LINK,
    fieldId: 83,
    defaultValue: {
      default: {
        destination: "external",
        target: "current",
        text: "info@company.com",
        pageId: "",
        href: "mailto:info@company.com"
      }
    }
  },
  email_icon: {
    type: d.ICON,
    fieldId: 88,
    defaultValue: {
      default: "envelope"
    }
  },
  phone_icon: {
    type: d.ICON,
    fieldId: 87,
    defaultValue: {
      default: "phone-square"
    }
  },
  socialLinks: {
    type: d.SOCIAL_LINKS,
    fieldId: 84,
    defaultValue: {
      default: {
        facebook: "#",
        twitter: "#",
        linkedin: "#"
      }
    }
  }
}, Ai = ({
  Elements: { DesktopMenu: n, MobileMenu: o, SocialLinks: t, LanguageSwitcher: a, Logo: i },
  classes: r,
  languages: c,
  pages: s,
  logo: _,
  socialLinks: m,
  menuItems: p,
  globalNavbarSettings: u
}) => {
  const { backgroundColor: v, navLinksColor: f } = u;
  return /* @__PURE__ */ l(
    "header",
    {
      style: {
        backgroundColor: v,
        padding: "20px 0px"
      },
      children: [
        /* @__PURE__ */ l("div", { className: "row mx-0 px-2 justify-content-between justify-content-lg-around", children: [
          /* @__PURE__ */ e("div", { className: "col-auto d-flex d-lg-none pl-0", children: /* @__PURE__ */ e(
            o,
            {
              className: r.mobileMenu,
              logo: _,
              pages: s,
              burgerClass: r.burger,
              languages: c,
              menuItems: p
            }
          ) }),
          /* @__PURE__ */ e("div", { className: "col-auto d-lg-flex d-none", children: /* @__PURE__ */ e(
            t,
            {
              value: m,
              listClass: r.social,
              itemClass: r.socialItem,
              navLinksColor: f
            }
          ) }),
          /* @__PURE__ */ e("div", { className: `col-auto d-flex ${r.logoContainer} `, children: /* @__PURE__ */ e(i, { pages: s, value: _, className: r.heroLogo }) }),
          /* @__PURE__ */ e("div", { className: "col-auto d-none d-lg-flex justify-content-center order-3 ", children: /* @__PURE__ */ e(a, { languages: c }) })
        ] }),
        /* @__PURE__ */ e("div", { className: "row mx-0 align-items-center justify-content-center ", children: /* @__PURE__ */ e("div", { className: "col-auto justify-content-center d-none d-lg-flex flex", children: /* @__PURE__ */ e(
          n,
          {
            className: `d-none d-lg-flex ${r.navMenu}`,
            itemClass: r.navItem,
            itemActive: r.naveItemActive,
            linkClass: r.navLink,
            pages: s,
            menuItems: p,
            navLinksColor: f
          }
        ) }) })
      ]
    }
  );
}, Si = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ai,
  meta: Ii,
  styles: xi
}, Symbol.toStringTag, { value: "Module" })), ki = {
  title: {
    type: d.TEXT,
    fieldId: 40,
    defaultValue: {
      default: "Page Title",
      ar: "عنوان الصفحة"
    }
  },
  image: {
    type: d.IMAGE,
    fieldId: 41,
    defaultValue: {
      default: "https://assets.wuiltsite.com/_damas/damas_hero_bg.jpg"
    }
  }
}, ji = "_background_7p6b1_1", wi = "_content_7p6b1_6 container", Mi = {
  background: ji,
  content: wi
}, Wi = ({ Elements: { Text: n }, classes: o, title: t }) => /* @__PURE__ */ e("div", { className: o.background, children: /* @__PURE__ */ e("div", { className: o.content, children: /* @__PURE__ */ e(n, { tag: "h1", value: t }) }) }), Ei = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wi,
  meta: ki,
  styles: Mi
}, Symbol.toStringTag, { value: "Module" })), Ti = "_hero_1h1m9_1", Li = "_heroContent_1h1m9_5", Oi = "_heroText_1h1m9_8", zi = "_buttonsContainer_1h1m9_25", Pi = "_primaryButton_1h1m9_34", Bi = "_secondaryButton_1h1m9_55", qi = "_imagesContainer_1h1m9_78", Hi = "_mainImg_1h1m9_84", Vi = "_image_1h1m9_78", Fi = "_subImg_1h1m9_95", Di = {
  hero: Ti,
  heroContent: Li,
  heroText: Oi,
  buttonsContainer: zi,
  primaryButton: Pi,
  secondaryButton: Bi,
  imagesContainer: qi,
  mainImg: Hi,
  image: Vi,
  subImg: Fi
}, Xi = {
  image: {
    type: d.IMAGE,
    fieldId: 96,
    defaultValue: {
      default: "https://assets.wuiltsite.com/_damas/hero_image_1.png"
    }
  },
  socialLinks: {
    type: d.SOCIAL_LINKS,
    fieldId: 84,
    defaultValue: {
      default: {
        facebook: "#",
        twitter: "#",
        linkedin: "#"
      }
    }
  },
  title: {
    type: d.TEXT,
    fieldId: 24,
    defaultValue: {
      default: "The Art of Beauty",
      ar: "الإبداع هو التفكير أعمق و بأكثر كفاءة"
    }
  },
  subtitle: {
    type: d.TEXT,
    fieldId: 25,
    defaultValue: {
      default: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
      ar: "عائد استثمار مرئي ونتائج مستمرة"
    }
  },
  primary_button: {
    type: d.LINK,
    fieldId: 26,
    defaultValue: {
      default: {
        destination: "external",
        target: "current",
        text: "Start Now",
        pageId: "",
        href: "#"
      },
      ar: {
        destination: "external",
        target: "current",
        text: "ابدا الان",
        pageId: "",
        href: "#"
      }
    }
  },
  secondary_button: {
    type: d.LINK,
    fieldId: 27,
    defaultValue: {
      default: {
        destination: "external",
        target: "current",
        text: "Get In Touch",
        pageId: "",
        href: "#"
      },
      ar: {
        destination: "external",
        target: "current",
        text: "تواصل معنا",
        pageId: "",
        href: "#"
      }
    }
  },
  cta_box_title: {
    type: d.TEXT,
    fieldId: 99,
    defaultValue: {
      default: "Learn about our services and join our community today",
      ar: "تعرف على خداماتنا وانضم إلى مجتمعنا اليوم"
    }
  },
  cta_box_subtitle: {
    type: d.TEXT,
    fieldId: 100,
    defaultValue: {
      default: "Feel free to reach out to us for a free consultation",
      ar: "لا تتردد أبدًا في التواصل معنا بشأن أيّ استشارة مجانية"
    }
  },
  foot_note: {
    type: d.TEXT,
    fieldId: 101,
    defaultValue: {
      default: "Learn about our services and join our community today",
      ar: "تقدّرنا بعض العلامات التجارية الكبرى في العالم بخدماتها"
    }
  },
  slideshow: {
    type: d.GROUP,
    values: {
      image: {
        type: d.IMAGE,
        fieldId: 16
      }
    },
    defaultValue: [
      {
        image: {
          default: "https://images.unsplash.com/photo-1516728043722-b394cb2f689e?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=c82882f6f384a30402cc75029d9e7b11&auto=format&fit=crop&w=550&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1494074734099-c4ec0c45687a?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=f18b2bf25abbaeddbe5ea1f9dae1ff85&auto=format&fit=crop&w=3150&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1516728043722-b394cb2f689e?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=c82882f6f384a30402cc75029d9e7b11&auto=format&fit=crop&w=550&q=80"
        }
      }
    ]
  }
}, Ri = ({
  classes: n,
  Elements: { Button: o, Text: t, Image: a },
  title: i,
  subtitle: r,
  primary_button: c,
  secondary_button: s,
  image: _
}) => /* @__PURE__ */ e("div", { className: n.hero, children: /* @__PURE__ */ e("div", { className: n.heroContent, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row mx-0", children: [
  /* @__PURE__ */ e("div", { className: "col-lg-6 ", children: /* @__PURE__ */ l("div", { className: n.heroText, children: [
    /* @__PURE__ */ e(t, { tag: "p", value: r }),
    /* @__PURE__ */ e(t, { tag: "h1", value: i }),
    /* @__PURE__ */ l("div", { className: n.buttonsContainer, children: [
      /* @__PURE__ */ e("div", { className: n.primaryButton, children: /* @__PURE__ */ e(o, { value: c }) }),
      /* @__PURE__ */ e("div", { className: n.secondaryButton, children: /* @__PURE__ */ e(o, { value: s }) })
    ] })
  ] }) }),
  /* @__PURE__ */ e("div", { className: "col-lg-6", children: /* @__PURE__ */ l("div", { className: n.imagesContainer, children: [
    /* @__PURE__ */ e("div", { className: n.mainImg, children: /* @__PURE__ */ e(
      a,
      {
        aspectRatio: "1:1.5",
        value: _,
        className: n.image
      }
    ) }),
    /* @__PURE__ */ e("div", { className: n.subImg, children: /* @__PURE__ */ e(
      "img",
      {
        src: "https://assets.wuiltsite.com/_damas/hero_image_1.png",
        alt: ""
      }
    ) })
  ] }) })
] }) }) }) }), Gi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ri,
  meta: Xi,
  styles: Di
}, Symbol.toStringTag, { value: "Module" })), Ui = "_buttonsWrapper_1u4ks_132", Ji = "_sectionContainer_1u4ks_165", Qi = "_sectionHeader_1u4ks_168", Ki = "_dash_1u4ks_173", Zi = "_productItem_1u4ks_184", Yi = "_containerImage_1u4ks_193", el = "_image_1u4ks_198", tl = "_itemText_1u4ks_201", al = "_sectionBtn_1u4ks_221", nl = {
  buttonsWrapper: Ui,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1u4ks_138",
  "spaceAfter--small": "_spaceAfter--small_1u4ks_141",
  "spaceAfter--medium": "_spaceAfter--medium_1u4ks_144",
  sectionContainer: Ji,
  sectionHeader: Qi,
  dash: Ki,
  productItem: Zi,
  containerImage: Yi,
  image: el,
  itemText: tl,
  sectionBtn: al
}, Y = {
  destination: "external",
  target: "current",
  text: "READ MORE",
  pageId: "",
  href: "#"
};
var ee = {
  destination: "external",
  target: "current",
  text: "المزيد",
  pageId: "",
  href: "#"
};
const ol = {
  section_title: {
    type: d.TEXT,
    fieldId: 133,
    defaultValue: {
      default: "Products",
      ar: "خدماتُنا"
    }
  },
  section_description: {
    type: d.TEXT,
    fieldId: 134,
    defaultValue: {
      default: "We offer top-notch services based on countless years of experience.",
      ar: "نمتلك خبرة طويلة في مجالنا، ولذلك نستطيع تقديم خدمات متميّزة لك."
    }
  },
  section_link: {
    type: d.LINK,
    fieldId: 140,
    defaultValue: {
      default: Y,
      ar: ee
    }
  },
  products: {
    type: d.GROUP,
    values: {
      product_title: {
        type: d.TEXT,
        fieldId: 135
      },
      product_description: {
        type: d.TEXT,
        fieldId: 136
      },
      product_image: {
        type: d.IMAGE,
        fieldId: 137
      },
      product_price: {
        type: d.TEXT,
        fieldId: 141
      },
      product_link1: {
        type: d.LINK,
        fieldId: 138
      },
      product_link2: {
        type: d.LINK,
        fieldId: 139
      }
    },
    defaultValue: [
      {
        product_title: {
          default: "SEM Marketing",
          ar: "التسويق عبر محركات البحث"
        },
        product_image: {
          default: "https://images.unsplash.com/photo-1516728043722-b394cb2f689e?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=c82882f6f384a30402cc75029d9e7b11&auto=format&fit=crop&w=550&q=80"
        },
        product_price: {
          default: "12 EGP"
        },
        product_description: {
          default: "We develop comprehensive PPC and SEO strategies. We’ll provide your AdWords account with continuous PPC support that is monitored to adapt to the evolving industry."
        },
        product_link1: {
          default: Y,
          ar: ee
        },
        product_link2: {
          default: Y,
          ar: ee
        }
      }
    ]
  }
};
function il(n) {
  const {
    Elements: { Text: o, Image: t },
    classes: a,
    product_image: i,
    product_title: r,
    product_description: c,
    product_price: s
  } = n;
  return /* @__PURE__ */ e("div", { className: a.productItem, children: /* @__PURE__ */ l("div", { className: "row w-100", children: [
    /* @__PURE__ */ e("div", { className: "col-lg-4", children: /* @__PURE__ */ e("div", { className: a.containerImage, children: /* @__PURE__ */ e(
      t,
      {
        value: i,
        className: a.image,
        aspectRatio: "1:1"
      }
    ) }) }),
    /* @__PURE__ */ e("div", { className: "col-lg-8", children: /* @__PURE__ */ l("div", { className: a.itemText, children: [
      /* @__PURE__ */ e(o, { tag: "h2", value: r }),
      /* @__PURE__ */ e(o, { tag: "p", value: c }),
      /* @__PURE__ */ e(o, { tag: "h4", value: s })
    ] }) })
  ] }) });
}
function ll(n) {
  const {
    Elements: { RepeatedItems: o, Button: t, Text: a },
    classes: i,
    section_title: r,
    section_link: c,
    products: s
  } = n;
  return /* @__PURE__ */ e("section", { className: "container", children: /* @__PURE__ */ l("div", { className: i.sectionContainer, children: [
    /* @__PURE__ */ l("div", { className: i.sectionHeader, children: [
      /* @__PURE__ */ e("span", { className: i.dash }),
      /* @__PURE__ */ e(a, { tag: "h2", value: r })
    ] }),
    /* @__PURE__ */ e(
      o,
      {
        classes: i,
        Component: il,
        value: s
      }
    ),
    /* @__PURE__ */ e(t, { value: c, className: i.sectionBtn })
  ] }) });
}
const rl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ll,
  meta: ol,
  styles: nl
}, Symbol.toStringTag, { value: "Module" })), cl = "_buttonsWrapper_3wqr0_132", sl = "_sectionContainer_3wqr0_165", dl = "_sectionHeader_3wqr0_170", _l = "_dash_3wqr0_175", ml = "_itemContainer_3wqr0_187", ul = "_imgContainer_3wqr0_194", pl = "_image_3wqr0_199", vl = "_btnContainer_3wqr0_202", fl = "_itemBtn_3wqr0_206", gl = {
  buttonsWrapper: cl,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_3wqr0_138",
  "spaceAfter--small": "_spaceAfter--small_3wqr0_141",
  "spaceAfter--medium": "_spaceAfter--medium_3wqr0_144",
  sectionContainer: sl,
  sectionHeader: dl,
  dash: _l,
  itemContainer: ml,
  imgContainer: ul,
  image: pl,
  btnContainer: vl,
  itemBtn: fl
}, te = {
  destination: "external",
  // 'internal'
  target: "current",
  // 'new'
  text: "READ MORE",
  pageId: "",
  href: "#"
}, ae = {
  destination: "external",
  target: "current",
  text: "المزيد",
  pageId: "",
  href: "#"
}, hl = {
  section_title: {
    type: d.TEXT,
    fieldId: 8,
    defaultValue: {
      default: "Our Services",
      ar: "خدماتُنا"
    }
  },
  section_short_description: {
    type: d.TEXT,
    fieldId: 9,
    defaultValue: {
      default: "We offer top-notch services based on countless years of experience.",
      ar: "نمتلك خبرة طويلة في مجالنا، ولذلك نستطيع تقديم خدمات متميّزة لك."
    }
  },
  section_image: {
    type: d.IMAGE,
    fieldId: 97,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1537646692914-61d73c4d6bad?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=b6e4b4359e874b7537c33c6ec1fe1a4d&auto=format&fit=crop&w=1500&q=80"
    }
  },
  services: {
    type: d.GROUP,
    values: {
      service_icon: { type: d.ICON, fieldId: 45 },
      service_image: { type: d.IMAGE, fieldId: 20 },
      service_title: { type: d.TEXT, fieldId: 10 },
      service_short_description: {
        type: d.TEXT,
        fieldId: 11
      },
      service_details_link: {
        type: d.LINK,
        fieldId: 28
      }
    },
    defaultValue: [
      {
        service_title: {
          default: "SEM Marketing",
          ar: "التسويق عبر محركات البحث"
        },
        service_image: {
          default: "https://images.unsplash.com/photo-1516728043722-b394cb2f689e?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=c82882f6f384a30402cc75029d9e7b11&auto=format&fit=crop&w=550&q=80"
        },
        service_icon: {
          default: "rocket"
        },
        service_short_description: {
          default: "We develop comprehensive PPC and SEO strategies. We’ll provide your AdWords account with continuous PPC support that is monitored to adapt to the evolving industry."
        },
        service_details_link: {
          default: te,
          ar: ae
        }
      },
      {
        service_title: {
          default: "Content Marketing",
          ar: "تسويق المحتوى"
        },
        service_icon: {
          default: "glass"
        },
        service_image: {
          default: "https://images.unsplash.com/photo-1496902526517-c0f2cb8fdb6a?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=8a8623f526569e949b73c4c7360d4532&auto=format&fit=crop&w=550&q=80"
        },
        service_short_description: {
          default: "Our writers are wordsmiths trained in creating quality content for all aspects of your brand. We’ll take care of your website copy, SEO articles, blog posts, whitepapers and more.",
          ar: ""
        },
        service_details_link: {
          default: te,
          ar: ae
        }
      },
      {
        service_title: {
          default: "Social Media Marketing",
          ar: "التسويق عبر وسائل التواصل الاجتماعي"
        },
        service_image: {
          default: "https://images.unsplash.com/photo-1519120126473-8be7aedcd6c6?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=a55332dfc236b13f118ef77a36b4052f&auto=format&fit=crop&w=550&q=80"
        },
        service_icon: {
          default: "tv"
        },
        service_short_description: {
          default: "Our team works to expand your social media presence by creating compelling content designed for you. boost your social media audience and develop a strong community around your brand."
        },
        service_details_link: {
          default: te,
          ar: ae
        }
      }
    ]
  }
}, bl = ({
  Elements: { Image: n, Button: o },
  classes: t,
  service_image: a,
  service_details_link: i
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 mb-4", children: /* @__PURE__ */ l("div", { className: t.itemContainer, children: [
  /* @__PURE__ */ e("div", { className: t.imgContainer, children: /* @__PURE__ */ e(
    n,
    {
      value: a,
      alt: "",
      aspectRatio: "1:1",
      className: t.image
    }
  ) }),
  /* @__PURE__ */ e("div", { className: t.btnContainer, children: /* @__PURE__ */ e(o, { value: i, className: t.itemBtn }) })
] }) }), yl = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  services: i
}) => /* @__PURE__ */ e("div", { className: t.sectionContainer, children: /* @__PURE__ */ l("div", { className: "container", children: [
  /* @__PURE__ */ l("div", { className: t.sectionHeader, children: [
    /* @__PURE__ */ e("span", { className: t.dash }),
    /* @__PURE__ */ e(o, { tag: "h2", value: a })
  ] }),
  /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: bl,
      value: i
    }
  ) }) })
] }) }), $l = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yl,
  meta: hl,
  styles: gl
}, Symbol.toStringTag, { value: "Module" })), _e = /* @__PURE__ */ Object.assign({ "./about/index.jsx": kn, "./contact-01/index.jsx": Gn, "./contact-02/index.jsx": vo, "./contact-03/index.jsx": wo, "./content-01/index.jsx": Po, "./content-02/index.jsx": Uo, "./footer/index.jsx": li, "./gallery/index.jsx": gi, "./header-home/index.jsx": Si, "./header/index.jsx": Ei, "./hero/index.jsx": Gi, "./product/index.jsx": rl, "./services/index.jsx": $l }), Nl = Object.keys(_e).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: _e[o] }),
  {}
), Cl = "_buttonsWrapper_hkdy6_132", xl = "_containerabout_hkdy6_165", Il = "_centerCol_hkdy6_170", Al = "_content_hkdy6_175", Sl = "_ImageStyle_hkdy6_181", kl = "_containerImage_hkdy6_186", jl = {
  buttonsWrapper: Cl,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_hkdy6_138",
  "spaceAfter--small": "_spaceAfter--small_hkdy6_141",
  "spaceAfter--medium": "_spaceAfter--medium_hkdy6_144",
  containerabout: xl,
  centerCol: Il,
  content: Al,
  ImageStyle: Sl,
  containerImage: kl
}, wl = {
  destination: "external",
  // 'internal'
  target: "current",
  // 'new'
  text: "READ MORE",
  pageId: "",
  href: "#"
}, Ml = {
  destination: "external",
  // 'internal'
  target: "current",
  // 'new'
  text: "المزيد",
  pageId: "",
  href: "#"
}, M = {
  section_title: {
    type: d.TEXT,
    fieldId: 17,
    defaultValue: {
      default: "About Us",
      ar: "من نحن"
    }
  },
  section_image: {
    type: d.IMAGE,
    fieldId: 19,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1483706571191-85c0c76b1947?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=79d169c2bf199ce6912f72c20ec301e4&auto=format&fit=crop&w=500&q=80"
    }
  },
  section_image2: {
    type: d.IMAGE,
    fieldId: 42,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1517502884422-41eaead166d4?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=3d8f17ce21e419f0ef0e90dfcbe19911&auto=format&fit=crop&w=500&q=80"
    }
  },
  section_content: {
    type: d.TEXT,
    fieldId: 18,
    defaultValue: {
      default: "Write about your businesses background, including your history, accomplishments and any awards you may have received. Use this section to show your brand’s personality.",
      ar: "اكتب خلفية عن أعمالك، بما في ذلك تاريخك، وإنجازاتك، وأي جوائز قد حصلت عليها. استخدم هذا القسم لعرض ملامح علامتك التجارية."
    }
  },
  section_action: {
    type: d.LINK,
    fieldId: 43,
    defaultValue: {
      default: wl,
      ar: Ml
    }
  }
}, Wl = ({
  Elements: { Text: n, Image: o, Button: t },
  classes: a,
  section_title: i,
  section_content: r,
  section_image: c,
  section_action: s
}) => /* @__PURE__ */ e("section", { className: `${a.containerabout} `, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: `${a.centerCol} col-md-6 `, children: /* @__PURE__ */ l("div", { className: a.content, children: [
    /* @__PURE__ */ e(n, { tag: "h2", value: i }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { tag: "p", value: r }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(t, { type: "Link", value: s })
  ] }) }),
  /* @__PURE__ */ e("div", { className: `${a.ImageStyle} col-md-6 `, children: /* @__PURE__ */ e("div", { className: a.containerImage, children: /* @__PURE__ */ e(o, { value: c }) }) })
] }) }) }), El = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wl,
  meta: M,
  styles: jl
}, Symbol.toStringTag, { value: "Module" })), Tl = "_buttonsWrapper_9tp8c_132", Ll = "_body_9tp8c_165", Ol = {
  buttonsWrapper: Tl,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_9tp8c_138",
  "spaceAfter--small": "_spaceAfter--small_9tp8c_141",
  "spaceAfter--medium": "_spaceAfter--medium_9tp8c_144",
  body: Ll
}, zl = ({
  Elements: { Text: n },
  classes: o,
  section_title: t,
  section_content: a
}) => /* @__PURE__ */ e("section", { className: `${o.containerAbout} `, children: /* @__PURE__ */ e("div", { className: o.body, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ l("div", { className: "col-md-5 offset-md-1", children: [
    /* @__PURE__ */ e(n, { tag: "h2", value: t }),
    /* @__PURE__ */ e("div", { className: o["spaceAfter--xSmall"] })
  ] }),
  /* @__PURE__ */ l("div", { className: "col-md-6", children: [
    /* @__PURE__ */ e(n, { tag: "p", value: a }),
    /* @__PURE__ */ e("div", { className: o["spaceAfter--xSmall"] })
  ] })
] }) }) }) }), Pl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zl,
  meta: M,
  styles: Ol
}, Symbol.toStringTag, { value: "Module" })), Bl = "_buttonsWrapper_1288g_132", ql = "_outerContainer_1288g_165", Hl = "_container_1288g_172", Vl = "_containerImage_1288g_176", Fl = "_imgWrapper_1288g_180", Dl = "_rowStyle_1288g_203", Xl = "_content_1288g_208", Rl = {
  buttonsWrapper: Bl,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1288g_138",
  "spaceAfter--small": "_spaceAfter--small_1288g_141",
  "spaceAfter--medium": "_spaceAfter--medium_1288g_144",
  outerContainer: ql,
  container: Hl,
  containerImage: Vl,
  imgWrapper: Fl,
  rowStyle: Dl,
  content: Xl
}, Gl = ({
  Elements: { Image: n, Text: o, Button: t },
  classes: a,
  section_title: i,
  section_content: r,
  section_image: c,
  section_action: s
}) => /* @__PURE__ */ l("section", { className: `${a.outerContainer} `, children: [
  /* @__PURE__ */ e("div", { className: a.containerImage, children: /* @__PURE__ */ e(n, { value: c, className: a.imgWrapper }) }),
  /* @__PURE__ */ e("div", { className: `${a.container} container`, children: /* @__PURE__ */ e("div", { className: `${a.rowStyle} row`, children: /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ l("div", { className: a.content, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: i }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(o, { tag: "p", value: r }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
    /* @__PURE__ */ e(t, { type: "Link", value: s })
  ] }) }) }) })
] }), Ul = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Gl,
  meta: M,
  styles: Rl
}, Symbol.toStringTag, { value: "Module" })), Jl = "_buttonsWrapper_1m7yl_132", Ql = "_containerabout_1m7yl_165", Kl = "_alignCenter_1m7yl_170", Zl = "_contentBox_1m7yl_174", Yl = {
  buttonsWrapper: Jl,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1m7yl_138",
  "spaceAfter--small": "_spaceAfter--small_1m7yl_141",
  "spaceAfter--medium": "_spaceAfter--medium_1m7yl_144",
  containerabout: Ql,
  alignCenter: Kl,
  contentBox: Zl
}, er = ({
  Elements: { Button: n, Text: o },
  classes: t,
  section_title: a,
  section_content: i,
  section_action: r
}) => /* @__PURE__ */ e("section", { className: `${t.containerabout}`, children: /* @__PURE__ */ e("div", { className: t.body, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: `row ${t.alignCenter}`, children: /* @__PURE__ */ e("div", { className: "col-md-10 col-lg-8", children: /* @__PURE__ */ e("div", { className: t.contentBox, children: /* @__PURE__ */ l("div", { className: t.content, children: [
  /* @__PURE__ */ e(o, { tag: "h2", value: a }),
  /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
  /* @__PURE__ */ e(o, { tag: "p", value: i }),
  /* @__PURE__ */ e("div", { className: t["spaceAfter--small"] }),
  /* @__PURE__ */ e(n, { type: "Primary", value: r })
] }) }) }) }) }) }) }), tr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: er,
  meta: M,
  styles: Yl
}, Symbol.toStringTag, { value: "Module" })), ar = "_buttonsWrapper_1sgv4_132", nr = "_containerabout_1sgv4_165", or = "_contentCol_1sgv4_169", ir = "_content_1sgv4_169", lr = "_btnStyle_1sgv4_183 btn", rr = "_ImageStyle_1sgv4_199", cr = "_containerImage_1sgv4_205", sr = "_firstImg_1sgv4_210", dr = "_block_1sgv4_219", _r = {
  buttonsWrapper: ar,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1sgv4_138",
  "spaceAfter--small": "_spaceAfter--small_1sgv4_141",
  "spaceAfter--medium": "_spaceAfter--medium_1sgv4_144",
  containerabout: nr,
  contentCol: or,
  content: ir,
  btnStyle: lr,
  ImageStyle: rr,
  containerImage: cr,
  firstImg: sr,
  block: dr
}, mr = ({
  Elements: { Text: n, Image: o, Button: t },
  classes: a,
  section_title: i,
  section_content: r,
  section_image: c,
  section_action: s
}) => /* @__PURE__ */ e("section", { className: `${a.containerabout} `, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: `${a.ImageStyle} col-md-6 `, children: /* @__PURE__ */ l("div", { className: a.containerImage, children: [
    /* @__PURE__ */ e("div", { className: a.block }),
    /* @__PURE__ */ e("div", { className: a.firstImg, children: /* @__PURE__ */ e(o, { value: c }) })
  ] }) }),
  /* @__PURE__ */ e("div", { className: `${a.contentCol} col-md-6 `, children: /* @__PURE__ */ l("div", { className: a.content, children: [
    /* @__PURE__ */ e(n, { tag: "h2", value: i }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { tag: "p", value: r }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
    /* @__PURE__ */ e(t, { type: "Primary", value: s })
  ] }) })
] }) }) }), ur = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mr,
  meta: M,
  styles: _r
}, Symbol.toStringTag, { value: "Module" })), pr = "_buttonsWrapper_1g9at_132", vr = "_container_1g9at_165", fr = "_content_1g9at_171", gr = {
  buttonsWrapper: pr,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1g9at_138",
  "spaceAfter--small": "_spaceAfter--small_1g9at_141",
  "spaceAfter--medium": "_spaceAfter--medium_1g9at_144",
  container: vr,
  content: fr
}, hr = ({
  Elements: { Text: n, Button: o },
  classes: t,
  section_title: a,
  section_content: i,
  section_action: r
}) => /* @__PURE__ */ e("section", { children: /* @__PURE__ */ e("div", { className: `${t.container} container`, children: /* @__PURE__ */ l("div", { className: t.content, children: [
  /* @__PURE__ */ e(n, { tag: "h2", value: a }),
  /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
  /* @__PURE__ */ e(n, { tag: "p", value: i }),
  /* @__PURE__ */ e("div", { className: t["spaceAfter--small"] }),
  /* @__PURE__ */ e(o, { type: "Link", value: r })
] }) }) }), br = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hr,
  meta: M,
  styles: gr
}, Symbol.toStringTag, { value: "Module" })), yr = "_buttonsWrapper_9dddm_132", $r = "_section_9dddm_165", Nr = "_content_9dddm_170", Cr = {
  buttonsWrapper: yr,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_9dddm_138",
  "spaceAfter--small": "_spaceAfter--small_9dddm_141",
  "spaceAfter--medium": "_spaceAfter--medium_9dddm_144",
  section: $r,
  content: Nr
}, xr = ({
  Elements: { Text: n, Button: o },
  classes: t,
  section_title: a,
  section_content: i,
  section_action: r
}) => /* @__PURE__ */ e("section", { className: t.section, children: /* @__PURE__ */ l("div", { className: `${t.content} container`, children: [
  /* @__PURE__ */ e(n, { tag: "h2", value: a }),
  /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
  /* @__PURE__ */ e(n, { tag: "p", value: i }),
  /* @__PURE__ */ e("div", { className: t["spaceAfter--small"] }),
  /* @__PURE__ */ e(o, { type: "Secondary", value: r })
] }) }), Ir = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xr,
  meta: M,
  styles: Cr
}, Symbol.toStringTag, { value: "Module" })), Ar = "_buttonsWrapper_197w3_132", Sr = "_container_197w3_165", kr = "_centerCol_197w3_169", jr = "_content_197w3_174", wr = "_imageCol_197w3_178", Mr = "_containerImage_197w3_183", Wr = "_secondImg_197w3_188", Er = "_boxStyle_197w3_197", Tr = {
  buttonsWrapper: Ar,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_197w3_138",
  "spaceAfter--small": "_spaceAfter--small_197w3_141",
  "spaceAfter--medium": "_spaceAfter--medium_197w3_144",
  container: Sr,
  centerCol: kr,
  content: jr,
  imageCol: wr,
  containerImage: Mr,
  secondImg: Wr,
  boxStyle: Er
}, Lr = ({
  Elements: { Text: n, Image: o, Button: t },
  classes: a,
  section_title: i,
  section_content: r,
  section_image: c,
  section_action: s
}) => /* @__PURE__ */ e("section", { className: le(a.container, "container"), children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: `${a.centerCol} col-md-6 `, children: /* @__PURE__ */ l("div", { className: a.content, children: [
    /* @__PURE__ */ e(n, { tag: "h2", value: i }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { tag: "p", value: r }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
    /* @__PURE__ */ e(t, { type: "Primary", value: s })
  ] }) }),
  /* @__PURE__ */ e("div", { className: `${a.imageCol} col-md-6 `, children: /* @__PURE__ */ l("div", { className: a.containerImage, children: [
    /* @__PURE__ */ e("div", { className: a.boxStyle }),
    /* @__PURE__ */ e("div", { className: a.secondImg, children: /* @__PURE__ */ e(o, { value: c }) })
  ] }) })
] }) }), Or = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Lr,
  meta: M,
  styles: Tr
}, Symbol.toStringTag, { value: "Module" })), zr = "_buttonsWrapper_1ojop_132", Pr = "_container_1ojop_165", Br = "_body_1ojop_169", qr = "_imageRow_1ojop_177", Hr = {
  buttonsWrapper: zr,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1ojop_138",
  "spaceAfter--small": "_spaceAfter--small_1ojop_141",
  "spaceAfter--medium": "_spaceAfter--medium_1ojop_144",
  container: Pr,
  body: Br,
  imageRow: qr
}, Vr = ({
  Elements: { Text: n, Button: o, Image: t },
  classes: a,
  section_title: i,
  section_content: r,
  section_action: c,
  section_image: s
}) => /* @__PURE__ */ l("section", { className: le("container", a.container), children: [
  /* @__PURE__ */ l("div", { className: a.body, children: [
    /* @__PURE__ */ e(n, { tag: "h2", value: i }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { tag: "p", value: r }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
    /* @__PURE__ */ e(o, { type: "Secondary", value: c }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] })
  ] }),
  /* @__PURE__ */ e("div", { className: `${a.imageRow} row`, children: /* @__PURE__ */ e("div", { className: "col-12 col-md-8", children: /* @__PURE__ */ e(t, { value: s }) }) })
] }), Fr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vr,
  meta: M,
  styles: Hr
}, Symbol.toStringTag, { value: "Module" })), Dr = "_buttonsWrapper_bvaj2_132", Xr = "_container_bvaj2_165", Rr = {
  buttonsWrapper: Dr,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_bvaj2_138",
  "spaceAfter--small": "_spaceAfter--small_bvaj2_141",
  "spaceAfter--medium": "_spaceAfter--medium_bvaj2_144",
  container: Xr
}, Gr = ({
  Elements: { Text: n, Button: o },
  classes: t,
  section_title: a,
  section_content: i,
  section_action: r
}) => /* @__PURE__ */ e("section", { className: t.container, children: /* @__PURE__ */ l("div", { className: t.content, children: [
  /* @__PURE__ */ e(n, { tag: "h2", value: a }),
  /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
  /* @__PURE__ */ e(n, { tag: "p", value: i }),
  /* @__PURE__ */ e("div", { className: t["spaceAfter--small"] }),
  /* @__PURE__ */ e(o, { type: "Primary", value: r })
] }) }), Ur = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Gr,
  meta: M,
  styles: Rr
}, Symbol.toStringTag, { value: "Module" })), Jr = "_buttonsWrapper_1r6c9_132", Qr = "_wrapper_1r6c9_165", Kr = "_section_1r6c9_169", Zr = "_content7grid_1r6c9_199", Yr = "_wnode33e4c0cdd70ab6116a24_1r6c9_216", ec = "_content7contentwrap_1r6c9_227", tc = "_size1text_1r6c9_250", ac = "_paragraph70_1r6c9_259", nc = "_wnode33e4c0cdd710b6116a24_1r6c9_266", oc = "_content7image_1r6c9_278", ic = {
  buttonsWrapper: Jr,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1r6c9_138",
  "spaceAfter--small": "_spaceAfter--small_1r6c9_141",
  "spaceAfter--medium": "_spaceAfter--medium_1r6c9_144",
  wrapper: Qr,
  section: Kr,
  "w-layout-grid": "_w-layout-grid_1r6c9_187",
  content7grid: Zr,
  wnode33e4c0cdd70ab6116a24: Yr,
  content7contentwrap: ec,
  size1text: tc,
  paragraph70: ac,
  wnode33e4c0cdd710b6116a24: nc,
  content7image: oc
}, lc = ({
  Elements: { Text: n, Image: o },
  classes: t,
  section_title: a,
  section_content: i,
  section_image: r
}) => /* @__PURE__ */ e("div", { className: t.wrapper, children: /* @__PURE__ */ e("div", { className: t.section, children: /* @__PURE__ */ l("div", { className: `${t["w-layout-grid"]} ${t.content7grid}`, children: [
  /* @__PURE__ */ l(
    "div",
    {
      className: `${t.wnode33e4c0cdd70ab6116a24} ${t.content7contentwrap}`,
      children: [
        /* @__PURE__ */ e(n, { tag: "h2", value: a, className: t.size1text }),
        /* @__PURE__ */ e(
          n,
          {
            tag: "p",
            value: i,
            className: t.paragraph70
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ e("div", { className: t.wnode33e4c0cdd710b6116a24, children: /* @__PURE__ */ e("div", { className: t.content7image, children: /* @__PURE__ */ e(o, { value: r }) }) })
] }) }) }), rc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lc,
  meta: M,
  styles: ic
}, Symbol.toStringTag, { value: "Module" })), cc = "_buttonsWrapper_1g9me_132", sc = "_container_1g9me_165", dc = "_centerCol_1g9me_170", _c = "_content_1g9me_175", mc = "_ImageStyle_1g9me_186", uc = "_containerImage_1g9me_191", pc = {
  buttonsWrapper: cc,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1g9me_138",
  "spaceAfter--small": "_spaceAfter--small_1g9me_141",
  "spaceAfter--medium": "_spaceAfter--medium_1g9me_144",
  container: sc,
  centerCol: dc,
  content: _c,
  ImageStyle: mc,
  containerImage: uc
}, vc = ({
  Elements: { Text: n, Image: o, Button: t },
  classes: a,
  section_title: i,
  section_content: r,
  section_image: c,
  section_action: s
}) => /* @__PURE__ */ e("section", { className: a.container, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: `${a.ImageStyle} col-md-6 `, children: /* @__PURE__ */ e("div", { className: a.containerImage, children: /* @__PURE__ */ e(o, { value: c }) }) }),
  /* @__PURE__ */ e("div", { className: `${a.centerCol} col-md-6 `, children: /* @__PURE__ */ l("div", { className: a.content, children: [
    /* @__PURE__ */ e(n, { tag: "h2", value: i }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { tag: "p", value: r }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
    /* @__PURE__ */ e(t, { type: "Link", value: s })
  ] }) })
] }) }) }), fc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vc,
  meta: M,
  styles: pc
}, Symbol.toStringTag, { value: "Module" })), gc = "_buttonsWrapper_13zjn_132", hc = "_outerContainer_13zjn_165", bc = "_containerImage_13zjn_172", yc = "_imgWrapper_13zjn_176", $c = "_content_13zjn_194", Nc = {
  buttonsWrapper: gc,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_13zjn_138",
  "spaceAfter--small": "_spaceAfter--small_13zjn_141",
  "spaceAfter--medium": "_spaceAfter--medium_13zjn_144",
  outerContainer: hc,
  containerImage: bc,
  imgWrapper: yc,
  content: $c
}, Cc = ({
  Elements: { Image: n, Text: o, Button: t },
  classes: a,
  section_title: i,
  section_content: r,
  section_image: c,
  section_action: s
}) => /* @__PURE__ */ e("section", { className: a.outerContainer, children: /* @__PURE__ */ l("div", { className: `${a.rowStyle} row mx-0`, children: [
  /* @__PURE__ */ l("div", { className: "col-md-6", children: [
    /* @__PURE__ */ l("div", { className: a.content, children: [
      /* @__PURE__ */ e(o, { tag: "h2", value: i }),
      /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
      /* @__PURE__ */ e(o, { tag: "p", value: r }),
      /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
      /* @__PURE__ */ e(t, { type: "Primary", value: s })
    ] }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] })
  ] }),
  /* @__PURE__ */ e("div", { className: "col-md-6 px-0", children: /* @__PURE__ */ e("div", { className: a.containerImage, children: /* @__PURE__ */ e(n, { value: c, className: a.imgWrapper }) }) })
] }) }), xc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Cc,
  meta: M,
  styles: Nc
}, Symbol.toStringTag, { value: "Module" })), Ic = "_buttonsWrapper_qzmry_132", Ac = "_wrapper_qzmry_165", Sc = "_section_qzmry_169", kc = "_content7grid_qzmry_199", jc = "_wnode33e4c0cdd70ab6116a24_qzmry_216", wc = "_content7contentwrap_qzmry_228", Mc = "_size1text_qzmry_251", Wc = "_paragraph70_qzmry_260", Ec = "_wnode33e4c0cdd710b6116a24_qzmry_267", Tc = "_content7image_qzmry_278", Lc = {
  buttonsWrapper: Ic,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_qzmry_138",
  "spaceAfter--small": "_spaceAfter--small_qzmry_141",
  "spaceAfter--medium": "_spaceAfter--medium_qzmry_144",
  wrapper: Ac,
  section: Sc,
  "w-layout-grid": "_w-layout-grid_qzmry_187",
  content7grid: kc,
  wnode33e4c0cdd70ab6116a24: jc,
  content7contentwrap: wc,
  size1text: Mc,
  paragraph70: Wc,
  wnode33e4c0cdd710b6116a24: Ec,
  content7image: Tc
}, Oc = ({
  Elements: { Text: n, Image: o },
  classes: t,
  section_title: a,
  section_content: i,
  section_image: r
}) => /* @__PURE__ */ e("div", { className: t.wrapper, children: /* @__PURE__ */ e("div", { className: t.section, children: /* @__PURE__ */ l("div", { className: `${t["w-layout-grid"]} ${t.content7grid}`, children: [
  /* @__PURE__ */ l(
    "div",
    {
      className: `${t.wnode33e4c0cdd710b6116a24} ${t.content7contentwrap}`,
      children: [
        /* @__PURE__ */ e(n, { tag: "h2", value: a }),
        /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
        /* @__PURE__ */ e(n, { tag: "p", value: i })
      ]
    }
  ),
  /* @__PURE__ */ e("div", { className: t.wnode33e4c0cdd70ab6116a24, children: /* @__PURE__ */ e(o, { value: r, className: `${t.content7image}` }) })
] }) }) }), zc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Oc,
  meta: M,
  styles: Lc
}, Symbol.toStringTag, { value: "Module" })), Pc = "_buttonsWrapper_f2kan_132", Bc = "_container_f2kan_165", qc = "_text_container_f2kan_176", Hc = {
  buttonsWrapper: Pc,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_f2kan_138",
  "spaceAfter--small": "_spaceAfter--small_f2kan_141",
  "spaceAfter--medium": "_spaceAfter--medium_f2kan_144",
  container: Bc,
  text_container: qc
}, Vc = ({
  Elements: { Text: n, Button: o },
  classes: t,
  section_title: a,
  section_content: i,
  section_action: r
}) => /* @__PURE__ */ e("section", { className: t.container, children: /* @__PURE__ */ l("div", { className: `${t.text_container}`, children: [
  /* @__PURE__ */ e(n, { tag: "h2", value: a }),
  /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
  /* @__PURE__ */ e(n, { tag: "p", value: i }),
  /* @__PURE__ */ e("div", { className: t["spaceAfter--small"] }),
  /* @__PURE__ */ e(o, { type: "Primary", value: r })
] }) }), Fc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vc,
  meta: M,
  styles: Hc
}, Symbol.toStringTag, { value: "Module" })), me = /* @__PURE__ */ Object.assign({ "./0001/index.jsx": El, "./0002/index.jsx": Pl, "./0003/index.jsx": Ul, "./0004/index.jsx": tr, "./0005/index.jsx": ur, "./0006/index.jsx": br, "./0008/index.jsx": Ir, "./0009/index.jsx": Or, "./0010/index.jsx": Fr, "./0011/index.jsx": Ur, "./0012/index.jsx": rc, "./0013/index.jsx": fc, "./0014/index.jsx": xc, "./0015/index.jsx": zc, "./0016/index.jsx": Fc }), Dc = Object.keys(me).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: me[o] }),
  {}
), Xc = "_buttonsWrapper_14zk1_132", Rc = "_alignCenter_14zk1_165", Gc = "_callaction_14zk1_169", Uc = {
  buttonsWrapper: Xc,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_14zk1_138",
  "spaceAfter--small": "_spaceAfter--small_14zk1_141",
  "spaceAfter--medium": "_spaceAfter--medium_14zk1_144",
  alignCenter: Rc,
  callaction: Gc
}, Jc = {
  destination: "external",
  target: "current",
  text: "Call Us",
  pageId: "",
  href: "#"
}, Qc = {
  destination: "external",
  target: "current",
  text: "Email Us",
  pageId: "",
  href: "#"
}, Kc = {
  destination: "external",
  target: "current",
  text: "ابدا الان",
  pageId: "",
  href: "#"
}, Zc = {
  destination: "external",
  target: "current",
  text: "اعرف المزيد",
  pageId: "",
  href: "#"
}, D = {
  section_title: {
    type: d.TEXT,
    fieldId: 60,
    defaultValue: {
      default: "Get In Touch",
      ar: "كن مستعد لتجربة مميزة"
    }
  },
  section_description: {
    type: d.TEXT,
    fieldId: 61,
    defaultValue: {
      default: "We want to hear from you – feel free to reach out at anytime",
      ar: "كن مستعد لتجربة مميزة! كن مستعد لتجربة مميزة!"
    }
  },
  section_image: {
    type: d.IMAGE,
    fieldId: 62,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1537557436197-445104c17075?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=e22e833eb944c01d3a469d1777fe0769&auto=format&fit=crop&w=1500&q=80"
    }
  },
  section_icon: {
    type: d.ICON,
    fieldId: 71,
    defaultValue: {
      default: "heartbeat"
    }
  },
  section_button1: {
    type: d.LINK,
    fieldId: 63,
    defaultValue: {
      default: Jc,
      ar: Kc
    }
  },
  section_button2: {
    type: d.LINK,
    fieldId: 64,
    defaultValue: {
      default: Qc,
      ar: Zc
    }
  }
}, Yc = ({
  Elements: { Text: n, Button: o },
  classes: t,
  section_title: a,
  section_description: i,
  section_button1: r,
  section_button2: c
}) => /* @__PURE__ */ e("section", { children: /* @__PURE__ */ e("div", { className: t["services-body"], children: /* @__PURE__ */ e("div", { className: "container text-center", children: /* @__PURE__ */ e("div", { className: `row ${t.alignCenter}`, children: /* @__PURE__ */ e("div", { className: "col-md-10", children: /* @__PURE__ */ l("div", { className: t.callaction, children: [
  /* @__PURE__ */ e(n, { tag: "h2", value: a }),
  /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
  /* @__PURE__ */ e(n, { tag: "p", value: i }),
  /* @__PURE__ */ e("div", { className: t["spaceAfter--small"] }),
  /* @__PURE__ */ l("div", { className: t.buttonsWrapper, children: [
    /* @__PURE__ */ e(o, { type: "Secondary", value: c }),
    /* @__PURE__ */ e(o, { type: "Primary", value: r })
  ] })
] }) }) }) }) }) }), es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Yc,
  meta: D,
  styles: Uc
}, Symbol.toStringTag, { value: "Module" })), ts = "_buttonsWrapper_6iy90_132", as = "_bk_6iy90_165", ns = "_callaction_6iy90_169", os = {
  buttonsWrapper: ts,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_6iy90_138",
  "spaceAfter--small": "_spaceAfter--small_6iy90_141",
  "spaceAfter--medium": "_spaceAfter--medium_6iy90_144",
  bk: as,
  callaction: ns
}, is = ({
  Elements: { Text: n, Button: o },
  classes: t,
  section_title: a,
  section_description: i,
  section_button1: r,
  section_button2: c
}) => /* @__PURE__ */ e("section", { className: t.bk, children: /* @__PURE__ */ e("div", { className: t["services-body"], children: /* @__PURE__ */ e("div", { className: "container text-center", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-md-12", children: /* @__PURE__ */ l("div", { className: t.callaction, children: [
    /* @__PURE__ */ e(n, { tag: "h2", value: a }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { tag: "p", value: i }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--small"] }),
    /* @__PURE__ */ l("div", { className: t.buttonsWrapper, children: [
      /* @__PURE__ */ e(o, { type: "Secondary", value: c }),
      /* @__PURE__ */ e(o, { type: "Primary", value: r })
    ] })
  ] }) }),
  /* @__PURE__ */ e("div", { className: "col-md-1" })
] }) }) }) }), ls = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: is,
  meta: D,
  styles: os
}, Symbol.toStringTag, { value: "Module" })), rs = "_buttonsWrapper_1spsu_132", cs = "_bk_1spsu_165", ss = "_callaction_1spsu_169", ds = {
  buttonsWrapper: rs,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1spsu_138",
  "spaceAfter--small": "_spaceAfter--small_1spsu_141",
  "spaceAfter--medium": "_spaceAfter--medium_1spsu_144",
  bk: cs,
  callaction: ss,
  "service-item": "_service-item_1spsu_175"
}, _s = ({
  Elements: { Text: n, Button: o, Icon: t },
  classes: a,
  section_title: i,
  section_icon: r,
  section_button1: c,
  section_button2: s
}) => /* @__PURE__ */ e("section", { className: a.bk, children: /* @__PURE__ */ e("div", { className: a["services-body"], children: /* @__PURE__ */ e("div", { className: "container ", children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e("div", { className: "col-md-11", children: /* @__PURE__ */ e("div", { className: a.callaction, children: /* @__PURE__ */ e("div", { className: a["service-item"], children: /* @__PURE__ */ e("div", { className: a["service-container"], children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-md-1", children: /* @__PURE__ */ e(t, { value: r, alt: "" }) }),
  /* @__PURE__ */ e("div", { className: "col-md-5", children: /* @__PURE__ */ e("div", { className: a["member-title"], children: /* @__PURE__ */ e(n, { tag: "h2", value: i }) }) }),
  /* @__PURE__ */ l("div", { className: "col-md-6", children: [
    /* @__PURE__ */ e(o, { type: "Secondary", value: s }),
    /* @__PURE__ */ e(o, { type: "Primary", value: c })
  ] })
] }) }) }) }) }) }) }) }) }), ms = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _s,
  meta: D,
  styles: ds
}, Symbol.toStringTag, { value: "Module" })), us = "_buttonsWrapper_63o09_132", ps = "_section_63o09_165", vs = "_alignCenter_63o09_169", fs = "_callaction_63o09_173", gs = "_styleColumn_63o09_180", hs = "_overlay_63o09_186", bs = {
  buttonsWrapper: us,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_63o09_138",
  "spaceAfter--small": "_spaceAfter--small_63o09_141",
  "spaceAfter--medium": "_spaceAfter--medium_63o09_144",
  section: ps,
  alignCenter: vs,
  callaction: fs,
  styleColumn: gs,
  overlay: hs
}, ys = ({
  Elements: { BackgroundContainer: n, Text: o, Button: t },
  classes: a,
  section_title: i,
  section_description: r,
  section_image: c,
  section_button1: s
}) => /* @__PURE__ */ e("section", { className: a.section, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: `row ${a.alignCenter}`, children: /* @__PURE__ */ e("div", { className: "col-lg-10", children: /* @__PURE__ */ l(
  n,
  {
    value: c,
    className: a.callaction,
    children: [
      /* @__PURE__ */ e("div", { className: a.overlay }),
      /* @__PURE__ */ l("div", { className: "row", children: [
        /* @__PURE__ */ l("div", { className: "col-lg-7", children: [
          /* @__PURE__ */ e(o, { tag: "h2", value: i }),
          /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
          /* @__PURE__ */ e(o, { tag: "p", value: r }),
          /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] })
        ] }),
        /* @__PURE__ */ e("div", { className: "col-lg-2" }),
        /* @__PURE__ */ e("div", { className: `${a.styleColumn} col-lg-3`, children: /* @__PURE__ */ e(t, { type: "Secondary", value: s }) })
      ] })
    ]
  }
) }) }) }) }), $s = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ys,
  meta: D,
  styles: bs
}, Symbol.toStringTag, { value: "Module" })), Ns = "_buttonsWrapper_ch87r_132", Cs = "_section_ch87r_165", xs = "_content_ch87r_169", Is = {
  buttonsWrapper: Ns,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_ch87r_138",
  "spaceAfter--small": "_spaceAfter--small_ch87r_141",
  "spaceAfter--medium": "_spaceAfter--medium_ch87r_144",
  section: Cs,
  content: xs
}, As = ({
  Elements: { Text: n, Button: o },
  classes: t,
  section_title: a,
  section_description: i,
  section_button1: r
}) => /* @__PURE__ */ e("div", { className: t.section, children: /* @__PURE__ */ e("div", { className: `${t.content} container`, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ l("div", { className: "col-md-12", children: [
  /* @__PURE__ */ l("div", { children: [
    /* @__PURE__ */ e(n, { tag: "h2", value: a }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { tag: "p", value: i }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--small"] })
  ] }),
  /* @__PURE__ */ e(o, { type: "Secondary", value: r })
] }) }) }) }), Ss = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: As,
  meta: D,
  styles: Is
}, Symbol.toStringTag, { value: "Module" })), ks = "_buttonsWrapper_vpqtm_132", js = "_containerImage_vpqtm_165", ws = "_alignCenter_vpqtm_169", Ms = "_content_vpqtm_173", Ws = {
  buttonsWrapper: ks,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_vpqtm_138",
  "spaceAfter--small": "_spaceAfter--small_vpqtm_141",
  "spaceAfter--medium": "_spaceAfter--medium_vpqtm_144",
  containerImage: js,
  alignCenter: ws,
  content: Ms
}, Es = ({
  Elements: { Text: n, Button: o },
  classes: t,
  section_title: a,
  section_description: i,
  section_button1: r
}) => /* @__PURE__ */ e("section", { className: t.containerImage, children: /* @__PURE__ */ e("div", { className: `${t.content} container`, children: /* @__PURE__ */ e("div", { className: `row ${t.alignCenter}`, children: /* @__PURE__ */ l("div", { className: "col-md-8", children: [
  /* @__PURE__ */ e(n, { tag: "h2", value: a }),
  /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
  /* @__PURE__ */ e(n, { tag: "p", value: i }),
  /* @__PURE__ */ e("div", { className: t["spaceAfter--small"] }),
  /* @__PURE__ */ e(o, { type: "Primary", value: r })
] }) }) }) }), Ts = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Es,
  meta: D,
  styles: Ws
}, Symbol.toStringTag, { value: "Module" })), ue = /* @__PURE__ */ Object.assign({ "./0001/index.jsx": es, "./0003/index.jsx": ls, "./0004/index.jsx": ms, "./0005/index.jsx": $s, "./0006/index.jsx": Ss, "./0007/index.jsx": Ts }), Ls = Object.keys(ue).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: ue[o] }),
  {}
), Os = "_buttonsWrapper_dtyj1_132", zs = "_containerabout_dtyj1_165", Ps = "_centerCol_dtyj1_170", Bs = "_content_dtyj1_175", qs = "_servicetitle_dtyj1_180", Hs = "_ImageStyle_dtyj1_202", Vs = "_containerImage_dtyj1_207", Fs = {
  buttonsWrapper: Os,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_dtyj1_138",
  "spaceAfter--small": "_spaceAfter--small_dtyj1_141",
  "spaceAfter--medium": "_spaceAfter--medium_dtyj1_144",
  containerabout: zs,
  centerCol: Ps,
  content: Bs,
  servicetitle: qs,
  ImageStyle: Hs,
  containerImage: Vs
}, W = {
  title: {
    type: d.TEXT,
    fieldId: 22,
    defaultValue: {
      default: "A section for you to write about just anything",
      ar: "قسم لكي تكتب عن أي شيء"
    }
  },
  image: {
    type: d.IMAGE,
    fieldId: 21,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1483706571191-85c0c76b1947?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=79d169c2bf199ce6912f72c20ec301e4&auto=format&fit=crop&w=500&q=80"
    }
  },
  text: {
    type: d.TEXT,
    fieldId: 23,
    defaultValue: {
      default: "Need a place to add in your awards? This is it. Want to include more information about your products, history, or features? This is the spot for that. Use this content section for anything and everything.",
      ar: "هل تريد تضمين المزيد من المعلومات حول منتجاتك أو سجلك أو ميزاتك؟ هذا هو المكان المناسب لذلك. استخدم قسم المحتوى هذا لأي شيء وكل شيء."
    }
  }
}, Ds = ({
  Elements: { Text: n, Image: o },
  classes: t,
  title: a,
  text: i,
  image: r
}) => /* @__PURE__ */ e("section", { className: `${t.containerabout} `, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: `${t.centerCol} col-md-6 `, children: /* @__PURE__ */ l("div", { className: t.content, children: [
    /* @__PURE__ */ e("div", { className: t.servicetitle, children: /* @__PURE__ */ e(n, { tag: "h2", value: a }) }),
    /* @__PURE__ */ e("div", { className: t.servcedes, children: /* @__PURE__ */ e(n, { tag: "p", value: i }) })
  ] }) }),
  /* @__PURE__ */ e("div", { className: `${t.ImageStyle} col-md-6 `, children: /* @__PURE__ */ e("div", { className: t.containerImage, children: /* @__PURE__ */ e(o, { value: r }) }) })
] }) }) }), Xs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ds,
  meta: W,
  styles: Fs
}, Symbol.toStringTag, { value: "Module" })), Rs = "_buttonsWrapper_1f83h_132", Gs = "_outercontainer_1f83h_165", Us = "_servicetitle_1f83h_168", Js = "_aboutContent_1f83h_188", Qs = {
  buttonsWrapper: Rs,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1f83h_138",
  "spaceAfter--small": "_spaceAfter--small_1f83h_141",
  "spaceAfter--medium": "_spaceAfter--medium_1f83h_144",
  outercontainer: Gs,
  servicetitle: Us,
  aboutContent: Js
}, Ks = ({ Elements: { Text: n }, classes: o, title: t, text: a }) => /* @__PURE__ */ e("section", { className: `${o.containerabout} `, children: /* @__PURE__ */ e("div", { className: o.outercontainer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-md-1" }),
  /* @__PURE__ */ e("div", { className: "col-md-5", children: /* @__PURE__ */ e("div", { className: o.content, children: /* @__PURE__ */ e("div", { className: o.servicetitle, children: /* @__PURE__ */ e(n, { tag: "h2", value: t }) }) }) }),
  /* @__PURE__ */ e("div", { className: "col-md-5", children: /* @__PURE__ */ e("div", { className: o.servcedes, children: /* @__PURE__ */ e(n, { tag: "p", value: a }) }) }),
  /* @__PURE__ */ e("div", { className: "col-md-1" })
] }) }) }) }), Zs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ks,
  meta: W,
  styles: Qs
}, Symbol.toStringTag, { value: "Module" })), Ys = "_buttonsWrapper_1cicp_132", ed = "_outerContainer_1cicp_165", td = "_container_1cicp_170", ad = "_containerImage_1cicp_174", nd = "_imgWrapper_1cicp_178", od = "_rowStyle_1cicp_200", id = "_content_1cicp_205", ld = {
  buttonsWrapper: Ys,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1cicp_138",
  "spaceAfter--small": "_spaceAfter--small_1cicp_141",
  "spaceAfter--medium": "_spaceAfter--medium_1cicp_144",
  outerContainer: ed,
  container: td,
  containerImage: ad,
  imgWrapper: nd,
  rowStyle: od,
  content: id
}, rd = ({
  Elements: { Image: n, Text: o },
  classes: t,
  title: a,
  text: i,
  image: r
}) => /* @__PURE__ */ l("section", { className: `${t.outerContainer} `, children: [
  /* @__PURE__ */ e("div", { className: t.containerImage, children: /* @__PURE__ */ e(n, { value: r, className: t.imgWrapper }) }),
  /* @__PURE__ */ e("div", { className: `${t.container} container`, children: /* @__PURE__ */ e("div", { className: `${t.rowStyle} row`, children: /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ l("div", { className: t.content, children: [
    /* @__PURE__ */ e("div", { className: t.servicetitle, children: /* @__PURE__ */ e(o, { tag: "h2", value: a }) }),
    /* @__PURE__ */ e("div", { className: t.servcedes, children: /* @__PURE__ */ e(o, { tag: "p", value: i }) })
  ] }) }) }) })
] }), cd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rd,
  meta: W,
  styles: ld
}, Symbol.toStringTag, { value: "Module" })), sd = "_containerabout_1mxf6_1", dd = "_contentbox_1mxf6_6", _d = "_sectionContent_1mxf6_13", md = "_btn_1mxf6_19 btn", ud = {
  containerabout: sd,
  contentbox: dd,
  sectionContent: _d,
  btn: md
}, pd = ({ Elements: { Text: n }, classes: o, title: t, text: a }) => /* @__PURE__ */ e("section", { className: `${o.containerabout}`, children: /* @__PURE__ */ e("div", { className: o.body, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-md-8 offset-md-2", children: /* @__PURE__ */ e("div", { className: o.contentbox, children: /* @__PURE__ */ e("div", { className: o.content, children: /* @__PURE__ */ l("div", { className: o.contenttext, children: [
    /* @__PURE__ */ e("div", { className: o.servicetitle, children: /* @__PURE__ */ e(n, { tag: "h4", value: t }) }),
    /* @__PURE__ */ e("div", { className: o.sectionContent, children: /* @__PURE__ */ e(n, { tag: "p", value: a }) })
  ] }) }) }) }),
  /* @__PURE__ */ e("div", { className: "col-md-2" })
] }) }) }) }), vd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pd,
  meta: W,
  styles: ud
}, Symbol.toStringTag, { value: "Module" })), fd = "_buttonsWrapper_1m4cg_132", gd = "_containerabout_1m4cg_165", hd = "_contentCol_1m4cg_169", bd = "_content_1m4cg_169", yd = "_servicetitle_1m4cg_178", $d = "_ImageStyle_1m4cg_198", Nd = "_containerImage_1m4cg_204", Cd = "_firstImg_1m4cg_209", xd = "_block_1m4cg_218", Id = {
  buttonsWrapper: fd,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1m4cg_138",
  "spaceAfter--small": "_spaceAfter--small_1m4cg_141",
  "spaceAfter--medium": "_spaceAfter--medium_1m4cg_144",
  containerabout: gd,
  contentCol: hd,
  content: bd,
  servicetitle: yd,
  ImageStyle: $d,
  containerImage: Nd,
  firstImg: Cd,
  block: xd
}, Ad = ({ Elements: { Text: n, Image: o }, classes: t, title: a, text: i, image: r }) => /* @__PURE__ */ e("section", { className: `${t.containerabout} `, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: `${t.ImageStyle} col-md-6 `, children: /* @__PURE__ */ l("div", { className: t.containerImage, children: [
    /* @__PURE__ */ e("div", { className: t.block }),
    /* @__PURE__ */ e("div", { className: t.firstImg, children: /* @__PURE__ */ e(o, { value: r }) })
  ] }) }),
  /* @__PURE__ */ e("div", { className: `${t.contentCol} col-md-6 `, children: /* @__PURE__ */ l("div", { className: t.content, children: [
    /* @__PURE__ */ e("div", { className: t.servicetitle, children: /* @__PURE__ */ e(n, { tag: "h2", value: a }) }),
    /* @__PURE__ */ e("div", { className: t.servcedes, children: /* @__PURE__ */ e(n, { tag: "p", value: i }) })
  ] }) })
] }) }) }), Sd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ad,
  meta: W,
  styles: Id
}, Symbol.toStringTag, { value: "Module" })), kd = "_container_1tju9_1", jd = "_content_1tju9_7", wd = "_btn_1tju9_23 btn", Md = {
  container: kd,
  content: jd,
  btn: wd
}, Wd = ({ Elements: { Text: n }, classes: o, title: t, text: a }) => /* @__PURE__ */ e("section", { children: /* @__PURE__ */ e("div", { className: `${o.container} container`, children: /* @__PURE__ */ l("div", { className: o.content, children: [
  /* @__PURE__ */ e("div", { className: o.servicetitle, children: /* @__PURE__ */ e(n, { tag: "h2", value: t }) }),
  /* @__PURE__ */ e("div", { className: o.servcedes, children: /* @__PURE__ */ e(n, { tag: "p", value: a }) })
] }) }) }), Ed = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wd,
  meta: W,
  styles: Md
}, Symbol.toStringTag, { value: "Module" })), Td = "_section_1lquk_1", Ld = "_content_1lquk_6", Od = "_button_1lquk_21", zd = {
  section: Td,
  content: Ld,
  button: Od
}, Pd = ({ Elements: { Text: n }, classes: o, title: t, text: a }) => /* @__PURE__ */ e("section", { className: o.section, children: /* @__PURE__ */ l("div", { className: `${o.content} container`, children: [
  /* @__PURE__ */ e("div", { className: o.servicetitle, children: /* @__PURE__ */ e(n, { tag: "h2", value: t }) }),
  /* @__PURE__ */ e("div", { className: o.servcedes, children: /* @__PURE__ */ e(n, { tag: "p", value: a }) })
] }) }), Bd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Pd,
  meta: W,
  styles: zd
}, Symbol.toStringTag, { value: "Module" })), qd = "_containerabout_12n6z_1", Hd = "_centerCol_12n6z_5", Vd = "_content_12n6z_10", Fd = "_aboutbn_12n6z_32 btn", Dd = "_containerImage_12n6z_49", Xd = "_boxStyle_12n6z_53", Rd = "_secondImg_12n6z_67", Gd = {
  containerabout: qd,
  centerCol: Hd,
  content: Vd,
  aboutbn: Fd,
  containerImage: Dd,
  boxStyle: Xd,
  secondImg: Rd
}, Ud = ({
  Elements: { Text: n, Image: o },
  classes: t,
  title: a,
  text: i,
  image: r
}) => /* @__PURE__ */ e("section", { className: `${t.containerabout} `, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: `${t.centerCol} col-lg-6 mb-lg-0 mb-4`, children: /* @__PURE__ */ l("div", { className: t.content, children: [
    /* @__PURE__ */ e("div", { className: t.servicetitle, children: /* @__PURE__ */ e(n, { tag: "h2", value: a }) }),
    /* @__PURE__ */ e("div", { className: t.servcedes, children: /* @__PURE__ */ e(n, { tag: "p", value: i }) })
  ] }) }),
  /* @__PURE__ */ e("div", { className: "col-lg-6", children: /* @__PURE__ */ l("div", { className: t.containerImage, children: [
    /* @__PURE__ */ e("div", { className: t.boxStyle }),
    /* @__PURE__ */ e("div", { className: t.secondImg, children: /* @__PURE__ */ e(o, { value: r }) })
  ] }) })
] }) }) }), Jd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ud,
  meta: W,
  styles: Gd
}, Symbol.toStringTag, { value: "Module" })), Qd = "_buttonsWrapper_n7qm6_132", Kd = "_body_n7qm6_165", Zd = "_serviceTitle_n7qm6_168", Yd = "_aboutbn_n7qm6_194", e_ = "_imgMain_n7qm6_201", t_ = "_imageRow_n7qm6_205", a_ = {
  buttonsWrapper: Qd,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_n7qm6_138",
  "spaceAfter--small": "_spaceAfter--small_n7qm6_141",
  "spaceAfter--medium": "_spaceAfter--medium_n7qm6_144",
  body: Kd,
  serviceTitle: Zd,
  aboutbn: Yd,
  imgMain: e_,
  imageRow: t_
}, n_ = ({
  Elements: { Text: n, Image: o },
  classes: t,
  title: a,
  text: i,
  image: r
}) => /* @__PURE__ */ e("section", { className: `${t.containerabout} `, children: /* @__PURE__ */ e("div", { className: t.body, children: /* @__PURE__ */ l("div", { className: "container", children: [
  /* @__PURE__ */ l("div", { className: t.serviceTitle, children: [
    /* @__PURE__ */ e(n, { tag: "h2", value: a }),
    /* @__PURE__ */ e(n, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: `${t.imageRow} row`, children: /* @__PURE__ */ e("div", { className: "col-12 col-md-8", children: /* @__PURE__ */ e(o, { value: r }) }) })
] }) }) }), o_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: n_,
  meta: W,
  styles: a_
}, Symbol.toStringTag, { value: "Module" })), i_ = "_buttonsWrapper_1ogb3_132", l_ = "_sectioncontent_1ogb3_165", r_ = "_cont_1ogb3_169", c_ = "_contentsubtitle_1ogb3_178", s_ = "_divider_1ogb3_182", d_ = "_contentwrap_1ogb3_188", __ = "_paragraph_1ogb3_192", m_ = {
  buttonsWrapper: i_,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1ogb3_138",
  "spaceAfter--small": "_spaceAfter--small_1ogb3_141",
  "spaceAfter--medium": "_spaceAfter--medium_1ogb3_144",
  sectioncontent: l_,
  cont: r_,
  contentsubtitle: c_,
  divider: s_,
  contentwrap: d_,
  paragraph: __
}, u_ = ({ Elements: { Text: n }, classes: o, title: t, text: a }) => /* @__PURE__ */ e("section", { className: `${o.sectioncontent} `, children: /* @__PURE__ */ l("div", { className: o.cont, children: [
  /* @__PURE__ */ e("div", { children: /* @__PURE__ */ l("div", { className: o.contenttitle, children: [
    /* @__PURE__ */ e(n, { tag: "h2", value: t }),
    /* @__PURE__ */ e("div", { className: o.divider })
  ] }) }),
  /* @__PURE__ */ e("div", { className: o.contentwrap, children: /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(n, { className: o.paragraph, tag: "p", value: a }) }) })
] }) }), p_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: u_,
  meta: W,
  styles: m_
}, Symbol.toStringTag, { value: "Module" })), v_ = "_sectionContent_1wrwz_1", f_ = "_contentHeader_1wrwz_4", g_ = "_roundedImg_1wrwz_20", h_ = "_contentText_1wrwz_28", b_ = {
  sectionContent: v_,
  contentHeader: f_,
  roundedImg: g_,
  contentText: h_
}, y_ = ({
  Elements: { Text: n, Image: o },
  classes: t,
  title: a,
  image: i,
  text: r
}) => /* @__PURE__ */ e("section", { className: t.sectionContent, children: /* @__PURE__ */ l("div", { className: "container", children: [
  /* @__PURE__ */ l("div", { className: t.contentHeader, children: [
    /* @__PURE__ */ e(n, { tag: "h1", value: a }),
    " "
  ] }),
  /* @__PURE__ */ l("div", { className: "row", children: [
    /* @__PURE__ */ l("div", { className: "col-lg-6", children: [
      /* @__PURE__ */ e("div", { className: t.roundedImg, children: /* @__PURE__ */ e(o, { value: i }) }),
      /* @__PURE__ */ l("div", { className: "row mt-3", children: [
        /* @__PURE__ */ e("div", { className: "col-6 pr-2", children: /* @__PURE__ */ e(
          o,
          {
            aspectRatio: "1:1",
            value: i,
            className: t.roundedImg
          }
        ) }),
        /* @__PURE__ */ e("div", { className: "col-6 pl-2", children: /* @__PURE__ */ e(
          o,
          {
            aspectRatio: "1:1",
            value: i,
            className: t.roundedImg
          }
        ) }),
        " "
      ] })
    ] }),
    /* @__PURE__ */ l("div", { className: "col-lg-6 mt-lg-0 mt-4", children: [
      /* @__PURE__ */ l("div", { className: `${t.contentText} py-xl-3 py-1`, children: [
        /* @__PURE__ */ e(n, { tag: "h2", value: a }),
        /* @__PURE__ */ e(n, { tag: "p", value: r })
      ] }),
      /* @__PURE__ */ l("div", { className: `${t.contentText} py-xl-3 py-1`, children: [
        /* @__PURE__ */ e(n, { tag: "h2", value: a }),
        /* @__PURE__ */ e(n, { tag: "p", value: r })
      ] }),
      /* @__PURE__ */ l("div", { className: "pt-xl-3 pt-1", children: [
        /* @__PURE__ */ e(n, { tag: "h2", value: a }),
        /* @__PURE__ */ e(n, { tag: "p", value: r })
      ] })
    ] })
  ] })
] }) }), $_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: y_,
  meta: W,
  styles: b_
}, Symbol.toStringTag, { value: "Module" })), N_ = "_buttonsWrapper_15383_132", C_ = "_sectionContent_15383_165", x_ = "_contentText_15383_168", I_ = {
  buttonsWrapper: N_,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_15383_138",
  "spaceAfter--small": "_spaceAfter--small_15383_141",
  "spaceAfter--medium": "_spaceAfter--medium_15383_144",
  sectionContent: C_,
  contentText: x_
}, A_ = ({ Elements: { Text: n }, classes: o, text: t }) => /* @__PURE__ */ e("section", { className: o.sectionContent, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: o.contentText, children: [
  /* @__PURE__ */ e(n, { tag: "h2", value: t }),
  " "
] }) }) }), S_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: A_,
  meta: W,
  styles: I_
}, Symbol.toStringTag, { value: "Module" })), k_ = "_buttonsWrapper_1qx73_132", j_ = "_sectionContent_1qx73_165", w_ = "_contentText_1qx73_168", M_ = {
  buttonsWrapper: k_,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1qx73_138",
  "spaceAfter--small": "_spaceAfter--small_1qx73_141",
  "spaceAfter--medium": "_spaceAfter--medium_1qx73_144",
  sectionContent: j_,
  contentText: w_
}, W_ = ({ Elements: { Text: n }, classes: o, text: t }) => /* @__PURE__ */ e("section", { className: o.sectionContent, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: o.contentText, children: [
  /* @__PURE__ */ e(n, { tag: "p", value: t }),
  " "
] }) }) }), E_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: W_,
  meta: W,
  styles: M_
}, Symbol.toStringTag, { value: "Module" })), T_ = "_sectionContent_azffh_1", L_ = "_contentHeader_azffh_4", O_ = "_contentText_azffh_20", z_ = "_buttonsContainer_azffh_38", P_ = "_primaryButton_azffh_42", B_ = "_secondaryButton_azffh_52", q_ = {
  sectionContent: T_,
  contentHeader: L_,
  contentText: O_,
  buttonsContainer: z_,
  primaryButton: P_,
  secondaryButton: B_
}, H_ = ({
  Elements: { Text: n, Button: o },
  classes: t,
  title: a,
  text: i,
  primary_button: r,
  secondary_button: c
}) => /* @__PURE__ */ e("section", { className: t.sectionContent, children: /* @__PURE__ */ l("div", { className: "container", children: [
  /* @__PURE__ */ l("div", { className: t.contentHeader, children: [
    /* @__PURE__ */ e(n, { tag: "h1", value: a }),
    " "
  ] }),
  /* @__PURE__ */ e("div", { className: t.contentText, children: /* @__PURE__ */ e(n, { tag: "p", value: i }) }),
  /* @__PURE__ */ l("div", { className: t.buttonsContainer, children: [
    /* @__PURE__ */ e(o, { type: "Primary", value: r }),
    /* @__PURE__ */ e(o, { type: "Secondary", value: c })
  ] })
] }) }), V_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: H_,
  meta: W,
  styles: q_
}, Symbol.toStringTag, { value: "Module" })), pe = /* @__PURE__ */ Object.assign({ "./0001/index.jsx": Xs, "./0002/index.jsx": Zs, "./0003/index.jsx": cd, "./0004/index.jsx": vd, "./0005/index.jsx": Sd, "./0006/index.jsx": Ed, "./0007/index.jsx": Bd, "./0008/index.jsx": Jd, "./0009/index.jsx": o_, "./0011/index.jsx": p_, "./0012/index.jsx": $_, "./0013/index.jsx": S_, "./0014/index.jsx": E_, "./0015/index.jsx": V_ }), F_ = Object.keys(pe).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: pe[o] }),
  {}
), D_ = "_buttonsWrapper_1f1kh_132", X_ = "_container_1f1kh_165", R_ = "_intro_1f1kh_171", G_ = "_sectionDescription_1f1kh_176", U_ = "_sectionTitle_1f1kh_183", J_ = "_contactInfo_1f1kh_188", Q_ = "_infoItem_1f1kh_195", K_ = "_label_1f1kh_200", Z_ = "_icon_1f1kh_209", Y_ = "_text_1f1kh_221", em = "_field_1f1kh_232", tm = "_textareaField_1f1kh_238", am = "_actionContainer_1f1kh_242", nm = {
  buttonsWrapper: D_,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1f1kh_138",
  "spaceAfter--small": "_spaceAfter--small_1f1kh_141",
  "spaceAfter--medium": "_spaceAfter--medium_1f1kh_144",
  container: X_,
  intro: R_,
  sectionDescription: G_,
  sectionTitle: U_,
  contactInfo: J_,
  infoItem: Q_,
  label: K_,
  icon: Z_,
  text: Y_,
  field: em,
  textareaField: tm,
  actionContainer: am
};
function ve(n) {
  var a, i, r, c, s, _;
  const o = {};
  function t(m = "") {
    const p = `Content:${j()}`;
    return Object.assign(o, { [p]: m }), { textId: p, content: m };
  }
  return y(b({
    texts: o
  }, n), {
    formPostSubmit: y(b({}, n.formPostSubmit), {
      successMessage: t(
        (i = (a = n.formPostSubmit) == null ? void 0 : a.successMessage) == null ? void 0 : i.content
      ),
      failureMessage: t(
        (c = (r = n.formPostSubmit) == null ? void 0 : r.failureMessage) == null ? void 0 : c.content
      )
    }),
    formButton: b(b({}, n.formButton), t((s = n.formButton) == null ? void 0 : s.content)),
    fields: (_ = n.fields) == null ? void 0 : _.map((m) => {
      var p, u, v, f, h, g, N, I;
      return y(b({}, m), {
        settings: y(b({}, m.settings), {
          placeholder: t((u = (p = m == null ? void 0 : m.settings) == null ? void 0 : p.placeholder) == null ? void 0 : u.content),
          label: t((f = (v = m == null ? void 0 : m.settings) == null ? void 0 : v.label) == null ? void 0 : f.content),
          description: t((g = (h = m == null ? void 0 : m.settings) == null ? void 0 : h.description) == null ? void 0 : g.content),
          errorMessage: t((I = (N = m == null ? void 0 : m.settings) == null ? void 0 : N.errorMessage) == null ? void 0 : I.content)
        })
      });
    })
  });
}
const om = {
  formName: "Contact From",
  formPostSubmit: {
    submitType: "Message",
    failureMessage: { content: "Error, please try again!" },
    successMessage: {
      content: "Message sent successfully! We will contact you soon"
    }
  },
  formButton: {
    id: `Button:${j()}`,
    content: "Send",
    action: { type: "Submit" },
    design: {
      borderRadius: 10,
      size: "Large",
      type: "Primary"
    }
  },
  fields: [
    {
      id: `Field:${j()}`,
      type: "Text",
      settings: {
        placeholder: { content: "Name" },
        autoComplete: "Name"
      }
    },
    {
      id: `Field:${j()}`,
      type: "Email",
      settings: {
        placeholder: { content: "Email" },
        autoComplete: "Email"
      }
    },
    {
      id: `Field:${j()}`,
      type: "Phone",
      settings: {
        placeholder: { content: "Phone" },
        autoComplete: "Phone"
      }
    },
    {
      id: `Field:${j()}`,
      type: "TextArea",
      settings: {
        placeholder: { content: "Enter your message" },
        autoComplete: ""
      }
    }
  ],
  notifications: { emails: [] }
}, im = {
  formName: "تواصل معنا",
  formPostSubmit: {
    submitType: "Message",
    failureMessage: { content: "خطأ، حاول مرة اخرى!" },
    successMessage: {
      content: "شكرًا لك على التواصل معنا ، وسنوافيك بالرد في أسرع وقت ممكن"
    }
  },
  formButton: {
    id: `Button:${j()}`,
    content: "إرسال",
    action: { type: "Submit" },
    design: {
      borderRadius: 10,
      size: "Large",
      type: "Primary"
    }
  },
  fields: [
    {
      id: `Field:${j()}`,
      type: "Text",
      settings: {
        placeholder: { content: "الاسم" },
        autoComplete: "Name"
      }
    },
    {
      id: `Field:${j()}`,
      type: "Email",
      settings: {
        placeholder: { content: "البريد الإلكتروني" },
        autoComplete: "Email"
      }
    },
    {
      id: `Field:${j()}`,
      type: "Phone",
      settings: {
        placeholder: { content: "الهاتف" },
        autoComplete: "Phone"
      }
    },
    {
      id: `Field:${j()}`,
      type: "TextArea",
      settings: {
        placeholder: { content: "الرسالة" },
        autoComplete: ""
      }
    }
  ],
  notifications: {
    emails: []
  }
};
function k() {
  return {
    section_title: {
      type: d.TEXT,
      fieldId: 54,
      defaultValue: {
        default: "Contact Us",
        ar: "تواصل معنا"
      }
    },
    section_description: {
      type: d.TEXT,
      fieldId: 55,
      defaultValue: {
        default: "Our team is always available to assist you.",
        ar: "نحن هنا لللإجابة عن استفساراتك و تعليقاتك"
      }
    },
    form: {
      type: d.FORM,
      fieldId: 32,
      defaultValue: {
        default: ve(om),
        ar: ve(im)
      }
    },
    section_image: {
      type: d.IMAGE,
      fieldId: 56,
      defaultValue: {
        default: "https://images.unsplash.com/photo-1528260249572-a56fc30084ef?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=0189bb96e70b69a83c49f9e667ff1366&auto=format&fit=crop&w=375&q=80"
      }
    },
    map: {
      type: d.MAP,
      fieldId: 132,
      defaultValue: {
        default: {
          zoom: 15,
          marker: {
            location: {
              lat: 25.814004,
              lng: -80.126808
            }
          },
          mapType: "roadmap"
        }
      }
    },
    phone: {
      type: d.TEXT,
      fieldId: 57,
      defaultValue: {
        default: "1(800) - 374 - 990"
      }
    },
    email: {
      type: d.TEXT,
      fieldId: 58,
      defaultValue: {
        default: "info@business.com"
      }
    },
    address: {
      type: d.TEXT,
      fieldId: 59,
      defaultValue: {
        default: "301 W. 41st Street, Suite 501 Miami Beach, FL 33140",
        ar: "301 غرب شارع رقم 41 - وحدة 501 شاطئ ميامي - فلوريدا - الولايات المتحدة"
      }
    },
    email_icon: {
      type: d.ICON,
      fieldId: 75,
      defaultValue: {
        default: "envelope"
      }
    },
    phone_icon: {
      type: d.ICON,
      fieldId: 73,
      defaultValue: {
        default: "phone"
      }
    },
    address_icon: {
      type: d.ICON,
      fieldId: 77,
      defaultValue: {
        default: "map-marker"
      }
    },
    email_label: {
      type: d.TEXT,
      fieldId: 74,
      defaultValue: {
        default: "Email",
        ar: "البريد اللإلكتروني"
      }
    },
    phone_label: {
      type: d.TEXT,
      fieldId: 72,
      defaultValue: {
        default: "Phone",
        ar: "التليفون"
      }
    },
    address_label: {
      type: d.TEXT,
      fieldId: 76,
      defaultValue: {
        default: "Address",
        ar: "العنوان"
      }
    },
    social_label: {
      type: d.TEXT,
      fieldId: 98,
      defaultValue: {
        default: "Social Media",
        ar: "التواصل الاجتماعي"
      }
    },
    social_links: {
      type: d.SOCIAL_LINKS,
      fieldId: 78,
      defaultValue: {
        default: {
          facebook: "#",
          twitter: "#",
          linkedin: "#",
          instagram: "#",
          snapchat: "#"
        }
      }
    }
  };
}
const lm = ({
  Elements: { Icon: n, Form: o, Text: t },
  classes: a,
  section_title: i,
  section_description: r,
  address: c,
  address_label: s,
  address_icon: _,
  phone: m,
  phone_label: p,
  phone_icon: u,
  email: v,
  email_label: f,
  email_icon: h,
  form: g,
  sectionId: N
}) => /* @__PURE__ */ l("section", { className: a.container, children: [
  /* @__PURE__ */ l("div", { className: a.intro, children: [
    /* @__PURE__ */ e(t, { tag: "h2", className: a.sectionTitle, value: i }),
    /* @__PURE__ */ e(
      t,
      {
        tag: "p",
        className: a.sectionDescription,
        value: r
      }
    )
  ] }),
  /* @__PURE__ */ l("div", { className: a.contactInfo, children: [
    /* @__PURE__ */ l("div", { className: a.infoItem, children: [
      /* @__PURE__ */ e("div", { className: a.icon, children: /* @__PURE__ */ e(n, { value: h }) }),
      /* @__PURE__ */ l("div", { className: a.text, children: [
        /* @__PURE__ */ e(t, { className: a.label, tag: "h4", value: f }),
        /* @__PURE__ */ e(t, { tag: "p", value: v })
      ] })
    ] }),
    /* @__PURE__ */ l("div", { className: a.infoItem, children: [
      /* @__PURE__ */ e("div", { className: a.icon, children: /* @__PURE__ */ e(n, { value: u }) }),
      /* @__PURE__ */ l("div", { className: a.text, children: [
        /* @__PURE__ */ e(t, { className: a.label, tag: "h4", value: p }),
        /* @__PURE__ */ e(t, { tag: "p", value: m })
      ] })
    ] }),
    /* @__PURE__ */ l("div", { className: a.infoItem, children: [
      /* @__PURE__ */ e("div", { className: a.icon, children: /* @__PURE__ */ e(n, { value: _ }) }),
      /* @__PURE__ */ l("div", { className: a.text, children: [
        /* @__PURE__ */ e(t, { className: a.label, tag: "h4", value: s }),
        /* @__PURE__ */ e(t, { tag: "p", value: c })
      ] })
    ] })
  ] }),
  /* @__PURE__ */ e("div", { className: "formContainer", children: /* @__PURE__ */ e(
    o,
    {
      fieldContainerClass: "form-group",
      textareaClass: `form-control ${a.textareaField}`,
      textClass: `form-control ${a.textField}`,
      actionContainerClass: a.actionContainer,
      buttonClass: a.submitButton,
      sectionId: N,
      value: g
    }
  ) })
] }), rm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lm,
  meta: k,
  styles: nm
}, Symbol.toStringTag, { value: "Module" })), cm = "_buttonsWrapper_9q0km_132", sm = "_outerContainer_9q0km_165", dm = "_containerImage_9q0km_169", _m = "_intro_9q0km_188", mm = "_contactInfo_9q0km_201", um = "_infoItem_9q0km_209", pm = "_label_9q0km_214", vm = "_socialTitle_9q0km_224", fm = "_socialLinks_9q0km_231", gm = {
  buttonsWrapper: cm,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_9q0km_138",
  "spaceAfter--small": "_spaceAfter--small_9q0km_141",
  "spaceAfter--medium": "_spaceAfter--medium_9q0km_144",
  outerContainer: sm,
  containerImage: dm,
  intro: _m,
  contactInfo: mm,
  infoItem: um,
  label: pm,
  socialTitle: vm,
  socialLinks: fm
}, hm = ({
  Elements: { Text: n, Image: o, SocialLinks: t },
  classes: a,
  section_title: i,
  section_description: r,
  address: c,
  address_label: s,
  phone: _,
  phone_label: m,
  section_image: p,
  social_label: u,
  social_links: v
}) => /* @__PURE__ */ e("section", { className: a.outerContainer, children: /* @__PURE__ */ l("div", { className: "row mx-0", children: [
  /* @__PURE__ */ e("div", { className: "col-md-6 px-0", children: /* @__PURE__ */ e("div", { className: a.containerImage, children: /* @__PURE__ */ e(o, { value: p }) }) }),
  /* @__PURE__ */ l("div", { className: "col-md-6", children: [
    /* @__PURE__ */ l("div", { className: a.intro, children: [
      /* @__PURE__ */ e(n, { tag: "h2", value: i }),
      /* @__PURE__ */ e(n, { tag: "p", value: r })
    ] }),
    /* @__PURE__ */ l("div", { className: a.contactInfo, children: [
      /* @__PURE__ */ e("div", { className: a.infoItem, children: /* @__PURE__ */ l("div", { className: a.text, children: [
        /* @__PURE__ */ e(n, { className: a.label, tag: "h4", value: s }),
        /* @__PURE__ */ e(n, { tag: "p", value: c })
      ] }) }),
      /* @__PURE__ */ e("div", { className: a.infoItem, children: /* @__PURE__ */ l("div", { className: a.text, children: [
        /* @__PURE__ */ e(n, { className: a.label, tag: "h4", value: m }),
        /* @__PURE__ */ e(n, { tag: "p", value: _ })
      ] }) }),
      /* @__PURE__ */ e(n, { tag: "h4", className: a.socialTitle, value: u }),
      /* @__PURE__ */ e("div", { className: a.socialLinks, children: /* @__PURE__ */ e(t, { value: v }) })
    ] })
  ] })
] }) }), bm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hm,
  meta: k,
  styles: gm
}, Symbol.toStringTag, { value: "Module" })), ym = "_buttonsWrapper_1ow9k_132", $m = "_outerContainer_1ow9k_165", Nm = "_intro_1ow9k_170", Cm = "_sectionTitle_1ow9k_176", xm = "_contactInfo_1ow9k_180", Im = "_infoItem_1ow9k_187", Am = "_label_1ow9k_192", Sm = "_icon_1ow9k_197", km = "_text_1ow9k_209", jm = "_formStyle_1ow9k_229", wm = "_formContainer_1ow9k_233", Mm = "_field_1ow9k_239", Wm = "_textareaField_1ow9k_247", Em = "_actionContainer_1ow9k_251", Tm = "_socialLinks_1ow9k_256", Lm = {
  buttonsWrapper: ym,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1ow9k_138",
  "spaceAfter--small": "_spaceAfter--small_1ow9k_141",
  "spaceAfter--medium": "_spaceAfter--medium_1ow9k_144",
  outerContainer: $m,
  intro: Nm,
  sectionTitle: Cm,
  contactInfo: xm,
  infoItem: Im,
  label: Am,
  icon: Sm,
  text: km,
  formStyle: jm,
  formContainer: wm,
  field: Mm,
  textareaField: Wm,
  actionContainer: Em,
  socialLinks: Tm
}, Om = ({
  Elements: { SocialLinks: n, Icon: o, Form: t, Text: a },
  classes: i,
  section_title: r,
  address: c,
  address_label: s,
  address_icon: _,
  phone: m,
  phone_label: p,
  phone_icon: u,
  email: v,
  email_label: f,
  email_icon: h,
  social_links: g,
  sectionId: N,
  form: I
}) => /* @__PURE__ */ e("section", { className: i.outerContainer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ l("div", { className: "col-md-5", children: [
    /* @__PURE__ */ e("div", { className: i.intro, children: /* @__PURE__ */ e(
      a,
      {
        tag: "h2",
        className: i.sectionTitle,
        value: r
      }
    ) }),
    /* @__PURE__ */ l("div", { className: i.contactInfo, children: [
      /* @__PURE__ */ l("div", { className: i.infoItem, children: [
        /* @__PURE__ */ e("div", { className: i.icon, children: /* @__PURE__ */ e(o, { value: _ }) }),
        /* @__PURE__ */ l("div", { className: i.text, children: [
          /* @__PURE__ */ e(
            a,
            {
              className: i.label,
              tag: "h4",
              value: s
            }
          ),
          /* @__PURE__ */ e(a, { tag: "p", value: c })
        ] })
      ] }),
      /* @__PURE__ */ l("div", { className: i.infoItem, children: [
        /* @__PURE__ */ e("div", { className: i.icon, children: /* @__PURE__ */ e(o, { value: u }) }),
        /* @__PURE__ */ l("div", { className: i.text, children: [
          /* @__PURE__ */ e(a, { className: i.label, tag: "h4", value: p }),
          /* @__PURE__ */ e(a, { tag: "p", value: m })
        ] })
      ] }),
      /* @__PURE__ */ l("div", { className: i.infoItem, children: [
        /* @__PURE__ */ e("div", { className: i.icon, children: /* @__PURE__ */ e(o, { value: h }) }),
        /* @__PURE__ */ l("div", { className: i.text, children: [
          /* @__PURE__ */ e(a, { className: i.label, tag: "h4", value: f }),
          /* @__PURE__ */ e(a, { tag: "p", value: v })
        ] })
      ] }),
      /* @__PURE__ */ e("div", { className: i.socialLinks, children: /* @__PURE__ */ e(n, { value: g }) })
    ] })
  ] }),
  /* @__PURE__ */ e("div", { className: "col-md-1" }),
  /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ e("div", { className: i.formStyle, children: /* @__PURE__ */ e("div", { className: i.formContainer, children: /* @__PURE__ */ e(
    t,
    {
      fieldContainerClass: "form-group",
      textareaClass: `form-control ${i.textareaField}`,
      textClass: `form-control ${i.textField}`,
      actionContainerClass: i.actionContainer,
      buttonClass: i.submitButton,
      sectionId: N,
      value: I
    }
  ) }) }) })
] }) }) }), zm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Om,
  meta: k,
  styles: Lm
}, Symbol.toStringTag, { value: "Module" })), Pm = "_buttonsWrapper_h5u30_132", Bm = "_outerContainer_h5u30_165", qm = "_columnStyle_h5u30_170", Hm = "_imgConatiner_h5u30_176", Vm = "_intro_h5u30_185", Fm = "_contactInfo_h5u30_196", Dm = "_formContainer_h5u30_203", Xm = "_field_h5u30_207", Rm = "_textareaField_h5u30_221", Gm = "_actionContainer_h5u30_225", Um = "_socialLinks_h5u30_230", Jm = {
  buttonsWrapper: Pm,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_h5u30_138",
  "spaceAfter--small": "_spaceAfter--small_h5u30_141",
  "spaceAfter--medium": "_spaceAfter--medium_h5u30_144",
  outerContainer: Bm,
  columnStyle: qm,
  imgConatiner: Hm,
  intro: Vm,
  contactInfo: Fm,
  formContainer: Dm,
  field: Xm,
  textareaField: Rm,
  actionContainer: Gm,
  socialLinks: Um
}, Qm = ({
  Elements: { SocialLinks: n, Form: o, Text: t, Image: a },
  classes: i,
  section_title: r,
  section_image: c,
  section_description: s,
  form: _,
  social_links: m,
  sectionId: p
}) => /* @__PURE__ */ e("section", { className: i.outerContainer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ l("div", { className: "col-md-6", children: [
    /* @__PURE__ */ l("div", { className: i.intro, children: [
      /* @__PURE__ */ e(
        t,
        {
          tag: "h2",
          className: i.sectionTitle,
          value: r
        }
      ),
      /* @__PURE__ */ e(t, { tag: "p", value: s })
    ] }),
    /* @__PURE__ */ e("div", { className: i.formContainer, children: /* @__PURE__ */ e(
      o,
      {
        fieldContainerClass: "form-group",
        textareaClass: `form-control ${i.textareaField}`,
        textClass: `form-control ${i.textField}`,
        actionContainerClass: i.actionContainer,
        buttonClass: i.submitButton,
        sectionId: p,
        value: _
      }
    ) }),
    /* @__PURE__ */ e("div", { className: i.socialLinks, children: /* @__PURE__ */ e(n, { value: m }) })
  ] }),
  /* @__PURE__ */ e("div", { className: "col-md-1" }),
  /* @__PURE__ */ e("div", { className: `${i.columnStyle} col-md-5 `, children: /* @__PURE__ */ e("div", { className: i.imgConatiner, children: /* @__PURE__ */ e(a, { value: c }) }) })
] }) }) }), Km = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Qm,
  meta: k,
  styles: Jm
}, Symbol.toStringTag, { value: "Module" })), Zm = "_outerContainer_1thrt_1", Ym = "_containerImage_1thrt_4", eu = "_overlay_1thrt_20", tu = "_intro_1thrt_31", au = "_socialTitle_1thrt_50", nu = "_socialLinks_1thrt_55", ou = "_contactInfo_1thrt_81", iu = "_infoItem_1thrt_95", lu = "_label_1thrt_99", ru = "_text_1thrt_105", cu = "_icon_1thrt_116", su = {
  outerContainer: Zm,
  containerImage: Ym,
  overlay: eu,
  intro: tu,
  socialTitle: au,
  socialLinks: nu,
  contactInfo: ou,
  infoItem: iu,
  label: lu,
  text: ru,
  icon: cu
}, du = ({
  Elements: { Icon: n, Text: o, BackgroundContainer: t, SocialLinks: a },
  classes: i,
  section_title: r,
  section_description: c,
  address: s,
  address_label: _,
  phone: m,
  phone_label: p,
  email_label: u,
  email_icon: v,
  phone_icon: f,
  address_icon: h,
  email: g,
  section_image: N,
  social_label: I,
  social_links: B
}) => /* @__PURE__ */ e("section", { className: i.outerContainer, children: /* @__PURE__ */ l(
  t,
  {
    className: i.containerImage,
    value: N,
    children: [
      /* @__PURE__ */ e("div", { className: i.overlay }),
      /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
        /* @__PURE__ */ l("div", { className: "col-md-5 d-flex flex-column", children: [
          /* @__PURE__ */ l("div", { className: i.intro, children: [
            /* @__PURE__ */ e(o, { tag: "h2", value: r }),
            /* @__PURE__ */ e(o, { tag: "p", value: c })
          ] }),
          /* @__PURE__ */ e(
            o,
            {
              tag: "h4",
              className: i.socialTitle,
              value: I
            }
          ),
          /* @__PURE__ */ e("div", { className: i.socialLinks, children: /* @__PURE__ */ e(a, { value: B }) })
        ] }),
        /* @__PURE__ */ e("div", { className: "col-md-7 d-flex justify-content-end", children: /* @__PURE__ */ l("div", { className: i.contactInfo, children: [
          /* @__PURE__ */ l("div", { className: i.infoItem, children: [
            /* @__PURE__ */ e("div", { className: i.icon, children: /* @__PURE__ */ e(n, { value: h }) }),
            /* @__PURE__ */ l("div", { className: i.text, children: [
              /* @__PURE__ */ e(
                o,
                {
                  className: i.label,
                  tag: "h4",
                  value: _
                }
              ),
              /* @__PURE__ */ e(o, { tag: "p", value: s })
            ] })
          ] }),
          /* @__PURE__ */ l("div", { className: i.infoItem, children: [
            /* @__PURE__ */ e("div", { className: i.icon, children: /* @__PURE__ */ e(n, { value: f }) }),
            /* @__PURE__ */ l("div", { className: i.text, children: [
              /* @__PURE__ */ e(
                o,
                {
                  className: i.label,
                  tag: "h4",
                  value: p
                }
              ),
              /* @__PURE__ */ e(o, { tag: "p", value: m })
            ] })
          ] }),
          /* @__PURE__ */ l("div", { className: i.infoItem, children: [
            /* @__PURE__ */ e("div", { className: i.icon, children: /* @__PURE__ */ e(n, { value: v }) }),
            /* @__PURE__ */ l("div", { className: i.text, children: [
              /* @__PURE__ */ e(
                o,
                {
                  className: i.label,
                  tag: "h4",
                  value: u
                }
              ),
              /* @__PURE__ */ e(o, { tag: "p", value: g })
            ] })
          ] })
        ] }) })
      ] }) })
    ]
  }
) }), _u = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: du,
  meta: k,
  styles: su
}, Symbol.toStringTag, { value: "Module" })), mu = "_buttonsWrapper_13tmh_132", uu = "_outerContainer_13tmh_165", pu = "_intro_13tmh_171", vu = "_contactInfo_13tmh_193", fu = "_infoItem_13tmh_212", gu = "_label_13tmh_216", hu = "_text_13tmh_222", bu = "_icon_13tmh_233", yu = "_formContainer_13tmh_244", $u = "_field_13tmh_252", Nu = "_textareaField_13tmh_271", Cu = "_actionContainer_13tmh_275", xu = {
  buttonsWrapper: mu,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_13tmh_138",
  "spaceAfter--small": "_spaceAfter--small_13tmh_141",
  "spaceAfter--medium": "_spaceAfter--medium_13tmh_144",
  outerContainer: uu,
  intro: pu,
  contactInfo: vu,
  infoItem: fu,
  label: gu,
  text: hu,
  icon: bu,
  formContainer: yu,
  field: $u,
  textareaField: Nu,
  actionContainer: Cu
}, Iu = ({
  Elements: { Icon: n, Text: o, Form: t },
  classes: a,
  section_title: i,
  section_description: r,
  address: c,
  address_label: s,
  phone: _,
  phone_label: m,
  email_label: p,
  email_icon: u,
  phone_icon: v,
  address_icon: f,
  email: h,
  form: g,
  sectionId: N
}) => /* @__PURE__ */ e("section", { className: a.outerContainer, children: /* @__PURE__ */ l("div", { className: "container", children: [
  /* @__PURE__ */ l("div", { className: a.intro, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: i }),
    /* @__PURE__ */ e(o, { tag: "p", value: r })
  ] }),
  /* @__PURE__ */ l("div", { className: "row", children: [
    /* @__PURE__ */ e("div", { className: "col-md-6 d-flex flex-column align-items-center", children: /* @__PURE__ */ e("div", { className: a.formContainer, children: /* @__PURE__ */ e(
      t,
      {
        fieldContainerClass: "form-group",
        textareaClass: `form-control ${a.textareaField}`,
        textClass: `form-control ${a.textField}`,
        actionContainerClass: a.actionContainer,
        buttonClass: a.submitButton,
        sectionId: N,
        value: g
      }
    ) }) }),
    /* @__PURE__ */ e(
      "div",
      {
        className: `${a.columnStyle} col-md-5 d-flex align-items-baseline`,
        children: /* @__PURE__ */ l("div", { className: a.contactInfo, children: [
          /* @__PURE__ */ l("div", { className: a.infoItem, children: [
            /* @__PURE__ */ e("div", { className: a.icon, children: /* @__PURE__ */ e(n, { value: f }) }),
            /* @__PURE__ */ l("div", { className: a.text, children: [
              /* @__PURE__ */ e(
                o,
                {
                  className: a.label,
                  tag: "h4",
                  value: s
                }
              ),
              /* @__PURE__ */ e(o, { tag: "p", value: c })
            ] })
          ] }),
          /* @__PURE__ */ l("div", { className: a.infoItem, children: [
            /* @__PURE__ */ e("div", { className: a.icon, children: /* @__PURE__ */ e(n, { value: v }) }),
            /* @__PURE__ */ l("div", { className: a.text, children: [
              /* @__PURE__ */ e(o, { className: a.label, tag: "h4", value: m }),
              /* @__PURE__ */ e(o, { tag: "p", value: _ })
            ] })
          ] }),
          /* @__PURE__ */ l("div", { className: a.infoItem, children: [
            /* @__PURE__ */ e("div", { className: a.icon, children: /* @__PURE__ */ e(n, { value: u }) }),
            /* @__PURE__ */ l("div", { className: a.text, children: [
              /* @__PURE__ */ e(o, { className: a.label, tag: "h4", value: p }),
              /* @__PURE__ */ e(o, { tag: "p", value: h })
            ] })
          ] })
        ] })
      }
    )
  ] })
] }) }), Au = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Iu,
  meta: k,
  styles: xu
}, Symbol.toStringTag, { value: "Module" })), Su = "_outerContainer_54mu4_1", ku = "_intro_54mu4_6", ju = "_boxContentstyle_54mu4_25", wu = "_contactInfo_54mu4_31", Mu = "_infoItem_54mu4_41", Wu = "_label_54mu4_46", Eu = "_text_54mu4_52", Tu = "_icon_54mu4_63", Lu = "_formContainer_54mu4_74", Ou = "_field_54mu4_89", zu = "_textareaField_54mu4_98", Pu = "_actionContainer_54mu4_102", Bu = "_socialTitle_54mu4_108", qu = "_socialLinks_54mu4_115", Hu = {
  outerContainer: Su,
  intro: ku,
  boxContentstyle: ju,
  contactInfo: wu,
  infoItem: Mu,
  label: Wu,
  text: Eu,
  icon: Tu,
  formContainer: Lu,
  field: Ou,
  textareaField: zu,
  actionContainer: Pu,
  socialTitle: Bu,
  socialLinks: qu
}, Vu = ({
  Elements: { SocialLinks: n, Icon: o, Text: t, Form: a },
  classes: i,
  section_title: r,
  section_description: c,
  address: s,
  address_label: _,
  phone: m,
  phone_label: p,
  email_label: u,
  email_icon: v,
  phone_icon: f,
  address_icon: h,
  email: g,
  social_label: N,
  social_links: I,
  form: B,
  sectionId: Z
}) => /* @__PURE__ */ e("section", { className: i.outerContainer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ l("div", { className: "col-md-6 d-flex flex-column", children: [
    /* @__PURE__ */ l("div", { className: i.intro, children: [
      /* @__PURE__ */ e(t, { tag: "h2", value: r }),
      /* @__PURE__ */ e(t, { tag: "p", value: c })
    ] }),
    /* @__PURE__ */ e("div", { className: i.formContainer, children: /* @__PURE__ */ e(
      a,
      {
        fieldContainerClass: "form-group",
        textareaClass: `form-control ${i.textareaField}`,
        textClass: `form-control ${i.textField}`,
        actionContainerClass: i.actionContainer,
        buttonClass: i.submitButton,
        sectionId: Z,
        value: B
      }
    ) })
  ] }),
  /* @__PURE__ */ e("div", { className: "col-md-1 " }),
  /* @__PURE__ */ l("div", { className: "col-md-5 ", children: [
    /* @__PURE__ */ e("div", { className: i.boxContentstyle, children: /* @__PURE__ */ l("div", { className: i.contactInfo, children: [
      /* @__PURE__ */ l("div", { className: i.infoItem, children: [
        /* @__PURE__ */ e("div", { className: i.icon, children: /* @__PURE__ */ e(o, { value: h }) }),
        /* @__PURE__ */ l("div", { className: i.text, children: [
          /* @__PURE__ */ e(
            t,
            {
              className: i.label,
              tag: "h4",
              value: _
            }
          ),
          /* @__PURE__ */ e(t, { tag: "p", value: s })
        ] })
      ] }),
      /* @__PURE__ */ l("div", { className: i.infoItem, children: [
        /* @__PURE__ */ e("div", { className: i.icon, children: /* @__PURE__ */ e(o, { value: f }) }),
        /* @__PURE__ */ l("div", { className: i.text, children: [
          /* @__PURE__ */ e(
            t,
            {
              className: i.label,
              tag: "h4",
              value: p
            }
          ),
          /* @__PURE__ */ e(t, { tag: "p", value: m })
        ] })
      ] }),
      /* @__PURE__ */ l("div", { className: i.infoItem, children: [
        /* @__PURE__ */ e("div", { className: i.icon, children: /* @__PURE__ */ e(o, { value: v }) }),
        /* @__PURE__ */ l("div", { className: i.text, children: [
          /* @__PURE__ */ e(
            t,
            {
              className: i.label,
              tag: "h4",
              value: u
            }
          ),
          /* @__PURE__ */ e(t, { tag: "p", value: g })
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ l("div", { className: i.socialLinks, children: [
      /* @__PURE__ */ e(
        t,
        {
          tag: "h4",
          className: i.socialTitle,
          value: N
        }
      ),
      /* @__PURE__ */ e(n, { value: I })
    ] })
  ] })
] }) }) }), Fu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vu,
  meta: k,
  styles: Hu
}, Symbol.toStringTag, { value: "Module" })), Du = "_outerContainer_a37kk_1", Xu = "_intro_a37kk_7", Ru = "_sectionDescription_a37kk_22", Gu = "_sectionTitle_a37kk_28", Uu = "_contactInfo_a37kk_33", Ju = "_infoItem_a37kk_42", Qu = "_label_a37kk_55", Ku = "_sepretor_a37kk_61", Zu = "_icon_a37kk_69", Yu = "_text_a37kk_86", ep = "_formStyle_a37kk_104", tp = "_formContainer_a37kk_108", ap = "_field_a37kk_113", np = "_textField_a37kk_121 _field_a37kk_113", op = "_textareaField_a37kk_125 _field_a37kk_113", ip = "_actionContainer_a37kk_130", lp = "_socialTitle_a37kk_135", rp = "_socialLinks_a37kk_140", cp = {
  outerContainer: Du,
  intro: Xu,
  sectionDescription: Ru,
  sectionTitle: Gu,
  contactInfo: Uu,
  infoItem: Ju,
  label: Qu,
  sepretor: Ku,
  icon: Zu,
  text: Yu,
  formStyle: ep,
  formContainer: tp,
  field: ap,
  textField: np,
  textareaField: op,
  actionContainer: ip,
  socialTitle: lp,
  socialLinks: rp
}, sp = ({
  Elements: { Icon: n, Text: o, SocialLinks: t },
  classes: a,
  section_title: i,
  address: r,
  section_description: c,
  social_links: s,
  address_label: _,
  address_icon: m,
  phone: p,
  phone_label: u,
  phone_icon: v,
  email: f,
  email_label: h,
  email_icon: g,
  social_label: N
}) => /* @__PURE__ */ e("section", { className: a.outerContainer, children: /* @__PURE__ */ l("div", { className: "container", children: [
  /* @__PURE__ */ l("div", { className: "row", children: [
    /* @__PURE__ */ l("div", { className: a.intro, children: [
      /* @__PURE__ */ e(
        o,
        {
          tag: "h2",
          className: a.sectionTitle,
          value: i
        }
      ),
      /* @__PURE__ */ e(o, { tag: "p", value: c })
    ] }),
    /* @__PURE__ */ l("div", { className: a.contactInfo, children: [
      /* @__PURE__ */ e("div", { className: "col-md-4 d-flex", children: /* @__PURE__ */ l("div", { className: a.infoItem, children: [
        /* @__PURE__ */ e("div", { className: a.icon, children: /* @__PURE__ */ e(n, { value: m }) }),
        /* @__PURE__ */ l("div", { className: a.text, children: [
          /* @__PURE__ */ e(
            o,
            {
              className: a.label,
              tag: "h4",
              value: _
            }
          ),
          /* @__PURE__ */ e("div", { className: a.sepretor }),
          /* @__PURE__ */ e(o, { tag: "p", value: r })
        ] })
      ] }) }),
      /* @__PURE__ */ e("div", { className: "col-md-4 d-flex", children: /* @__PURE__ */ l("div", { className: a.infoItem, children: [
        /* @__PURE__ */ e("div", { className: a.icon, children: /* @__PURE__ */ e(n, { value: v }) }),
        /* @__PURE__ */ l("div", { className: a.text, children: [
          /* @__PURE__ */ e(o, { className: a.label, tag: "h4", value: u }),
          /* @__PURE__ */ e("div", { className: a.sepretor }),
          /* @__PURE__ */ e(o, { tag: "p", value: p })
        ] })
      ] }) }),
      /* @__PURE__ */ e("div", { className: "col-md-4 d-flex", children: /* @__PURE__ */ l("div", { className: a.infoItem, children: [
        /* @__PURE__ */ e("div", { className: a.icon, children: /* @__PURE__ */ e(n, { value: g }) }),
        /* @__PURE__ */ l("div", { className: a.text, children: [
          /* @__PURE__ */ e(o, { className: a.label, tag: "h4", value: h }),
          /* @__PURE__ */ e("div", { className: a.sepretor }),
          /* @__PURE__ */ e(o, { tag: "p", value: f })
        ] })
      ] }) })
    ] })
  ] }),
  /* @__PURE__ */ e(o, { tag: "h4", className: a.socialTitle, value: N }),
  /* @__PURE__ */ e("div", { className: a.socialLinks, children: /* @__PURE__ */ e(t, { value: s }) })
] }) }), dp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sp,
  meta: k,
  styles: cp
}, Symbol.toStringTag, { value: "Module" })), _p = "_section_1vg2a_1", mp = "_bkColor_1vg2a_5", up = "_intro_1vg2a_12", pp = "_boxRow_1vg2a_32", vp = "_contactInfo_1vg2a_41", fp = "_sepretor_1vg2a_52", gp = "_infoItem_1vg2a_59", hp = "_label_1vg2a_64", bp = "_text_1vg2a_70", yp = "_icon_1vg2a_81", $p = "_socialTitle_1vg2a_92", Np = "_socialLinks_1vg2a_97", Cp = "_formContainer_1vg2a_122", xp = "_field_1vg2a_138", Ip = "_textareaField_1vg2a_148", Ap = "_actionContainer_1vg2a_152", Sp = {
  section: _p,
  bkColor: mp,
  intro: up,
  boxRow: pp,
  contactInfo: vp,
  sepretor: fp,
  infoItem: gp,
  label: hp,
  text: bp,
  icon: yp,
  socialTitle: $p,
  socialLinks: Np,
  formContainer: Cp,
  field: xp,
  textareaField: Ip,
  actionContainer: Ap
}, kp = ({
  Elements: { SocialLinks: n, Icon: o, Text: t, Form: a },
  classes: i,
  section_title: r,
  section_description: c,
  address: s,
  address_label: _,
  phone: m,
  phone_label: p,
  email_label: u,
  email_icon: v,
  phone_icon: f,
  address_icon: h,
  email: g,
  social_label: N,
  form: I,
  social_links: B,
  sectionId: Z
}) => /* @__PURE__ */ l("div", { className: i.section, children: [
  /* @__PURE__ */ e("div", { className: i.bkColor, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
    /* @__PURE__ */ e("div", { className: "col-md-8", children: /* @__PURE__ */ l("div", { className: i.intro, children: [
      /* @__PURE__ */ e(t, { tag: "h2", value: r }),
      /* @__PURE__ */ e(t, { tag: "p", value: c })
    ] }) }),
    /* @__PURE__ */ l("div", { className: "col-md-4 d-flex justify-content-center flex-column", children: [
      /* @__PURE__ */ e(
        t,
        {
          tag: "h4",
          className: i.socialTitle,
          value: N
        }
      ),
      /* @__PURE__ */ e("div", { className: i.socialLinks, children: /* @__PURE__ */ e(n, { value: B }) })
    ] })
  ] }) }) }),
  /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e("div", { className: "col-md-12 d-flex", children: /* @__PURE__ */ e("div", { className: i.boxRow, children: /* @__PURE__ */ l("div", { className: "row", children: [
    /* @__PURE__ */ e("div", { className: "col-md-6 d-flex flex-column", children: /* @__PURE__ */ e("div", { className: i.formContainer, children: /* @__PURE__ */ e(
      a,
      {
        fieldContainerClass: "form-group",
        textareaClass: `form-control ${i.textareaField}`,
        textClass: `form-control ${i.textField}`,
        actionContainerClass: i.actionContainer,
        buttonClass: i.submitButton,
        sectionId: Z,
        value: I
      }
    ) }) }),
    /* @__PURE__ */ e("div", { className: "col-md-6 d-flex flex-column ", children: /* @__PURE__ */ l("div", { className: i.contactInfo, children: [
      /* @__PURE__ */ l("div", { className: i.infoItem, children: [
        /* @__PURE__ */ e("div", { className: i.icon, children: /* @__PURE__ */ e(o, { value: h }) }),
        /* @__PURE__ */ l("div", { className: i.text, children: [
          /* @__PURE__ */ e(
            t,
            {
              className: i.label,
              tag: "h4",
              value: _
            }
          ),
          /* @__PURE__ */ e(t, { tag: "p", value: s })
        ] })
      ] }),
      /* @__PURE__ */ l("div", { className: i.infoItem, children: [
        /* @__PURE__ */ e("div", { className: i.icon, children: /* @__PURE__ */ e(o, { value: f }) }),
        /* @__PURE__ */ l("div", { className: i.text, children: [
          /* @__PURE__ */ e(
            t,
            {
              className: i.label,
              tag: "h4",
              value: p
            }
          ),
          /* @__PURE__ */ e(t, { tag: "p", value: m })
        ] })
      ] }),
      /* @__PURE__ */ l("div", { className: i.infoItem, children: [
        /* @__PURE__ */ e("div", { className: i.icon, children: /* @__PURE__ */ e(o, { value: v }) }),
        /* @__PURE__ */ l("div", { className: i.text, children: [
          /* @__PURE__ */ e(
            t,
            {
              className: i.label,
              tag: "h4",
              value: u
            }
          ),
          /* @__PURE__ */ e(t, { tag: "p", value: g })
        ] })
      ] })
    ] }) })
  ] }) }) }) }) })
] }), jp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kp,
  meta: k,
  styles: Sp
}, Symbol.toStringTag, { value: "Module" })), wp = "_buttonsWrapper_7zd69_132", Mp = "_contactUS_7zd69_165", Wp = "_container_7zd69_169", Ep = "_intro_7zd69_176", Tp = "_sectionDescription_7zd69_182", Lp = "_sectionTitle_7zd69_190", Op = "_contactInfo_7zd69_195", zp = "_alignCenter_7zd69_204", Pp = "_infoItem_7zd69_208", Bp = "_label_7zd69_215", qp = "_icon_7zd69_223", Hp = "_field_7zd69_243", Vp = "_textareaField_7zd69_252", Fp = "_actionContainer_7zd69_257", Dp = "_overlay_7zd69_262", Xp = {
  buttonsWrapper: wp,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_7zd69_138",
  "spaceAfter--small": "_spaceAfter--small_7zd69_141",
  "spaceAfter--medium": "_spaceAfter--medium_7zd69_144",
  contactUS: Mp,
  container: Wp,
  intro: Ep,
  sectionDescription: Tp,
  sectionTitle: Lp,
  contactInfo: Op,
  alignCenter: zp,
  infoItem: Pp,
  label: Bp,
  icon: qp,
  field: Hp,
  textareaField: Vp,
  actionContainer: Fp,
  overlay: Dp
}, Rp = ({
  Elements: { Icon: n, Form: o, Text: t },
  classes: a,
  section_title: i,
  section_description: r,
  address: c,
  address_icon: s,
  phone: _,
  phone_icon: m,
  email: p,
  email_icon: u,
  form: v,
  sectionId: f
}) => /* @__PURE__ */ e("div", { className: a.contactUS, children: /* @__PURE__ */ l("div", { className: a.container, children: [
  /* @__PURE__ */ l("div", { className: a.intro, children: [
    /* @__PURE__ */ e(t, { tag: "h2", className: a.sectionTitle, value: i }),
    /* @__PURE__ */ e(
      t,
      {
        tag: "p",
        className: a.sectionDescription,
        value: r
      }
    )
  ] }),
  /* @__PURE__ */ l("div", { className: a.contactInfo, children: [
    /* @__PURE__ */ l("div", { className: a.infoItem, children: [
      /* @__PURE__ */ e("div", { className: a.icon, children: /* @__PURE__ */ e(n, { value: m }) }),
      /* @__PURE__ */ e("div", { className: a.text, children: /* @__PURE__ */ e(t, { tag: "p", value: _ }) })
    ] }),
    /* @__PURE__ */ l("div", { className: a.infoItem, children: [
      /* @__PURE__ */ e("div", { className: a.icon, children: /* @__PURE__ */ e(n, { value: s }) }),
      /* @__PURE__ */ e("div", { className: a.text, children: /* @__PURE__ */ e(t, { tag: "p", value: c }) })
    ] }),
    /* @__PURE__ */ l("div", { className: a.infoItem, children: [
      /* @__PURE__ */ e("div", { className: a.icon, children: /* @__PURE__ */ e(n, { value: u }) }),
      /* @__PURE__ */ e("div", { className: a.text, children: /* @__PURE__ */ e(t, { tag: "p", value: p }) })
    ] })
  ] }),
  /* @__PURE__ */ e("div", { className: `row ${a.alignCenter}`, children: /* @__PURE__ */ e("div", { className: "col-md-10", children: /* @__PURE__ */ e("div", { className: "formContainer", children: /* @__PURE__ */ e(
    o,
    {
      fieldContainerClass: "form-group",
      textareaClass: `form-control ${a.textareaField}`,
      textClass: `form-control ${a.textField}`,
      actionContainerClass: a.actionContainer,
      buttonClass: a.submitButton,
      value: v,
      sectionId: f
    }
  ) }) }) })
] }) }), Gp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Rp,
  meta: k,
  styles: Xp
}, Symbol.toStringTag, { value: "Module" })), Up = "_buttonsWrapper_1htj6_132", Jp = "_outerContainer_1htj6_165", Qp = "_mapContainer_1htj6_177", Kp = "_map_1htj6_177", Zp = "_contentContainer_1htj6_200", Yp = "_intro_1htj6_209", ev = "_contactInfo_1htj6_225", tv = "_infoItem_1htj6_239", av = "_label_1htj6_244", nv = "_socialTitle_1htj6_254", ov = "_socialLinksContainer_1htj6_261", iv = "_socialLinks_1htj6_261", lv = "_socialLinkItem_1htj6_272", rv = {
  buttonsWrapper: Up,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1htj6_138",
  "spaceAfter--small": "_spaceAfter--small_1htj6_141",
  "spaceAfter--medium": "_spaceAfter--medium_1htj6_144",
  outerContainer: Jp,
  mapContainer: Qp,
  map: Kp,
  contentContainer: Zp,
  intro: Yp,
  contactInfo: ev,
  infoItem: tv,
  label: av,
  socialTitle: nv,
  socialLinksContainer: ov,
  socialLinks: iv,
  socialLinkItem: lv
}, cv = ({
  Elements: { Text: n, Map: o, SocialLinks: t },
  classes: a,
  section_title: i,
  section_description: r,
  address: c,
  address_label: s,
  phone: _,
  phone_label: m,
  map: p,
  social_label: u,
  social_links: v
}) => /* @__PURE__ */ l("section", { className: a.outerContainer, children: [
  /* @__PURE__ */ e("div", { className: a.mapContainer, children: /* @__PURE__ */ e(o, { className: a.map, value: p }) }),
  /* @__PURE__ */ l("div", { className: a.contentContainer, children: [
    /* @__PURE__ */ l("div", { className: a.intro, children: [
      /* @__PURE__ */ e(n, { tag: "h2", value: i }),
      /* @__PURE__ */ e(n, { tag: "p", value: r })
    ] }),
    /* @__PURE__ */ l("div", { className: a.contactInfo, children: [
      /* @__PURE__ */ e("div", { className: a.infoItem, children: /* @__PURE__ */ l("div", { className: a.text, children: [
        /* @__PURE__ */ e(n, { className: a.label, tag: "h4", value: s }),
        /* @__PURE__ */ e(n, { tag: "p", value: c })
      ] }) }),
      /* @__PURE__ */ e("div", { className: a.infoItem, children: /* @__PURE__ */ l("div", { className: a.text, children: [
        /* @__PURE__ */ e(n, { className: a.label, tag: "h4", value: m }),
        /* @__PURE__ */ e(n, { tag: "p", value: _ })
      ] }) }),
      /* @__PURE__ */ e(n, { tag: "h4", className: a.socialTitle, value: u }),
      /* @__PURE__ */ e("div", { className: a.socialLinksContainer, children: /* @__PURE__ */ e(
        t,
        {
          listClass: a.socialLinks,
          itemClass: a.socialLinkItem,
          value: v
        }
      ) })
    ] })
  ] })
] }), sv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cv,
  meta: k,
  styles: rv
}, Symbol.toStringTag, { value: "Module" })), dv = "_buttonsWrapper_gootw_132", _v = "_contactx00_gootw_165", mv = "_contactx01_gootw_168", uv = "_contactx02_gootw_175", pv = "_contactxmapbox_gootw_195", vv = "_contactxmap_gootw_195", fv = "_contactx03_gootw_215", gv = "_contactxinfo_gootw_233", hv = "_contactxtitle_gootw_233", bv = "_contactxitem_gootw_247", yv = "_contactx04_gootw_262", $v = "_textareaField_gootw_266", Nv = "_textField_gootw_278", Cv = "_fileUpload_gootw_385", xv = "_dateClass_gootw_392", Iv = "_timeClass_gootw_402", Av = "_selectBoxClass_gootw_412", Sv = {
  buttonsWrapper: dv,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_gootw_138",
  "spaceAfter--small": "_spaceAfter--small_gootw_141",
  "spaceAfter--medium": "_spaceAfter--medium_gootw_144",
  contactx00: _v,
  contactx01: mv,
  contactx02: uv,
  contactxmapbox: pv,
  contactxmap: vv,
  contactx03: fv,
  contactxinfo: gv,
  contactxtitle: hv,
  contactxitem: bv,
  contactx04: yv,
  textareaField: $v,
  textField: Nv,
  fileUpload: Cv,
  dateClass: xv,
  timeClass: Iv,
  selectBoxClass: Av
}, kv = ({
  Elements: { Map: n, Form: o, Text: t },
  classes: a,
  section_title: i,
  section_description: r,
  map: c,
  phone: s,
  phone_label: _,
  email: m,
  email_label: p,
  form: u,
  sectionId: v
}) => /* @__PURE__ */ e("section", { className: a.contactx00, children: /* @__PURE__ */ e("div", { className: a.contactx01, children: /* @__PURE__ */ l("div", { className: a.contactx02, children: [
  /* @__PURE__ */ e("div", { className: a.contactxmapbox, children: /* @__PURE__ */ e(n, { className: a.contactxmap, value: c }) }),
  /* @__PURE__ */ l("div", { className: a.contactx03, children: [
    /* @__PURE__ */ l("div", { className: a.contactxinfo, children: [
      /* @__PURE__ */ l("div", { className: a.contactxtitle, children: [
        /* @__PURE__ */ e(t, { tag: "h2", value: i }),
        /* @__PURE__ */ e(t, { tag: "p", value: r })
      ] }),
      /* @__PURE__ */ l("div", { children: [
        /* @__PURE__ */ l("div", { className: a.contactxitem, children: [
          /* @__PURE__ */ e(t, { tag: "h4", value: _ }),
          /* @__PURE__ */ e(t, { tag: "p", value: s })
        ] }),
        /* @__PURE__ */ l("div", { className: a.contactxitem, children: [
          /* @__PURE__ */ e(t, { tag: "h4", value: p }),
          /* @__PURE__ */ e(t, { tag: "p", value: m })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ e("div", { className: a.contactx04, children: /* @__PURE__ */ e(
      o,
      {
        fieldContainerClass: "form-group",
        textareaClass: `form-control ${a.textareaField}`,
        textClass: `form-control ${a.textField}`,
        buttonClass: a.submitButton,
        value: u,
        fileUploadClass: a.fileUpload,
        timeClass: a.timeClass,
        selectBoxClass: a.selectBoxClass,
        dateClass: a.dateClass,
        sectionId: v
      }
    ) })
  ] })
] }) }) }), jv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kv,
  meta: k,
  styles: Sv
}, Symbol.toStringTag, { value: "Module" })), wv = "_buttonsWrapper_1pl3r_132", Mv = "_outerContainer_1pl3r_165", Wv = "_sectionDescription_1pl3r_168", Ev = "_contactInfo_1pl3r_180", Tv = "_infoItem_1pl3r_180", Lv = "_icon_1pl3r_184", Ov = "_text_1pl3r_189", zv = "_socialLinks_1pl3r_198", Pv = "_social_1pl3r_198", Bv = "_socialItem_1pl3r_213", qv = {
  buttonsWrapper: wv,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1pl3r_138",
  "spaceAfter--small": "_spaceAfter--small_1pl3r_141",
  "spaceAfter--medium": "_spaceAfter--medium_1pl3r_144",
  outerContainer: Mv,
  sectionDescription: Wv,
  contactInfo: Ev,
  infoItem: Tv,
  icon: Lv,
  text: Ov,
  socialLinks: zv,
  social: Pv,
  socialItem: Bv
}, Hv = ({
  Elements: { SocialLinks: n, Icon: o, Text: t },
  classes: a,
  section_description: i,
  address: r,
  address_label: c,
  address_icon: s,
  phone: _,
  phone_label: m,
  phone_icon: p,
  email: u,
  email_label: v,
  email_icon: f,
  social_links: h,
  social_label: g
}) => /* @__PURE__ */ e("section", { className: a.outerContainer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-xl-5 col-lg-12 mb-xl-0 mb-4", children: /* @__PURE__ */ e(
    t,
    {
      tag: "p",
      value: i,
      className: a.sectionDescription
    }
  ) }),
  /* @__PURE__ */ e("div", { className: "col-xl-3 col-lg-6", children: /* @__PURE__ */ l("div", { className: a.contactInfo, children: [
    /* @__PURE__ */ l("div", { className: a.infoItem, children: [
      /* @__PURE__ */ e("div", { className: a.icon, children: /* @__PURE__ */ e(o, { value: s }) }),
      /* @__PURE__ */ l("div", { className: a.text, children: [
        /* @__PURE__ */ e(
          t,
          {
            className: a.label,
            tag: "h4",
            value: c
          }
        ),
        /* @__PURE__ */ e(t, { tag: "p", value: r })
      ] })
    ] }),
    /* @__PURE__ */ l("div", { className: a.infoItem, children: [
      /* @__PURE__ */ e("div", { className: a.icon, children: /* @__PURE__ */ e(o, { value: p }) }),
      /* @__PURE__ */ l("div", { className: a.text, children: [
        /* @__PURE__ */ e(t, { className: a.label, tag: "h4", value: m }),
        /* @__PURE__ */ e(t, { tag: "p", value: _ })
      ] })
    ] }),
    /* @__PURE__ */ l("div", { className: a.infoItem, children: [
      /* @__PURE__ */ e("div", { className: a.icon, children: /* @__PURE__ */ e(o, { value: f }) }),
      /* @__PURE__ */ l("div", { className: a.text, children: [
        /* @__PURE__ */ e(t, { className: a.label, tag: "h4", value: v }),
        /* @__PURE__ */ e(t, { tag: "p", value: u })
      ] })
    ] })
  ] }) }),
  /* @__PURE__ */ e("div", { className: "col-xl-4 col-lg-6", children: /* @__PURE__ */ l("div", { className: a.socialLinks, children: [
    /* @__PURE__ */ e(t, { tag: "h4", value: g }),
    /* @__PURE__ */ e(
      n,
      {
        value: h,
        listClass: a.social,
        itemClass: a.socialItem
      }
    )
  ] }) })
] }) }) }), Vv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hv,
  meta: k,
  styles: qv
}, Symbol.toStringTag, { value: "Module" })), Fv = "_buttonsWrapper_dnmi1_132", Dv = "_sectionContainer_dnmi1_165", Xv = "_mapContainer_dnmi1_168", Rv = "_map_dnmi1_168", Gv = "_contactInfo_dnmi1_187", Uv = "_info_dnmi1_211", Jv = "_contactFields_dnmi1_219", Qv = "_fieldsHeader_dnmi1_228", Kv = "_textField_dnmi1_240", Zv = "_textareaField_dnmi1_241", Yv = "_actionContainer_dnmi1_248", ef = {
  buttonsWrapper: Fv,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_dnmi1_138",
  "spaceAfter--small": "_spaceAfter--small_dnmi1_141",
  "spaceAfter--medium": "_spaceAfter--medium_dnmi1_144",
  sectionContainer: Dv,
  mapContainer: Xv,
  map: Rv,
  contactInfo: Gv,
  info: Uv,
  contactFields: Jv,
  fieldsHeader: Qv,
  textField: Kv,
  textareaField: Zv,
  actionContainer: Yv
}, tf = ({
  Elements: { Map: n, Form: o, Text: t },
  classes: a,
  section_title: i,
  section_description: r,
  map: c,
  phone: s,
  phone_label: _,
  email: m,
  email_label: p,
  address: u,
  address_label: v,
  form: f,
  sectionId: h
}) => /* @__PURE__ */ e("section", { children: /* @__PURE__ */ l("div", { className: a.sectionContainer, children: [
  /* @__PURE__ */ l("div", { className: a.mapContainer, children: [
    /* @__PURE__ */ e(n, { className: a.map, value: c }),
    /* @__PURE__ */ l("div", { className: a.contactInfo, children: [
      /* @__PURE__ */ l("div", { className: a.info, children: [
        /* @__PURE__ */ e(t, { tag: "h4", value: v }),
        /* @__PURE__ */ e(t, { tag: "p", value: u })
      ] }),
      /* @__PURE__ */ l("div", { className: a.info, children: [
        /* @__PURE__ */ e(t, { tag: "h4", value: _ }),
        /* @__PURE__ */ e(t, { tag: "p", value: s })
      ] }),
      /* @__PURE__ */ l("div", { className: a.info, children: [
        /* @__PURE__ */ e(t, { tag: "h4", value: p }),
        /* @__PURE__ */ e(t, { tag: "p", value: m })
      ] })
    ] })
  ] }),
  /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: a.contactFields, children: [
    /* @__PURE__ */ l("div", { className: a.fieldsHeader, children: [
      /* @__PURE__ */ e(t, { tag: "h2", value: i }),
      /* @__PURE__ */ e(t, { tag: "p", value: r })
    ] }),
    /* @__PURE__ */ e(
      o,
      {
        fieldContainerClass: "form-group",
        textareaClass: `form-control ${a.textareaField}`,
        textClass: `form-control ${a.textField}`,
        buttonClass: a.submitButton,
        actionContainerClass: a.actionContainer,
        sectionId: h,
        value: f
      }
    )
  ] }) })
] }) }), af = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tf,
  meta: k,
  styles: ef
}, Symbol.toStringTag, { value: "Module" })), nf = "_buttonsWrapper_9nbx8_132", of = "_sectionContainer_9nbx8_165", lf = "_contactFields_9nbx8_168", rf = "_fieldsHeader_9nbx8_172", cf = "_textField_9nbx8_181", sf = "_textareaField_9nbx8_182", df = "_contactInfo_9nbx8_188", _f = "_info_9nbx8_196", mf = "_social_9nbx8_207", uf = "_socialItem_9nbx8_213", pf = "_actionContainer_9nbx8_225", vf = {
  buttonsWrapper: nf,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_9nbx8_138",
  "spaceAfter--small": "_spaceAfter--small_9nbx8_141",
  "spaceAfter--medium": "_spaceAfter--medium_9nbx8_144",
  sectionContainer: of,
  contactFields: lf,
  fieldsHeader: rf,
  textField: cf,
  textareaField: sf,
  contactInfo: df,
  info: _f,
  social: mf,
  socialItem: uf,
  actionContainer: pf
}, ff = ({
  Elements: { Form: n, Text: o, SocialLinks: t },
  classes: a,
  section_title: i,
  section_description: r,
  phone: c,
  phone_label: s,
  email: _,
  email_label: m,
  address: p,
  address_label: u,
  form: v,
  social_label: f,
  social_links: h,
  sectionId: g
}) => /* @__PURE__ */ e("section", { className: "container", children: /* @__PURE__ */ e("div", { className: a.sectionContainer, children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-lg-6", children: /* @__PURE__ */ l("div", { className: a.contactFields, children: [
    /* @__PURE__ */ l("div", { className: a.fieldsHeader, children: [
      /* @__PURE__ */ e(o, { tag: "h2", value: i }),
      /* @__PURE__ */ e(o, { tag: "p", value: r })
    ] }),
    /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(
      n,
      {
        fieldContainerClass: "form-group",
        textareaClass: `form-control ${a.textareaField}`,
        textClass: `form-control ${a.textField}`,
        buttonClass: a.submitButton,
        actionContainerClass: a.actionContainer,
        sectionId: g,
        value: v
      }
    ) })
  ] }) }),
  /* @__PURE__ */ e("div", { className: "col-lg-6", children: /* @__PURE__ */ l("div", { className: a.contactInfo, children: [
    /* @__PURE__ */ l("div", { className: a.info, children: [
      /* @__PURE__ */ e(o, { tag: "h4", value: u }),
      /* @__PURE__ */ e(o, { tag: "p", value: p })
    ] }),
    /* @__PURE__ */ l("div", { className: a.info, children: [
      /* @__PURE__ */ e(o, { tag: "h4", value: s }),
      /* @__PURE__ */ e(o, { tag: "p", value: c })
    ] }),
    /* @__PURE__ */ l("div", { className: a.info, children: [
      /* @__PURE__ */ e(o, { tag: "h4", value: m }),
      /* @__PURE__ */ e(o, { tag: "p", value: _ })
    ] }),
    /* @__PURE__ */ l("div", { className: a.info, children: [
      /* @__PURE__ */ e(o, { tag: "h4", value: f }),
      /* @__PURE__ */ e(
        t,
        {
          value: h,
          listClass: a.social,
          itemClass: a.socialItem
        }
      )
    ] })
  ] }) })
] }) }) }), gf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ff,
  meta: k,
  styles: vf
}, Symbol.toStringTag, { value: "Module" })), hf = "_buttonsWrapper_g0bal_132", bf = "_sectionContainer_g0bal_165", yf = "_map_g0bal_168", $f = "_mapContainer_g0bal_176", Nf = "_contactFields_g0bal_197", Cf = "_fieldsHeader_g0bal_218", xf = "_textField_g0bal_230", If = "_textareaField_g0bal_231", Af = "_actionContainer_g0bal_238", Sf = {
  buttonsWrapper: hf,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_g0bal_138",
  "spaceAfter--small": "_spaceAfter--small_g0bal_141",
  "spaceAfter--medium": "_spaceAfter--medium_g0bal_144",
  sectionContainer: bf,
  map: yf,
  mapContainer: $f,
  contactFields: Nf,
  fieldsHeader: Cf,
  textField: xf,
  textareaField: If,
  actionContainer: Af
}, kf = ({
  Elements: { Map: n, Form: o, Text: t },
  classes: a,
  section_title: i,
  section_description: r,
  map: c,
  form: s,
  sectionId: _
}) => /* @__PURE__ */ e("section", { children: /* @__PURE__ */ e("div", { className: a.sectionContainer, children: /* @__PURE__ */ l("div", { className: a.mapContainer, children: [
  /* @__PURE__ */ e(n, { className: a.map, value: c }),
  /* @__PURE__ */ l("div", { className: a.contactFields, children: [
    /* @__PURE__ */ l("div", { className: a.fieldsHeader, children: [
      /* @__PURE__ */ e(t, { tag: "h2", value: i }),
      /* @__PURE__ */ e(t, { tag: "p", value: r })
    ] }),
    /* @__PURE__ */ e(
      o,
      {
        fieldContainerClass: "form-group",
        textareaClass: `form-control ${a.textareaField}`,
        textClass: `form-control ${a.textField}`,
        buttonClass: a.submitButton,
        actionContainerClass: a.actionContainer,
        value: s,
        sectionId: _
      }
    )
  ] })
] }) }) }), jf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kf,
  meta: k,
  styles: Sf
}, Symbol.toStringTag, { value: "Module" })), wf = "_buttonsWrapper_1gv4v_132", Mf = "_sectionContainer_1gv4v_165", Wf = "_contactFields_1gv4v_179", Ef = "_fieldsHeader_1gv4v_184", Tf = "_contactInfo_1gv4v_201", Lf = "_infoItem_1gv4v_209", Of = "_icon_1gv4v_224", zf = "_text_1gv4v_238", Pf = "_formFields_1gv4v_254", Bf = "_mapContainer_1gv4v_257", qf = "_map_1gv4v_257", Hf = "_actionContainer_1gv4v_268", Vf = "_fileUpload_1gv4v_273", Ff = "_timeClass_1gv4v_279", Df = "_radioClass_1gv4v_288", Xf = "_selectBoxClass_1gv4v_292", Rf = "_dateClass_1gv4v_299", Gf = "_textField_1gv4v_304", Uf = "_textareaField_1gv4v_317", Jf = {
  buttonsWrapper: wf,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1gv4v_138",
  "spaceAfter--small": "_spaceAfter--small_1gv4v_141",
  "spaceAfter--medium": "_spaceAfter--medium_1gv4v_144",
  sectionContainer: Mf,
  contactFields: Wf,
  fieldsHeader: Ef,
  contactInfo: Tf,
  infoItem: Lf,
  icon: Of,
  text: zf,
  formFields: Pf,
  mapContainer: Bf,
  map: qf,
  actionContainer: Hf,
  fileUpload: Vf,
  timeClass: Ff,
  radioClass: Df,
  selectBoxClass: Xf,
  dateClass: Rf,
  textField: Gf,
  textareaField: Uf
}, Qf = ({
  Elements: { Form: n, Text: o, Icon: t, Map: a },
  classes: i,
  section_title: r,
  section_description: c,
  form: s,
  map: _,
  address_label: m,
  address: p,
  address_icon: u,
  phone_label: v,
  phone: f,
  phone_icon: h,
  email: g,
  email_label: N,
  email_icon: I,
  sectionId: B
}) => /* @__PURE__ */ e("section", { className: `${i.sectionContainer} container`, children: /* @__PURE__ */ l("div", { children: [
  /* @__PURE__ */ l("div", { className: "row justify-content-between", children: [
    /* @__PURE__ */ e("div", { className: "col-lg-6 col-12", children: /* @__PURE__ */ e("div", { className: i.contactFields, children: /* @__PURE__ */ l("div", { className: i.fieldsHeader, children: [
      /* @__PURE__ */ e(o, { tag: "h2", value: r }),
      /* @__PURE__ */ e(o, { tag: "p", value: c })
    ] }) }) }),
    /* @__PURE__ */ e("div", { className: "col-lg-5 col-12", children: /* @__PURE__ */ l("div", { className: i.contactInfo, children: [
      /* @__PURE__ */ l("div", { className: i.infoItem, children: [
        /* @__PURE__ */ e("div", { className: i.icon, children: /* @__PURE__ */ e(t, { value: I }) }),
        /* @__PURE__ */ l("div", { className: i.text, children: [
          /* @__PURE__ */ e(o, { tag: "h4", value: N }),
          /* @__PURE__ */ e(o, { tag: "p", value: g })
        ] })
      ] }),
      /* @__PURE__ */ l("div", { className: i.infoItem, children: [
        /* @__PURE__ */ e("div", { className: i.icon, children: /* @__PURE__ */ e(t, { value: h }) }),
        /* @__PURE__ */ l("div", { className: i.text, children: [
          /* @__PURE__ */ e(o, { className: i.label, tag: "h4", value: v }),
          /* @__PURE__ */ e(o, { tag: "p", value: f })
        ] })
      ] }),
      /* @__PURE__ */ l("div", { className: i.infoItem, children: [
        /* @__PURE__ */ e("div", { className: i.icon, children: /* @__PURE__ */ e(t, { value: u }) }),
        /* @__PURE__ */ l("div", { className: i.text, children: [
          /* @__PURE__ */ e(
            o,
            {
              className: i.label,
              tag: "h4",
              value: m
            }
          ),
          /* @__PURE__ */ e(o, { tag: "p", value: p })
        ] })
      ] })
    ] }) })
  ] }),
  /* @__PURE__ */ l("div", { className: "row", children: [
    /* @__PURE__ */ e("div", { className: "col-lg-6 col-12", children: /* @__PURE__ */ e("div", { className: i.formFields, children: /* @__PURE__ */ e(
      n,
      {
        fieldContainerClass: "form-group",
        textareaClass: `form-control ${i.textareaField}`,
        textClass: `form-control ${i.textField}`,
        buttonClass: i.submitButton,
        actionContainerClass: i.actionContainer,
        fileUploadClass: i.fileUpload,
        timeClass: i.timeClass,
        selectBoxClass: i.selectBoxClass,
        radioClass: i.radioClass,
        dateClass: i.dateClass,
        sectionId: B,
        value: s
      }
    ) }) }),
    /* @__PURE__ */ e("div", { className: "col-lg-6 col-12", children: /* @__PURE__ */ e("div", { className: i.mapContainer, children: /* @__PURE__ */ e(a, { className: i.map, value: _ }) }) })
  ] })
] }) }), Kf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Qf,
  meta: k,
  styles: Jf
}, Symbol.toStringTag, { value: "Module" })), fe = /* @__PURE__ */ Object.assign({ "./0001/index.jsx": rm, "./0002/index.jsx": bm, "./0003/index.jsx": zm, "./0004/index.jsx": Km, "./0005/index.jsx": _u, "./0006/index.jsx": Au, "./0007/index.jsx": Fu, "./0008/index.jsx": dp, "./0009/index.jsx": jp, "./0010/index.jsx": Gp, "./0011/index.jsx": sv, "./0012/index.jsx": jv, "./0013/index.jsx": Vv, "./0014/index.jsx": af, "./0015/index.jsx": gf, "./0016/index.jsx": jf, "./0017/index.jsx": Kf }), Zf = Object.keys(fe).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: fe[o] }),
  {}
), Yf = {}, ge = {
  settings: {
    background: [
      {
        id: `Background:${j()}`,
        type: "Color",
        color: "#FFFFFF01",
        image: void 0,
        gradient: void 0
      }
    ],
    gap: 0,
    layout: {
      padding: { top: 60, bottom: 60 }
    }
  },
  rows: [
    {
      id: `Row:${j()}`,
      columns: [
        {
          id: `Column:${j()}`,
          elements: [],
          settings: {
            background: [
              {
                id: `Background:${j()}`,
                type: "Color",
                color: "#FFFFFF01",
                image: void 0,
                gradient: void 0
              }
            ],
            layout: {
              alignment: { horizontal: "start", vertical: "start" },
              padding: { bottom: 16, left: 16, top: 16, right: 16 }
            }
          }
        }
      ],
      settings: {
        background: [
          {
            id: `Background:${j()}`,
            type: "Color",
            color: "#FFFFFF01",
            image: void 0,
            gradient: void 0
          }
        ],
        layout: {
          padding: { bottom: 16, left: 16, top: 16, right: 16 }
        }
      }
    }
  ]
};
function e1() {
  return {
    data: {
      type: d.CUSTOM_ELEMENT,
      fieldId: 272,
      defaultValue: {
        default: ge,
        ar: ge
      }
    }
  };
}
const t1 = ({
  sectionId: n,
  activePage: o,
  Elements: { CustomElement: t },
  data: a,
  pages: i
}) => /* @__PURE__ */ e(
  t,
  {
    value: a,
    sectionId: n,
    activePage: o,
    pages: i
  }
), a1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: t1,
  meta: e1,
  styles: Yf
}, Symbol.toStringTag, { value: "Module" })), he = /* @__PURE__ */ Object.assign({ "./0001/index.jsx": a1 }), n1 = Object.keys(he).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: he[o] }),
  {}
), o1 = "_embedContainer_pr1ku_1", i1 = "_embedText_pr1ku_7", l1 = {
  embedContainer: o1,
  embedText: i1
}, K = {
  embed_title: {
    type: d.TEXT,
    fieldId: 120,
    defaultValue: {
      default: "Two line long header example for web",
      ar: "نموذج عنوان رئيسي للويب من سطرين"
    }
  },
  embed_content: {
    type: d.TEXT,
    fieldId: 121,
    defaultValue: {
      default: "There is a moment in the life of any aspiring astronomer that it is time to buy that first telescope. It’s exciting to think about setting up your own viewing station whether that is on the deck of your home or having.",
      ar: "مهمتنا أن تصمم موقعك بنفسك في 5 دقائق، ويلت منصة بناء للمواقع الجاهزة، تخرج فيها المواقع الإلكترونية للنور في 3 خطوات فقط، دون أكواد برمجية معقدة أو بالسحب والإسقاط المربك ودون مشكلات."
    }
  },
  embed_code: {
    type: d.Embed,
    fieldId: 122,
    defaultValue: {
      default: `
      <html>
        <head>
          <style>
            .embed{
               background: #e8edf1;
               border-radius: 8px;
               border: 1px dashed #bac7d5;
               width: 100%;
               height: 412px;
               justify-content: center;
               align-items: center;
               display: flex;
               flex-direction: column;
               text-align: center;
               color: #5f738c;
              }
              .embedContainer{
                background: #e8edf1;
                padding: 12px;
                border-radius: 8px;
              }
          </style>
        </head>
        <body>
       <div class="embedContainer">
       <div class="embed">
       <svg
         width="60"
         height="46"
         viewBox="0 0 60 46"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
       >
         <path
           d="M30 0.5L25 45.5H30L35 0.5H30ZM14.2676 8.73242L0 23L14.2676 37.2676L17.8027 33.7324L7.07031 23L17.8027 12.2676L14.2676 8.73242ZM45.7324 8.73242L42.1973 12.2676L52.9297 23L42.1973 33.7324L45.7324 37.2676L60 23L45.7324 8.73242Z"
           fill="#5F738C"
         />
       </svg>
      </div>
       </div>
      </body>
    </html>
    `
    }
  }
}, r1 = ({
  Elements: { Text: n, Embed: o },
  classes: t,
  embed_title: a,
  embed_content: i,
  embed_code: r
}) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: `row ${t.embedContainer} mx-0`, children: [
  /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ l("div", { className: t.embedText, children: [
    /* @__PURE__ */ e(n, { tag: "h2", value: a }),
    /* @__PURE__ */ e(n, { tag: "p", value: i })
  ] }) }),
  /* @__PURE__ */ e(
    "div",
    {
      className: "col-md-6 p-3 mt-5 mt-md-0 w-100 h-100",
      style: { overflowX: "auto" },
      children: /* @__PURE__ */ e(o, { value: r })
    }
  )
] }) }), c1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: r1,
  meta: K,
  styles: l1
}, Symbol.toStringTag, { value: "Module" })), s1 = "_embedContainer_q1tde_1", d1 = "_embedText_q1tde_7", _1 = {
  embedContainer: s1,
  embedText: d1
}, m1 = ({
  Elements: { Text: n, Embed: o },
  classes: t,
  embed_title: a,
  embed_content: i,
  embed_code: r
}) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: `row ${t.embedContainer} mx-0`, children: [
  /* @__PURE__ */ e("div", { className: "col-md-6 p-3 mb-5 mb-md-0", style: { overflowX: "auto" }, children: /* @__PURE__ */ e(o, { value: r }) }),
  /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ l("div", { className: `${t.embedText} ml-md-5`, children: [
    /* @__PURE__ */ e(n, { tag: "h2", value: a }),
    /* @__PURE__ */ e(n, { tag: "p", value: i })
  ] }) })
] }) }), u1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: m1,
  meta: K,
  styles: _1
}, Symbol.toStringTag, { value: "Module" })), p1 = "_embedContainer_1ys5k_1", v1 = {
  embedContainer: p1
}, f1 = ({ Elements: { Embed: n }, classes: o, embed_code: t }) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: `row ${o.embedContainer} mx-0`, children: /* @__PURE__ */ e("div", { className: "w-100 p-3", style: { overflowX: "auto" }, children: /* @__PURE__ */ e(n, { value: t }) }) }) }), g1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: f1,
  meta: K,
  styles: v1
}, Symbol.toStringTag, { value: "Module" })), h1 = ({ Elements: { Embed: n }, embed_code: o }) => /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e("div", { style: { overflowX: "auto" }, children: /* @__PURE__ */ e(n, { value: o }) }) }), b1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: h1,
  meta: K
}, Symbol.toStringTag, { value: "Module" })), be = /* @__PURE__ */ Object.assign({ "./0001/index.jsx": c1, "./0002/index.jsx": u1, "./0003/index.jsx": g1, "./0004/index.jsx": b1 }), y1 = Object.keys(be).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: be[o] }),
  {}
), $1 = "_servicesContainer_gxsuu_1", N1 = "_body_gxsuu_5", C1 = "_item_gxsuu_10", x1 = "_iconContainer_gxsuu_15", I1 = "_itemTitle_gxsuu_21", A1 = "_itemInfo_gxsuu_27", S1 = "_servicesTitle_gxsuu_35", k1 = "_containerImage_gxsuu_48", j1 = {
  servicesContainer: $1,
  body: N1,
  item: C1,
  iconContainer: x1,
  itemTitle: I1,
  itemInfo: A1,
  servicesTitle: S1,
  containerImage: k1
}, G = {
  destination: "external",
  // 'internal'
  target: "current",
  // 'new'
  text: "Read More",
  pageId: "",
  href: "#"
}, U = {
  destination: "external",
  // 'internal'
  target: "current",
  // 'new'
  text: "اقرا المزيد",
  pageId: "",
  href: "#"
}, E = {
  section_title: {
    type: d.TEXT,
    defaultValue: {
      default: "Features",
      ar: "المميزات"
    }
  },
  section_short_description: {
    type: d.TEXT,
    defaultValue: {
      default: "what you get?",
      ar: "على ماذا ستحصل؟"
    }
  },
  section_image: {
    type: d.IMAGE,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1541772717-413b5874fed9?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=4c4bee6a26fba4b720c0107836b269f1&auto=format&fit=crop&w=334&q=80"
    }
  },
  section_link: {
    type: d.LINK,
    defaultValue: {
      default: G,
      ar: U
    }
  },
  features: {
    type: d.GROUP,
    defaultValue: [
      {
        feature_title: {
          default: "Professional Support",
          ar: "دعم احترافي"
        },
        feature_image: {
          default: "https://images.unsplash.com/photo-1525332421884-c2f224a01519?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=2166c838ff990f31fda665022735da2b&auto=format&fit=crop&w=2551&q=80"
        },
        feature_icon: {
          default: "support"
        },
        feature_short_description: {
          default: "Our team works diligently to ensure that all your questions are answered and your needs met.",
          ar: "يعمل فريقنا بجد لضمان الإجابة على جميع أسئلتك وتلبية احتياجاتك."
        },
        feature_details_link: {
          default: G,
          ar: U
        }
      },
      {
        feature_title: {
          default: "Qualified Team",
          ar: "فريق بارع"
        },
        feature_short_description: {
          default: "From designers to developers to writers, our team is equipped with a diverse set of skills.",
          ar: "من المصممين إلى المطورين إلى الكتاب ، فريقنا مجهز بمجموعة متنوعة من المهارات."
        },
        feature_image: {
          default: "https://images.unsplash.com/photo-1526455192392-2aec60ae8485?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=af18ae684049a7f73e2583d829b794c2&auto=format&fit=crop&w=3000&q=80"
        },
        feature_icon: {
          default: "users"
        },
        feature_details_link: {
          default: G,
          ar: U
        }
      },
      {
        feature_title: {
          default: "High Quality Work",
          ar: "جودة عالية للعمل"
        },
        feature_short_description: {
          default: "All our work is executed with the highest degree of efficiency.",
          ar: "يتم تنفيذ جميع أعمالنا بأعلى درجة من الكفاءة."
        },
        feature_image: {
          default: "https://images.unsplash.com/photo-1451933371645-a3029668b979?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=6b5c99388f5b9a4cdc908bc781490e33&auto=format&fit=crop&w=3150&q=80"
        },
        feature_icon: {
          default: "briefcase"
        },
        feature_details_link: {
          default: G,
          ar: U
        }
      },
      {
        feature_title: {
          default: "Detail-oriented approach",
          ar: "نهج التفصيل"
        },
        feature_short_description: {
          default: "We focus on every aspect of our clients’ needs to leave nothing to chance.",
          ar: "نحن نركز على كل جانب من جوانب احتياجات عملائنا دون ترك أي شيء للصدفة."
        },
        feature_icon: {
          default: "asterisk"
        },
        feature_image: {
          default: "https://images.unsplash.com/photo-1503032837158-6a350e21ac22?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=51bae5180290942876c0bc137d26d600&auto=format&fit=crop&w=1663&q=80"
        },
        feature_details_link: {
          default: G,
          ar: U
        }
      }
    ],
    values: {
      feature_title: {
        type: d.TEXT
      },
      feature_short_description: {
        type: d.TEXT
      },
      feature_image: {
        type: d.IMAGE
      },
      feature_details_link: {
        type: d.LINK
      },
      feature_icon: {
        type: d.ICON
      }
    }
  }
}, w1 = ({
  Elements: { Text: n, Icon: o },
  classes: t,
  feature_icon: a,
  feature_title: i,
  feature_short_description: r
}) => /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ e("div", { className: t.item, children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-md-2", children: /* @__PURE__ */ e("div", { className: t.iconContainer, children: /* @__PURE__ */ e(o, { value: a, alt: "" }) }) }),
  /* @__PURE__ */ e("div", { className: "col-md-10", children: /* @__PURE__ */ l("div", { className: t.itemInfo, children: [
    /* @__PURE__ */ e(
      n,
      {
        className: t.itemTitle,
        tag: "h4",
        value: i
      }
    ),
    /* @__PURE__ */ e(
      n,
      {
        tag: "p",
        className: t.img__description,
        value: r
      }
    )
  ] }) })
] }) }) }), M1 = ({
  Elements: { RepeatedItems: n, Text: o, BackgroundContainer: t },
  classes: a,
  section_title: i,
  features: r,
  section_image: c
}) => /* @__PURE__ */ e("div", { className: a.servicesContainer, children: /* @__PURE__ */ l("div", { className: `${a.container} container`, children: [
  /* @__PURE__ */ e("div", { className: a.servicesTitle, children: /* @__PURE__ */ e(o, { tag: "h2", value: i }) }),
  /* @__PURE__ */ e("div", { className: a.services, children: /* @__PURE__ */ l("div", { className: "row", children: [
    /* @__PURE__ */ e("div", { className: "col-lg-8", children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
      n,
      {
        classes: a,
        Component: w1,
        value: r
      }
    ) }) }),
    /* @__PURE__ */ e("div", { className: "col-lg-4", children: /* @__PURE__ */ e(
      t,
      {
        className: a.containerImage,
        value: c
      }
    ) })
  ] }) })
] }) }), W1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: M1,
  meta: E,
  styles: j1
}, Symbol.toStringTag, { value: "Module" })), E1 = "_servicesContainer_15ibz_1", T1 = "_imageContainer_15ibz_5", L1 = "_item_15ibz_9", O1 = "_itemImage_15ibz_13", z1 = "_itemInfo_15ibz_19", P1 = "_btnread_15ibz_33", B1 = "_servicesTitle_15ibz_39", q1 = "_contactMe_15ibz_61", H1 = {
  servicesContainer: E1,
  imageContainer: T1,
  item: L1,
  itemImage: O1,
  itemInfo: z1,
  btnread: P1,
  servicesTitle: B1,
  contactMe: q1
}, V1 = ({
  Elements: { Text: n, Image: o, Button: t },
  classes: a,
  feature_image: i,
  feature_title: r,
  feature_short_description: c,
  feature_details_link: s
}) => /* @__PURE__ */ e("div", { className: "col-lg-3 col-md-6", children: /* @__PURE__ */ l("div", { className: a.item, children: [
  /* @__PURE__ */ e("div", { className: a.imageContainer, children: /* @__PURE__ */ e(
    o,
    {
      aspectRatio: "1:1",
      className: a.itemImage,
      value: i,
      small: !0
    }
  ) }),
  /* @__PURE__ */ l("div", { className: a.itemInfo, children: [
    /* @__PURE__ */ e(n, { className: a.headertext, tag: "h4", value: r }),
    /* @__PURE__ */ e(
      n,
      {
        className: a.itemdesc,
        tag: "p",
        value: c
      }
    ),
    /* @__PURE__ */ e(t, { type: "Link", value: s })
  ] })
] }) }), F1 = ({
  Elements: { RepeatedItems: n, Text: o, Button: t },
  classes: a,
  section_title: i,
  section_short_description: r,
  features: c,
  section_link: s
}) => /* @__PURE__ */ e("div", { className: a.servicesContainer, children: /* @__PURE__ */ l("div", { className: `${a.container} container text-center `, children: [
  /* @__PURE__ */ l("div", { className: a.servicesTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h1", value: i }),
    /* @__PURE__ */ e(o, { tag: "p", value: r })
  ] }),
  /* @__PURE__ */ l("div", { className: a.services, children: [
    /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
      n,
      {
        classes: a,
        Component: V1,
        value: c
      }
    ) }),
    /* @__PURE__ */ e(t, { type: "Primary", value: s })
  ] })
] }) }), D1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: F1,
  meta: E,
  styles: H1
}, Symbol.toStringTag, { value: "Module" })), X1 = "_buttonsWrapper_11djb_132", R1 = "_servicesContainer_11djb_165", G1 = "_body_11djb_169", U1 = "_item_11djb_174", J1 = "_iconContainer_11djb_182", Q1 = "_itemTitle_11djb_188", K1 = "_itemInfo_11djb_195", Z1 = "_servicesTitle_11djb_201", Y1 = "_containerImage_11djb_215", eg = {
  buttonsWrapper: X1,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_11djb_138",
  "spaceAfter--small": "_spaceAfter--small_11djb_141",
  "spaceAfter--medium": "_spaceAfter--medium_11djb_144",
  servicesContainer: R1,
  body: G1,
  item: U1,
  iconContainer: J1,
  itemTitle: Q1,
  itemInfo: K1,
  servicesTitle: Z1,
  containerImage: Y1
}, tg = ({
  Elements: { Text: n, Icon: o },
  classes: t,
  feature_icon: a,
  feature_title: i,
  feature_short_description: r
}) => /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ e("div", { className: t.item, children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-md-2", children: /* @__PURE__ */ e("div", { className: t.iconContainer, children: /* @__PURE__ */ e(o, { value: a, alt: "" }) }) }),
  /* @__PURE__ */ e("div", { className: "col-md-10", children: /* @__PURE__ */ l("div", { className: t.itemInfo, children: [
    /* @__PURE__ */ e(
      n,
      {
        className: t.itemTitle,
        tag: "h4",
        value: i
      }
    ),
    /* @__PURE__ */ e(
      n,
      {
        className: t.img__description,
        tag: "p",
        value: r
      }
    )
  ] }) })
] }) }) }), ag = ({
  Elements: { RepeatedItems: n, Text: o, Image: t },
  classes: a,
  section_title: i,
  features: r,
  section_image: c
}) => /* @__PURE__ */ e("div", { className: a.servicesContainer, children: /* @__PURE__ */ l("div", { className: `${a.container} container`, children: [
  /* @__PURE__ */ e("div", { className: a.servicesTitle, children: /* @__PURE__ */ e(o, { tag: "h2", value: i }) }),
  /* @__PURE__ */ e("div", { className: a.services, children: /* @__PURE__ */ l("div", { className: "row", children: [
    /* @__PURE__ */ e("div", { className: "col-md-8", children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
      n,
      {
        classes: a,
        Component: tg,
        value: r
      }
    ) }) }),
    /* @__PURE__ */ e("div", { className: "col-md-4", children: /* @__PURE__ */ e("div", { className: a.containerImage, children: /* @__PURE__ */ e(t, { value: c }) }) })
  ] }) })
] }) }), ng = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ag,
  meta: E,
  styles: eg
}, Symbol.toStringTag, { value: "Module" })), og = "_buttonsWrapper_j0y24_132", ig = "_servicesContainer_j0y24_165", lg = "_itemImage_j0y24_174", rg = "_itemInfo_j0y24_186", cg = "_styleitem_j0y24_193", sg = "_service_j0y24_165", dg = "_btnread_j0y24_233", _g = {
  buttonsWrapper: og,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_j0y24_138",
  "spaceAfter--small": "_spaceAfter--small_j0y24_141",
  "spaceAfter--medium": "_spaceAfter--medium_j0y24_144",
  servicesContainer: ig,
  itemImage: lg,
  itemInfo: rg,
  styleitem: cg,
  service: sg,
  btnread: dg
}, mg = ({
  Elements: { Text: n, Icon: o, Button: t },
  classes: a,
  feature_icon: i,
  feature_title: r,
  feature_short_description: c,
  feature_details_link: s
}) => /* @__PURE__ */ e("div", { className: a.item, children: /* @__PURE__ */ l("div", { className: `${a.styleitem} row`, children: [
  /* @__PURE__ */ e("div", { className: "col-md-2 col-xs-6 col-sm-6", children: /* @__PURE__ */ e("div", { className: a.itemImage, children: /* @__PURE__ */ e(o, { value: i, alt: "" }) }) }),
  /* @__PURE__ */ e("div", { className: "col-md-10 col-xs-6 col-sm-6", children: /* @__PURE__ */ l("div", { className: a.itemInfo, children: [
    /* @__PURE__ */ e(n, { className: a.headertext, tag: "h4", value: r }),
    /* @__PURE__ */ e(
      n,
      {
        className: a.itemdesc,
        tag: "p",
        value: c
      }
    ),
    /* @__PURE__ */ e(t, { type: "Link", value: s })
  ] }) })
] }) }), ug = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_short_description: i,
  features: r
}) => /* @__PURE__ */ e("div", { className: t.servicesContainer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ l("div", { className: t.service, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }) }),
  /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: mg,
      value: r
    }
  ) })
] }) }) }), pg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ug,
  meta: E,
  styles: _g
}, Symbol.toStringTag, { value: "Module" })), vg = "_buttonsWrapper_1o49n_132", fg = "_featuresContainer_1o49n_165", gg = "_featureItem_1o49n_175", hg = "_itemIcon_1o49n_175", bg = "_itemText_1o49n_202", yg = {
  buttonsWrapper: vg,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1o49n_138",
  "spaceAfter--small": "_spaceAfter--small_1o49n_141",
  "spaceAfter--medium": "_spaceAfter--medium_1o49n_144",
  featuresContainer: fg,
  featureItem: gg,
  itemIcon: hg,
  itemText: bg
}, $g = ({
  Elements: { Text: n, Icon: o },
  classes: t,
  feature_icon: a,
  feature_title: i,
  feature_short_description: r
}) => /* @__PURE__ */ e("div", { className: "col-lg-4", children: /* @__PURE__ */ e("div", { className: t.featureItem, children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-2", children: /* @__PURE__ */ e("div", { className: t.itemIcon, children: /* @__PURE__ */ e(o, { value: a, alt: "" }) }) }),
  /* @__PURE__ */ e("div", { className: "col-10", children: /* @__PURE__ */ l("div", { className: t.itemText, children: [
    /* @__PURE__ */ e(n, { tag: "h4", value: i }),
    /* @__PURE__ */ e(n, { tag: "p", value: r })
  ] }) })
] }) }) }), Ng = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  features: i
}) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: t.featuresContainer, children: [
  /* @__PURE__ */ e(o, { tag: "h2", value: a }),
  /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: $g,
      value: i
    }
  ) })
] }) }), Cg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ng,
  meta: E,
  styles: yg
}, Symbol.toStringTag, { value: "Module" })), xg = "_buttonsWrapper_agat0_132", Ig = "_featuresContainer_agat0_165", Ag = "_featureItem_agat0_169", Sg = "_itemIcon_agat0_169", kg = "_itemText_agat0_196", jg = {
  buttonsWrapper: xg,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_agat0_138",
  "spaceAfter--small": "_spaceAfter--small_agat0_141",
  "spaceAfter--medium": "_spaceAfter--medium_agat0_144",
  featuresContainer: Ig,
  featureItem: Ag,
  itemIcon: Sg,
  itemText: kg
}, wg = ({
  Elements: { Text: n, Icon: o },
  classes: t,
  feature_icon: a,
  feature_title: i,
  feature_short_description: r
}) => /* @__PURE__ */ e("div", { className: "col-lg-4", children: /* @__PURE__ */ l("div", { className: t.featureItem, children: [
  /* @__PURE__ */ e("div", { className: t.itemIcon, children: /* @__PURE__ */ e(o, { value: a, alt: "" }) }),
  /* @__PURE__ */ l("div", { className: t.itemText, children: [
    /* @__PURE__ */ e(n, { tag: "h4", value: i }),
    /* @__PURE__ */ e(n, { tag: "p", value: r })
  ] })
] }) }), Mg = ({ Elements: { RepeatedItems: n }, classes: o, features: t }) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: o.featuresContainer, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
  n,
  {
    classes: o,
    Component: wg,
    value: t
  }
) }) }) }), Wg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mg,
  meta: E,
  styles: jg
}, Symbol.toStringTag, { value: "Module" })), Eg = "_buttonsWrapper_15f25_132", Tg = "_featuresContainer_15f25_165", Lg = "_featureItem_15f25_169", Og = "_itemIcon_15f25_169", zg = "_itemText_15f25_196", Pg = {
  buttonsWrapper: Eg,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_15f25_138",
  "spaceAfter--small": "_spaceAfter--small_15f25_141",
  "spaceAfter--medium": "_spaceAfter--medium_15f25_144",
  featuresContainer: Tg,
  featureItem: Lg,
  itemIcon: Og,
  itemText: zg
}, Bg = ({
  Elements: { Text: n, Icon: o },
  classes: t,
  feature_icon: a,
  feature_title: i,
  feature_short_description: r
}) => /* @__PURE__ */ e("div", { className: "col-lg-4", children: /* @__PURE__ */ l("div", { className: t.featureItem, children: [
  /* @__PURE__ */ e("div", { className: t.itemIcon, children: /* @__PURE__ */ e(o, { value: a, alt: "" }) }),
  /* @__PURE__ */ l("div", { className: t.itemText, children: [
    /* @__PURE__ */ e(n, { tag: "h4", value: i }),
    /* @__PURE__ */ e(n, { tag: "p", value: r })
  ] })
] }) }), qg = ({ Elements: { RepeatedItems: n }, classes: o, features: t }) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: o.featuresContainer, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
  n,
  {
    classes: o,
    Component: Bg,
    value: t
  }
) }) }) }), Hg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qg,
  meta: E,
  styles: Pg
}, Symbol.toStringTag, { value: "Module" })), Vg = "_buttonsWrapper_is0pk_132", Fg = "_featuresContainer_is0pk_165", Dg = "_featureItemContainer_is0pk_169", Xg = "_featureItem_is0pk_169", Rg = "_itemIcon_is0pk_186", Gg = "_itemText_is0pk_213", Ug = {
  buttonsWrapper: Vg,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_is0pk_138",
  "spaceAfter--small": "_spaceAfter--small_is0pk_141",
  "spaceAfter--medium": "_spaceAfter--medium_is0pk_144",
  featuresContainer: Fg,
  featureItemContainer: Dg,
  featureItem: Xg,
  itemIcon: Rg,
  itemText: Gg
}, Jg = ({
  Elements: { Text: n, Icon: o },
  classes: t,
  feature_icon: a,
  feature_title: i,
  feature_short_description: r
}) => /* @__PURE__ */ e("div", { className: `col-lg-4 px-0 ${t.featureItemContainer}`, children: /* @__PURE__ */ l("div", { className: t.featureItem, children: [
  /* @__PURE__ */ e("div", { className: t.itemIcon, children: /* @__PURE__ */ e(o, { value: a, alt: "" }) }),
  /* @__PURE__ */ l("div", { className: t.itemText, children: [
    /* @__PURE__ */ e(n, { tag: "h4", value: i }),
    /* @__PURE__ */ e(n, { tag: "p", value: r })
  ] })
] }) }), Qg = ({ Elements: { RepeatedItems: n }, classes: o, features: t }) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: o.featuresContainer, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
  n,
  {
    classes: o,
    Component: Jg,
    value: t
  }
) }) }) }), Kg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Qg,
  meta: E,
  styles: Ug
}, Symbol.toStringTag, { value: "Module" })), Zg = "_buttonsWrapper_y8zwy_132", Yg = "_featuresContainer_y8zwy_165", eh = "_featureItem_y8zwy_169", th = "_featureHeader_y8zwy_177", ah = "_itemIcon_y8zwy_180", nh = "_itemText_y8zwy_216", oh = "_serviceBtn_y8zwy_222", ih = {
  buttonsWrapper: Zg,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_y8zwy_138",
  "spaceAfter--small": "_spaceAfter--small_y8zwy_141",
  "spaceAfter--medium": "_spaceAfter--medium_y8zwy_144",
  featuresContainer: Yg,
  featureItem: eh,
  featureHeader: th,
  itemIcon: ah,
  itemText: nh,
  serviceBtn: oh
}, lh = ({
  Elements: { Text: n, Icon: o, Button: t },
  classes: a,
  feature_icon: i,
  feature_title: r,
  feature_short_description: c,
  feature_details_link: s
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 mb-4 py-3", children: /* @__PURE__ */ l("div", { className: a.featureItem, children: [
  /* @__PURE__ */ l("div", { className: a.featureHeader, children: [
    /* @__PURE__ */ e("div", { className: a.itemIcon, children: /* @__PURE__ */ e(o, { value: i, alt: "" }) }),
    /* @__PURE__ */ e(n, { tag: "h4", value: r })
  ] }),
  /* @__PURE__ */ e("div", { className: a.itemText, children: /* @__PURE__ */ e(n, { tag: "p", value: c }) }),
  /* @__PURE__ */ e("div", { className: "mt-auto", children: /* @__PURE__ */ e(t, { type: "Link", value: s }) })
] }) }), rh = ({ Elements: { RepeatedItems: n }, classes: o, features: t }) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: o.featuresContainer, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
  n,
  {
    classes: o,
    Component: lh,
    value: t
  }
) }) }) }), ch = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rh,
  meta: E,
  styles: ih
}, Symbol.toStringTag, { value: "Module" })), sh = "_buttonsWrapper_18k1d_132", dh = "_featuresContainer_18k1d_165", _h = "_containerLarge_18k1d_165", mh = "_paddingVerticalXhuge_18k1d_171", uh = "_wLayoutGrid_18k1d_174", ph = "_layout175Component_18k1d_185", vh = "_paddingXhuge_18k1d_205", fh = "_paddingVertical_18k1d_171", gh = "_featureItem_18k1d_245", hh = "_layout175Content_18k1d_248", bh = "_marginBottomSmall_18k1d_264", yh = "_iconContainer_18k1d_267", $h = "_marginTopMedium_18k1d_272", Nh = "_buttonRowCenter_18k1d_275", Ch = "_marginTop_18k1d_272", xh = "_marginBottom_18k1d_264", Ih = "_marginSmall_18k1d_307", Ah = "_marginMedium_18k1d_310", Sh = {
  buttonsWrapper: sh,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_18k1d_138",
  "spaceAfter--small": "_spaceAfter--small_18k1d_141",
  "spaceAfter--medium": "_spaceAfter--medium_18k1d_144",
  featuresContainer: dh,
  containerLarge: _h,
  paddingVerticalXhuge: mh,
  wLayoutGrid: uh,
  layout175Component: ph,
  paddingXhuge: vh,
  paddingVertical: fh,
  featureItem: gh,
  layout175Content: hh,
  marginBottomSmall: bh,
  iconContainer: yh,
  marginTopMedium: $h,
  buttonRowCenter: Nh,
  marginTop: Ch,
  marginBottom: xh,
  marginSmall: Ih,
  marginMedium: Ah
}, kh = ({
  Elements: { Text: n, Icon: o, Button: t },
  classes: a,
  feature_icon: i,
  feature_title: r,
  feature_details_link: c,
  feature_short_description: s
}) => /* @__PURE__ */ e("div", { className: a.featureItem, children: /* @__PURE__ */ l("div", { className: a.layout175Content, children: [
  /* @__PURE__ */ e("div", { className: `${a.marginBottomSmall} ${a.iconContainer}`, children: /* @__PURE__ */ e(o, { value: i, alt: "" }) }),
  /* @__PURE__ */ e("div", { className: a.marginBottomSmall, children: /* @__PURE__ */ e(n, { tag: "h3", value: r }) }),
  /* @__PURE__ */ e(n, { tag: "p", value: s }),
  /* @__PURE__ */ e("div", { className: a.marginTopMedium, children: /* @__PURE__ */ e(t, { type: "Primary", value: c }) })
] }) }), jh = ({ Elements: { RepeatedItems: n }, classes: o, features: t }) => /* @__PURE__ */ e("section", { className: o.featuresContainer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: o.containerLarge, children: /* @__PURE__ */ e("div", { className: o.paddingVerticalXhuge, children: /* @__PURE__ */ e(
  "div",
  {
    className: `${o.wLayoutGrid} ${o.layout175Component}`,
    children: /* @__PURE__ */ e(
      n,
      {
        classes: o,
        Component: kh,
        value: t
      }
    )
  }
) }) }) }) }), wh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jh,
  meta: E,
  styles: Sh
}, Symbol.toStringTag, { value: "Module" })), ye = /* @__PURE__ */ Object.assign({ "./0001/index.jsx": W1, "./0002/index.jsx": D1, "./0003/index.jsx": ng, "./0004/index.jsx": pg, "./0005/index.jsx": Cg, "./0006/index.jsx": Wg, "./0007/index.jsx": Hg, "./0008/index.jsx": Kg, "./0009/index.jsx": ch, "./0010/index.jsx": wh }), Mh = Object.keys(ye).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: ye[o] }),
  {}
), X = {
  pages: {
    type: d.NAV_MENU,
    source: w.UNIVERSAL,
    defaultValue: []
  },
  menuItems: {
    type: d.NAV_MENU,
    source: w.UNIVERSAL
  },
  logo: {
    type: d.LOGO,
    fieldId: 91,
    defaultValue: {
      default: {
        url: "https://assets.wuiltsite.com/defaults/google-logo.png",
        size: "medium"
      }
    }
  },
  text: {
    type: d.TEXT,
    fieldId: 70,
    defaultValue: {
      default: "text",
      ar: "كلام"
    }
  },
  copyright_text: {
    type: d.TEXT,
    fieldId: 69,
    defaultValue: {
      default: "© 2018 Creation - One & Multi Page Multipurpose Theme ",
      ar: "© جميع الحقوق محفوظة"
    }
  },
  title_text: {
    type: d.TEXT,
    fieldId: 107,
    defaultValue: {
      default: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.",
      ar: "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium."
    }
  },
  social_links: {
    type: d.SOCIAL_LINKS,
    fieldId: 106,
    defaultValue: {
      default: {
        facebook: "https://facebook.com/",
        twitter: "#",
        instagram: "#",
        snapchat: "#"
      }
    }
  }
}, Wh = "_buttonsWrapper_nh8jj_132", Eh = "_footer_nh8jj_165", Th = "_footerLinks_nh8jj_170", Lh = "_linkItem_nh8jj_177", Oh = "_footerSeparator_nh8jj_197", zh = "_footerSocial_nh8jj_205", Ph = "_footerCopyright_nh8jj_226", Bh = {
  buttonsWrapper: Wh,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_nh8jj_138",
  "spaceAfter--small": "_spaceAfter--small_nh8jj_141",
  "spaceAfter--medium": "_spaceAfter--medium_nh8jj_144",
  footer: Eh,
  footerLinks: Th,
  linkItem: Lh,
  footerSeparator: Oh,
  footerSocial: zh,
  footerCopyright: Ph
}, qh = ({
  Elements: { NavMenu: n, Text: o },
  classes: t,
  pages: a,
  text: i,
  copyright_text: r,
  menuItems: c
}) => /* @__PURE__ */ e("footer", { className: t.footer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ l("div", { className: "col-md-6", children: [
    /* @__PURE__ */ e("div", { className: t.footerLogo }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ e(
    n,
    {
      onlyTopLevel: !0,
      pages: a,
      className: t.footerLinks,
      itemClass: t.linkItem,
      itemActive: t.active,
      menuItems: c
    }
  ) }),
  /* @__PURE__ */ e("div", { className: "col-md-12", children: /* @__PURE__ */ e("div", { className: t.footerSeparator }) }),
  /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ e("div", { className: t.footerCopyright, children: /* @__PURE__ */ e(o, { tag: "p", value: r }) }) }),
  /* @__PURE__ */ e("div", { className: "col-md-6" })
] }) }) }), Hh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qh,
  meta: X,
  styles: Bh
}, Symbol.toStringTag, { value: "Module" })), Vh = "_buttonsWrapper_qm4xs_132", Fh = "_footer_qm4xs_165", Dh = "_footerLogo_qm4xs_170", Xh = "_titleText_qm4xs_179", Rh = "_footerSocial_qm4xs_187", Gh = "_footerSeparator_qm4xs_214", Uh = "_footerCopyright_qm4xs_222", Jh = {
  buttonsWrapper: Vh,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_qm4xs_138",
  "spaceAfter--small": "_spaceAfter--small_qm4xs_141",
  "spaceAfter--medium": "_spaceAfter--medium_qm4xs_144",
  footer: Fh,
  footerLogo: Dh,
  titleText: Xh,
  footerSocial: Rh,
  footerSeparator: Gh,
  footerCopyright: Uh
}, Qh = ({
  Elements: { Text: n },
  classes: o,
  title_text: t,
  copyright_text: a
}) => /* @__PURE__ */ e("footer", { className: o.footer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-md-2" }),
  /* @__PURE__ */ l("div", { className: "col-md-8", children: [
    /* @__PURE__ */ e("div", { className: o.footerLogo }),
    /* @__PURE__ */ e(n, { tag: "p", className: o.titleText, value: t }),
    /* @__PURE__ */ e("div", { className: o.footerSocial })
  ] }),
  /* @__PURE__ */ e("div", { className: "col-md-12", children: /* @__PURE__ */ e("div", { className: o.footerSeparator }) }),
  /* @__PURE__ */ e("div", { className: "col-md-12", children: /* @__PURE__ */ e("div", { className: o.footerCopyright, children: /* @__PURE__ */ e(n, { tag: "p", value: a }) }) })
] }) }) }), Kh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Qh,
  meta: X,
  styles: Jh
}, Symbol.toStringTag, { value: "Module" })), Zh = "_buttonsWrapper_10602_132", Yh = "_footer_10602_165", eb = "_footerLinks_10602_170", tb = "_linkItem_10602_175", ab = "_footerSocial_10602_192", nb = {
  buttonsWrapper: Zh,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_10602_138",
  "spaceAfter--small": "_spaceAfter--small_10602_141",
  "spaceAfter--medium": "_spaceAfter--medium_10602_144",
  footer: Yh,
  footerLinks: eb,
  linkItem: tb,
  footerSocial: ab
}, ob = ({ Elements: { NavMenu: n }, classes: o, pages: t, menuItems: a }) => /* @__PURE__ */ e("footer", { className: o.footer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ e(
    n,
    {
      onlyTopLevel: !0,
      pages: t,
      className: o.footerLinks,
      itemClass: o.linkItem,
      itemActive: o.active,
      menuItems: a
    }
  ) }),
  /* @__PURE__ */ e("div", { className: "col-md-6 d-flex flex-column justify-content-center align-items-center", children: /* @__PURE__ */ e("div", { className: o.footerSocial }) })
] }) }) }), ib = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ob,
  meta: X,
  styles: nb
}, Symbol.toStringTag, { value: "Module" })), lb = "_footer_1gh5i_1", rb = "_footerLogo_1gh5i_6", cb = "_titleText_1gh5i_15", sb = "_footerSocial_1gh5i_23", db = {
  footer: lb,
  footerLogo: rb,
  titleText: cb,
  footerSocial: sb
}, _b = ({ Elements: { Text: n }, classes: o, copyright_text: t }) => /* @__PURE__ */ e("footer", { className: o.footer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-md-2" }),
  /* @__PURE__ */ l("div", { className: "col-md-8", children: [
    /* @__PURE__ */ e("div", { className: o.footerLogo }),
    /* @__PURE__ */ e("div", { className: o.footerSocial }),
    /* @__PURE__ */ e(n, { tag: "p", className: o.titleText, value: t })
  ] }),
  /* @__PURE__ */ e("div", { className: "col-md-2" })
] }) }) }), mb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _b,
  meta: X,
  styles: db
}, Symbol.toStringTag, { value: "Module" })), ub = "_footer_1xo2u_1", pb = "_footerLogo_1xo2u_6", vb = "_footerLinks_1xo2u_14", fb = "_linkItem_1xo2u_23", gb = "_footerSocial_1xo2u_35", hb = {
  footer: ub,
  footerLogo: pb,
  footerLinks: vb,
  linkItem: fb,
  footerSocial: gb
}, bb = ({
  Elements: { NavMenu: n, Logo: o, SocialLinks: t },
  classes: a,
  logo: i,
  pages: r,
  social_links: c,
  menuItems: s
}) => /* @__PURE__ */ e("footer", { className: a.footer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-md-3 d-flex  align-items-center justify-content-center  mb-md-0 mb-4", children: /* @__PURE__ */ e("div", { className: a.footerLogo, children: /* @__PURE__ */ e(o, { pages: r, value: i }) }) }),
  /* @__PURE__ */ e("div", { className: "col-md-6 d-flex  justify-content-center ", children: /* @__PURE__ */ e(
    n,
    {
      onlyTopLevel: !0,
      pages: r,
      className: a.footerLinks,
      itemClass: a.linkItem,
      itemActive: a.active,
      menuItems: s
    }
  ) }),
  /* @__PURE__ */ e("div", { className: "col-md-3 d-flex flex-column justify-content-center align-items-center mt-md-0 mt-4", children: /* @__PURE__ */ e("div", { className: a.footerSocial, children: /* @__PURE__ */ e(t, { value: c }) }) })
] }) }) }), yb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bb,
  meta: X,
  styles: hb
}, Symbol.toStringTag, { value: "Module" })), $b = "_footer_ugo6y_1", Nb = "_footerLogo_ugo6y_6", Cb = "_titleText_ugo6y_15", xb = "_footerLinks_ugo6y_23", Ib = "_linkItem_ugo6y_31", Ab = "_footerSocial_ugo6y_43", Sb = "_footerCopyright_ugo6y_84", kb = "_footerSeparator_ugo6y_87", jb = {
  footer: $b,
  footerLogo: Nb,
  titleText: Cb,
  footerLinks: xb,
  linkItem: Ib,
  footerSocial: Ab,
  footerCopyright: Sb,
  footerSeparator: kb
}, wb = ({
  Elements: { Text: n, NavMenu: o, Logo: t },
  classes: a,
  logo: i,
  pages: r,
  copyright_text: c,
  menuItems: s
}) => /* @__PURE__ */ e("footer", { className: a.footer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-md-2" }),
  /* @__PURE__ */ l("div", { className: "col-md-8", children: [
    /* @__PURE__ */ e("div", { className: a.footerLogo, children: /* @__PURE__ */ e(t, { pages: r, value: i }) }),
    /* @__PURE__ */ e(
      o,
      {
        onlyTopLevel: !0,
        pages: r,
        className: a.footerLinks,
        itemClass: a.linkItem,
        itemActive: a.active,
        menuItems: s
      }
    ),
    /* @__PURE__ */ e(n, { tag: "p", className: a.titleText, value: c })
  ] }),
  /* @__PURE__ */ e("div", { className: "col-md-2" })
] }) }) }), Mb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wb,
  meta: X,
  styles: jb
}, Symbol.toStringTag, { value: "Module" })), $e = /* @__PURE__ */ Object.assign({ "./0001/index.jsx": Hh, "./0002/index.jsx": Kh, "./0003/index.jsx": ib, "./0004/index.jsx": mb, "./0005/index.jsx": yb, "./0006/index.jsx": Mb }), Wb = Object.keys($e).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: $e[o] }),
  {}
), Eb = "_galleryContainer_1anml_1", Tb = "_row_1anml_6 row", Lb = "_imageCol_1anml_11", Ob = "_itemImage_1anml_15", zb = "_body_1anml_19", Pb = "_intro_1anml_22", Bb = "_text_1anml_30", qb = "_aboutbn_1anml_45", Hb = "_imgMain_1anml_52", Vb = "_imageContainer_1anml_56", Fb = {
  galleryContainer: Eb,
  row: Tb,
  imageCol: Lb,
  itemImage: Ob,
  body: zb,
  intro: Pb,
  text: Bb,
  aboutbn: qb,
  imgMain: Hb,
  imageContainer: Vb
}, R = {
  title: {
    type: d.TEXT,
    fieldId: 92,
    defaultValue: {
      default: "Our Work",
      ar: "اعمالنا"
    }
  },
  description: {
    type: d.TEXT,
    fieldId: 93,
    defaultValue: {
      default: "Browse through our collection of stunning images",
      ar: "أمثلة حيَّة رائعة لأعمالنا"
    }
  },
  primary_button: {
    type: d.LINK,
    fieldId: 215,
    defaultValue: {
      default: {
        destination: "external",
        // 'internal'
        target: "current",
        // 'new'
        text: "Start Now",
        pageId: "",
        href: "#"
      },
      ar: {
        destination: "external",
        // 'internal'
        target: "current",
        // 'new'
        text: "ابدا الان",
        pageId: "",
        href: "#"
      }
    }
  },
  images: {
    type: d.GROUP,
    defaultValue: [
      {
        image: {
          default: "https://images.unsplash.com/photo-1580118586709-50d0a0eea2cb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1268&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1580152040915-ad6ceeaeb8c1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1580142541272-4f6b7e815563?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2851&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1558981822-0c0c5b070026?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1268&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1580197370215-38fdb17dfe8f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1590&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1580124173799-934609852db8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80"
        }
      }
    ],
    values: {
      image: {
        type: d.IMAGE,
        fieldId: 94
      }
    }
  }
}, Db = ({ Elements: { Image: n }, classes: o, image: t }) => /* @__PURE__ */ e("div", { className: `${o.imageCol} col-md-4 col-sm-2`, children: /* @__PURE__ */ e("div", { className: o.item, children: /* @__PURE__ */ e("div", { className: o.imageContainer, children: /* @__PURE__ */ e(n, { className: o.itemImage, value: t }) }) }) }), Xb = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  title: a,
  description: i,
  images: r
}) => /* @__PURE__ */ l("section", { className: `${t.body} container`, children: [
  /* @__PURE__ */ l("div", { className: t.intro, children: [
    /* @__PURE__ */ e("div", { className: t.text, children: /* @__PURE__ */ e(o, { tag: "h2", value: a }) }),
    /* @__PURE__ */ e("div", { className: t.text, children: /* @__PURE__ */ e(o, { tag: "p", value: i }) })
  ] }),
  /* @__PURE__ */ e("div", { className: t.galleryContainer, children: /* @__PURE__ */ e("div", { className: t.row, children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: Db,
      value: r
    }
  ) }) })
] }), Rb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xb,
  meta: R,
  styles: Fb
}, Symbol.toStringTag, { value: "Module" })), Gb = "_galleryContainer_1ximo_1", Ub = "_row_1ximo_6 row", Jb = "_imageCol_1ximo_11", Qb = "_itemImage_1ximo_16", Kb = "_body_1ximo_20", Zb = "_intro_1ximo_23", Yb = "_text_1ximo_30", ey = "_aboutbn_1ximo_45", ty = "_imgMain_1ximo_52", ay = "_imageContainer_1ximo_56", ny = {
  galleryContainer: Gb,
  row: Ub,
  imageCol: Jb,
  itemImage: Qb,
  body: Kb,
  intro: Zb,
  text: Yb,
  aboutbn: ey,
  imgMain: ty,
  imageContainer: ay
}, oy = ({ Elements: { Image: n }, classes: o, image: t }) => /* @__PURE__ */ e("div", { className: `${o.imageCol}`, children: /* @__PURE__ */ e("div", { className: o.item, children: /* @__PURE__ */ e("div", { className: o.imageContainer, children: /* @__PURE__ */ e(n, { className: o.itemImage, value: t }) }) }) }), iy = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  title: a,
  description: i,
  images: r
}) => /* @__PURE__ */ l("section", { className: `${t.body} container`, children: [
  /* @__PURE__ */ l("div", { className: t.intro, children: [
    /* @__PURE__ */ e("div", { className: t.text, children: /* @__PURE__ */ e(o, { tag: "h2", value: a }) }),
    /* @__PURE__ */ e("div", { className: t.text, children: /* @__PURE__ */ e(o, { tag: "p", value: i }) })
  ] }),
  /* @__PURE__ */ e("div", { className: t.galleryContainer, children: /* @__PURE__ */ e("div", { className: t.row, children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: oy,
      value: r
    }
  ) }) })
] }), ly = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: iy,
  meta: R,
  styles: ny
}, Symbol.toStringTag, { value: "Module" })), ry = "_section_1heqj_1", cy = "_cont_1heqj_21", sy = "_gallerywrapper_1heqj_27", dy = "_imagewrapper_1heqj_34", _y = {
  section: ry,
  cont: cy,
  gallerywrapper: sy,
  imagewrapper: dy
}, my = ({ Elements: { Image: n }, classes: o, image: t }) => /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(n, { className: o.imagewrapper, value: t }) }), uy = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  title: a,
  description: i,
  images: r
}) => /* @__PURE__ */ e("section", { className: `${t.section} `, children: /* @__PURE__ */ e("div", { className: t.cont, children: /* @__PURE__ */ l("div", { children: [
  /* @__PURE__ */ l("div", { className: t.intro, children: [
    /* @__PURE__ */ e(o, { tag: "h1", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: t.gallerywrapper, children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: my,
      value: r
    }
  ) })
] }) }) }), py = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: uy,
  meta: R,
  styles: _y
}, Symbol.toStringTag, { value: "Module" })), vy = "_galleryContainer_1po5x_1", fy = "_row_1po5x_6 row", gy = "_imageCol_1po5x_11", hy = "_itemImage_1po5x_15", by = "_body_1po5x_22", yy = "_intro_1po5x_25", $y = "_text_1po5x_32", Ny = "_aboutbn_1po5x_47", Cy = "_imgMain_1po5x_54", xy = "_imageContainer_1po5x_58", Iy = {
  galleryContainer: vy,
  row: fy,
  imageCol: gy,
  itemImage: hy,
  body: by,
  intro: yy,
  text: $y,
  aboutbn: Ny,
  imgMain: Cy,
  imageContainer: xy
}, Ay = ({ Elements: { Image: n }, classes: o, image: t }) => /* @__PURE__ */ e("div", { className: `${o.imageCol} col-md-12 col-sm-12`, children: /* @__PURE__ */ e("div", { className: o.item, children: /* @__PURE__ */ e("div", { className: o.imageContainer, children: /* @__PURE__ */ e(n, { className: o.itemImage, value: t }) }) }) }), Sy = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  title: a,
  description: i,
  images: r
}) => /* @__PURE__ */ l("section", { className: `${t.body} container`, children: [
  /* @__PURE__ */ l("div", { className: t.intro, children: [
    /* @__PURE__ */ e("div", { className: t.text, children: /* @__PURE__ */ e(o, { tag: "h2", value: a }) }),
    /* @__PURE__ */ e("div", { className: t.text, children: /* @__PURE__ */ e(o, { tag: "p", value: i }) })
  ] }),
  /* @__PURE__ */ e("div", { className: t.galleryContainer, children: /* @__PURE__ */ e("div", { className: t.row, children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: Ay,
      value: r
    }
  ) }) })
] }), ky = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Sy,
  meta: R,
  styles: Iy
}, Symbol.toStringTag, { value: "Module" })), jy = "_buttonsWrapper_1rj9m_132", wy = "_galleryx00_1rj9m_165", My = "_intro_1rj9m_168", Wy = "_text_1rj9m_175", Ey = "_heroxbtn_1rj9m_189", Ty = "_galleryxitem_1rj9m_211", Ly = "_galleryximg_1rj9m_222", Oy = {
  buttonsWrapper: jy,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1rj9m_138",
  "spaceAfter--small": "_spaceAfter--small_1rj9m_141",
  "spaceAfter--medium": "_spaceAfter--medium_1rj9m_144",
  galleryx00: wy,
  intro: My,
  text: Wy,
  heroxbtn: Ey,
  galleryxitem: Ty,
  galleryximg: Ly
}, zy = ({ Elements: { Image: n }, classes: o, image: t }) => /* @__PURE__ */ e("div", { className: o.galleryximg, children: /* @__PURE__ */ e(n, { value: t }) }), Py = ({
  Elements: { RepeatedItems: n, Text: o, Button: t },
  classes: a,
  title: i,
  description: r,
  images: c,
  primary_button: s
}) => /* @__PURE__ */ l("section", { className: a.galleryx00, children: [
  /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: a.intro, children: [
    /* @__PURE__ */ e("div", { className: a.text, children: /* @__PURE__ */ e(o, { tag: "h2", value: i }) }),
    /* @__PURE__ */ e("div", { className: a.text, children: /* @__PURE__ */ e(o, { tag: "p", value: r }) }),
    /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(t, { type: "Primary", value: s }) })
  ] }) }),
  /* @__PURE__ */ e("div", { className: a.galleryxitem, children: /* @__PURE__ */ e(n, { classes: a, Component: zy, value: c }) })
] }), By = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Py,
  meta: R,
  styles: Oy
}, Symbol.toStringTag, { value: "Module" })), qy = "_galleryContainer_1siuf_1", Hy = "_imageCol_1siuf_6", Vy = "_itemImage_1siuf_10", Fy = "_imageContainer_1siuf_14", Dy = "_body_1siuf_22", Xy = "_container_1siuf_28", Ry = "_button_1siuf_36", Gy = "_button_row_1siuf_47", Uy = "_margin_top_1siuf_62", Jy = "_is_button_row_center_1siuf_67", Qy = "_text_container_1siuf_80", Ky = {
  galleryContainer: qy,
  imageCol: Hy,
  itemImage: Vy,
  imageContainer: Fy,
  body: Dy,
  container: Xy,
  button: Ry,
  button_row: Gy,
  margin_top: Uy,
  is_button_row_center: Jy,
  text_container: Qy
}, Zy = ({ Elements: { Image: n }, classes: o, image: t }) => /* @__PURE__ */ e("div", { className: `${o.imageCol} col-lg-3 col-6`, children: /* @__PURE__ */ e("div", { className: o.item, children: /* @__PURE__ */ e("div", { className: o.imageContainer, children: /* @__PURE__ */ e(n, { className: o.itemImage, value: t }) }) }) }), Yy = ({
  Elements: { RepeatedItems: n, Text: o, Button: t },
  classes: a,
  title: i,
  description: r,
  images: c,
  primary_button: s
}) => /* @__PURE__ */ l("section", { className: `${a.body} ${a.container} container`, children: [
  /* @__PURE__ */ l("div", { className: a.text_container, children: [
    /* @__PURE__ */ e("div", { className: a.text_color_white, children: /* @__PURE__ */ e(o, { tag: "h2", value: i }) }),
    /* @__PURE__ */ e("div", { className: a.text_color_white, children: /* @__PURE__ */ e(o, { tag: "p", value: r }) }),
    /* @__PURE__ */ e(
      "div",
      {
        className: `${a.button_row} ${a.margin_top} ${a.is_button_row_center}`,
        children: /* @__PURE__ */ e(t, { type: "Primary", value: s })
      }
    )
  ] }),
  /* @__PURE__ */ e("div", { className: a.galleryContainer, children: /* @__PURE__ */ e("div", { className: "row mx-0", children: /* @__PURE__ */ e(
    n,
    {
      classes: a,
      Component: Zy,
      value: c
    }
  ) }) })
] }), e$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Yy,
  meta: R,
  styles: Ky
}, Symbol.toStringTag, { value: "Module" })), Ne = /* @__PURE__ */ Object.assign({ "./0001/index.jsx": Rb, "./0002/index.jsx": ly, "./0003/index.jsx": py, "./0004/index.jsx": ky, "./0005/index.jsx": By, "./0006/index.jsx": e$ }), t$ = Object.keys(Ne).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: Ne[o] }),
  {}
), re = {
  title: {
    type: d.TEXT,
    fieldId: 40,
    defaultValue: {
      default: "Page Title",
      ar: "عنوان الصفحة"
    }
  },
  image: {
    type: d.IMAGE,
    fieldId: 41,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1536323760109-ca8c07450053?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=f2822ffa43aba0e2ebb6a1387d49b7c9&auto=format&fit=crop&w=3202&q=80"
    }
  }
}, a$ = "_header_bzxzr_1", n$ = "_overlay_bzxzr_5", o$ = "_content_bzxzr_10 container", i$ = {
  header: a$,
  overlay: n$,
  content: o$
}, l$ = ({
  Elements: { Text: n, BackgroundContainer: o },
  classes: t,
  title: a,
  image: i
}) => /* @__PURE__ */ e(
  o,
  {
    withOverlay: t.overlay,
    value: i,
    className: t.header,
    children: /* @__PURE__ */ e("div", { className: t.content, children: /* @__PURE__ */ e(n, { tag: "h1", value: a }) })
  }
), r$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: l$,
  meta: re,
  styles: i$
}, Symbol.toStringTag, { value: "Module" })), c$ = "_header_1web2_1", s$ = "_content_1web2_5", d$ = {
  header: c$,
  content: s$
}, _$ = ({ Elements: { Text: n }, classes: o, title: t }) => /* @__PURE__ */ e("div", { className: o.header, children: /* @__PURE__ */ e("div", { className: o.content, children: /* @__PURE__ */ e(n, { tag: "h1", value: t }) }) }), m$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _$,
  meta: re,
  styles: d$
}, Symbol.toStringTag, { value: "Module" })), u$ = "_header_34r5f_1", p$ = "_overlay_34r5f_5", v$ = "_content_34r5f_10 container", f$ = {
  header: u$,
  overlay: p$,
  content: v$
}, g$ = ({
  Elements: { Text: n, BackgroundContainer: o },
  classes: t,
  title: a,
  image: i
}) => /* @__PURE__ */ e(
  o,
  {
    withOverlay: t.overlay,
    value: i,
    className: t.header,
    children: /* @__PURE__ */ e("div", { className: t.content, children: /* @__PURE__ */ e(n, { tag: "h1", value: a }) })
  }
), h$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: g$,
  meta: re,
  styles: f$
}, Symbol.toStringTag, { value: "Module" })), Ce = /* @__PURE__ */ Object.assign({ "./0001/index.jsx": r$, "./0002/index.jsx": m$, "./0003/index.jsx": h$ }), b$ = Object.keys(Ce).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: Ce[o] }),
  {}
), y$ = "_buttonsWrapper_108gk_132", $$ = "_header_108gk_165", N$ = "_desktopMenu_108gk_169", C$ = "_mobileMenuContainer_108gk_179", x$ = "_burger_108gk_188", I$ = "_logoImg_108gk_192", A$ = "_phone_108gk_199", S$ = "_contactInfo_108gk_203", k$ = "_contactInfoItem_108gk_213", j$ = "_contactInfoIcon_108gk_224", w$ = "_navMenu_108gk_228", M$ = "_navLink_108gk_236", W$ = "_buttonLink_108gk_245", E$ = "_languageSwitcher_108gk_250", T$ = {
  buttonsWrapper: y$,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_108gk_138",
  "spaceAfter--small": "_spaceAfter--small_108gk_141",
  "spaceAfter--medium": "_spaceAfter--medium_108gk_144",
  header: $$,
  desktopMenu: N$,
  mobileMenuContainer: C$,
  burger: x$,
  logoImg: I$,
  phone: A$,
  contactInfo: S$,
  contactInfoItem: k$,
  contactInfoIcon: j$,
  navMenu: w$,
  navLink: M$,
  buttonLink: W$,
  languageSwitcher: E$
}, $ = {
  logo: {
    type: d.LOGO,
    fieldId: 86,
    defaultValue: {
      default: {
        url: "https://assets.wuiltsite.com/defaults/default-logo.svg",
        size: "medium"
      }
    }
  },
  languages: {
    source: w.UNIVERSAL,
    noProcessing: !0
  },
  menuItems: {
    type: d.NAV_MENU,
    source: w.UNIVERSAL
  },
  pages: {
    type: d.NAV_MENU,
    source: w.UNIVERSAL
  },
  phone: {
    type: d.LINK,
    fieldId: 82,
    defaultValue: {
      default: {
        destination: "external",
        target: "current",
        text: "01000200300",
        pageId: "",
        href: "tel:01000200300"
      }
    }
  },
  email: {
    type: d.LINK,
    fieldId: 83,
    defaultValue: {
      default: {
        destination: "external",
        target: "current",
        text: "info@company.com",
        pageId: "",
        href: "mailto:info@company.com"
      }
    }
  },
  email_icon: {
    type: d.ICON,
    fieldId: 88,
    defaultValue: {
      default: "envelope"
    }
  },
  phone_icon: {
    type: d.ICON,
    fieldId: 87,
    defaultValue: {
      default: "phone-square"
    }
  },
  socialLinks: {
    type: d.SOCIAL_LINKS,
    fieldId: 84,
    defaultValue: {
      default: {
        facebook: "#",
        twitter: "#",
        linkedin: "#"
      }
    }
  },
  primary_button: {
    type: d.LINK,
    fieldId: 26,
    defaultValue: {
      default: {
        destination: "external",
        // 'internal'
        target: "current",
        // 'new'
        text: "Start Now",
        pageId: "",
        href: "#"
      },
      ar: {
        destination: "external",
        // 'internal'
        target: "current",
        // 'new'
        text: "ابدا الان",
        pageId: "",
        href: "#"
      }
    }
  },
  secondary_button: {
    type: d.LINK,
    fieldId: 27,
    defaultValue: {
      default: {
        destination: "external",
        target: "current",
        text: "Get In Touch",
        pageId: "",
        href: "#"
      },
      ar: {
        destination: "external",
        target: "current",
        text: "تواصل معنا",
        pageId: "",
        href: "#"
      }
    }
  }
}, L$ = ({
  Elements: { Logo: n, Icon: o, Button: t, LanguageSwitcher: a, DesktopMenu: i, MobileMenu: r },
  classes: c,
  languages: s,
  pages: _,
  logo: m,
  phone: p,
  email: u,
  email_icon: v,
  phone_icon: f,
  menuItems: h,
  globalNavbarSettings: g
}) => {
  const { backgroundColor: N, navLinksColor: I } = g;
  return /* @__PURE__ */ e(
    "header",
    {
      className: c.header,
      style: {
        backgroundColor: N,
        "--navLinksColor": I
      },
      children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e(
          n,
          {
            pages: _,
            value: m,
            className: `flex-fill ${c.logoImg}`
          }
        ),
        /* @__PURE__ */ e("div", { className: `flex-fill ${c.desktopMenu}`, children: /* @__PURE__ */ e(
          i,
          {
            className: c.navMenu,
            itemClass: c.navItem,
            linkClass: c.navLink,
            pages: _,
            menuItems: h,
            navLinksColor: I
          }
        ) }),
        /* @__PURE__ */ l(
          "div",
          {
            className: `${c.contactInfo}`,
            style: {
              color: I
            },
            children: [
              /* @__PURE__ */ l("span", { className: c.contactInfoItem, children: [
                /* @__PURE__ */ e(o, { className: c.contactInfoIcon, value: f }),
                /* @__PURE__ */ e(
                  t,
                  {
                    type: "Link",
                    value: p,
                    isHeader: !0,
                    className: `${c.navLink} p-0`,
                    customStyle: c.buttonLink,
                    pages: _ == null ? void 0 : _.value
                  }
                )
              ] }),
              /* @__PURE__ */ l("span", { className: c.contactInfoItem, children: [
                /* @__PURE__ */ e(o, { className: c.contactInfoIcon, value: v }),
                /* @__PURE__ */ e(
                  t,
                  {
                    type: "Link",
                    value: u,
                    isHeader: !0,
                    className: `${c.navLink} p-0`,
                    customStyle: c.buttonLink,
                    pages: _ == null ? void 0 : _.value
                  }
                )
              ] })
            ]
          }
        ),
        /* @__PURE__ */ e(
          a,
          {
            displayClass: c.languageSwitcher,
            languages: s,
            showDivider: !1
          }
        ),
        /* @__PURE__ */ e("div", { className: c.mobileMenuContainer, children: /* @__PURE__ */ e(
          r,
          {
            logo: m,
            pages: _,
            burgerClass: c.burger,
            languages: s,
            menuItems: h,
            email: u,
            phone: p,
            emailIcon: v,
            phoneIcon: f
          }
        ) })
      ] }) })
    }
  );
}, O$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: L$,
  meta: $,
  styles: T$
}, Symbol.toStringTag, { value: "Module" })), z$ = "_buttonsWrapper_ont1i_132", P$ = "_navBar_ont1i_165", B$ = "_desktopMenu_ont1i_169", q$ = "_mobileMenuContainer_ont1i_179", H$ = "_navMenu_ont1i_188", V$ = "_navLink_ont1i_196", F$ = "_logoImg_ont1i_205", D$ = "_contactInfoItem_ont1i_212", X$ = "_contactLink_ont1i_232", R$ = "_burger_ont1i_248", G$ = "_buttonLink_ont1i_252", U$ = "_languageSwitcher_ont1i_257", J$ = {
  buttonsWrapper: z$,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_ont1i_138",
  "spaceAfter--small": "_spaceAfter--small_ont1i_141",
  "spaceAfter--medium": "_spaceAfter--medium_ont1i_144",
  navBar: P$,
  desktopMenu: B$,
  mobileMenuContainer: q$,
  navMenu: H$,
  navLink: V$,
  logoImg: F$,
  contactInfoItem: D$,
  contactLink: X$,
  burger: R$,
  buttonLink: G$,
  languageSwitcher: U$
}, Q$ = ({
  Elements: { Logo: n, DesktopMenu: o, MobileMenu: t, Icon: a, LanguageSwitcher: i, Button: r },
  classes: c,
  languages: s,
  pages: _,
  logo: m,
  phone_icon: p,
  phone: u,
  menuItems: v,
  globalNavbarSettings: f
}) => {
  const { backgroundColor: h, navLinksColor: g } = f;
  return /* @__PURE__ */ e("header", { children: /* @__PURE__ */ e(
    "div",
    {
      className: `container ${c.navBar}`,
      style: {
        backgroundColor: h,
        "--navLinksColor": g
      },
      children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e(
          n,
          {
            pages: _,
            value: m,
            className: `flex-fill ${c.logoImg}`
          }
        ),
        /* @__PURE__ */ e("div", { className: `flex-fill ${c.desktopMenu}`, children: /* @__PURE__ */ e(
          o,
          {
            className: ` ${c.navMenu}`,
            itemClass: c.navItem,
            itemActive: c.naveItemActive,
            linkClass: c.navLink,
            pages: _,
            menuItems: v,
            navLinksColor: g
          }
        ) }),
        /* @__PURE__ */ l(
          "div",
          {
            className: ` ${c.contactInfoItem}`,
            style: {
              color: g
            },
            children: [
              /* @__PURE__ */ e(a, { value: p }),
              /* @__PURE__ */ e(
                r,
                {
                  type: "Link",
                  isHeader: !0,
                  className: c.contactLink,
                  value: u,
                  customStyle: c.buttonLink,
                  pages: _ == null ? void 0 : _.value
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ e(
          i,
          {
            displayClass: c.languageSwitcher,
            languages: s,
            showDivider: !1
          }
        ),
        /* @__PURE__ */ e("div", { className: c.mobileMenuContainer, children: /* @__PURE__ */ e(
          t,
          {
            className: c.mobileMenu,
            logo: m,
            pages: _,
            burgerClass: c.burger,
            languages: s,
            menuItems: v,
            phone: u,
            phoneIcon: p
          }
        ) })
      ] })
    }
  ) });
}, K$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Q$,
  meta: $,
  styles: J$
}, Symbol.toStringTag, { value: "Module" })), Z$ = "_buttonsWrapper_wm9en_132", Y$ = "_navBar_wm9en_165", e2 = "_navMenu_wm9en_186 navbar-nav", t2 = "_logo_wm9en_211", a2 = "_languageSwitcher_wm9en_215", n2 = "_desktopMenu_wm9en_224", o2 = "_mobileMenuContainer_wm9en_234", i2 = "_burger_wm9en_243", l2 = {
  buttonsWrapper: Z$,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_wm9en_138",
  "spaceAfter--small": "_spaceAfter--small_wm9en_141",
  "spaceAfter--medium": "_spaceAfter--medium_wm9en_144",
  navBar: Y$,
  navMenu: e2,
  logo: t2,
  languageSwitcher: a2,
  desktopMenu: n2,
  mobileMenuContainer: o2,
  burger: i2
}, r2 = ({
  Elements: { Logo: n, MobileMenu: o, DesktopMenu: t, LanguageSwitcher: a },
  classes: i,
  languages: r,
  pages: c,
  logo: s,
  menuItems: _,
  globalNavbarSettings: m
}) => {
  const { backgroundColor: p, navLinksColor: u } = m;
  return /* @__PURE__ */ e(
    "header",
    {
      className: i.topBarContainer,
      style: {
        backgroundColor: p,
        "--navLinksColor": u
      },
      children: /* @__PURE__ */ e("div", { className: i.navBar, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e("div", { className: `${i.logo}`, children: /* @__PURE__ */ e(n, { pages: c, value: s }) }),
        /* @__PURE__ */ e("div", { className: `flex-fill ${i.desktopMenu}`, children: /* @__PURE__ */ e("div", { className: "navbar-expand-lg", children: /* @__PURE__ */ e(
          t,
          {
            className: i.navMenu,
            itemClass: i.navItem,
            itemActive: i.naveItemActive,
            linkClass: i.navLink,
            pages: c,
            menuItems: _,
            navLinksColor: u
          }
        ) }) }),
        /* @__PURE__ */ e(
          a,
          {
            languages: r,
            displayClass: i.languageSwitcher,
            showDivider: !1
          }
        ),
        /* @__PURE__ */ e("div", { className: i.mobileMenuContainer, children: /* @__PURE__ */ e(
          o,
          {
            logo: s,
            pages: c,
            languages: r,
            menuItems: _,
            burgerClass: i.burger
          }
        ) })
      ] }) }) })
    }
  );
}, c2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: r2,
  meta: $,
  styles: l2
}, Symbol.toStringTag, { value: "Module" })), s2 = "_buttonsWrapper_p8d4j_132", d2 = "_logo_p8d4j_165", _2 = "_burger_p8d4j_169", m2 = "_desktopMenu_p8d4j_173", u2 = "_navBar_p8d4j_183", p2 = "_navMenu_p8d4j_196 navbar-nav", v2 = "_navLink_p8d4j_213", f2 = "_mobileMenuContainer_p8d4j_224", g2 = "_socialLinksContainer_p8d4j_233", h2 = "_socialIcons_p8d4j_245", b2 = "_socialIcon_p8d4j_245", y2 = "_languageSwitcher_p8d4j_260", $2 = {
  buttonsWrapper: s2,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_p8d4j_138",
  "spaceAfter--small": "_spaceAfter--small_p8d4j_141",
  "spaceAfter--medium": "_spaceAfter--medium_p8d4j_144",
  logo: d2,
  burger: _2,
  desktopMenu: m2,
  navBar: u2,
  navMenu: p2,
  navLink: v2,
  mobileMenuContainer: f2,
  socialLinksContainer: g2,
  socialIcons: h2,
  socialIcon: b2,
  languageSwitcher: y2
}, N2 = ({
  Elements: { Logo: n, SocialLinks: o, DesktopMenu: t, MobileMenu: a, LanguageSwitcher: i },
  classes: r,
  languages: c,
  pages: s,
  socialLinks: _,
  logo: m,
  menuItems: p,
  globalNavbarSettings: u
}) => {
  const { backgroundColor: v, navLinksColor: f } = u;
  return /* @__PURE__ */ e("header", { children: /* @__PURE__ */ e(
    "div",
    {
      className: r.navBar,
      style: {
        backgroundColor: v,
        "--navLinksColor": f
      },
      children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e(
          n,
          {
            pages: s,
            value: m,
            className: `flex-fill ${r.logo}`
          }
        ),
        /* @__PURE__ */ e("div", { className: `flex-fill ${r.desktopMenu}`, children: /* @__PURE__ */ e("div", { className: "navbar-expand-lg", children: /* @__PURE__ */ e(
          t,
          {
            className: `${r.navMenu}`,
            itemClass: r.navItem,
            itemActive: r.naveItemActive,
            linkClass: r.navLink,
            pages: s,
            menuItems: p,
            navLinksColor: f
          }
        ) }) }),
        /* @__PURE__ */ l("div", { className: r.socialLinksContainer, children: [
          /* @__PURE__ */ e(
            o,
            {
              value: _,
              listClass: `${r.socialIcons}`,
              itemClass: r.socialIcon,
              navLinksColor: f
            }
          ),
          /* @__PURE__ */ e(
            i,
            {
              displayClass: r.languageSwitcher,
              languages: c,
              showDivider: !1
            }
          )
        ] }),
        /* @__PURE__ */ e("div", { className: r.mobileMenuContainer, children: /* @__PURE__ */ e(
          a,
          {
            logo: m,
            pages: s,
            languages: c,
            menuItems: p,
            burgerClass: r.burger,
            socialLinks: _
          }
        ) })
      ] }) })
    }
  ) });
}, C2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: N2,
  meta: $,
  styles: $2
}, Symbol.toStringTag, { value: "Module" })), x2 = "_buttonsWrapper_g3bng_132", I2 = "_navbarBrand_g3bng_165", A2 = "_langSwitcher_g3bng_169", S2 = "_desktopMenu_g3bng_176", k2 = "_mobileMenuContainer_g3bng_185", j2 = "_siteBar_g3bng_194", w2 = "_navMenu_g3bng_199", M2 = "_navLink_g3bng_210", W2 = "_languageSwitcher_g3bng_217", E2 = "_burger_g3bng_226", T2 = {
  buttonsWrapper: x2,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_g3bng_138",
  "spaceAfter--small": "_spaceAfter--small_g3bng_141",
  "spaceAfter--medium": "_spaceAfter--medium_g3bng_144",
  navbarBrand: I2,
  langSwitcher: A2,
  desktopMenu: S2,
  mobileMenuContainer: k2,
  siteBar: j2,
  navMenu: w2,
  navLink: M2,
  languageSwitcher: W2,
  burger: E2
}, L2 = ({
  Elements: { Logo: n, DesktopMenu: o, MobileMenu: t, LanguageSwitcher: a },
  classes: i,
  languages: r,
  logo: c,
  pages: s,
  menuItems: _,
  globalNavbarSettings: m
}) => {
  const { backgroundColor: p, navLinksColor: u } = m;
  return /* @__PURE__ */ e(
    "header",
    {
      className: i.siteBar,
      style: {
        backgroundColor: p,
        "--navLinksColor": u
      },
      children: /* @__PURE__ */ e("div", { className: "container py-3", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e("div", { className: `${i.navbarBrand}`, children: /* @__PURE__ */ e(n, { pages: s, value: c }) }),
        /* @__PURE__ */ e("div", { className: `flex-fill ${i.desktopMenu}`, children: /* @__PURE__ */ e(
          o,
          {
            className: i.navMenu,
            itemClass: i.navItem,
            itemActive: i.naveItemActive,
            linkClass: i.navLink,
            pages: s,
            menuItems: _,
            navLinksColor: u
          }
        ) }),
        /* @__PURE__ */ e(
          a,
          {
            languages: r,
            displayClass: i.languageSwitcher,
            showDivider: !1
          }
        ),
        /* @__PURE__ */ e("div", { className: i.mobileMenuContainer, children: /* @__PURE__ */ e(
          t,
          {
            logo: c,
            pages: s,
            languages: r,
            menuItems: _,
            burgerClass: i.burger
          }
        ) })
      ] }) })
    }
  );
}, O2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: L2,
  meta: $,
  styles: T2
}, Symbol.toStringTag, { value: "Module" })), z2 = "_buttonsWrapper_5tt20_132", P2 = "_desktopMenu_5tt20_165", B2 = "_navMenu_5tt20_174 navbar-nav", q2 = "_navLink_5tt20_190", H2 = "_mobileMenuContainer_5tt20_198", V2 = "_languageSwitcher_5tt20_207", F2 = "_burger_5tt20_224", D2 = "_navBarRow_5tt20_228", X2 = "_logoImg_5tt20_233", R2 = "_mobileMenu_5tt20_198", G2 = "_contactInfoItem_5tt20_241", U2 = "_contactLink_5tt20_257", J2 = {
  buttonsWrapper: z2,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_5tt20_138",
  "spaceAfter--small": "_spaceAfter--small_5tt20_141",
  "spaceAfter--medium": "_spaceAfter--medium_5tt20_144",
  desktopMenu: P2,
  navMenu: B2,
  navLink: q2,
  mobileMenuContainer: H2,
  languageSwitcher: V2,
  burger: F2,
  navBarRow: D2,
  logoImg: X2,
  mobileMenu: R2,
  contactInfoItem: G2,
  contactLink: U2
}, Q2 = ({
  Elements: { Logo: n, DesktopMenu: o, MobileMenu: t, Icon: a, Button: i, LanguageSwitcher: r },
  classes: c,
  languages: s,
  pages: _,
  logo: m,
  phone_icon: p,
  phone: u,
  menuItems: v,
  globalNavbarSettings: f
}) => {
  const { backgroundColor: h, navLinksColor: g } = f;
  return /* @__PURE__ */ e(
    "header",
    {
      className: `container ${c.navBar}`,
      style: {
        backgroundColor: h,
        "--navLinksColor": g
      },
      children: /* @__PURE__ */ l(
        "div",
        {
          className: `d-flex justify-content-between align-items-center ${c.navBarRow}`,
          children: [
            /* @__PURE__ */ e(
              n,
              {
                pages: _,
                value: m,
                className: `flex-fill px-0 ${c.logoImg}`
              }
            ),
            /* @__PURE__ */ e("div", { className: `flex-fill ${c.desktopMenu}`, children: /* @__PURE__ */ e("div", { className: `navbar navbar-expand-lg ${c.navbar}`, children: /* @__PURE__ */ e(
              o,
              {
                className: c.navMenu,
                itemClass: c.navItem,
                itemActive: c.naveItemActive,
                linkClass: c.navLink,
                pages: _,
                menuItems: v,
                navLinksColor: g
              }
            ) }) }),
            /* @__PURE__ */ l(
              "div",
              {
                className: c.contactInfoItem,
                style: {
                  color: g
                },
                children: [
                  /* @__PURE__ */ e(a, { value: p }),
                  /* @__PURE__ */ e(i, { type: "Link", className: c.contactLink, value: u })
                ]
              }
            ),
            /* @__PURE__ */ e(
              r,
              {
                languages: s,
                displayClass: c.languageSwitcher,
                showDivider: !1
              }
            ),
            /* @__PURE__ */ e("div", { className: c.mobileMenuContainer, children: /* @__PURE__ */ e(
              t,
              {
                className: c.mobileMenu,
                logo: m,
                pages: _,
                burgerClass: c.burger,
                languages: s,
                menuItems: v
              }
            ) })
          ]
        }
      )
    }
  );
}, K2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Q2,
  meta: $,
  styles: J2
}, Symbol.toStringTag, { value: "Module" })), Z2 = "_buttonsWrapper_12cpo_132", Y2 = "_logoImg_12cpo_165", eN = "_socialLinksContainer_12cpo_169", tN = "_socialIcons_12cpo_179", aN = "_socialIcon_12cpo_179", nN = "_burger_12cpo_208", oN = "_navBar_12cpo_212", iN = "_navLink_12cpo_230", lN = "_navMenu_12cpo_237 navbar-nav", rN = "_desktopMenu_12cpo_269", cN = "_mobileMenuContainer_12cpo_278", sN = "_languageSwitcher_12cpo_287", dN = {
  buttonsWrapper: Z2,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_12cpo_138",
  "spaceAfter--small": "_spaceAfter--small_12cpo_141",
  "spaceAfter--medium": "_spaceAfter--medium_12cpo_144",
  logoImg: Y2,
  socialLinksContainer: eN,
  socialIcons: tN,
  socialIcon: aN,
  burger: nN,
  navBar: oN,
  navLink: iN,
  navMenu: lN,
  desktopMenu: rN,
  mobileMenuContainer: cN,
  languageSwitcher: sN
}, _N = ({
  Elements: { Logo: n, SocialLinks: o, DesktopMenu: t, MobileMenu: a, LanguageSwitcher: i },
  classes: r,
  languages: c,
  pages: s,
  logo: _,
  socialLinks: m,
  menuItems: p,
  globalNavbarSettings: u
}) => {
  const { backgroundColor: v, navLinksColor: f } = u;
  return /* @__PURE__ */ e(
    "header",
    {
      className: r.navBar,
      style: {
        backgroundColor: v,
        "--navLinksColor": f
      },
      children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e(
          n,
          {
            pages: s,
            value: _,
            className: `flex-fill px-0 px-lg-2 ${r.logoImg}`
          }
        ),
        /* @__PURE__ */ e("div", { className: `flex-fill ${r.desktopMenu}`, children: /* @__PURE__ */ e("div", { className: "navbar-expand-lg", children: /* @__PURE__ */ e(
          t,
          {
            className: r.navMenu,
            itemClass: r.navItem,
            itemActive: r.naveItemActive,
            linkClass: r.navLink,
            pages: s,
            menuItems: p,
            navLinksColor: f
          }
        ) }) }),
        /* @__PURE__ */ e("div", { className: `flex-fill ${r.socialLinksContainer}`, children: /* @__PURE__ */ e(
          o,
          {
            value: m,
            listClass: r.socialIcons,
            itemClass: r.socialIcon,
            navLinksColor: f
          }
        ) }),
        /* @__PURE__ */ e(
          i,
          {
            displayClass: r.languageSwitcher,
            languages: c,
            showDivider: !1
          }
        ),
        /* @__PURE__ */ e("div", { className: r.mobileMenuContainer, children: /* @__PURE__ */ e(
          a,
          {
            burgerClass: r.burger,
            logo: _,
            pages: s,
            languages: c,
            menuItems: p
          }
        ) })
      ] }) })
    }
  );
}, mN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _N,
  meta: $,
  styles: dN
}, Symbol.toStringTag, { value: "Module" })), uN = "_buttonsWrapper_1mve4_132", pN = "_desktopMenu_1mve4_165", vN = "_navBar_1mve4_174", fN = "_navMenu_1mve4_183 navbar-nav", gN = "_navLink_1mve4_199", hN = "_languageSwitcher_1mve4_208", bN = "_mobileMenuContainer_1mve4_217", yN = "_logo_1mve4_226", $N = "_burger_1mve4_230", NN = {
  buttonsWrapper: uN,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1mve4_138",
  "spaceAfter--small": "_spaceAfter--small_1mve4_141",
  "spaceAfter--medium": "_spaceAfter--medium_1mve4_144",
  desktopMenu: pN,
  navBar: vN,
  navMenu: fN,
  navLink: gN,
  languageSwitcher: hN,
  mobileMenuContainer: bN,
  logo: yN,
  burger: $N
}, CN = ({
  Elements: { Logo: n, DesktopMenu: o, MobileMenu: t, LanguageSwitcher: a },
  classes: i,
  languages: r,
  pages: c,
  logo: s,
  menuItems: _,
  globalNavbarSettings: m
}) => {
  const { backgroundColor: p, navLinksColor: u } = m;
  return /* @__PURE__ */ e("header", { children: /* @__PURE__ */ e(
    "div",
    {
      className: i.navBar,
      style: {
        backgroundColor: p,
        "--navLinksColor": u
      },
      children: /* @__PURE__ */ e("div", { className: "container py-2", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center ", children: [
        /* @__PURE__ */ e("div", { className: `${i.logo}`, children: /* @__PURE__ */ e(n, { pages: c, value: s }) }),
        /* @__PURE__ */ e("div", { className: `flex-fill ${i.desktopMenu}`, children: /* @__PURE__ */ e("div", { className: "navbar-expand-lg", children: /* @__PURE__ */ e(
          o,
          {
            className: `${i.navMenu}`,
            itemClass: i.navItem,
            itemActive: i.naveItemActive,
            linkClass: i.navLink,
            pages: c,
            menuItems: _,
            navLinksColor: u
          }
        ) }) }),
        /* @__PURE__ */ e(
          a,
          {
            languages: r,
            displayClass: i.languageSwitcher,
            showDivider: !1
          }
        ),
        /* @__PURE__ */ e("div", { className: i.mobileMenuContainer, children: /* @__PURE__ */ e(
          t,
          {
            logo: s,
            pages: c,
            languages: r,
            menuItems: _,
            burgerClass: i.burger
          }
        ) })
      ] }) })
    }
  ) });
}, xN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: CN,
  meta: $,
  styles: NN
}, Symbol.toStringTag, { value: "Module" })), IN = "_buttonsWrapper_rv4k3_132", AN = "_desktopMenu_rv4k3_165", SN = "_navBar_rv4k3_175", kN = "_navMenu_rv4k3_182 navbar-nav", jN = "_navLink_rv4k3_198", wN = "_logo_rv4k3_215", MN = "_mobileMenuContainer_rv4k3_219", WN = "_contactInfoItem_rv4k3_228", EN = "_contactLink_rv4k3_248", TN = "_mobileMenu_rv4k3_219", LN = "_burger_rv4k3_267", ON = "_buttonLink_rv4k3_271", zN = "_languageSwitcher_rv4k3_276", PN = {
  buttonsWrapper: IN,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_rv4k3_138",
  "spaceAfter--small": "_spaceAfter--small_rv4k3_141",
  "spaceAfter--medium": "_spaceAfter--medium_rv4k3_144",
  desktopMenu: AN,
  navBar: SN,
  navMenu: kN,
  navLink: jN,
  logo: wN,
  mobileMenuContainer: MN,
  contactInfoItem: WN,
  contactLink: EN,
  mobileMenu: TN,
  burger: LN,
  buttonLink: ON,
  languageSwitcher: zN
}, BN = ({
  Elements: { Logo: n, MobileMenu: o, DesktopMenu: t, LanguageSwitcher: a, Button: i, Icon: r },
  classes: c,
  languages: s,
  pages: _,
  logo: m,
  phone_icon: p,
  phone: u,
  menuItems: v,
  globalNavbarSettings: f
}) => {
  const { backgroundColor: h, navLinksColor: g } = f;
  return /* @__PURE__ */ e(
    "header",
    {
      className: c.navBar,
      style: {
        backgroundColor: h,
        "--navLinksColor": g
      },
      children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e(
          n,
          {
            pages: _,
            value: m,
            className: `flex-fill ${c.logo}`
          }
        ),
        /* @__PURE__ */ e("div", { className: `flex-fill ${c.desktopMenu}`, children: /* @__PURE__ */ e("div", { className: "navbar-expand-lg", children: /* @__PURE__ */ e(
          t,
          {
            className: c.navMenu,
            itemClass: c.navItem,
            itemActive: c.naveItemActive,
            linkClass: c.navLink,
            pages: _,
            menuItems: v,
            navLinksColor: g
          }
        ) }) }),
        /* @__PURE__ */ l(
          "div",
          {
            className: c.contactInfoItem,
            style: {
              color: g
            },
            children: [
              /* @__PURE__ */ e(r, { value: p }),
              /* @__PURE__ */ e(
                i,
                {
                  type: "Link",
                  isHeader: !0,
                  className: c.contactLink,
                  value: u,
                  customStyle: c.buttonLink,
                  pages: _ == null ? void 0 : _.value
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ e(
          a,
          {
            languages: s,
            displayClass: c.languageSwitcher,
            showDivider: !1
          }
        ),
        /* @__PURE__ */ e("div", { className: c.mobileMenuContainer, children: /* @__PURE__ */ e(
          o,
          {
            logo: m,
            pages: _,
            burgerClass: c.burger,
            languages: s,
            menuItems: v,
            phone: u,
            phoneIcon: p
          }
        ) })
      ] }) })
    }
  );
}, qN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: BN,
  meta: $,
  styles: PN
}, Symbol.toStringTag, { value: "Module" })), HN = "_buttonsWrapper_14vf0_132", VN = "_logoImg_14vf0_165", FN = "_desktopMenu_14vf0_172", DN = "_navBar_14vf0_181", XN = "_navMenu_14vf0_188 navbar-nav", RN = "_navLink_14vf0_199", GN = "_languageSwitcher_14vf0_207", UN = "_mobileMenuContainer_14vf0_216", JN = "_burger_14vf0_225", QN = {
  buttonsWrapper: HN,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_14vf0_138",
  "spaceAfter--small": "_spaceAfter--small_14vf0_141",
  "spaceAfter--medium": "_spaceAfter--medium_14vf0_144",
  logoImg: VN,
  desktopMenu: FN,
  navBar: DN,
  navMenu: XN,
  navLink: RN,
  languageSwitcher: GN,
  mobileMenuContainer: UN,
  burger: JN
}, KN = ({
  Elements: { Logo: n, DesktopMenu: o, MobileMenu: t, LanguageSwitcher: a },
  classes: i,
  languages: r,
  pages: c,
  logo: s,
  menuItems: _,
  globalNavbarSettings: m
}) => {
  const { backgroundColor: p, navLinksColor: u } = m;
  return /* @__PURE__ */ e(
    "header",
    {
      className: i.navBar,
      style: {
        backgroundColor: p,
        "--navLinksColor": u
      },
      children: /* @__PURE__ */ e("div", { className: "container py-4", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e("div", { className: `${i.logoImg}`, children: /* @__PURE__ */ e(n, { pages: c, value: s }) }),
        /* @__PURE__ */ e("div", { className: `flex-fill ${i.desktopMenu}`, children: /* @__PURE__ */ e("div", { className: "navbar-expand-lg", children: /* @__PURE__ */ e(
          o,
          {
            className: `${i.navMenu}`,
            itemClass: i.navItem,
            itemActive: i.naveItemActive,
            linkClass: i.navLink,
            pages: c,
            menuItems: _,
            navLinksColor: u
          }
        ) }) }),
        /* @__PURE__ */ e(
          a,
          {
            languages: r,
            displayClass: i.languageSwitcher,
            showDivider: !1
          }
        ),
        /* @__PURE__ */ e("div", { className: i.mobileMenuContainer, children: /* @__PURE__ */ e(
          t,
          {
            burgerClass: i.burger,
            logo: s,
            pages: c,
            languages: r,
            menuItems: _
          }
        ) })
      ] }) })
    }
  );
}, ZN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: KN,
  meta: $,
  styles: QN
}, Symbol.toStringTag, { value: "Module" })), YN = "_buttonsWrapper_1j35q_132", e0 = "_logoImg_1j35q_165", t0 = "_desktopMenu_1j35q_169", a0 = "_languageSwitcher_1j35q_178", n0 = "_mobileMenuContainer_1j35q_188", o0 = "_navBar_1j35q_197", i0 = "_burger_1j35q_205", l0 = "_navMenu_1j35q_210", r0 = "_navLink_1j35q_217", c0 = {
  buttonsWrapper: YN,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1j35q_138",
  "spaceAfter--small": "_spaceAfter--small_1j35q_141",
  "spaceAfter--medium": "_spaceAfter--medium_1j35q_144",
  logoImg: e0,
  desktopMenu: t0,
  languageSwitcher: a0,
  mobileMenuContainer: n0,
  navBar: o0,
  burger: i0,
  navMenu: l0,
  navLink: r0
}, s0 = ({
  Elements: { Logo: n, DesktopMenu: o, MobileMenu: t, LanguageSwitcher: a },
  classes: i,
  languages: r,
  pages: c,
  logo: s,
  menuItems: _,
  globalNavbarSettings: m
}) => {
  const { backgroundColor: p, navLinksColor: u } = m;
  return /* @__PURE__ */ e(
    "header",
    {
      className: i.navBar,
      style: {
        backgroundColor: p,
        "--navLinksColor": u
      },
      children: /* @__PURE__ */ l("div", { className: "container py-3", children: [
        /* @__PURE__ */ l("div", { className: "d-flex align-items-center", children: [
          /* @__PURE__ */ e(
            "div",
            {
              className: `flex-fill d-flex justify-content-start justify-content-lg-center ${i.logoImg}`,
              children: /* @__PURE__ */ e(n, { pages: c, value: s })
            }
          ),
          /* @__PURE__ */ e(
            a,
            {
              languages: r,
              displayClass: i.languageSwitcher,
              showDivider: !1
            }
          ),
          /* @__PURE__ */ e("div", { className: `${i.mobileMenuContainer}`, children: /* @__PURE__ */ e(
            t,
            {
              burgerClass: i.burger,
              logo: s,
              pages: c,
              languages: r,
              menuItems: _
            }
          ) })
        ] }),
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(
          "div",
          {
            className: ` d-none d-lg-flex justify-content-center ${i.desktopMenu}`,
            children: /* @__PURE__ */ e(
              o,
              {
                className: i.navMenu,
                itemClass: i.navItem,
                itemActive: i.naveItemActive,
                linkClass: i.navLink,
                pages: c,
                menuItems: _,
                navLinksColor: u
              }
            )
          }
        ) })
      ] })
    }
  );
}, d0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: s0,
  meta: $,
  styles: c0
}, Symbol.toStringTag, { value: "Module" })), _0 = "_buttonsWrapper_1vy7k_132", m0 = "_desktopMenu_1vy7k_165", u0 = "_navBar_1vy7k_174", p0 = "_logoImg_1vy7k_181", v0 = "_navMenu_1vy7k_185 navbar-nav", f0 = "_navLink_1vy7k_196", g0 = "_mobileMenu_1vy7k_214", h0 = "_languageSwitcher_1vy7k_218", b0 = "_mobileMenuContainer_1vy7k_227", y0 = "_burger_1vy7k_236", $0 = "_contactInfoItem_1vy7k_240", N0 = "_contactLink_1vy7k_256", C0 = {
  buttonsWrapper: _0,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1vy7k_138",
  "spaceAfter--small": "_spaceAfter--small_1vy7k_141",
  "spaceAfter--medium": "_spaceAfter--medium_1vy7k_144",
  desktopMenu: m0,
  navBar: u0,
  logoImg: p0,
  navMenu: v0,
  navLink: f0,
  mobileMenu: g0,
  languageSwitcher: h0,
  mobileMenuContainer: b0,
  burger: y0,
  contactInfoItem: $0,
  contactLink: N0
}, x0 = ({
  Elements: { Logo: n, MobileMenu: o, DesktopMenu: t, LanguageSwitcher: a, Button: i, Icon: r },
  classes: c,
  languages: s,
  pages: _,
  logo: m,
  phone_icon: p,
  phone: u,
  menuItems: v,
  globalNavbarSettings: f
}) => {
  const { backgroundColor: h, navLinksColor: g } = f;
  return /* @__PURE__ */ e(
    "header",
    {
      className: c.navBar,
      style: {
        backgroundColor: h,
        "--navLinksColor": g
      },
      children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e(
          n,
          {
            pages: _,
            value: m,
            className: `flex-fill ${c.logoImg}`
          }
        ),
        /* @__PURE__ */ e("div", { className: `flex-fill ${c.desktopMenu}`, children: /* @__PURE__ */ e("div", { className: "navbar-expand-lg", children: /* @__PURE__ */ e(
          t,
          {
            className: c.navMenu,
            itemClass: c.navItem,
            itemActive: c.naveItemActive,
            linkClass: c.navLink,
            pages: _,
            menuItems: v,
            navLinksColor: g
          }
        ) }) }),
        /* @__PURE__ */ l(
          "div",
          {
            className: c.contactInfoItem,
            style: {
              color: g
            },
            children: [
              /* @__PURE__ */ e(r, { value: p }),
              /* @__PURE__ */ e(i, { type: "Link", className: c.contactLink, value: u })
            ]
          }
        ),
        /* @__PURE__ */ e(
          a,
          {
            languages: s,
            displayClass: c.languageSwitcher,
            showDivider: !1
          }
        ),
        /* @__PURE__ */ e("div", { className: c.mobileMenuContainer, children: /* @__PURE__ */ e(
          o,
          {
            logo: m,
            pages: _,
            burgerClass: c.burger,
            languages: s,
            menuItems: v
          }
        ) })
      ] }) })
    }
  );
}, I0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: x0,
  meta: $,
  styles: C0
}, Symbol.toStringTag, { value: "Module" })), A0 = "_buttonsWrapper_1akv1_132", S0 = "_burger_1akv1_165", k0 = "_logoImg_1akv1_169", j0 = "_desktopMenu_1akv1_173", w0 = "_navBar_1akv1_182", M0 = "_navMenu_1akv1_188 navbar-nav", W0 = "_navLink_1akv1_204", E0 = "_mobileMenu_1akv1_221", T0 = "_languageSwitcher_1akv1_225", L0 = "_mobileMenuContainer_1akv1_234", O0 = "_contactInfoItem_1akv1_243", z0 = "_contactLink_1akv1_258", P0 = {
  buttonsWrapper: A0,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1akv1_138",
  "spaceAfter--small": "_spaceAfter--small_1akv1_141",
  "spaceAfter--medium": "_spaceAfter--medium_1akv1_144",
  burger: S0,
  logoImg: k0,
  desktopMenu: j0,
  navBar: w0,
  navMenu: M0,
  navLink: W0,
  mobileMenu: E0,
  languageSwitcher: T0,
  mobileMenuContainer: L0,
  contactInfoItem: O0,
  contactLink: z0
}, B0 = ({
  Elements: { Logo: n, MobileMenu: o, DesktopMenu: t, LanguageSwitcher: a, Button: i, Icon: r },
  classes: c,
  languages: s,
  pages: _,
  logo: m,
  phone_icon: p,
  phone: u,
  menuItems: v,
  globalNavbarSettings: f
}) => {
  const { backgroundColor: h, navLinksColor: g } = f;
  return /* @__PURE__ */ e(
    "header",
    {
      className: c.navBar,
      style: {
        backgroundColor: h,
        "--navLinksColor": g
      },
      children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e(
          n,
          {
            pages: _,
            value: m,
            className: `flex-fill ${c.logoImg}`
          }
        ),
        /* @__PURE__ */ e("div", { className: `flex-fill ${c.desktopMenu}`, children: /* @__PURE__ */ e("div", { className: "navbar-expand-lg", children: /* @__PURE__ */ e(
          t,
          {
            className: c.navMenu,
            itemClass: c.navItem,
            itemActive: c.naveItemActive,
            linkClass: c.navLink,
            pages: _,
            menuItems: v,
            navLinksColor: g
          }
        ) }) }),
        /* @__PURE__ */ l(
          "div",
          {
            className: c.contactInfoItem,
            style: {
              color: g
            },
            children: [
              /* @__PURE__ */ e(r, { value: p }),
              /* @__PURE__ */ e(i, { className: c.contactLink, value: u })
            ]
          }
        ),
        /* @__PURE__ */ e(
          a,
          {
            languages: s,
            displayClass: c.languageSwitcher,
            showDivider: !1
          }
        ),
        /* @__PURE__ */ e("div", { className: c.mobileMenuContainer, children: /* @__PURE__ */ e(
          o,
          {
            logo: m,
            pages: _,
            burgerClass: c.burger,
            languages: s,
            menuItems: v
          }
        ) })
      ] }) })
    }
  );
}, q0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: B0,
  meta: $,
  styles: P0
}, Symbol.toStringTag, { value: "Module" })), H0 = "_buttonsWrapper_1n9gc_132", V0 = "_topBarContainer_1n9gc_165", F0 = "_desktopMenu_1n9gc_169", D0 = "_navBar_1n9gc_178", X0 = "_navBarRow_1n9gc_191", R0 = "_languageSwitcher_1n9gc_195", G0 = "_mobileMenuContainer_1n9gc_204", U0 = "_contactInfoItem_1n9gc_213", J0 = "_contactLink_1n9gc_233", Q0 = "_logoImg_1n9gc_248", K0 = "_navbar_1n9gc_252", Z0 = "_navMenu_1n9gc_256 navbar-nav", Y0 = "_navLink_1n9gc_272", eC = "_buttonLink_1n9gc_283", tC = "_burger_1n9gc_288", aC = {
  buttonsWrapper: H0,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1n9gc_138",
  "spaceAfter--small": "_spaceAfter--small_1n9gc_141",
  "spaceAfter--medium": "_spaceAfter--medium_1n9gc_144",
  topBarContainer: V0,
  desktopMenu: F0,
  navBar: D0,
  navBarRow: X0,
  languageSwitcher: R0,
  mobileMenuContainer: G0,
  contactInfoItem: U0,
  contactLink: J0,
  logoImg: Q0,
  navbar: K0,
  navMenu: Z0,
  navLink: Y0,
  buttonLink: eC,
  burger: tC
}, nC = ({
  Elements: { Logo: n, DesktopMenu: o, MobileMenu: t, Icon: a, Button: i, LanguageSwitcher: r },
  classes: c,
  languages: s,
  pages: _,
  logo: m,
  phone_icon: p,
  phone: u,
  menuItems: v,
  globalNavbarSettings: f
}) => {
  const { backgroundColor: h, navLinksColor: g } = f;
  return /* @__PURE__ */ e(
    "header",
    {
      className: c.topBarContainer,
      style: {
        backgroundColor: h,
        "--navLinksColor": g
      },
      children: /* @__PURE__ */ e("div", { className: `container ${c.navBar}`, children: /* @__PURE__ */ l(
        "div",
        {
          className: `d-flex justify-content-between align-items-center ${c.navBarRow}`,
          children: [
            /* @__PURE__ */ e(
              n,
              {
                pages: _,
                value: m,
                className: `flex-fill ${c.logoImg}`
              }
            ),
            /* @__PURE__ */ e("div", { className: `flex-fill ${c.desktopMenu}`, children: /* @__PURE__ */ e("div", { className: `navbar-expand-lg ${c.navbar}`, children: /* @__PURE__ */ e(
              o,
              {
                className: c.navMenu,
                itemClass: c.navItem,
                itemActive: c.naveItemActive,
                linkClass: c.navLink,
                pages: _,
                menuItems: v,
                navLinksColor: g
              }
            ) }) }),
            /* @__PURE__ */ l(
              "div",
              {
                className: c.contactInfoItem,
                style: {
                  color: g
                },
                children: [
                  /* @__PURE__ */ e(a, { value: p }),
                  /* @__PURE__ */ e(
                    i,
                    {
                      type: "Link",
                      value: u,
                      className: c.contactLink,
                      customStyle: c.buttonLink,
                      pages: _ == null ? void 0 : _.value
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ e(
              r,
              {
                languages: s,
                displayClass: c.languageSwitcher,
                showDivider: !1
              }
            ),
            /* @__PURE__ */ e("div", { className: c.mobileMenuContainer, children: /* @__PURE__ */ e(
              t,
              {
                className: c.mobileMenu,
                logo: m,
                pages: _,
                languages: s,
                menuItems: v,
                burgerClass: c.burger,
                phone: u,
                phoneIcon: p
              }
            ) })
          ]
        }
      ) })
    }
  );
}, oC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: nC,
  meta: $,
  styles: aC
}, Symbol.toStringTag, { value: "Module" })), iC = "_buttonsWrapper_pt0yc_132", lC = "_contactInfoLink_pt0yc_165", rC = "_burger_pt0yc_174", cC = "_logoCol_pt0yc_178", sC = "_logoImg_pt0yc_182", dC = "_phone_pt0yc_186", _C = "_contactInfo_pt0yc_165", mC = "_contactInfoItem_pt0yc_195", uC = "_contactInfoIcon_pt0yc_203", pC = "_navBar_pt0yc_207", vC = "_navLink_pt0yc_225", fC = {
  buttonsWrapper: iC,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_pt0yc_138",
  "spaceAfter--small": "_spaceAfter--small_pt0yc_141",
  "spaceAfter--medium": "_spaceAfter--medium_pt0yc_144",
  contactInfoLink: lC,
  burger: rC,
  logoCol: cC,
  logoImg: sC,
  phone: dC,
  contactInfo: _C,
  contactInfoItem: mC,
  contactInfoIcon: uC,
  navBar: pC,
  navLink: vC
}, gC = ({
  Elements: { Logo: n, Icon: o, Button: t, LanguageSwitcher: a, DesktopMenu: i, MobileMenu: r },
  classes: c,
  languages: s,
  pages: _,
  logo: m,
  phone: p,
  email: u,
  email_icon: v,
  phone_icon: f,
  menuItems: h,
  globalNavbarSettings: g
}) => {
  const { backgroundColor: N, navLinksColor: I } = g;
  return /* @__PURE__ */ e(
    "header",
    {
      className: c.header,
      style: {
        backgroundColor: N
      },
      children: /* @__PURE__ */ e("div", { className: c.navBar, id: "navBarContainer", children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row align-items-center", children: [
        /* @__PURE__ */ e(
          "div",
          {
            className: `col-auto flex-grow-1 flex-md-grow-0 ${c.logoCol}`,
            children: /* @__PURE__ */ e("div", { className: c.logoImg, id: "logo", children: /* @__PURE__ */ e(n, { pages: _, value: m }) })
          }
        ),
        /* @__PURE__ */ e("div", { className: "col-auto flex-grow-1", id: "desktopMenu", children: /* @__PURE__ */ e(
          i,
          {
            className: "d-none d-lg-flex",
            linkClass: c.navLink,
            pages: _,
            menuItems: h,
            navLinksColor: I
          }
        ) }),
        /* @__PURE__ */ l("div", { className: `${c.secondCol}`, children: [
          /* @__PURE__ */ e(
            r,
            {
              displayClass: "d-lg-none",
              logo: m,
              pages: _,
              burgerClass: c.burger,
              languages: s,
              menuItems: h
            }
          ),
          /* @__PURE__ */ l("div", { className: `${c.contactInfo} d-none d-lg-flex`, children: [
            /* @__PURE__ */ l("span", { className: c.contactInfoItem, children: [
              /* @__PURE__ */ e(
                o,
                {
                  className: c.contactInfoIcon,
                  value: f
                }
              ),
              /* @__PURE__ */ e(
                t,
                {
                  type: "Link",
                  value: p,
                  className: c.contactInfoLink
                }
              )
            ] }),
            /* @__PURE__ */ l("span", { className: c.contactInfoItem, children: [
              /* @__PURE__ */ e(
                o,
                {
                  className: c.contactInfoIcon,
                  value: v
                }
              ),
              /* @__PURE__ */ e(
                t,
                {
                  type: "Link",
                  value: u,
                  className: c.contactInfoLink
                }
              )
            ] })
          ] })
        ] }),
        /* @__PURE__ */ e("div", { className: "d-none d-lg-flex", id: "languageSwitcher", children: /* @__PURE__ */ e(
          a,
          {
            displayClass: "d-none d-lg-block",
            languages: s,
            showDivider: !1
          }
        ) })
      ] }) }) })
    }
  );
}, hC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gC,
  meta: $,
  styles: fC
}, Symbol.toStringTag, { value: "Module" })), bC = "_buttonsWrapper_2gsam_132", yC = "_siteBar_2gsam_165", $C = "_desktopMenu_2gsam_169", NC = "_navMenu_2gsam_178", CC = "_navLink_2gsam_186", xC = "_logoImg_2gsam_193", IC = "_languageSwitcher_2gsam_197", AC = "_mobileMenuContainer_2gsam_206", SC = "_burger_2gsam_215", kC = {
  buttonsWrapper: bC,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_2gsam_138",
  "spaceAfter--small": "_spaceAfter--small_2gsam_141",
  "spaceAfter--medium": "_spaceAfter--medium_2gsam_144",
  siteBar: yC,
  desktopMenu: $C,
  navMenu: NC,
  navLink: CC,
  logoImg: xC,
  languageSwitcher: IC,
  mobileMenuContainer: AC,
  burger: SC
}, jC = ({
  Elements: { Logo: n, DesktopMenu: o, MobileMenu: t, LanguageSwitcher: a },
  classes: i,
  languages: r,
  pages: c,
  logo: s,
  menuItems: _,
  globalNavbarSettings: m
}) => {
  const { backgroundColor: p, navLinksColor: u } = m;
  return /* @__PURE__ */ e(
    "header",
    {
      className: i.siteBar,
      style: {
        backgroundColor: p,
        "--navLinksColor": u
      },
      children: /* @__PURE__ */ e("div", { className: "container py-4 px-0", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e("div", { className: `${i.logoImg}`, children: /* @__PURE__ */ e(n, { pages: c, value: s }) }),
        /* @__PURE__ */ e("div", { className: `flex-fill ${i.desktopMenu}`, children: /* @__PURE__ */ e("div", { className: "navbar-expand-lg", children: /* @__PURE__ */ e(
          o,
          {
            className: i.navMenu,
            itemClass: i.navItem,
            itemActive: i.naveItemActive,
            linkClass: i.navLink,
            pages: c,
            menuItems: _,
            navLinksColor: u
          }
        ) }) }),
        /* @__PURE__ */ e(
          a,
          {
            languages: r,
            displayClass: i.languageSwitcher,
            showDivider: !1
          }
        ),
        /* @__PURE__ */ e("div", { className: i.mobileMenuContainer, children: /* @__PURE__ */ e(
          t,
          {
            logo: s,
            pages: c,
            languages: r,
            menuItems: _,
            burgerClass: i.burger
          }
        ) })
      ] }) })
    }
  );
}, wC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jC,
  meta: $,
  styles: kC
}, Symbol.toStringTag, { value: "Module" })), MC = "_buttonsWrapper_2gsam_132", WC = "_siteBar_2gsam_165", EC = "_desktopMenu_2gsam_169", TC = "_navMenu_2gsam_178", LC = "_navLink_2gsam_186", OC = "_logoImg_2gsam_193", zC = "_languageSwitcher_2gsam_197", PC = "_mobileMenuContainer_2gsam_206", BC = "_burger_2gsam_215", qC = {
  buttonsWrapper: MC,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_2gsam_138",
  "spaceAfter--small": "_spaceAfter--small_2gsam_141",
  "spaceAfter--medium": "_spaceAfter--medium_2gsam_144",
  siteBar: WC,
  desktopMenu: EC,
  navMenu: TC,
  navLink: LC,
  logoImg: OC,
  languageSwitcher: zC,
  mobileMenuContainer: PC,
  burger: BC
}, HC = ({
  Elements: { Logo: n, DesktopMenu: o, MobileMenu: t, LanguageSwitcher: a },
  classes: i,
  languages: r,
  pages: c,
  logo: s,
  menuItems: _,
  globalNavbarSettings: m
}) => {
  const { backgroundColor: p, navLinksColor: u } = m;
  return /* @__PURE__ */ e(
    "header",
    {
      className: i.siteBar,
      style: {
        backgroundColor: p,
        "--navLinksColor": u
      },
      children: /* @__PURE__ */ e("div", { className: "container py-4 px-0", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e("div", { className: `${i.logoImg}`, children: /* @__PURE__ */ e(n, { pages: c, value: s }) }),
        /* @__PURE__ */ e("div", { className: `flex-fill ${i.desktopMenu}`, children: /* @__PURE__ */ e("div", { className: "navbar-expand-lg", children: /* @__PURE__ */ e(
          o,
          {
            className: i.navMenu,
            itemClass: i.navItem,
            itemActive: i.naveItemActive,
            linkClass: i.navLink,
            pages: c,
            menuItems: _,
            navLinksColor: u
          }
        ) }) }),
        /* @__PURE__ */ e(
          a,
          {
            languages: r,
            displayClass: i.languageSwitcher,
            showDivider: !1
          }
        ),
        /* @__PURE__ */ e("div", { className: i.mobileMenuContainer, children: /* @__PURE__ */ e(
          t,
          {
            logo: s,
            pages: c,
            languages: r,
            menuItems: _,
            burgerClass: i.burger
          }
        ) })
      ] }) })
    }
  );
}, VC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: HC,
  meta: $,
  styles: qC
}, Symbol.toStringTag, { value: "Module" })), FC = "_buttonsWrapper_2gsam_132", DC = "_siteBar_2gsam_165", XC = "_desktopMenu_2gsam_169", RC = "_navMenu_2gsam_178", GC = "_navLink_2gsam_186", UC = "_logoImg_2gsam_193", JC = "_languageSwitcher_2gsam_197", QC = "_mobileMenuContainer_2gsam_206", KC = "_burger_2gsam_215", ZC = {
  buttonsWrapper: FC,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_2gsam_138",
  "spaceAfter--small": "_spaceAfter--small_2gsam_141",
  "spaceAfter--medium": "_spaceAfter--medium_2gsam_144",
  siteBar: DC,
  desktopMenu: XC,
  navMenu: RC,
  navLink: GC,
  logoImg: UC,
  languageSwitcher: JC,
  mobileMenuContainer: QC,
  burger: KC
}, YC = ({
  Elements: { Logo: n, DesktopMenu: o, MobileMenu: t, LanguageSwitcher: a },
  classes: i,
  languages: r,
  pages: c,
  logo: s,
  menuItems: _,
  globalNavbarSettings: m
}) => {
  const { backgroundColor: p, navLinksColor: u } = m;
  return /* @__PURE__ */ e(
    "header",
    {
      className: i.siteBar,
      style: {
        backgroundColor: p,
        "--navLinksColor": u
      },
      children: /* @__PURE__ */ e("div", { className: "container py-4 px-0", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e("div", { className: `${i.logoImg}`, children: /* @__PURE__ */ e(n, { pages: c, value: s }) }),
        /* @__PURE__ */ e("div", { className: `flex-fill ${i.desktopMenu}`, children: /* @__PURE__ */ e("div", { className: "navbar-expand-lg", children: /* @__PURE__ */ e(
          o,
          {
            className: i.navMenu,
            itemClass: i.navItem,
            itemActive: i.naveItemActive,
            linkClass: i.navLink,
            pages: c,
            menuItems: _,
            navLinksColor: u
          }
        ) }) }),
        /* @__PURE__ */ e(
          a,
          {
            languages: r,
            displayClass: i.languageSwitcher,
            showDivider: !1
          }
        ),
        /* @__PURE__ */ e("div", { className: i.mobileMenuContainer, children: /* @__PURE__ */ e(
          t,
          {
            logo: s,
            pages: c,
            languages: r,
            menuItems: _,
            burgerClass: i.burger
          }
        ) })
      ] }) })
    }
  );
}, ex = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: YC,
  meta: $,
  styles: ZC
}, Symbol.toStringTag, { value: "Module" })), tx = "_buttonsWrapper_2gsam_132", ax = "_siteBar_2gsam_165", nx = "_desktopMenu_2gsam_169", ox = "_navMenu_2gsam_178", ix = "_navLink_2gsam_186", lx = "_logoImg_2gsam_193", rx = "_languageSwitcher_2gsam_197", cx = "_mobileMenuContainer_2gsam_206", sx = "_burger_2gsam_215", dx = {
  buttonsWrapper: tx,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_2gsam_138",
  "spaceAfter--small": "_spaceAfter--small_2gsam_141",
  "spaceAfter--medium": "_spaceAfter--medium_2gsam_144",
  siteBar: ax,
  desktopMenu: nx,
  navMenu: ox,
  navLink: ix,
  logoImg: lx,
  languageSwitcher: rx,
  mobileMenuContainer: cx,
  burger: sx
}, _x = ({
  Elements: { Logo: n, DesktopMenu: o, MobileMenu: t, LanguageSwitcher: a },
  classes: i,
  languages: r,
  pages: c,
  logo: s,
  menuItems: _,
  globalNavbarSettings: m
}) => {
  const { backgroundColor: p, navLinksColor: u } = m;
  return /* @__PURE__ */ e(
    "header",
    {
      className: i.siteBar,
      style: {
        backgroundColor: p,
        "--navLinksColor": u
      },
      children: /* @__PURE__ */ e("div", { className: "container py-4 px-0", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e("div", { className: `${i.logoImg}`, children: /* @__PURE__ */ e(n, { pages: c, value: s }) }),
        /* @__PURE__ */ e("div", { className: `flex-fill ${i.desktopMenu}`, children: /* @__PURE__ */ e("div", { className: "navbar-expand-lg", children: /* @__PURE__ */ e(
          o,
          {
            className: i.navMenu,
            itemClass: i.navItem,
            itemActive: i.naveItemActive,
            linkClass: i.navLink,
            pages: c,
            menuItems: _,
            navLinksColor: u
          }
        ) }) }),
        /* @__PURE__ */ e(
          a,
          {
            languages: r,
            displayClass: i.languageSwitcher,
            showDivider: !1
          }
        ),
        /* @__PURE__ */ e("div", { className: i.mobileMenuContainer, children: /* @__PURE__ */ e(
          t,
          {
            logo: s,
            pages: c,
            languages: r,
            menuItems: _,
            burgerClass: i.burger
          }
        ) })
      ] }) })
    }
  );
}, mx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _x,
  meta: $,
  styles: dx
}, Symbol.toStringTag, { value: "Module" })), ux = "_buttonsWrapper_2gsam_132", px = "_siteBar_2gsam_165", vx = "_desktopMenu_2gsam_169", fx = "_navMenu_2gsam_178", gx = "_navLink_2gsam_186", hx = "_logoImg_2gsam_193", bx = "_languageSwitcher_2gsam_197", yx = "_mobileMenuContainer_2gsam_206", $x = "_burger_2gsam_215", Nx = {
  buttonsWrapper: ux,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_2gsam_138",
  "spaceAfter--small": "_spaceAfter--small_2gsam_141",
  "spaceAfter--medium": "_spaceAfter--medium_2gsam_144",
  siteBar: px,
  desktopMenu: vx,
  navMenu: fx,
  navLink: gx,
  logoImg: hx,
  languageSwitcher: bx,
  mobileMenuContainer: yx,
  burger: $x
}, Cx = ({
  Elements: { Logo: n, DesktopMenu: o, MobileMenu: t, LanguageSwitcher: a },
  classes: i,
  languages: r,
  pages: c,
  logo: s,
  menuItems: _,
  globalNavbarSettings: m
}) => {
  const { backgroundColor: p, navLinksColor: u } = m;
  return /* @__PURE__ */ e(
    "header",
    {
      className: i.siteBar,
      style: {
        backgroundColor: p,
        "--navLinksColor": u
      },
      children: /* @__PURE__ */ e("div", { className: "container py-4 px-0", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e("div", { className: `${i.logoImg}`, children: /* @__PURE__ */ e(n, { pages: c, value: s }) }),
        /* @__PURE__ */ e("div", { className: `flex-fill ${i.desktopMenu}`, children: /* @__PURE__ */ e("div", { className: "navbar-expand-lg", children: /* @__PURE__ */ e(
          o,
          {
            className: i.navMenu,
            itemClass: i.navItem,
            itemActive: i.naveItemActive,
            linkClass: i.navLink,
            pages: c,
            menuItems: _,
            navLinksColor: u
          }
        ) }) }),
        /* @__PURE__ */ e(
          a,
          {
            languages: r,
            displayClass: i.languageSwitcher,
            showDivider: !1
          }
        ),
        /* @__PURE__ */ e("div", { className: i.mobileMenuContainer, children: /* @__PURE__ */ e(
          t,
          {
            logo: s,
            pages: c,
            languages: r,
            menuItems: _,
            burgerClass: i.burger
          }
        ) })
      ] }) })
    }
  );
}, xx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Cx,
  meta: $,
  styles: Nx
}, Symbol.toStringTag, { value: "Module" })), Ix = "_buttonsWrapper_1alsj_132", Ax = "_siteBar_1alsj_165", Sx = "_desktopMenu_1alsj_171", kx = "_navMenu_1alsj_180", jx = "_navLink_1alsj_188", wx = "_logoImg_1alsj_195", Mx = "_languageSwitcher_1alsj_199", Wx = "_mobileMenuContainer_1alsj_208", Ex = "_socialLinksContainer_1alsj_217", Tx = "_social_1alsj_217", Lx = "_socialItem_1alsj_233", Ox = "_burger_1alsj_241", zx = {
  buttonsWrapper: Ix,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1alsj_138",
  "spaceAfter--small": "_spaceAfter--small_1alsj_141",
  "spaceAfter--medium": "_spaceAfter--medium_1alsj_144",
  siteBar: Ax,
  desktopMenu: Sx,
  navMenu: kx,
  navLink: jx,
  logoImg: wx,
  languageSwitcher: Mx,
  mobileMenuContainer: Wx,
  socialLinksContainer: Ex,
  social: Tx,
  socialItem: Lx,
  burger: Ox
}, Px = ({
  Elements: { Logo: n, DesktopMenu: o, MobileMenu: t, SocialLinks: a, LanguageSwitcher: i },
  classes: r,
  languages: c,
  pages: s,
  logo: _,
  socialLinks: m,
  menuItems: p,
  globalNavbarSettings: u
}) => {
  const { backgroundColor: v, navLinksColor: f } = u;
  return /* @__PURE__ */ e(
    "header",
    {
      className: r.siteBar,
      style: {
        backgroundColor: v,
        "--navLinksColor": f
      },
      children: /* @__PURE__ */ l("div", { className: "container d-flex py-4 justify-content-between align-items-center", children: [
        /* @__PURE__ */ e(
          n,
          {
            pages: s,
            value: _,
            className: `flex-fill ${r.logoImg}`
          }
        ),
        /* @__PURE__ */ e("div", { className: `flex-fill ${r.desktopMenu}`, children: /* @__PURE__ */ e("div", { className: "navbar-expand-lg", children: /* @__PURE__ */ e(
          o,
          {
            className: r.navMenu,
            itemClass: r.navItem,
            itemActive: r.naveItemActive,
            linkClass: r.navLink,
            pages: s,
            menuItems: p,
            navLinksColor: f
          }
        ) }) }),
        /* @__PURE__ */ e("div", { className: r.socialLinksContainer, children: /* @__PURE__ */ e(
          a,
          {
            value: m,
            listClass: r.social,
            itemClass: r.socialItem,
            navLinksColor: f
          }
        ) }),
        /* @__PURE__ */ e(
          i,
          {
            languages: c,
            displayClass: r.languageSwitcher,
            showDivider: !1
          }
        ),
        /* @__PURE__ */ e("div", { className: r.mobileMenuContainer, children: /* @__PURE__ */ e(
          t,
          {
            className: r.mobileMenu,
            logo: _,
            pages: s,
            languages: c,
            menuItems: p,
            burgerClass: r.burger
          }
        ) })
      ] })
    }
  );
}, Bx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Px,
  meta: $,
  styles: zx
}, Symbol.toStringTag, { value: "Module" })), qx = "_buttonsWrapper_1o7hw_132", Hx = "_siteBar_1o7hw_165", Vx = "_desktopMenu_1o7hw_169", Fx = "_navMenu_1o7hw_178", Dx = "_navLink_1o7hw_186", Xx = "_logoImg_1o7hw_193", Rx = "_languageSwitcher_1o7hw_197", Gx = "_mobileMenuContainer_1o7hw_206", Ux = "_burger_1o7hw_215", Jx = {
  buttonsWrapper: qx,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1o7hw_138",
  "spaceAfter--small": "_spaceAfter--small_1o7hw_141",
  "spaceAfter--medium": "_spaceAfter--medium_1o7hw_144",
  siteBar: Hx,
  desktopMenu: Vx,
  navMenu: Fx,
  navLink: Dx,
  logoImg: Xx,
  languageSwitcher: Rx,
  mobileMenuContainer: Gx,
  burger: Ux
}, Qx = ({
  Elements: { Logo: n, DesktopMenu: o, MobileMenu: t, LanguageSwitcher: a },
  classes: i,
  languages: r,
  pages: c,
  logo: s,
  menuItems: _,
  globalNavbarSettings: m
}) => {
  const { backgroundColor: p, navLinksColor: u } = m;
  return /* @__PURE__ */ e(
    "header",
    {
      className: i.siteBar,
      style: {
        backgroundColor: p,
        "--navLinksColor": u
      },
      children: /* @__PURE__ */ l("div", { className: "container d-flex py-3 justify-content-between align-items-center", children: [
        /* @__PURE__ */ e("div", { className: ` ${i.logoImg}`, children: /* @__PURE__ */ e(n, { pages: c, value: s }) }),
        /* @__PURE__ */ e("div", { className: `flex-fill ${i.desktopMenu}`, children: /* @__PURE__ */ e("div", { className: "navbar-expand-lg", children: /* @__PURE__ */ e(
          o,
          {
            className: i.navMenu,
            itemClass: i.navItem,
            itemActive: i.naveItemActive,
            linkClass: i.navLink,
            pages: c,
            menuItems: _,
            navLinksColor: u
          }
        ) }) }),
        /* @__PURE__ */ e(
          a,
          {
            languages: r,
            displayClass: i.languageSwitcher,
            showDivider: !1
          }
        ),
        /* @__PURE__ */ e("div", { className: i.mobileMenuContainer, children: /* @__PURE__ */ e(
          t,
          {
            className: i.mobileMenu,
            logo: s,
            pages: c,
            languages: r,
            burgerClass: i.burger,
            menuItems: _
          }
        ) })
      ] })
    }
  );
}, Kx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Qx,
  meta: $,
  styles: Jx
}, Symbol.toStringTag, { value: "Module" })), Zx = "_buttonsWrapper_w0nn2_132", Yx = "_globalHeader_w0nn2_165", e4 = "_navbarBrand_w0nn2_171", t4 = "_desktopMenu_w0nn2_175", a4 = "_navMenu_w0nn2_187", n4 = "_navLink_w0nn2_198", o4 = "_mobileMenuContainer_w0nn2_205", i4 = "_socialLinksContainer_w0nn2_214", l4 = "_socialLinksList_w0nn2_225", r4 = "_socialLinksListItem_w0nn2_231", c4 = "_languageSwitcher_w0nn2_239", s4 = "_burger_w0nn2_248", d4 = {
  buttonsWrapper: Zx,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_w0nn2_138",
  "spaceAfter--small": "_spaceAfter--small_w0nn2_141",
  "spaceAfter--medium": "_spaceAfter--medium_w0nn2_144",
  globalHeader: Yx,
  navbarBrand: e4,
  desktopMenu: t4,
  navMenu: a4,
  navLink: n4,
  mobileMenuContainer: o4,
  socialLinksContainer: i4,
  socialLinksList: l4,
  socialLinksListItem: r4,
  languageSwitcher: c4,
  burger: s4
}, _4 = ({
  Elements: { Logo: n, DesktopMenu: o, MobileMenu: t, SocialLinks: a, LanguageSwitcher: i },
  classes: r,
  languages: c,
  logo: s,
  pages: _,
  socialLinks: m,
  menuItems: p,
  globalNavbarSettings: u
}) => {
  const { backgroundColor: v, navLinksColor: f } = u;
  return /* @__PURE__ */ e(
    "header",
    {
      className: r.globalHeader,
      style: {
        backgroundColor: v,
        "--navLinksColor": f
      },
      children: /* @__PURE__ */ e("div", { className: "container py-3", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e("div", { className: r.navbarBrand, children: /* @__PURE__ */ e(n, { pages: _, value: s }) }),
        /* @__PURE__ */ e("div", { className: `${r.desktopMenu}`, children: /* @__PURE__ */ e(
          o,
          {
            className: r.navMenu,
            itemClass: r.navItem,
            itemActive: r.naveItemActive,
            linkClass: r.navLink,
            pages: _,
            menuItems: p,
            navLinksColor: f
          }
        ) }),
        /* @__PURE__ */ e("div", { className: r.socialLinksContainer, children: /* @__PURE__ */ e(
          a,
          {
            value: m,
            listClass: r.socialLinksList,
            itemClass: r.socialLinksListItem,
            navLinksColor: f
          }
        ) }),
        /* @__PURE__ */ e(
          i,
          {
            languages: c,
            displayClass: r.languageSwitcher,
            showDivider: !1
          }
        ),
        /* @__PURE__ */ e("div", { className: r.mobileMenuContainer, children: /* @__PURE__ */ e(
          t,
          {
            logo: s,
            pages: _,
            languages: c,
            menuItems: p,
            burgerClass: r.burger
          }
        ) })
      ] }) })
    }
  );
}, m4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _4,
  meta: $,
  styles: d4
}, Symbol.toStringTag, { value: "Module" })), u4 = "_buttonsWrapper_110ge_132", p4 = "_header_110ge_165", v4 = "_desktopMenu_110ge_169", f4 = "_mobileMenuContainer_110ge_179", g4 = "_burger_110ge_188", h4 = "_logoImg_110ge_192", b4 = "_navMenu_110ge_199", y4 = "_navLink_110ge_207", $4 = "_languageSwitcher_110ge_215", N4 = {
  buttonsWrapper: u4,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_110ge_138",
  "spaceAfter--small": "_spaceAfter--small_110ge_141",
  "spaceAfter--medium": "_spaceAfter--medium_110ge_144",
  header: p4,
  desktopMenu: v4,
  mobileMenuContainer: f4,
  burger: g4,
  logoImg: h4,
  navMenu: b4,
  navLink: y4,
  languageSwitcher: $4
}, C4 = ({
  Elements: { Logo: n, DesktopMenu: o, LanguageSwitcher: t, MobileMenu: a },
  classes: i,
  languages: r,
  pages: c,
  logo: s,
  menuItems: _,
  globalNavbarSettings: m
}) => {
  const { backgroundColor: p, navLinksColor: u } = m;
  return /* @__PURE__ */ e(
    "header",
    {
      className: i.header,
      style: {
        backgroundColor: p,
        "--navLinksColor": u
      },
      children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e(n, { pages: c, value: s, className: ` ${i.logoImg}` }),
        /* @__PURE__ */ l("div", { className: ` ${i.desktopMenu}`, children: [
          /* @__PURE__ */ e(
            o,
            {
              className: i.navMenu,
              itemClass: i.navItem,
              linkClass: i.navLink,
              pages: c,
              menuItems: _,
              navLinksColor: u
            }
          ),
          /* @__PURE__ */ e(
            t,
            {
              displayClass: i.languageSwitcher,
              languages: r
            }
          )
        ] }),
        /* @__PURE__ */ e("div", { className: i.mobileMenuContainer, children: /* @__PURE__ */ e(
          a,
          {
            logo: s,
            pages: c,
            burgerClass: i.burger,
            languages: r,
            menuItems: _
          }
        ) })
      ] }) })
    }
  );
}, x4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: C4,
  meta: $,
  styles: N4
}, Symbol.toStringTag, { value: "Module" })), I4 = "_buttonsWrapper_lvmzc_132", A4 = "_header_lvmzc_165", S4 = "_desktopMenu_lvmzc_169", k4 = "_mobileMenuContainer_lvmzc_179", j4 = "_burger_lvmzc_188", w4 = "_logoImg_lvmzc_192", M4 = "_navMenu_lvmzc_199", W4 = "_navLink_lvmzc_208", E4 = "_socialLinksContainer_lvmzc_216", T4 = "_socialIcons_lvmzc_230", L4 = "_socialIcon_lvmzc_230", O4 = "_languageSwitcher_lvmzc_245", z4 = {
  buttonsWrapper: I4,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_lvmzc_138",
  "spaceAfter--small": "_spaceAfter--small_lvmzc_141",
  "spaceAfter--medium": "_spaceAfter--medium_lvmzc_144",
  header: A4,
  desktopMenu: S4,
  mobileMenuContainer: k4,
  burger: j4,
  logoImg: w4,
  navMenu: M4,
  navLink: W4,
  socialLinksContainer: E4,
  socialIcons: T4,
  socialIcon: L4,
  languageSwitcher: O4
}, P4 = ({
  Elements: { Logo: n, SocialLinks: o, LanguageSwitcher: t, DesktopMenu: a, MobileMenu: i },
  classes: r,
  languages: c,
  pages: s,
  logo: _,
  socialLinks: m,
  menuItems: p,
  globalNavbarSettings: u
}) => {
  const { backgroundColor: v, navLinksColor: f } = u;
  return /* @__PURE__ */ e(
    "header",
    {
      className: r.header,
      style: {
        backgroundColor: v,
        "--navLinksColor": f
      },
      children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(n, { pages: s, value: _, className: r.logoImg }) }),
        /* @__PURE__ */ e("div", { className: r.desktopMenu, children: /* @__PURE__ */ e(
          a,
          {
            className: r.navMenu,
            itemClass: r.navItem,
            linkClass: r.navLink,
            pages: s,
            menuItems: p,
            navLinksColor: f
          }
        ) }),
        /* @__PURE__ */ l("div", { className: r.socialLinksContainer, children: [
          /* @__PURE__ */ e(
            o,
            {
              value: m,
              listClass: `${r.socialIcons}`,
              itemClass: r.socialIcon,
              navLinksColor: f
            }
          ),
          /* @__PURE__ */ e(
            t,
            {
              displayClass: r.languageSwitcher,
              languages: c
            }
          )
        ] }),
        /* @__PURE__ */ e("div", { className: r.mobileMenuContainer, children: /* @__PURE__ */ e(
          i,
          {
            logo: _,
            pages: s,
            burgerClass: r.burger,
            languages: c,
            menuItems: p,
            socialLinks: m
          }
        ) })
      ] }) })
    }
  );
}, B4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: P4,
  meta: $,
  styles: z4
}, Symbol.toStringTag, { value: "Module" })), q4 = "_buttonsWrapper_1abi8_132", H4 = "_header_1abi8_165", V4 = "_desktopMenu_1abi8_169", F4 = "_mobileMenuContainer_1abi8_179", D4 = "_burger_1abi8_188", X4 = "_logoImg_1abi8_192", R4 = "_navMenu_1abi8_199", G4 = "_navLink_1abi8_207", U4 = "_secondaryButton_1abi8_215", J4 = "_buttonLink_1abi8_239", Q4 = "_languageSwitcher_1abi8_244", K4 = "_buttonsContainer_1abi8_253", Z4 = {
  buttonsWrapper: q4,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1abi8_138",
  "spaceAfter--small": "_spaceAfter--small_1abi8_141",
  "spaceAfter--medium": "_spaceAfter--medium_1abi8_144",
  header: H4,
  desktopMenu: V4,
  mobileMenuContainer: F4,
  burger: D4,
  logoImg: X4,
  navMenu: R4,
  navLink: G4,
  secondaryButton: U4,
  buttonLink: J4,
  languageSwitcher: Q4,
  buttonsContainer: K4
}, Y4 = ({
  Elements: { Logo: n, Button: o, LanguageSwitcher: t, DesktopMenu: a, MobileMenu: i },
  classes: r,
  languages: c,
  pages: s,
  logo: _,
  menuItems: m,
  secondary_button: p,
  globalNavbarSettings: u
}) => {
  const { backgroundColor: v, navLinksColor: f } = u;
  return /* @__PURE__ */ e(
    "header",
    {
      className: r.header,
      style: {
        backgroundColor: v,
        "--navLinksColor": f
      },
      children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e(
          n,
          {
            pages: s,
            value: _,
            className: `flex-fill ${r.logoImg}`
          }
        ),
        /* @__PURE__ */ e("div", { className: `flex-fill ${r.desktopMenu}`, children: /* @__PURE__ */ e(
          a,
          {
            className: r.navMenu,
            itemClass: r.navItem,
            linkClass: r.navLink,
            pages: s,
            menuItems: m,
            navLinksColor: f
          }
        ) }),
        /* @__PURE__ */ l("div", { className: r.buttonsContainer, children: [
          /* @__PURE__ */ e(
            o,
            {
              type: "Secondary",
              isHeader: !0,
              value: p,
              customStyle: r.buttonLink,
              pages: s == null ? void 0 : s.value
            }
          ),
          /* @__PURE__ */ e(
            t,
            {
              displayClass: r.languageSwitcher,
              languages: c
            }
          )
        ] }),
        /* @__PURE__ */ e("div", { className: r.mobileMenuContainer, children: /* @__PURE__ */ e(
          i,
          {
            logo: _,
            pages: s,
            burgerClass: r.burger,
            languages: c,
            menuItems: m,
            secondaryButton: p
          }
        ) })
      ] }) })
    }
  );
}, e3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Y4,
  meta: $,
  styles: Z4
}, Symbol.toStringTag, { value: "Module" })), t3 = "_buttonsWrapper_12ybt_132", a3 = "_header_12ybt_165", n3 = "_desktopMenu_12ybt_169", o3 = "_mobileMenuContainer_12ybt_179", i3 = "_burger_12ybt_188", l3 = "_logoImg_12ybt_192", r3 = "_navMenu_12ybt_199", c3 = "_navLink_12ybt_208", s3 = "_secondaryButton_12ybt_216", d3 = "_buttonLink_12ybt_240", _3 = "_languageSwitcher_12ybt_245", m3 = "_buttonsContainer_12ybt_254", u3 = {
  buttonsWrapper: t3,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_12ybt_138",
  "spaceAfter--small": "_spaceAfter--small_12ybt_141",
  "spaceAfter--medium": "_spaceAfter--medium_12ybt_144",
  header: a3,
  desktopMenu: n3,
  mobileMenuContainer: o3,
  burger: i3,
  logoImg: l3,
  navMenu: r3,
  navLink: c3,
  secondaryButton: s3,
  buttonLink: d3,
  languageSwitcher: _3,
  buttonsContainer: m3
}, p3 = ({
  Elements: { Logo: n, Button: o, LanguageSwitcher: t, DesktopMenu: a, MobileMenu: i },
  classes: r,
  languages: c,
  pages: s,
  logo: _,
  secondary_button: m,
  menuItems: p,
  globalNavbarSettings: u
}) => {
  const { backgroundColor: v, navLinksColor: f } = u;
  return /* @__PURE__ */ e(
    "header",
    {
      className: r.header,
      style: {
        backgroundColor: v,
        "--navLinksColor": f
      },
      children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(n, { pages: s, value: _, className: r.logoImg }) }),
        /* @__PURE__ */ e("div", { className: r.desktopMenu, children: /* @__PURE__ */ e(
          a,
          {
            className: r.navMenu,
            itemClass: r.navItem,
            linkClass: r.navLink,
            pages: s,
            menuItems: p,
            navLinksColor: f
          }
        ) }),
        /* @__PURE__ */ l("div", { className: r.buttonsContainer, children: [
          /* @__PURE__ */ e(
            o,
            {
              type: "Secondary",
              isHeader: !0,
              value: m,
              customStyle: r.buttonLink,
              pages: s == null ? void 0 : s.value
            }
          ),
          /* @__PURE__ */ e(
            t,
            {
              displayClass: r.languageSwitcher,
              languages: c
            }
          )
        ] }),
        /* @__PURE__ */ e("div", { className: r.mobileMenuContainer, children: /* @__PURE__ */ e(
          i,
          {
            logo: _,
            pages: s,
            burgerClass: r.burger,
            languages: c,
            menuItems: p,
            secondaryButton: m
          }
        ) })
      ] }) })
    }
  );
}, v3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: p3,
  meta: $,
  styles: u3
}, Symbol.toStringTag, { value: "Module" })), f3 = "_buttonsWrapper_1ss1p_132", g3 = "_header_1ss1p_165", h3 = "_desktopMenu_1ss1p_169", b3 = "_navMenu_1ss1p_179", y3 = "_buttonLink_1ss1p_187", $3 = "_navLink_1ss1p_192", N3 = "_mobileMenuContainer_1ss1p_200", C3 = "_buttonsContainer_1ss1p_209", x3 = "_secondaryButton_1ss1p_219", I3 = "_burger_1ss1p_223", A3 = "_logoImg_1ss1p_227", S3 = "_languageSwitcher_1ss1p_234", k3 = {
  buttonsWrapper: f3,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1ss1p_138",
  "spaceAfter--small": "_spaceAfter--small_1ss1p_141",
  "spaceAfter--medium": "_spaceAfter--medium_1ss1p_144",
  header: g3,
  desktopMenu: h3,
  navMenu: b3,
  buttonLink: y3,
  navLink: $3,
  mobileMenuContainer: N3,
  buttonsContainer: C3,
  secondaryButton: x3,
  burger: I3,
  logoImg: A3,
  languageSwitcher: S3
}, j3 = ({
  Elements: { Logo: n, Button: o, LanguageSwitcher: t, DesktopMenu: a, MobileMenu: i },
  classes: r,
  languages: c,
  pages: s,
  logo: _,
  menuItems: m,
  globalNavbarSettings: p,
  primary_button: u,
  secondary_button: v
}) => {
  const { backgroundColor: f, navLinksColor: h } = p;
  return /* @__PURE__ */ e(
    "header",
    {
      className: r.header,
      style: {
        backgroundColor: f,
        "--navLinksColor": h
      },
      children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e(
          n,
          {
            pages: s,
            value: _,
            className: `flex-fill ${r.logoImg}`
          }
        ),
        /* @__PURE__ */ e("div", { className: `flex-fill ${r.desktopMenu}`, children: /* @__PURE__ */ e(
          a,
          {
            className: r.navMenu,
            itemClass: r.navItem,
            linkClass: r.navLink,
            pages: s,
            menuItems: m,
            navLinksColor: h
          }
        ) }),
        /* @__PURE__ */ l("div", { className: r.buttonsContainer, children: [
          /* @__PURE__ */ e(
            o,
            {
              type: "Secondary",
              isHeader: !0,
              value: v,
              customStyle: r.buttonLink,
              pages: s == null ? void 0 : s.value
            }
          ),
          /* @__PURE__ */ e(
            o,
            {
              type: "Primary",
              isHeader: !0,
              value: u,
              customStyle: r.buttonLink,
              pages: s == null ? void 0 : s.value
            }
          )
        ] }),
        /* @__PURE__ */ e(
          t,
          {
            displayClass: r.languageSwitcher,
            languages: c
          }
        ),
        /* @__PURE__ */ e("div", { className: r.mobileMenuContainer, children: /* @__PURE__ */ e(
          i,
          {
            logo: _,
            pages: s,
            burgerClass: r.burger,
            languages: c,
            menuItems: m,
            primaryButton: u,
            secondaryButton: v
          }
        ) })
      ] }) })
    }
  );
}, w3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: j3,
  meta: $,
  styles: k3
}, Symbol.toStringTag, { value: "Module" })), M3 = "_buttonsWrapper_5dpri_132", W3 = "_header_5dpri_165", E3 = "_desktopMenu_5dpri_169", T3 = "_navMenu_5dpri_179", L3 = "_navLink_5dpri_188", O3 = "_mobileMenuContainer_5dpri_196", z3 = "_buttonsContainer_5dpri_205", P3 = "_secondaryButton_5dpri_214", B3 = "_burger_5dpri_233", q3 = "_logoImg_5dpri_237", H3 = "_buttonLink_5dpri_244", V3 = "_languageSwitcher_5dpri_249", F3 = {
  buttonsWrapper: M3,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_5dpri_138",
  "spaceAfter--small": "_spaceAfter--small_5dpri_141",
  "spaceAfter--medium": "_spaceAfter--medium_5dpri_144",
  header: W3,
  desktopMenu: E3,
  navMenu: T3,
  navLink: L3,
  mobileMenuContainer: O3,
  buttonsContainer: z3,
  secondaryButton: P3,
  burger: B3,
  logoImg: q3,
  buttonLink: H3,
  languageSwitcher: V3
}, D3 = ({
  Elements: { Logo: n, Button: o, LanguageSwitcher: t, DesktopMenu: a, MobileMenu: i },
  classes: r,
  languages: c,
  pages: s,
  logo: _,
  menuItems: m,
  globalNavbarSettings: p,
  secondary_button: u
}) => {
  const { backgroundColor: v, navLinksColor: f } = p;
  return /* @__PURE__ */ e(
    "header",
    {
      className: r.header,
      style: {
        backgroundColor: v,
        "--navLinksColor": f
      },
      children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e(
          n,
          {
            pages: s,
            value: _,
            className: `flex-fill ${r.logoImg}`
          }
        ),
        /* @__PURE__ */ l("div", { className: "d-flex align-items-center", children: [
          /* @__PURE__ */ e("div", { className: `flex-fill ${r.desktopMenu}`, children: /* @__PURE__ */ e(
            a,
            {
              className: r.navMenu,
              itemClass: r.navItem,
              linkClass: r.navLink,
              pages: s,
              menuItems: m,
              navLinksColor: f
            }
          ) }),
          /* @__PURE__ */ e("div", { className: r.buttonsContainer, children: /* @__PURE__ */ e(
            o,
            {
              type: "Secondary",
              isHeader: !0,
              value: u,
              customStyle: r.buttonLink,
              pages: s == null ? void 0 : s.value
            }
          ) }),
          /* @__PURE__ */ e(
            t,
            {
              displayClass: r.languageSwitcher,
              languages: c
            }
          )
        ] }),
        /* @__PURE__ */ e("div", { className: r.mobileMenuContainer, children: /* @__PURE__ */ e(
          i,
          {
            logo: _,
            pages: s,
            burgerClass: r.burger,
            languages: c,
            menuItems: m,
            secondaryButton: u
          }
        ) })
      ] }) })
    }
  );
}, X3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: D3,
  meta: $,
  styles: F3
}, Symbol.toStringTag, { value: "Module" })), R3 = "_buttonsWrapper_q8n_132", G3 = "_header_q8n_165", U3 = "_desktopMenu_q8n_169", J3 = "_navMenu_q8n_179", Q3 = "_navLink_q8n_187", K3 = "_mobileMenuContainer_q8n_195", Z3 = "_buttonsContainer_q8n_204", Y3 = "_primaryButton_q8n_213", eI = "_burger_q8n_227", tI = "_logoImg_q8n_231", aI = "_buttonLink_q8n_238", nI = "_languageSwitcher_q8n_243", oI = {
  buttonsWrapper: R3,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_q8n_138",
  "spaceAfter--small": "_spaceAfter--small_q8n_141",
  "spaceAfter--medium": "_spaceAfter--medium_q8n_144",
  header: G3,
  desktopMenu: U3,
  navMenu: J3,
  navLink: Q3,
  mobileMenuContainer: K3,
  buttonsContainer: Z3,
  primaryButton: Y3,
  burger: eI,
  logoImg: tI,
  buttonLink: aI,
  languageSwitcher: nI
}, iI = ({
  Elements: { Logo: n, Button: o, LanguageSwitcher: t, DesktopMenu: a, MobileMenu: i },
  classes: r,
  languages: c,
  pages: s,
  logo: _,
  menuItems: m,
  globalNavbarSettings: p,
  primary_button: u
}) => {
  const { backgroundColor: v, navLinksColor: f } = p;
  return /* @__PURE__ */ e(
    "header",
    {
      className: r.header,
      style: {
        backgroundColor: v,
        "--navLinksColor": f
      },
      children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e(
          n,
          {
            pages: s,
            value: _,
            className: `flex-fill ${r.logoImg}`
          }
        ),
        /* @__PURE__ */ l("div", { className: "d-flex align-items-center", children: [
          /* @__PURE__ */ e("div", { className: `flex-fill ${r.desktopMenu}`, children: /* @__PURE__ */ e(
            a,
            {
              className: r.navMenu,
              itemClass: r.navItem,
              linkClass: r.navLink,
              pages: s,
              menuItems: m,
              navLinksColor: f
            }
          ) }),
          /* @__PURE__ */ e("div", { className: r.buttonsContainer, children: /* @__PURE__ */ e(
            o,
            {
              type: "Primary",
              isHeader: !0,
              value: u,
              customStyle: r.buttonLink,
              pages: s == null ? void 0 : s.value
            }
          ) }),
          /* @__PURE__ */ e(
            t,
            {
              displayClass: r.languageSwitcher,
              languages: c
            }
          )
        ] }),
        /* @__PURE__ */ e("div", { className: r.mobileMenuContainer, children: /* @__PURE__ */ e(
          i,
          {
            logo: _,
            pages: s,
            burgerClass: r.burger,
            languages: c,
            menuItems: m,
            primaryButton: u
          }
        ) })
      ] }) })
    }
  );
}, lI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: iI,
  meta: $,
  styles: oI
}, Symbol.toStringTag, { value: "Module" })), rI = "_buttonsWrapper_43a8n_132", cI = "_header_43a8n_165", sI = "_desktopMenu_43a8n_169", dI = "_navMenu_43a8n_179", _I = "_navLink_43a8n_187", mI = "_mobileMenuContainer_43a8n_195", uI = "_buttonsContainer_43a8n_204", pI = "_secondaryButton_43a8n_214", vI = "_burger_43a8n_218", fI = "_logoImg_43a8n_222", gI = "_buttonLink_43a8n_229", hI = "_languageSwitcher_43a8n_234", bI = {
  buttonsWrapper: rI,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_43a8n_138",
  "spaceAfter--small": "_spaceAfter--small_43a8n_141",
  "spaceAfter--medium": "_spaceAfter--medium_43a8n_144",
  header: cI,
  desktopMenu: sI,
  navMenu: dI,
  navLink: _I,
  mobileMenuContainer: mI,
  buttonsContainer: uI,
  secondaryButton: pI,
  burger: vI,
  logoImg: fI,
  buttonLink: gI,
  languageSwitcher: hI
}, yI = ({
  Elements: { Logo: n, Button: o, LanguageSwitcher: t, DesktopMenu: a, MobileMenu: i },
  classes: r,
  languages: c,
  pages: s,
  logo: _,
  menuItems: m,
  globalNavbarSettings: p,
  primary_button: u,
  secondary_button: v
}) => {
  const { backgroundColor: f, navLinksColor: h } = p;
  return /* @__PURE__ */ e(
    "header",
    {
      className: r.header,
      style: {
        backgroundColor: f,
        "--navLinksColor": h
      },
      children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "d-flex justify-content-between align-items-center", children: [
        /* @__PURE__ */ e(
          n,
          {
            pages: s,
            value: _,
            className: `flex-fill ${r.logoImg}`
          }
        ),
        /* @__PURE__ */ e("div", { className: `flex-fill ${r.desktopMenu}`, children: /* @__PURE__ */ e(
          a,
          {
            className: r.navMenu,
            itemClass: r.navItem,
            linkClass: r.navLink,
            pages: s,
            menuItems: m,
            navLinksColor: h
          }
        ) }),
        /* @__PURE__ */ l("div", { className: r.buttonsContainer, children: [
          /* @__PURE__ */ e(
            o,
            {
              type: "Secondary",
              isHeader: !0,
              value: v,
              customStyle: r.buttonLink,
              pages: s == null ? void 0 : s.value
            }
          ),
          /* @__PURE__ */ e(
            o,
            {
              type: "Primary",
              isHeader: !0,
              value: u,
              customStyle: r.buttonLink,
              pages: s == null ? void 0 : s.value
            }
          )
        ] }),
        /* @__PURE__ */ e(
          t,
          {
            displayClass: r.languageSwitcher,
            languages: c
          }
        ),
        /* @__PURE__ */ e("div", { className: r.mobileMenuContainer, children: /* @__PURE__ */ e(
          i,
          {
            logo: _,
            pages: s,
            burgerClass: r.burger,
            languages: c,
            menuItems: m,
            primaryButton: u,
            secondaryButton: v
          }
        ) })
      ] }) })
    }
  );
}, $I = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yI,
  meta: $,
  styles: bI
}, Symbol.toStringTag, { value: "Module" })), xe = /* @__PURE__ */ Object.assign({ "./0011/index.jsx": O$, "./0012/index.jsx": K$, "./0013/index.jsx": c2, "./0014/index.jsx": C2, "./0015/index.jsx": O2, "./0016/index.jsx": K2, "./0017/index.jsx": mN, "./0018/index.jsx": xN, "./0019/index.jsx": qN, "./0020/index.jsx": ZN, "./0021/index.jsx": d0, "./0022/index.jsx": I0, "./0023/index.jsx": q0, "./0024/index.jsx": oC, "./0025/index.jsx": hC, "./0026/index.jsx": wC, "./0027/index.jsx": VC, "./0028/index.jsx": ex, "./0029/index.jsx": mx, "./0030/index.jsx": xx, "./0031/index.jsx": Bx, "./0032/index.jsx": Kx, "./0033/index.jsx": m4, "./0034/index.jsx": x4, "./0035/index.jsx": B4, "./0036/index.jsx": e3, "./0037/index.jsx": v3, "./0038/index.jsx": w3, "./0039/index.jsx": X3, "./0040/index.jsx": lI, "./0041/index.jsx": $I }), NI = Object.keys(xe).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: xe[o] }),
  {}
), CI = "_buttonsWrapper_1n96j_132", xI = "_hero_1n96j_165", II = "_heroContainer_1n96j_174 container", AI = "_socialLinksContainer_1n96j_183", SI = "_socialIcons_1n96j_196", kI = "_socialIcon_1n96j_196", jI = "_heroContent_1n96j_223", wI = "_imageColumn_1n96j_235", MI = "_imageContainer_1n96j_247", WI = {
  buttonsWrapper: CI,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1n96j_138",
  "spaceAfter--small": "_spaceAfter--small_1n96j_141",
  "spaceAfter--medium": "_spaceAfter--medium_1n96j_144",
  hero: xI,
  heroContainer: II,
  socialLinksContainer: AI,
  socialIcons: SI,
  socialIcon: kI,
  heroContent: jI,
  imageColumn: wI,
  imageContainer: MI
}, C = {
  image: {
    type: d.IMAGE,
    fieldId: 260,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1541362254971-29e9b6af8d05?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=f58b9886fd9017e1ed8d255b6ace511c&auto=format&fit=crop&w=750&q=80"
    }
  },
  socialLinks: {
    type: d.SOCIAL_LINKS,
    fieldId: 270,
    defaultValue: {
      default: {
        facebook: "#",
        twitter: "#",
        linkedin: "#"
      }
    }
  },
  title: {
    type: d.TEXT,
    fieldId: 261,
    defaultValue: {
      default: "<strong>Creativity is to think deeper and more Efficiently</strong>",
      ar: "<strong>الإبداع هو التفكير أعمق و بأكثر كفاءة</strong>"
    }
  },
  subtitle: {
    type: d.TEXT,
    fieldId: 262,
    defaultValue: {
      default: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
      ar: "عائد استثمار مرئي ونتائج مستمرة"
    }
  },
  primary_button: {
    type: d.LINK,
    fieldId: 263,
    defaultValue: {
      default: {
        destination: "external",
        // 'internal'
        target: "current",
        // 'new'
        text: "Start Now",
        pageId: "",
        href: "#"
      },
      ar: {
        destination: "external",
        // 'internal'
        target: "current",
        // 'new'
        text: "ابدا الان",
        pageId: "",
        href: "#"
      }
    }
  },
  secondary_button: {
    type: d.LINK,
    fieldId: 264,
    defaultValue: {
      default: {
        destination: "external",
        target: "current",
        text: "Get In Touch",
        pageId: "",
        href: "#"
      },
      ar: {
        destination: "external",
        target: "current",
        text: "تواصل معنا",
        pageId: "",
        href: "#"
      }
    }
  },
  cta_box_title: {
    type: d.TEXT,
    fieldId: 265,
    defaultValue: {
      default: "Learn about our services and join our community today",
      ar: "تعرف على خداماتنا وانضم إلى مجتمعنا اليوم"
    }
  },
  cta_box_subtitle: {
    type: d.TEXT,
    fieldId: 266,
    defaultValue: {
      default: "Feel free to reach out to us for a free consultation",
      ar: "لا تتردد أبدًا في التواصل معنا بشأن أيّ استشارة مجانية"
    }
  },
  foot_note: {
    type: d.TEXT,
    fieldId: 267,
    defaultValue: {
      default: "Learn about our services and join our community today",
      ar: "تقدّرنا بعض العلامات التجارية الكبرى في العالم بخدماتها"
    }
  },
  slideshow: {
    type: d.GROUP,
    values: {
      image: {
        type: d.IMAGE,
        fieldId: 271
      }
    },
    defaultValue: [
      {
        image: {
          default: "https://images.unsplash.com/photo-1516728043722-b394cb2f689e?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=c82882f6f384a30402cc75029d9e7b11&auto=format&fit=crop&w=550&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1494074734099-c4ec0c45687a?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=f18b2bf25abbaeddbe5ea1f9dae1ff85&auto=format&fit=crop&w=3150&q=80"
        }
      },
      {
        image: {
          default: "https://images.unsplash.com/photo-1516728043722-b394cb2f689e?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=c82882f6f384a30402cc75029d9e7b11&auto=format&fit=crop&w=550&q=80"
        }
      }
    ]
  }
}, EI = (n) => {
  const o = He(null), {
    Elements: t,
    classes: a,
    title: i,
    subtitle: r,
    primary_button: c,
    secondary_button: s,
    socialLinks: _,
    image: m
  } = n, { Button: p, Text: u, SocialLinks: v, Image: f } = t;
  return /* @__PURE__ */ e("div", { className: a.hero, ref: o, children: /* @__PURE__ */ e("div", { className: a.heroContainer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row align-items-top", children: [
    /* @__PURE__ */ l("div", { className: "col-md-6 col-xs-12", children: [
      /* @__PURE__ */ l("div", { className: a.heroContent, children: [
        /* @__PURE__ */ e(u, { tag: "h1", value: i }),
        /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
        /* @__PURE__ */ e(u, { tag: "p", value: r })
      ] }),
      /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
      /* @__PURE__ */ l("div", { className: a.buttonsWrapper, children: [
        /* @__PURE__ */ e(p, { type: "Primary", value: c }),
        /* @__PURE__ */ e(p, { type: "Secondary", value: s })
      ] }),
      /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
      /* @__PURE__ */ e("div", { className: a.socialLinksContainer, children: /* @__PURE__ */ e(
        v,
        {
          value: _,
          listClass: a.socialIcons,
          itemClass: a.socialIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ e("div", { className: `col-md-6 col-xs-12 ${a.imageColumn}`, children: /* @__PURE__ */ e("div", { className: a.imageContainer, children: /* @__PURE__ */ e(f, { value: m }) }) })
  ] }) }) }) });
}, TI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EI,
  meta: C,
  styles: WI
}, Symbol.toStringTag, { value: "Module" })), LI = "_buttonsWrapper_13hjz_132", OI = "_hero_13hjz_165", zI = "_heroContent_13hjz_178", PI = "_socialLinksColumn_13hjz_209", BI = "_socialIcons_13hjz_216", qI = "_socialIcon_13hjz_216", HI = {
  buttonsWrapper: LI,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_13hjz_138",
  "spaceAfter--small": "_spaceAfter--small_13hjz_141",
  "spaceAfter--medium": "_spaceAfter--medium_13hjz_144",
  hero: OI,
  heroContent: zI,
  socialLinksColumn: PI,
  socialIcons: BI,
  socialIcon: qI
}, VI = ({
  classes: n,
  Elements: { Button: o, SocialLinks: t, Text: a },
  title: i,
  subtitle: r,
  primary_button: c,
  secondary_button: s,
  socialLinks: _
}) => /* @__PURE__ */ e("div", { className: n.hero, children: /* @__PURE__ */ e("div", { className: n.heroContent, children: /* @__PURE__ */ l("div", { className: "container", children: [
  /* @__PURE__ */ e(a, { tag: "h1", value: i }),
  /* @__PURE__ */ e(a, { tag: "p", value: r }),
  /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
  /* @__PURE__ */ l("div", { className: n.buttonsWrapper, children: [
    /* @__PURE__ */ e(o, { type: "Primary", value: c }),
    /* @__PURE__ */ e(o, { type: "Secondary", value: s })
  ] }),
  /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
  /* @__PURE__ */ e("div", { className: n.socialLinksColumn, children: /* @__PURE__ */ e(
    t,
    {
      value: _,
      listClass: n.socialIcons,
      itemClass: n.socialIcon
    }
  ) })
] }) }) }), FI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VI,
  meta: C,
  styles: HI
}, Symbol.toStringTag, { value: "Module" })), DI = "_buttonsWrapper_157er_132", XI = "_hero_157er_165", RI = "_socialLinksColumn_157er_169", GI = "_actionCol_157er_175", UI = "_content_157er_179", JI = "_rowStyle_157er_191", QI = "_imageContainer_157er_201", KI = "_overlay_157er_209", ZI = "_heroContent_157er_219", YI = "_btnColumn_157er_231", e6 = {
  buttonsWrapper: DI,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_157er_138",
  "spaceAfter--small": "_spaceAfter--small_157er_141",
  "spaceAfter--medium": "_spaceAfter--medium_157er_144",
  hero: XI,
  socialLinksColumn: RI,
  actionCol: GI,
  content: UI,
  rowStyle: JI,
  imageContainer: QI,
  overlay: KI,
  heroContent: ZI,
  btnColumn: YI
}, t6 = ({
  classes: n,
  Elements: o,
  title: t,
  subtitle: a,
  image: i,
  primary_button: r,
  secondary_button: c
}) => {
  const { Button: s, Text: _, Image: m } = o;
  return /* @__PURE__ */ l("div", { className: n.hero, children: [
    /* @__PURE__ */ e("div", { className: `${n.content} container`, children: /* @__PURE__ */ e("div", { className: n.rowStyle, children: /* @__PURE__ */ l("div", { className: "row", children: [
      /* @__PURE__ */ e("div", { className: "col-md-7 ", children: /* @__PURE__ */ l("div", { className: n.heroContent, children: [
        /* @__PURE__ */ e(_, { tag: "h1", value: t }),
        /* @__PURE__ */ e(_, { tag: "p", value: a })
      ] }) }),
      /* @__PURE__ */ e("div", { className: `col-md-5 d-xs-none ${n.actionCol}`, children: /* @__PURE__ */ l("div", { className: n.buttonsWrapper, children: [
        /* @__PURE__ */ e(s, { type: "Primary", value: r }),
        /* @__PURE__ */ e(s, { type: "Secondary", value: c })
      ] }) })
    ] }) }) }),
    /* @__PURE__ */ e("div", { className: n.imageContainer, children: /* @__PURE__ */ e(m, { withOverlay: n.overlay, value: i }) })
  ] });
}, a6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: t6,
  meta: C,
  styles: e6
}, Symbol.toStringTag, { value: "Module" })), n6 = "_buttonsWrapper_198t4_132", o6 = "_hero_198t4_165", i6 = "_overlay_198t4_169", l6 = "_heroContentContainer_198t4_173 container", r6 = "_heroContent_198t4_173", c6 = {
  buttonsWrapper: n6,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_198t4_138",
  "spaceAfter--small": "_spaceAfter--small_198t4_141",
  "spaceAfter--medium": "_spaceAfter--medium_198t4_144",
  hero: o6,
  overlay: i6,
  heroContentContainer: l6,
  heroContent: r6
}, s6 = ({
  classes: n,
  Elements: { Button: o, Text: t, BackgroundContainer: a },
  title: i,
  subtitle: r,
  primary_button: c,
  image: s
}) => /* @__PURE__ */ e(
  a,
  {
    withOverlay: n.overlay,
    value: s,
    className: n.hero,
    children: /* @__PURE__ */ e("div", { className: n.heroContentContainer, children: /* @__PURE__ */ l("div", { className: n.heroContent, children: [
      /* @__PURE__ */ e(t, { tag: "h1", value: i }),
      /* @__PURE__ */ e("div", { className: n["spaceAfter--xSmall"] }),
      /* @__PURE__ */ e(t, { tag: "p", value: r }),
      /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
      /* @__PURE__ */ e(o, { type: "Primary", value: c })
    ] }) })
  }
), d6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: s6,
  meta: C,
  styles: c6
}, Symbol.toStringTag, { value: "Module" })), _6 = "_buttonsWrapper_v8if2_132", m6 = "_hero_v8if2_165", u6 = "_heroContent_v8if2_171 container", p6 = "_langSwitcher_v8if2_188", v6 = "_block_v8if2_195", f6 = "_right_block_v8if2_203 _block_v8if2_195", g6 = "_block_right_back_v8if2_210 _right_block_v8if2_203 _block_v8if2_195", h6 = "_block_right_front_v8if2_216 _right_block_v8if2_203 _block_v8if2_195", b6 = "_block_bottom_v8if2_227 _block_v8if2_195", y6 = "_button_v8if2_132", $6 = {
  buttonsWrapper: _6,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_v8if2_138",
  "spaceAfter--small": "_spaceAfter--small_v8if2_141",
  "spaceAfter--medium": "_spaceAfter--medium_v8if2_144",
  hero: m6,
  heroContent: u6,
  langSwitcher: p6,
  block: v6,
  right_block: f6,
  block_right_back: g6,
  block_right_front: h6,
  block_bottom: b6,
  button: y6
}, N6 = ({
  classes: n,
  Elements: { Button: o, Text: t },
  title: a,
  subtitle: i,
  primary_button: r,
  secondary_button: c
}) => /* @__PURE__ */ l("div", { className: n.hero, children: [
  /* @__PURE__ */ e("div", { className: n.block_right_back }),
  /* @__PURE__ */ e("div", { className: n.block_right_front }),
  /* @__PURE__ */ e("div", { className: n.block_bottom }),
  /* @__PURE__ */ e("div", { className: n.heroContent, children: /* @__PURE__ */ l("div", { className: "container", children: [
    /* @__PURE__ */ e(t, { tag: "h1", value: a }),
    /* @__PURE__ */ e(t, { tag: "p", value: i }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
    /* @__PURE__ */ l("div", { className: n.buttonsWrapper, children: [
      /* @__PURE__ */ e(o, { type: "Primary", value: r }),
      /* @__PURE__ */ e(o, { type: "Secondary", value: c })
    ] })
  ] }) })
] }), C6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: N6,
  meta: C,
  styles: $6
}, Symbol.toStringTag, { value: "Module" })), x6 = "_buttonsWrapper_1j9ta_132", I6 = "_hero_1j9ta_165", A6 = "_bk_1j9ta_171", S6 = "_heroContent_1j9ta_182", k6 = "_buttonsContainer_1j9ta_209", j6 = "_socialIcons_1j9ta_221", w6 = "_socialIcon_1j9ta_221", M6 = {
  buttonsWrapper: x6,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1j9ta_138",
  "spaceAfter--small": "_spaceAfter--small_1j9ta_141",
  "spaceAfter--medium": "_spaceAfter--medium_1j9ta_144",
  hero: I6,
  bk: A6,
  heroContent: S6,
  buttonsContainer: k6,
  socialIcons: j6,
  socialIcon: w6
}, W6 = ({
  classes: n,
  Elements: { Button: o, SocialLinks: t, Text: a },
  title: i,
  subtitle: r,
  primary_button: c,
  secondary_button: s,
  socialLinks: _
}) => /* @__PURE__ */ l("div", { className: n.hero, children: [
  /* @__PURE__ */ e("div", { className: n.bk }),
  /* @__PURE__ */ e("div", { className: n.heroContent, children: /* @__PURE__ */ l("div", { className: "container", children: [
    /* @__PURE__ */ e(a, { tag: "h1", value: i }),
    /* @__PURE__ */ e(a, { tag: "p", value: r }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
    /* @__PURE__ */ l("div", { className: n.buttonsWrapper, children: [
      /* @__PURE__ */ e(o, { type: "Primary", value: c }),
      /* @__PURE__ */ e(o, { type: "Secondary", value: s })
    ] }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
    /* @__PURE__ */ e("div", { className: n.socialLinksColumn, children: /* @__PURE__ */ e(
      t,
      {
        value: _,
        listClass: n.socialIcons,
        itemClass: n.socialIcon
      }
    ) })
  ] }) })
] }), E6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: W6,
  meta: C,
  styles: M6
}, Symbol.toStringTag, { value: "Module" })), T6 = "_buttonsWrapper_1ci05_132", L6 = "_containerImage_1ci05_165", O6 = "_hero_1ci05_174", z6 = "_overlay_1ci05_184", P6 = "_heroContainer_1ci05_193 container", B6 = "_heroContent_1ci05_197", q6 = "_ctaContentContainer_1ci05_222", H6 = "_backgroundText_1ci05_228", V6 = {
  buttonsWrapper: T6,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1ci05_138",
  "spaceAfter--small": "_spaceAfter--small_1ci05_141",
  "spaceAfter--medium": "_spaceAfter--medium_1ci05_144",
  containerImage: L6,
  hero: O6,
  overlay: z6,
  heroContainer: P6,
  heroContent: B6,
  ctaContentContainer: q6,
  backgroundText: H6
}, F6 = ({
  classes: n,
  Elements: o,
  title: t,
  subtitle: a,
  primary_button: i,
  secondary_button: r,
  image: c,
  cta_box_title: s,
  cta_box_subtitle: _
}) => {
  const { Button: m, Text: p, BackgroundContainer: u } = o;
  return /* @__PURE__ */ e(
    u,
    {
      value: c,
      withOverlay: n.overlay,
      className: n.containerImage,
      children: /* @__PURE__ */ l("div", { className: n.hero, children: [
        /* @__PURE__ */ e("div", { className: n.heroContainer, children: /* @__PURE__ */ l("div", { className: n.heroContent, children: [
          /* @__PURE__ */ e(p, { tag: "h1", value: t }),
          /* @__PURE__ */ e(p, { tag: "p", value: a })
        ] }) }),
        /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: n.backgroundText, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
          /* @__PURE__ */ e("div", { className: "col-xl-7 col-lg-8 col-md-8", children: /* @__PURE__ */ e("div", { className: n.ctaContentContainer, children: /* @__PURE__ */ l("div", { className: n.content, children: [
            /* @__PURE__ */ e(p, { tag: "h4", value: s }),
            /* @__PURE__ */ e("div", { className: n["spaceAfter--xSmall"] }),
            /* @__PURE__ */ e(p, { tag: "p", value: _ })
          ] }) }) }),
          /* @__PURE__ */ e("div", { className: "col-xl-5 col-lg-4 col-md-4", children: /* @__PURE__ */ l("div", { className: n.buttonsWrapper, children: [
            /* @__PURE__ */ e(m, { type: "Primary", value: i }),
            /* @__PURE__ */ e(m, { type: "Secondary", value: r })
          ] }) })
        ] }) }) }) })
      ] })
    }
  );
}, D6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: F6,
  meta: C,
  styles: V6
}, Symbol.toStringTag, { value: "Module" })), X6 = "_buttonsWrapper_zq0u4_132", R6 = "_section_zq0u4_165", G6 = "_socialLinksColumn_zq0u4_170", U6 = "_socialIcons_zq0u4_175", J6 = "_socialIcon_zq0u4_175", Q6 = "_hero_zq0u4_198", K6 = "_heroContentContainer_zq0u4_205 container", Z6 = "_heroContent_zq0u4_205", Y6 = "_backgroundCol_zq0u4_217", e8 = "_containerImage_zq0u4_229", t8 = "_imgWrapper_zq0u4_233", a8 = {
  buttonsWrapper: X6,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_zq0u4_138",
  "spaceAfter--small": "_spaceAfter--small_zq0u4_141",
  "spaceAfter--medium": "_spaceAfter--medium_zq0u4_144",
  section: R6,
  socialLinksColumn: G6,
  socialIcons: U6,
  socialIcon: J6,
  hero: Q6,
  heroContentContainer: K6,
  heroContent: Z6,
  backgroundCol: Y6,
  containerImage: e8,
  imgWrapper: t8
}, n8 = ({
  classes: n,
  Elements: { Button: o, SocialLinks: t, Text: a, Image: i },
  title: r,
  subtitle: c,
  primary_button: s,
  secondary_button: _,
  image: m,
  socialLinks: p,
  foot_note: u
}) => /* @__PURE__ */ e("div", { className: n.section, children: /* @__PURE__ */ e("div", { className: n.hero, children: /* @__PURE__ */ l("div", { className: "container", children: [
  /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e("div", { className: "col-lg-6 col-md-12 col-xs-12", children: /* @__PURE__ */ e("div", { className: n.heroContentContainer, children: /* @__PURE__ */ l("div", { className: n.heroContent, children: [
    /* @__PURE__ */ e(a, { tag: "h1", value: r }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(a, { tag: "p", value: c }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
    /* @__PURE__ */ l("div", { className: n.buttonsWrapper, children: [
      /* @__PURE__ */ e(o, { type: "Primary", value: s }),
      /* @__PURE__ */ e(o, { type: "Secondary", value: _ })
    ] }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
    /* @__PURE__ */ e("div", { className: n.socialLinksColumn, children: /* @__PURE__ */ e(
      t,
      {
        value: p,
        listClass: `${n.socialIcons}`,
        itemClass: n.socialIcon
      }
    ) }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
    /* @__PURE__ */ e(a, { className: n.subTitle, tag: "p", value: u }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] })
  ] }) }) }) }),
  /* @__PURE__ */ e("div", { className: `${n.backgroundCol} d-none d-lg-block`, children: /* @__PURE__ */ e("div", { className: n.containerImage, children: /* @__PURE__ */ e(i, { value: m, className: n.imgWrapper }) }) })
] }) }) }), o8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: n8,
  meta: C,
  styles: a8
}, Symbol.toStringTag, { value: "Module" })), i8 = "_buttonsWrapper_x46za_132", l8 = "_hero_x46za_165", r8 = "_bk_x46za_171", c8 = "_heroContent_x46za_185", s8 = "_socialLinksColumn_x46za_218", d8 = "_socialIcons_x46za_223", _8 = "_socialIcon_x46za_223", m8 = {
  buttonsWrapper: i8,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_x46za_138",
  "spaceAfter--small": "_spaceAfter--small_x46za_141",
  "spaceAfter--medium": "_spaceAfter--medium_x46za_144",
  hero: l8,
  bk: r8,
  heroContent: c8,
  socialLinksColumn: s8,
  socialIcons: d8,
  socialIcon: _8
}, u8 = ({
  classes: n,
  Elements: { Button: o, SocialLinks: t, Text: a },
  title: i,
  subtitle: r,
  primary_button: c,
  secondary_button: s,
  socialLinks: _
}) => /* @__PURE__ */ l("div", { className: n.hero, children: [
  /* @__PURE__ */ e("div", { className: n.bk }),
  /* @__PURE__ */ e("div", { className: n.heroContent, children: /* @__PURE__ */ l("div", { className: "container", children: [
    /* @__PURE__ */ e(a, { tag: "h1", value: i }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(a, { tag: "p", value: r }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
    /* @__PURE__ */ l("div", { className: n.buttonsWrapper, children: [
      /* @__PURE__ */ e(o, { type: "Primary", value: c }),
      /* @__PURE__ */ e(o, { type: "Secondary", value: s })
    ] }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
    /* @__PURE__ */ e("div", { className: n.socialLinksColumn, children: /* @__PURE__ */ e(
      t,
      {
        value: _,
        listClass: n.socialIcons,
        itemClass: n.socialIcon
      }
    ) })
  ] }) })
] }), p8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: u8,
  meta: C,
  styles: m8
}, Symbol.toStringTag, { value: "Module" })), v8 = "_buttonsWrapper_1ukrm_132", f8 = "_socialLinksColumn_1ukrm_165", g8 = "_hero_1ukrm_176", h8 = "_heroContentContainer_1ukrm_183 container", b8 = "_heroContent_1ukrm_183", y8 = "_containerImage_1ukrm_203", $8 = "_overlay_1ukrm_206", N8 = "_socialIcons_1ukrm_215", C8 = "_socialIcon_1ukrm_215", x8 = {
  buttonsWrapper: v8,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1ukrm_138",
  "spaceAfter--small": "_spaceAfter--small_1ukrm_141",
  "spaceAfter--medium": "_spaceAfter--medium_1ukrm_144",
  socialLinksColumn: f8,
  hero: g8,
  heroContentContainer: h8,
  heroContent: b8,
  containerImage: y8,
  overlay: $8,
  socialIcons: N8,
  socialIcon: C8
}, I8 = ({
  classes: n,
  Elements: { Button: o, Text: t, SocialLinks: a, BackgroundContainer: i },
  title: r,
  subtitle: c,
  primary_button: s,
  image: _,
  secondary_button: m,
  socialLinks: p,
  foot_note: u
}) => /* @__PURE__ */ e(
  i,
  {
    withOverlay: n.overlay,
    value: _,
    className: n.containerImage,
    children: /* @__PURE__ */ e("div", { className: n.hero, children: /* @__PURE__ */ e("div", { className: n.heroContentContainer, children: /* @__PURE__ */ l("div", { className: n.heroContent, children: [
      /* @__PURE__ */ e(t, { tag: "h1", value: r }),
      /* @__PURE__ */ e("div", { className: n["spaceAfter--xSmall"] }),
      /* @__PURE__ */ e(t, { tag: "p", value: c }),
      /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
      /* @__PURE__ */ l("div", { className: n.buttonsWrapper, children: [
        /* @__PURE__ */ e(o, { type: "Primary", value: s }),
        /* @__PURE__ */ e(o, { type: "Secondary", value: m })
      ] }),
      /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
      /* @__PURE__ */ e("div", { className: n.socialLinksColumn, children: /* @__PURE__ */ e(
        a,
        {
          value: p,
          listClass: n.socialIcons,
          itemClass: n.socialIcon
        }
      ) }),
      /* @__PURE__ */ e("div", { className: n["spaceAfter--xSmall"] }),
      /* @__PURE__ */ e(t, { tag: "p", value: u, className: n.subTitle })
    ] }) }) })
  }
), A8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: I8,
  meta: C,
  styles: x8
}, Symbol.toStringTag, { value: "Module" })), S8 = "_buttonsWrapper_1fq6e_132", k8 = "_socialLinksColumn_1fq6e_165", j8 = "_socialIcons_1fq6e_171", w8 = "_socialIcon_1fq6e_171", M8 = "_hero_1fq6e_190", W8 = "_heroContentContainer_1fq6e_198 container", E8 = "_heroContent_1fq6e_198", T8 = "_subTitle_1fq6e_210", L8 = "_containerImage_1fq6e_241", O8 = "_overlay_1fq6e_244", z8 = {
  buttonsWrapper: S8,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1fq6e_138",
  "spaceAfter--small": "_spaceAfter--small_1fq6e_141",
  "spaceAfter--medium": "_spaceAfter--medium_1fq6e_144",
  socialLinksColumn: k8,
  socialIcons: j8,
  socialIcon: w8,
  hero: M8,
  heroContentContainer: W8,
  heroContent: E8,
  subTitle: T8,
  containerImage: L8,
  overlay: O8
}, P8 = ({
  classes: n,
  Elements: {
    Button: o,
    Text: t,
    SocialLinks: a,
    BackgroundContainer: i
  },
  title: r,
  subtitle: c,
  primary_button: s,
  image: _,
  secondary_button: m,
  socialLinks: p,
  foot_note: u
}) => /* @__PURE__ */ e(
  i,
  {
    withOverlay: n.overlay,
    value: _,
    className: n.containerImage,
    children: /* @__PURE__ */ e("div", { className: n.hero, children: /* @__PURE__ */ e("div", { className: n.heroContentContainer, children: /* @__PURE__ */ l("div", { className: n.heroContent, children: [
      /* @__PURE__ */ e(t, { tag: "h1", value: r }),
      /* @__PURE__ */ e("div", { className: n["spaceAfter--xSmall"] }),
      /* @__PURE__ */ e(t, { tag: "p", value: c }),
      /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
      /* @__PURE__ */ l("div", { className: n.buttonsWrapper, children: [
        /* @__PURE__ */ e(o, { type: "Primary", value: s }),
        /* @__PURE__ */ e(o, { type: "Secondary", value: m })
      ] }),
      /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
      /* @__PURE__ */ e("div", { className: n.socialLinksColumn, children: /* @__PURE__ */ e(
        a,
        {
          value: p,
          listClass: n.socialIcons,
          itemClass: n.socialIcon
        }
      ) }),
      /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
      /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
      /* @__PURE__ */ e(t, { tag: "p", value: u, className: n.subTitle })
    ] }) }) })
  }
), B8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: P8,
  meta: C,
  styles: z8
}, Symbol.toStringTag, { value: "Module" })), q8 = "_buttonsWrapper_492b6_132", H8 = "_hero_492b6_165", V8 = "_bk_492b6_171", F8 = "_heroContent_492b6_193", D8 = "_socialLinksColumn_492b6_211", X8 = "_socialIcons_492b6_216", R8 = "_socialIcon_492b6_216", G8 = {
  buttonsWrapper: q8,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_492b6_138",
  "spaceAfter--small": "_spaceAfter--small_492b6_141",
  "spaceAfter--medium": "_spaceAfter--medium_492b6_144",
  hero: H8,
  bk: V8,
  heroContent: F8,
  socialLinksColumn: D8,
  socialIcons: X8,
  socialIcon: R8
}, U8 = ({
  classes: n,
  Elements: { Button: o, SocialLinks: t, Text: a },
  title: i,
  subtitle: r,
  primary_button: c,
  secondary_button: s,
  socialLinks: _
}) => /* @__PURE__ */ l("div", { className: n.hero, children: [
  /* @__PURE__ */ e("div", { className: n.bk }),
  /* @__PURE__ */ e("div", { className: n.heroContent, children: /* @__PURE__ */ l("div", { className: "container", children: [
    /* @__PURE__ */ e(a, { tag: "h1", value: i }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(a, { tag: "p", value: r }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
    /* @__PURE__ */ l("div", { className: n.buttonsWrapper, children: [
      /* @__PURE__ */ e(o, { type: "Primary", value: c }),
      /* @__PURE__ */ e(o, { type: "Secondary", value: s })
    ] }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
    /* @__PURE__ */ e("div", { className: n.socialLinksColumn, children: /* @__PURE__ */ e(
      t,
      {
        value: _,
        listClass: n.socialIcons,
        itemClass: n.socialIcon
      }
    ) })
  ] }) })
] }), J8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: U8,
  meta: C,
  styles: G8
}, Symbol.toStringTag, { value: "Module" })), Q8 = "_buttonsWrapper_pdhwt_132", K8 = "_hero_pdhwt_165", Z8 = "_heroContent_pdhwt_170", Y8 = "_socialLinksColumn_pdhwt_192", eA = "_socialIcons_pdhwt_197", tA = "_socialIcon_pdhwt_197", aA = "_bk_pdhwt_221", nA = "_bk2_pdhwt_236", oA = {
  buttonsWrapper: Q8,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_pdhwt_138",
  "spaceAfter--small": "_spaceAfter--small_pdhwt_141",
  "spaceAfter--medium": "_spaceAfter--medium_pdhwt_144",
  hero: K8,
  heroContent: Z8,
  socialLinksColumn: Y8,
  socialIcons: eA,
  socialIcon: tA,
  bk: aA,
  bk2: nA
}, iA = ({
  classes: n,
  Elements: { Button: o, SocialLinks: t, Text: a },
  title: i,
  subtitle: r,
  primary_button: c,
  secondary_button: s,
  socialLinks: _
}) => /* @__PURE__ */ l("div", { className: n.hero, children: [
  /* @__PURE__ */ e("div", { className: n.bk }),
  /* @__PURE__ */ e("div", { className: n.bk2 }),
  /* @__PURE__ */ e("div", { className: n.bkArabic }),
  /* @__PURE__ */ e("div", { className: n.bkArabic2 }),
  /* @__PURE__ */ e("div", { className: n.heroContent, children: /* @__PURE__ */ l("div", { className: "container", children: [
    /* @__PURE__ */ e(a, { tag: "h1", value: i }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(a, { tag: "p", value: r }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
    /* @__PURE__ */ l("div", { className: n.buttonsWrapper, children: [
      /* @__PURE__ */ e(o, { type: "Primary", value: c }),
      /* @__PURE__ */ e(o, { type: "Secondary", value: s })
    ] }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
    /* @__PURE__ */ e("div", { className: n.socialLinksColumn, children: /* @__PURE__ */ e(
      t,
      {
        value: _,
        listClass: n.socialIcons,
        itemClass: n.socialIcon
      }
    ) })
  ] }) })
] }), lA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: iA,
  meta: C,
  styles: oA
}, Symbol.toStringTag, { value: "Module" })), rA = "_buttonsWrapper_dujkq_132", cA = "_socialLinksColumn_dujkq_165", sA = "_socialIcons_dujkq_172", dA = "_socialIcon_dujkq_172", _A = "_overlay_dujkq_192", mA = "_heroContent_dujkq_196", uA = {
  buttonsWrapper: rA,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_dujkq_138",
  "spaceAfter--small": "_spaceAfter--small_dujkq_141",
  "spaceAfter--medium": "_spaceAfter--medium_dujkq_144",
  socialLinksColumn: cA,
  socialIcons: sA,
  socialIcon: dA,
  overlay: _A,
  heroContent: mA
}, pA = ({
  classes: n,
  Elements: { Button: o, SocialLinks: t, Text: a, BackgroundContainer: i },
  title: r,
  subtitle: c,
  primary_button: s,
  secondary_button: _,
  socialLinks: m,
  image: p
}) => /* @__PURE__ */ e(
  i,
  {
    value: p,
    withOverlay: n.overlay,
    className: n.hero,
    children: /* @__PURE__ */ e("div", { className: n.heroContent, children: /* @__PURE__ */ l("div", { className: "container", children: [
      /* @__PURE__ */ e(a, { tag: "h1", value: r }),
      /* @__PURE__ */ e("div", { className: n["spaceAfter--xSmall"] }),
      /* @__PURE__ */ e(a, { tag: "p", value: c }),
      /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
      /* @__PURE__ */ l("div", { className: n.buttonsWrapper, children: [
        /* @__PURE__ */ e(o, { type: "Primary", value: s }),
        /* @__PURE__ */ e(o, { type: "Secondary", value: _ })
      ] }),
      /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
      /* @__PURE__ */ e("div", { className: n.socialLinksColumn, children: /* @__PURE__ */ e(
        t,
        {
          value: m,
          listClass: n.socialIcons,
          itemClass: n.socialIcon
        }
      ) })
    ] }) })
  }
), vA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pA,
  meta: C,
  styles: uA
}, Symbol.toStringTag, { value: "Module" })), fA = "_buttonsWrapper_182s0_132", gA = "_herox00_182s0_165", hA = "_herox01_182s0_175", bA = "_herox02_182s0_181", yA = "_herox03_182s0_194", $A = "_herox04_182s0_202", NA = "_phone_182s0_272", CA = {
  buttonsWrapper: fA,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_182s0_138",
  "spaceAfter--small": "_spaceAfter--small_182s0_141",
  "spaceAfter--medium": "_spaceAfter--medium_182s0_144",
  herox00: gA,
  herox01: hA,
  herox02: bA,
  herox03: yA,
  herox04: $A,
  phone: NA
}, xA = ({
  classes: n,
  Elements: { Button: o, Text: t, BackgroundContainer: a },
  title: i,
  subtitle: r,
  primary_button: c,
  image: s
}) => /* @__PURE__ */ e(a, { className: n.herox00, value: s, children: /* @__PURE__ */ e("div", { className: n.herox01, children: /* @__PURE__ */ e("div", { className: n.herox02, children: /* @__PURE__ */ l("div", { className: n.herox03, children: [
  /* @__PURE__ */ l("div", { className: n.herox04, children: [
    /* @__PURE__ */ e(t, { tag: "h1", value: i }),
    /* @__PURE__ */ e(t, { tag: "p", value: r })
  ] }),
  /* @__PURE__ */ e(o, { type: "Primary", value: c })
] }) }) }) }), IA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xA,
  meta: C,
  styles: CA
}, Symbol.toStringTag, { value: "Module" })), AA = "_buttonsWrapper_ndx1d_132", SA = "_heroSection_ndx1d_165", kA = "_heroContent_ndx1d_168", jA = "_heroText_ndx1d_168", wA = "_primaryButton_ndx1d_174", MA = "_imageContainer_ndx1d_179", WA = {
  buttonsWrapper: AA,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_ndx1d_138",
  "spaceAfter--small": "_spaceAfter--small_ndx1d_141",
  "spaceAfter--medium": "_spaceAfter--medium_ndx1d_144",
  heroSection: SA,
  heroContent: kA,
  heroText: jA,
  primaryButton: wA,
  imageContainer: MA
}, EA = ({
  classes: n,
  Elements: { Button: o, Text: t, Image: a },
  title: i,
  subtitle: r,
  primary_button: c,
  image: s
}) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: n.heroSection, children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-lg-6 d-flex flex-column justify-content-center mt-4 mt-lg-0 order-2 order-lg-1", children: /* @__PURE__ */ l("div", { className: n.heroContent, children: [
    /* @__PURE__ */ l("div", { className: n.heroText, children: [
      /* @__PURE__ */ e(t, { tag: "h1", value: i }),
      /* @__PURE__ */ e(t, { tag: "p", value: r })
    ] }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
    /* @__PURE__ */ e(o, { type: "Primary", value: c })
  ] }) }),
  /* @__PURE__ */ e("div", { className: "col-lg-6 order-1 order-lg-2", children: /* @__PURE__ */ e("div", { className: n.imageContainer, children: /* @__PURE__ */ e(a, { value: s }) }) })
] }) }) }), TA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EA,
  meta: C,
  styles: WA
}, Symbol.toStringTag, { value: "Module" })), LA = "_buttonsWrapper_xhu17_132", OA = "_heroSection_xhu17_165", zA = "_imageContainer_xhu17_168", PA = "_heroContent_xhu17_178", BA = "_heroText_xhu17_186", qA = {
  buttonsWrapper: LA,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_xhu17_138",
  "spaceAfter--small": "_spaceAfter--small_xhu17_141",
  "spaceAfter--medium": "_spaceAfter--medium_xhu17_144",
  heroSection: OA,
  imageContainer: zA,
  heroContent: PA,
  heroText: BA
}, HA = ({
  classes: n,
  Elements: { Button: o, Text: t, Image: a },
  title: i,
  subtitle: r,
  primary_button: c,
  image: s
}) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: n.heroSection, children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-lg-6", children: /* @__PURE__ */ e("div", { className: n.imageContainer, children: /* @__PURE__ */ e(a, { value: s }) }) }),
  /* @__PURE__ */ e("div", { className: "col-lg-6 d-flex flex-column justify-content-center mt-4 mt-lg-0", children: /* @__PURE__ */ l("div", { className: n.heroContent, children: [
    /* @__PURE__ */ l("div", { className: n.heroText, children: [
      /* @__PURE__ */ e(t, { tag: "h1", value: i }),
      /* @__PURE__ */ e(t, { tag: "p", value: r })
    ] }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
    /* @__PURE__ */ e(o, { type: "Primary", value: c })
  ] }) })
] }) }) }), VA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: HA,
  meta: C,
  styles: qA
}, Symbol.toStringTag, { value: "Module" })), FA = "_buttonsWrapper_ty6w9_132", DA = "_heroSection_ty6w9_165", XA = "_imageContainer_ty6w9_174", RA = "_heroContent_ty6w9_183", GA = "_heroText_ty6w9_183", UA = {
  buttonsWrapper: FA,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_ty6w9_138",
  "spaceAfter--small": "_spaceAfter--small_ty6w9_141",
  "spaceAfter--medium": "_spaceAfter--medium_ty6w9_144",
  heroSection: DA,
  imageContainer: XA,
  heroContent: RA,
  heroText: GA
}, JA = ({
  classes: n,
  Elements: { Button: o, Text: t, Image: a },
  title: i,
  subtitle: r,
  primary_button: c,
  secondary_button: s,
  image: _
}) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e("div", { className: n.heroSection, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ l("div", { className: "col-12", children: [
  /* @__PURE__ */ e("div", { className: n.imageContainer, children: /* @__PURE__ */ e(a, { value: _ }) }),
  /* @__PURE__ */ l("div", { className: n.heroContent, children: [
    /* @__PURE__ */ l("div", { className: n.heroText, children: [
      /* @__PURE__ */ e(t, { tag: "h1", value: i }),
      /* @__PURE__ */ e(t, { tag: "p", value: r })
    ] }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
    /* @__PURE__ */ l("div", { className: n.buttonsWrapper, children: [
      /* @__PURE__ */ e(o, { type: "Primary", value: c }),
      /* @__PURE__ */ e(o, { type: "Secondary", value: s })
    ] })
  ] })
] }) }) }) }) }), QA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JA,
  meta: C,
  styles: UA
}, Symbol.toStringTag, { value: "Module" })), KA = "_buttonsWrapper_rmdre_132", ZA = "_heroSection_rmdre_165", YA = "_heroText_rmdre_174", eS = {
  buttonsWrapper: KA,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_rmdre_138",
  "spaceAfter--small": "_spaceAfter--small_rmdre_141",
  "spaceAfter--medium": "_spaceAfter--medium_rmdre_144",
  heroSection: ZA,
  heroText: YA
}, tS = ({
  classes: n,
  Elements: { Button: o, Text: t },
  title: a,
  subtitle: i,
  primary_button: r,
  secondary_button: c
}) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: n.heroSection, children: [
  /* @__PURE__ */ l("div", { className: n.heroText, children: [
    /* @__PURE__ */ e(t, { tag: "h1", value: a }),
    /* @__PURE__ */ e(t, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
  /* @__PURE__ */ l("div", { className: n.buttonsWrapper, children: [
    /* @__PURE__ */ e(o, { type: "Primary", value: r }),
    /* @__PURE__ */ e(o, { type: "Secondary", value: c })
  ] })
] }) }) }), aS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tS,
  meta: C,
  styles: eS
}, Symbol.toStringTag, { value: "Module" })), nS = "_buttonsWrapper_9f3yn_132", oS = "_heroSection_9f3yn_165", iS = "_heroContent_9f3yn_168", lS = "_heroText_9f3yn_168", rS = "_imageContainer_9f3yn_174", cS = {
  buttonsWrapper: nS,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_9f3yn_138",
  "spaceAfter--small": "_spaceAfter--small_9f3yn_141",
  "spaceAfter--medium": "_spaceAfter--medium_9f3yn_144",
  heroSection: oS,
  heroContent: iS,
  heroText: lS,
  imageContainer: rS
}, sS = ({
  classes: n,
  Elements: { Button: o, Text: t, Image: a },
  title: i,
  subtitle: r,
  primary_button: c,
  secondary_button: s,
  image: _
}) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: n.heroSection, children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-lg-6 d-flex flex-column justify-content-center mt-4 mt-lg-0 order-2 order-lg-1", children: /* @__PURE__ */ l("div", { className: n.heroContent, children: [
    /* @__PURE__ */ l("div", { className: n.heroText, children: [
      /* @__PURE__ */ e(t, { tag: "h1", value: i }),
      /* @__PURE__ */ e(t, { tag: "p", value: r })
    ] }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
    /* @__PURE__ */ l("div", { className: n.buttonsWrapper, children: [
      /* @__PURE__ */ e(o, { type: "Primary", value: c }),
      /* @__PURE__ */ e(o, { type: "Secondary", value: s })
    ] })
  ] }) }),
  /* @__PURE__ */ e("div", { className: "col-lg-6 order-1 order-lg-2", children: /* @__PURE__ */ e("div", { className: n.imageContainer, children: /* @__PURE__ */ e(a, { value: _ }) }) })
] }) }) }), dS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sS,
  meta: C,
  styles: cS
}, Symbol.toStringTag, { value: "Module" })), _S = "_buttonsWrapper_19ohk_132", mS = "_heroSection_19ohk_165", uS = "_slide_19ohk_174", pS = "_overlay_19ohk_177", vS = "_navArrows_19ohk_181", fS = "_back_19ohk_190", gS = "_next_19ohk_198", hS = "_heroContent_19ohk_206", bS = "_heroText_19ohk_224", yS = "_buttonsContainer_19ohk_238", $S = {
  buttonsWrapper: _S,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_19ohk_138",
  "spaceAfter--small": "_spaceAfter--small_19ohk_141",
  "spaceAfter--medium": "_spaceAfter--medium_19ohk_144",
  heroSection: mS,
  slide: uS,
  overlay: pS,
  navArrows: vS,
  back: fS,
  next: gS,
  heroContent: hS,
  heroText: bS,
  buttonsContainer: yS
}, NS = ({
  classes: n,
  Elements: { SlideShow: o, Text: t, Button: a },
  slideshow: i,
  title: r,
  subtitle: c,
  primary_button: s,
  secondary_button: _
}) => /* @__PURE__ */ l("div", { className: n.heroSection, children: [
  /* @__PURE__ */ e(
    o,
    {
      value: i,
      slideClass: n.slide,
      overlayClass: n.overlay,
      navClass: n.navArrows,
      nextClass: n.next,
      backClass: n.back
    }
  ),
  /* @__PURE__ */ l("div", { className: n.heroContent, children: [
    /* @__PURE__ */ l("div", { className: n.heroText, children: [
      /* @__PURE__ */ e(t, { tag: "h1", value: r }),
      /* @__PURE__ */ e("div", { className: n["spaceAfter--xSmall"] }),
      /* @__PURE__ */ e(t, { tag: "p", value: c })
    ] }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--small"] }),
    /* @__PURE__ */ l("div", { className: n.buttonsWrapper, children: [
      /* @__PURE__ */ e(a, { type: "Primary", value: s }),
      /* @__PURE__ */ e(a, { type: "Secondary", value: _ })
    ] })
  ] })
] }), CS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NS,
  meta: C,
  styles: $S
}, Symbol.toStringTag, { value: "Module" })), xS = "_buttonsWrapper_mxa90_132", IS = "_heroSection_mxa90_165", AS = "_slide_mxa90_174", SS = "_overlay_mxa90_177", kS = "_navArrows_mxa90_181", jS = "_back_mxa90_190", wS = "_next_mxa90_198", MS = "_slideshow_mxa90_206", WS = "_heroContent_mxa90_209", ES = "_heroText_mxa90_222", TS = {
  buttonsWrapper: xS,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_mxa90_138",
  "spaceAfter--small": "_spaceAfter--small_mxa90_141",
  "spaceAfter--medium": "_spaceAfter--medium_mxa90_144",
  heroSection: IS,
  slide: AS,
  overlay: SS,
  navArrows: kS,
  back: jS,
  next: wS,
  slideshow: MS,
  heroContent: WS,
  heroText: ES
}, LS = ({
  classes: n,
  Elements: { SlideShow: o, Text: t },
  slideshow: a,
  title: i,
  subtitle: r
}) => /* @__PURE__ */ l("div", { className: n.heroSection, children: [
  /* @__PURE__ */ e(
    o,
    {
      value: a,
      slideClass: n.slide,
      overlayClass: n.overlay,
      navClass: n.navArrows,
      nextClass: n.next,
      backClass: n.back
    }
  ),
  /* @__PURE__ */ e("div", { className: n.heroContent, children: /* @__PURE__ */ l("div", { className: n.heroText, children: [
    /* @__PURE__ */ e(t, { tag: "h1", value: i }),
    /* @__PURE__ */ e("div", { className: n["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(t, { tag: "p", value: r })
  ] }) })
] }), OS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: LS,
  meta: C,
  styles: TS
}, Symbol.toStringTag, { value: "Module" })), zS = "_buttonsWrapper_l84ry_132", PS = "_containerLarge_l84ry_165", BS = "_paddingXhuge_l84ry_176", qS = "_paddingVertical_l84ry_180", HS = "_paddingvertical_l84ry_185", VS = "_header26_component_l84ry_190", FS = "_marginSmall_l84ry_206", DS = "_marginXxlarge_l84ry_210", XS = "_marginBottom_l84ry_214", RS = "_textAlignCenter_l84ry_226", GS = "_maxWidthLarge_l84ry_230", US = "_textSizeMedium_l84ry_241", JS = "_marginMedium_l84ry_245", QS = "_marginTop_l84ry_249", KS = "_buttonRow_l84ry_261", ZS = "_isButtonRowCenter_l84ry_277", YS = "_button_l84ry_132", e5 = "_buttonSecondary_l84ry_295", t5 = "_imageContainer_l84ry_306", a5 = {
  buttonsWrapper: zS,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_l84ry_138",
  "spaceAfter--small": "_spaceAfter--small_l84ry_141",
  "spaceAfter--medium": "_spaceAfter--medium_l84ry_144",
  containerLarge: PS,
  paddingXhuge: BS,
  paddingVertical: qS,
  paddingvertical: HS,
  header26_component: VS,
  marginSmall: FS,
  marginXxlarge: DS,
  marginBottom: XS,
  textAlignCenter: RS,
  maxWidthLarge: GS,
  textSizeMedium: US,
  marginMedium: JS,
  marginTop: QS,
  buttonRow: KS,
  isButtonRowCenter: ZS,
  button: YS,
  buttonSecondary: e5,
  imageContainer: t5
}, n5 = ({
  classes: n,
  Elements: { Button: o, Text: t, Image: a },
  title: i,
  subtitle: r,
  primary_button: c,
  secondary_button: s,
  image: _
}) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: n.containerLarge, children: /* @__PURE__ */ e(
  "div",
  {
    className: `${n.heroSection} ${n.paddingvertical} ${n.paddingXhuge}`,
    children: /* @__PURE__ */ l("div", { className: n.header26_component, children: [
      /* @__PURE__ */ l(
        "div",
        {
          className: `${n.marginBottom} ${n.marginXxlarge} ${n.textAlignCenter} ${n.maxWidthLarge}`,
          children: [
            /* @__PURE__ */ e("div", { className: `${n.marginBottom} ${n.marginSmall}`, children: /* @__PURE__ */ e(t, { tag: "h1", value: i }) }),
            /* @__PURE__ */ e("div", { className: `${n.textSizeMedium}`, children: /* @__PURE__ */ e(t, { tag: "p", value: r }) }),
            /* @__PURE__ */ l(
              "div",
              {
                className: `${n.marginTop} ${n.marginMedium} ${n.buttonRow} ${n.isButtonRowCenter}`,
                children: [
                  /* @__PURE__ */ e(o, { type: "Primary", value: c }),
                  /* @__PURE__ */ e(o, { type: "Secondary", value: s })
                ]
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ e("div", { className: n.imageContainer, children: /* @__PURE__ */ e(a, { value: _, className: n.image }) })
    ] })
  }
) }) }), o5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: n5,
  meta: C,
  styles: a5
}, Symbol.toStringTag, { value: "Module" })), Ie = /* @__PURE__ */ Object.assign({ "./0001/index.jsx": TI, "./0002/index.jsx": FI, "./0003/index.jsx": a6, "./0004/index.jsx": d6, "./0005/index.jsx": C6, "./0006/index.jsx": E6, "./0007/index.jsx": D6, "./0008/index.jsx": o8, "./0009/index.jsx": p8, "./0010/index.jsx": A8, "./0011/index.jsx": B8, "./0012/index.jsx": J8, "./0013/index.jsx": lA, "./0014/index.jsx": vA, "./0015/index.jsx": IA, "./0016/index.jsx": TA, "./0017/index.jsx": VA, "./0018/index.jsx": QA, "./0019/index.jsx": aS, "./0020/index.jsx": dS, "./0021/index.jsx": CS, "./0022/index.jsx": OS, "./0023/index.jsx": o5 }), i5 = Object.keys(Ie).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: Ie[o] }),
  {}
), l5 = "_buttonsWrapper_cteir_132", r5 = "_bk_cteir_165", c5 = "_imageContainer_cteir_175", s5 = "_clientTitle_cteir_185", d5 = "_item_cteir_205", _5 = "_space_cteir_138", m5 = {
  buttonsWrapper: l5,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_cteir_138",
  "spaceAfter--small": "_spaceAfter--small_cteir_141",
  "spaceAfter--medium": "_spaceAfter--medium_cteir_144",
  bk: r5,
  imageContainer: c5,
  clientTitle: s5,
  item: d5,
  space: _5
}, T = {
  section_title: {
    type: d.TEXT,
    fieldId: 65,
    defaultValue: {
      default: "Our Clients",
      ar: "عملائنا"
    }
  },
  section_description: {
    type: d.TEXT,
    fieldId: 66,
    defaultValue: {
      default: "Some of the world’s biggest brands trust us with their services",
      ar: "تقدّرنا بعض العلامات التجارية الكبرى في العالم بخدماتها"
    }
  },
  section_image: {
    type: d.IMAGE,
    fieldId: 68,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1537336097086-38557cfb415e?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=86a0b376544ccfe2ce05f559988ab6a5&auto=format&fit=crop&w=1525&q=80"
    }
  },
  logos: {
    type: d.GROUP,
    values: {
      image: d.IMAGE,
      fieldId: 67
    },
    defaultValue: [
      {
        image: {
          default: "https://assets.wuiltsite.com/defaults/google-logo.png"
        }
      },
      {
        image: {
          default: "https://assets.wuiltsite.com/defaults/facebook-logo.png"
        }
      },
      {
        image: {
          default: "https://assets.wuiltsite.com/defaults/evernote-logo.png"
        }
      },
      {
        image: {
          default: "https://assets.wuiltsite.com/defaults/shutterstock-logo.png"
        }
      },
      {
        image: {
          default: "https://assets.wuiltsite.com/defaults/google-logo.png"
        }
      },
      {
        image: {
          default: "https://assets.wuiltsite.com/defaults/facebook-logo.png"
        }
      },
      {
        image: {
          default: "https://assets.wuiltsite.com/defaults/evernote-logo.png"
        }
      },
      {
        image: {
          default: "https://assets.wuiltsite.com/defaults/shutterstock-logo.png"
        }
      }
    ]
  }
}, u5 = ({ Elements: { Image: n }, classes: o, image: t }) => /* @__PURE__ */ e("div", { className: `${o.space} col-md-3 col-sm-6 col-6`, children: /* @__PURE__ */ e("div", { className: o.item, children: /* @__PURE__ */ e("div", { className: o.imageContainer, children: /* @__PURE__ */ e(n, { className: o.itemImage, value: t, small: !0 }) }) }) }), p5 = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_description: i,
  logos: r
}) => /* @__PURE__ */ l("section", { className: t.bk, children: [
  /* @__PURE__ */ e("div", { className: t.overlay }),
  /* @__PURE__ */ l("div", { className: `${t.container} container `, children: [
    /* @__PURE__ */ l("div", { className: t.clientTitle, children: [
      /* @__PURE__ */ e(o, { tag: "h2", value: a }),
      /* @__PURE__ */ e(o, { tag: "p", value: i })
    ] }),
    /* @__PURE__ */ e("div", { className: t.services, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(n, { classes: t, Component: u5, value: r }) }) })
  ] })
] }), v5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: p5,
  meta: T,
  styles: m5
}, Symbol.toStringTag, { value: "Module" })), f5 = "_bk_1b1ph_1", g5 = "_imageContainer_1b1ph_5", h5 = "_clienteTitle_1b1ph_13", b5 = "_space_1b1ph_31", y5 = {
  bk: f5,
  imageContainer: g5,
  clienteTitle: h5,
  space: b5
}, $5 = ({ Elements: { Image: n }, classes: o, image: t }) => /* @__PURE__ */ e("div", { className: `${o.space} col-md-3 `, children: /* @__PURE__ */ e("div", { className: o.item, children: /* @__PURE__ */ e("div", { className: o.imageContainer, children: /* @__PURE__ */ e(n, { className: o.itemImage, value: t, small: !0 }) }) }) }), N5 = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_description: i,
  logos: r
}) => /* @__PURE__ */ l("div", { className: t.bk, children: [
  /* @__PURE__ */ e("div", { className: t.overlay }),
  /* @__PURE__ */ l("div", { className: `${t.container} container `, children: [
    /* @__PURE__ */ l("div", { className: t.clienteTitle, children: [
      /* @__PURE__ */ e(o, { tag: "h1", value: a }),
      /* @__PURE__ */ e(o, { tag: "p", value: i })
    ] }),
    /* @__PURE__ */ e("div", { className: t.services, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(n, { classes: t, Component: $5, value: r }) }) })
  ] })
] }), C5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: N5,
  meta: T,
  styles: y5
}, Symbol.toStringTag, { value: "Module" })), x5 = "_buttonsWrapper_1qlbs_132", I5 = "_bk_1qlbs_165", A5 = "_imageContainer_1qlbs_174", S5 = "_clientTitle_1qlbs_183", k5 = "_item_1qlbs_202", j5 = "_space_1qlbs_138", w5 = "_readmore_1qlbs_216", M5 = {
  buttonsWrapper: x5,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1qlbs_138",
  "spaceAfter--small": "_spaceAfter--small_1qlbs_141",
  "spaceAfter--medium": "_spaceAfter--medium_1qlbs_144",
  bk: I5,
  imageContainer: A5,
  clientTitle: S5,
  item: k5,
  space: j5,
  readmore: w5
}, W5 = ({ Elements: { Image: n }, classes: o, image: t }) => /* @__PURE__ */ e("div", { className: `col-md-3 col-xs-6 col-sm-12 col-6 ${o.space} `, children: /* @__PURE__ */ e("div", { className: o.item, children: /* @__PURE__ */ e("div", { className: o.imageContainer, children: /* @__PURE__ */ e(n, { className: o.itemImage, value: t, small: !0 }) }) }) }), E5 = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_description: i,
  logos: r
}) => /* @__PURE__ */ e("div", { className: t.bk, children: /* @__PURE__ */ l("div", { className: `${t.container} container `, children: [
  /* @__PURE__ */ l("div", { className: t.clientTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: t.services, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(n, { classes: t, Component: W5, value: r }) }) })
] }) }), T5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: E5,
  meta: T,
  styles: M5
}, Symbol.toStringTag, { value: "Module" })), L5 = "_buttonsWrapper_uyujk_132", O5 = "_section_uyujk_165", z5 = "_logoImage_uyujk_175", P5 = "_clienteTitle_uyujk_179", B5 = "_imageContainer_uyujk_198", q5 = "_logosContainer_uyujk_207", H5 = {
  buttonsWrapper: L5,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_uyujk_138",
  "spaceAfter--small": "_spaceAfter--small_uyujk_141",
  "spaceAfter--medium": "_spaceAfter--medium_uyujk_144",
  section: O5,
  logoImage: z5,
  clienteTitle: P5,
  imageContainer: B5,
  logosContainer: q5
}, V5 = ({ Elements: { Image: n }, classes: o, image: t }) => /* @__PURE__ */ e("div", { className: `col-md-3 col-xs-6 col-sm-12 col-6 ${o.space} `, children: /* @__PURE__ */ e("div", { className: o.item, children: /* @__PURE__ */ e("div", { className: o.imageContainer, children: /* @__PURE__ */ e(n, { className: o.logoImage, value: t, small: !0 }) }) }) }), F5 = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_description: i,
  logos: r
}) => /* @__PURE__ */ e("div", { className: t.section, children: /* @__PURE__ */ l("div", { className: `${t.container} container`, children: [
  /* @__PURE__ */ l("div", { className: t.clienteTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: t.logosContainer, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(n, { classes: t, Component: V5, value: r }) }) })
] }) }), D5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: F5,
  meta: T,
  styles: H5
}, Symbol.toStringTag, { value: "Module" })), X5 = "_buttonsWrapper_bj5vz_132", R5 = "_section_bj5vz_165", G5 = "_styleColumn_bj5vz_169", U5 = "_clienteTitle_bj5vz_179", J5 = "_imageContainer_bj5vz_198", Q5 = "_logosContainer_bj5vz_210", K5 = {
  buttonsWrapper: X5,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_bj5vz_138",
  "spaceAfter--small": "_spaceAfter--small_bj5vz_141",
  "spaceAfter--medium": "_spaceAfter--medium_bj5vz_144",
  section: R5,
  styleColumn: G5,
  clienteTitle: U5,
  imageContainer: J5,
  logosContainer: Q5
}, Z5 = ({ Elements: { Image: n }, classes: o, image: t }) => /* @__PURE__ */ e("div", { className: "col-xl-3 col-lg-4 col-md-6 col-6 col-sm-6", children: /* @__PURE__ */ e("div", { className: o.item, children: /* @__PURE__ */ e("div", { className: o.imageContainer, children: /* @__PURE__ */ e(n, { className: o.logoImage, value: t, small: !0 }) }) }) }), Y5 = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_description: i,
  logos: r
}) => /* @__PURE__ */ e("div", { className: t.section, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: `col-lg-4 col-md-5  ${t.styleColumn} `, children: /* @__PURE__ */ l("div", { className: t.clienteTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }) }),
  /* @__PURE__ */ e("div", { className: "col-lg-8 col-md-7 col-xs-6 col-sm-6", children: /* @__PURE__ */ e("div", { className: t.logosContainer, children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: Z5,
      value: r
    }
  ) }) })
] }) }) }), ek = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Y5,
  meta: T,
  styles: K5
}, Symbol.toStringTag, { value: "Module" })), tk = "_buttonsWrapper_jy2ie_132", ak = "_section_jy2ie_165", nk = "_styleColumn_jy2ie_168", ok = "_styleColumn2_jy2ie_175", ik = "_clienteTitle_jy2ie_186", lk = "_imageContainer_jy2ie_214", rk = "_logosContainer_jy2ie_226", ck = {
  buttonsWrapper: tk,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_jy2ie_138",
  "spaceAfter--small": "_spaceAfter--small_jy2ie_141",
  "spaceAfter--medium": "_spaceAfter--medium_jy2ie_144",
  section: ak,
  styleColumn: nk,
  styleColumn2: ok,
  clienteTitle: ik,
  imageContainer: lk,
  logosContainer: rk
}, sk = ({ Elements: { Image: n }, classes: o, image: t }) => /* @__PURE__ */ e("div", { className: "col-lg-4 col-md-6 col-6", children: /* @__PURE__ */ e("div", { className: o.item, children: /* @__PURE__ */ e("div", { className: o.imageContainer, children: /* @__PURE__ */ e(n, { className: o.logoImage, value: t, small: !0 }) }) }) }), dk = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_description: i,
  logos: r
}) => /* @__PURE__ */ e("div", { className: t.section, children: /* @__PURE__ */ e("div", { className: "container-fluid", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: `col-md-6  ${t.styleColumn} `, children: /* @__PURE__ */ l("div", { className: t.clienteTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }) }),
  /* @__PURE__ */ e("div", { className: `col-md-6  ${t.styleColumn2} `, children: /* @__PURE__ */ e("div", { className: t.logosContainer, children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: sk,
      value: r
    }
  ) }) })
] }) }) }), _k = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dk,
  meta: T,
  styles: ck
}, Symbol.toStringTag, { value: "Module" })), mk = "_buttonsWrapper_111jy_132", uk = "_section_111jy_165", pk = "_clientTitle_111jy_175", vk = "_logoImage_111jy_193", fk = "_imageContainer_111jy_197", gk = "_logosContainer_111jy_206", hk = {
  buttonsWrapper: mk,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_111jy_138",
  "spaceAfter--small": "_spaceAfter--small_111jy_141",
  "spaceAfter--medium": "_spaceAfter--medium_111jy_144",
  section: uk,
  clientTitle: pk,
  logoImage: vk,
  imageContainer: fk,
  logosContainer: gk
}, bk = ({ Elements: { Image: n }, classes: o, image: t }) => /* @__PURE__ */ e("div", { className: `col-md-3 col-xs-6 col-sm-12  ${o.space} `, children: /* @__PURE__ */ e("div", { className: o.item, children: /* @__PURE__ */ e("div", { className: o.imageContainer, children: /* @__PURE__ */ e(n, { className: o.logoImage, value: t, small: !0 }) }) }) }), yk = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_description: i,
  logos: r
}) => /* @__PURE__ */ e("div", { className: t.section, children: /* @__PURE__ */ l("div", { className: `${t.container} container `, children: [
  /* @__PURE__ */ l("div", { className: t.clientTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: t.logosContainer, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(n, { classes: t, Component: bk, value: r }) }) })
] }) }), $k = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yk,
  meta: T,
  styles: hk
}, Symbol.toStringTag, { value: "Module" })), Nk = "_buttonsWrapper_jbrji_132", Ck = "_section_jbrji_165", xk = "_styleColumn_jbrji_168", Ik = "_styleColumn2_jbrji_173", Ak = "_bkStyle_jbrji_184", Sk = "_overlay_jbrji_193", kk = "_clienteTitle_jbrji_202", jk = "_imageContainer_jbrji_229", wk = "_logosContainer_jbrji_241", Mk = {
  buttonsWrapper: Nk,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_jbrji_138",
  "spaceAfter--small": "_spaceAfter--small_jbrji_141",
  "spaceAfter--medium": "_spaceAfter--medium_jbrji_144",
  section: Ck,
  styleColumn: xk,
  styleColumn2: Ik,
  bkStyle: Ak,
  overlay: Sk,
  clienteTitle: kk,
  imageContainer: jk,
  logosContainer: wk
}, Wk = ({ Elements: { Image: n }, classes: o, image: t }) => /* @__PURE__ */ e("div", { className: "col-lg-4 col-md-6 col-6", children: /* @__PURE__ */ e("div", { className: o.item, children: /* @__PURE__ */ e("div", { className: o.imageContainer, children: /* @__PURE__ */ e(n, { className: o.logoImage, value: t, small: !0 }) }) }) }), Ek = ({
  Elements: { RepeatedItems: n, Text: o, BackgroundContainer: t },
  classes: a,
  section_title: i,
  section_description: r,
  section_image: c,
  logos: s
}) => /* @__PURE__ */ e("div", { className: a.section, children: /* @__PURE__ */ e("div", { className: "container-fluid", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: `col-md-6  ${a.styleColumn} `, children: /* @__PURE__ */ l(
    t,
    {
      value: c,
      className: a.bkStyle,
      children: [
        /* @__PURE__ */ e("div", { className: a.overlay }),
        /* @__PURE__ */ l("div", { className: a.clienteTitle, children: [
          /* @__PURE__ */ e(o, { tag: "h2", value: i }),
          /* @__PURE__ */ e(o, { tag: "p", value: r })
        ] })
      ]
    }
  ) }),
  /* @__PURE__ */ e("div", { className: `col-md-6  ${a.styleColumn2} `, children: /* @__PURE__ */ e("div", { className: a.logosContainer, children: /* @__PURE__ */ e(
    n,
    {
      classes: a,
      Component: Wk,
      value: s
    }
  ) }) })
] }) }) }), Tk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ek,
  meta: T,
  styles: Mk
}, Symbol.toStringTag, { value: "Module" })), Lk = "_buttonsWrapper_i41fa_132", Ok = "_logosContainer_i41fa_165", zk = "_containerLarge_i41fa_180", Pk = "_paddingVerticalXxlarge_i41fa_186", Bk = "_marginBottomSmall_i41fa_189", qk = "_marginBottomLarge_i41fa_192", Hk = "_textAlignCenter_i41fa_195", Vk = "_maxWidthLarge_i41fa_198", Fk = "_alignCenter_i41fa_202", Dk = "_textSizeMedium_i41fa_206", Xk = "_wLayoutGrid_i41fa_209", Rk = "_logo6_list_i41fa_220", Gk = "_logoItem_i41fa_266", Uk = "_logo6_wrapper_i41fa_266", Jk = "_wrapperId_i41fa_1", Qk = {
  buttonsWrapper: Lk,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_i41fa_138",
  "spaceAfter--small": "_spaceAfter--small_i41fa_141",
  "spaceAfter--medium": "_spaceAfter--medium_i41fa_144",
  logosContainer: Ok,
  containerLarge: zk,
  paddingVerticalXxlarge: Pk,
  marginBottomSmall: Bk,
  marginBottomLarge: qk,
  textAlignCenter: Hk,
  maxWidthLarge: Vk,
  alignCenter: Fk,
  textSizeMedium: Dk,
  wLayoutGrid: Xk,
  logo6_list: Rk,
  logoItem: Gk,
  logo6_wrapper: Uk,
  wrapperId: Jk
}, Kk = ({ Elements: { Image: n }, classes: o, image: t }) => /* @__PURE__ */ e("div", { className: o.logoItem, children: /* @__PURE__ */ e("div", { className: o.logo6_wrapper, id: o.wrapperId, children: /* @__PURE__ */ e(n, { className: o.logo6_logo, value: t, small: !0 }) }) }), Zk = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_description: i,
  logos: r
}) => /* @__PURE__ */ e("section", { className: t.logosContainer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: t.containerLarge, children: /* @__PURE__ */ l("div", { className: t.paddingVerticalXxlarge, children: [
  /* @__PURE__ */ e(
    "div",
    {
      className: `${t.marginBottomSmall} ${t.textAlignCenter}`,
      children: /* @__PURE__ */ e(o, { tag: "h2", value: a })
    }
  ),
  /* @__PURE__ */ e("div", { className: t.marginBottomLarge, children: /* @__PURE__ */ e("div", { className: t.textAlignCenter, children: /* @__PURE__ */ e(
    "div",
    {
      className: `${t.maxWidthLarge} ${t.alignCenter}`,
      children: /* @__PURE__ */ e(
        "div",
        {
          className: `${t.textSizeMedium} ${t.textAlignCenter}`,
          children: /* @__PURE__ */ e(o, { tag: "p", value: i })
        }
      )
    }
  ) }) }),
  /* @__PURE__ */ e("div", { className: `${t.wLayoutGrid} ${t.logo6_list}`, children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: Kk,
      value: r
    }
  ) })
] }) }) }) }), Yk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Zk,
  meta: T,
  styles: Qk
}, Symbol.toStringTag, { value: "Module" })), Ae = /* @__PURE__ */ Object.assign({ "./0001/index.jsx": v5, "./0002/index.jsx": C5, "./0003/index.jsx": T5, "./0004/index.jsx": D5, "./0005/index.jsx": ek, "./0006/index.jsx": _k, "./0007/index.jsx": $k, "./0008/index.jsx": Tk, "./0009/index.jsx": Yk }), e9 = Object.keys(Ae).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: Ae[o] }),
  {}
), t9 = "_container_rv8jh_1", a9 = "_map_rv8jh_5", n9 = "_alignCenter_rv8jh_11", o9 = {
  container: t9,
  map: a9,
  alignCenter: n9
}, i9 = {
  title: {
    type: d.TEXT,
    defaultValue: {
      default: "A section for you to write about just anything",
      ar: "PLACEHOLDER_TODO"
    }
  },
  content: {
    type: d.TEXT,
    defaultValue: {
      default: "Need a place to add in your awards? This is it. Want to include more information about your products, history, or features? This is the spot for that. Use this content section for anything and everything.",
      ar: "PLACEHOLDER_TODO"
    }
  },
  map: {
    type: d.MAP,
    defaultValue: {
      default: {
        zoom: 15,
        marker: {
          location: {
            lat: 37.77431841442777,
            lng: -122.41890101586915
          }
        },
        mapType: "roadmap"
      }
    }
  }
}, l9 = ({ Elements: { Text: n, Map: o }, classes: t, title: a, content: i, map: r }) => /* @__PURE__ */ e("section", { children: /* @__PURE__ */ e("div", { className: `container ${t.container}`, children: /* @__PURE__ */ l("div", { className: `row ${t.alignCenter}`, children: [
  /* @__PURE__ */ l("div", { className: "col-md-6", children: [
    /* @__PURE__ */ e(n, { tag: "h2", value: a }),
    /* @__PURE__ */ e(n, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ e(o, { className: t.map, value: r }) })
] }) }) }), r9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: l9,
  meta: i9,
  styles: o9
}, Symbol.toStringTag, { value: "Module" })), Se = /* @__PURE__ */ Object.assign({ "./0001/index.jsx": r9 }), c9 = Object.keys(Se).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: Se[o] }),
  {}
), s9 = "_buttonsWrapper_pote0_132", d9 = "_sectionContainer_pote0_165", _9 = "_sectionHeader_pote0_168", m9 = "_pricingItem_pote0_182", u9 = "_itemHeader_pote0_191", p9 = "_itemHeaderText_pote0_197", v9 = "_itemHeaderIcon_pote0_210", f9 = "_itemText_pote0_238", g9 = "_itemFooter_pote0_252", h9 = "_btn_pote0_252", b9 = "_activeBtn_pote0_263", y9 = "_active_pote0_263", $9 = {
  buttonsWrapper: s9,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_pote0_138",
  "spaceAfter--small": "_spaceAfter--small_pote0_141",
  "spaceAfter--medium": "_spaceAfter--medium_pote0_144",
  sectionContainer: d9,
  sectionHeader: _9,
  pricingItem: m9,
  itemHeader: u9,
  itemHeaderText: p9,
  itemHeaderIcon: v9,
  itemText: f9,
  itemFooter: g9,
  btn: h9,
  activeBtn: b9,
  active: y9
}, L = {
  destination: "external",
  // 'internal'
  target: "current",
  // 'new'
  text: "Read More",
  pageId: "",
  href: "#"
}, O = {
  destination: "external",
  // 'internal'
  target: "current",
  // 'new'
  text: "اقرا المزيد",
  pageId: "",
  href: "#"
}, q = {
  plan_type_one: {
    type: d.TEXT,
    fieldId: 236,
    defaultValue: {
      default: "Monthly",
      ar: "شهريًا"
    }
  },
  plan_type_two: {
    type: d.TEXT,
    fieldId: 239,
    defaultValue: {
      default: "Annually",
      ar: "سنويًا"
    }
  },
  section_title: {
    type: d.TEXT,
    fieldId: 237,
    defaultValue: {
      default: "Pricing that makes sense",
      ar: "أسعار مناسبة لك"
    }
  },
  section_short_description: {
    type: d.TEXT,
    fieldId: 238,
    defaultValue: {
      default: "Simple, fair pricing for everyone",
      ar: "تجربة مجانية ١٤ يوم على كل الباقات"
    }
  },
  plans: {
    type: d.GROUP,
    defaultValue: [
      {
        first_plan_name: {
          default: "Start",
          ar: "بداية"
        },
        first_plan_price: {
          default: "Free",
          ar: "مجانًا"
        },
        first_plan_image: {
          default: "https://images.unsplash.com/photo-1525332421884-c2f224a01519?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=2166c838ff990f31fda665022735da2b&auto=format&fit=crop&w=2551&q=80"
        },
        first_plan_icon: {
          default: "support"
        },
        first_plan_features_header: {
          default: "features",
          ar: "سوف تحصل على:"
        },
        first_plan_features: {
          default: `✔ Feature One<br/>
✔ Feature Two`,
          ar: `✔ الميزة الأولى<br/>
✔ الميزة الثانية`
        },
        first_plan_short_description: {
          default: "This paragraph to explain how your pricing model works and what are the benefits your customer will have. Should be straight to the point and not a  long paragraph",
          ar: " هذا النص هو مثال لمساعدتك في توضيح أسعارك والفوائد والمميزات التي سيحصل عليها العملاء مقابل هذه الأسعار، حاول أن يكون النص مباشرًا وواضحًا ومختصرًا قدر الإمكان."
        },
        first_plan_button: {
          default: L,
          ar: O
        },
        second_plan_name: {
          default: "Start",
          ar: "بداية"
        },
        second_plan_price: {
          default: "Free",
          ar: "مجانًا"
        },
        second_plan_image: {
          default: "https://images.unsplash.com/photo-1525332421884-c2f224a01519?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=2166c838ff990f31fda665022735da2b&auto=format&fit=crop&w=2551&q=80"
        },
        second_plan_icon: {
          default: "support"
        },
        second_plan_features_header: {
          default: "features",
          ar: "سوف تحصل على:"
        },
        second_plan_features: {
          default: `✔ Feature One<br/>
✔ Feature Two`,
          ar: `✔ الميزة الاولى<br/>
✔ الميزة الثانية`
        },
        second_plan_short_description: {
          default: "This paragraph to explain how your pricing model works and what are the benefits your customer will have. Should be straight to the point and not a  long paragraph",
          ar: " هذا النص هو مثال لمساعدتك في توضيح أسعارك والفوائد والمميزات التي سيحصل عليها العملاء مقابل هذه الأسعار، حاول أن يكون النص مباشرًا وواضحًا ومختصرًا قدر الإمكان."
        },
        second_plan_button: {
          default: L,
          ar: O
        }
      },
      {
        first_plan_name: {
          default: "Personal",
          ar: "شخصي"
        },
        first_plan_price: {
          default: "$50 ",
          ar: " $50"
        },
        first_plan_image: {
          default: "https://images.unsplash.com/photo-1526455192392-2aec60ae8485?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=af18ae684049a7f73e2583d829b794c2&auto=format&fit=crop&w=3000&q=80"
        },
        first_plan_icon: {
          default: "users"
        },
        first_plan_features_header: {
          default: "features",
          ar: "سوف تحصل على:"
        },
        first_plan_features: {
          default: `✔ Feature One<br/>
✔ Feature Two<br/>
✔ Feature Three<br/>
✔ Feature Four<br/>
✔ Feature Five`,
          ar: `✔ الميزة الاولى<br/>
✔ الميزة الثانية<br/>
✔ الميزة الثالثة<br/>
✔ الميزة الرابعة<br/>
✔ الميزة الخامسة`
        },
        first_plan_short_description: {
          default: "This paragraph to explain how your pricing model works and what are the benefits your customer will have. Should be straight to the point and not a  long paragraph",
          ar: "هذا النص هو مثال لمساعدتك في توضيح أسعارك والفوائد والمميزات التي سيحصل عليها العملاء مقابل هذه الأسعار، حاول أن يكون النص مباشرًا وواضحًا ومختصرًا قدر الإمكان. "
        },
        first_plan_button: {
          default: L,
          ar: O
        },
        second_plan_name: {
          default: "Personal",
          ar: "شخصي"
        },
        second_plan_price: {
          default: "$50",
          ar: "$50"
        },
        second_plan_image: {
          default: "https://images.unsplash.com/photo-1526455192392-2aec60ae8485?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=af18ae684049a7f73e2583d829b794c2&auto=format&fit=crop&w=3000&q=80"
        },
        second_plan_icon: {
          default: "users"
        },
        second_plan_features_header: {
          default: "features",
          ar: "سوف تحصل على:"
        },
        second_plan_features: {
          default: `✔ Feature One<br/>
✔ Feature Two<br/>
✔ Feature Three<br/>
✔ Feature Four<br/>
✔ Feature Five`,
          ar: `✔ الميزة الاولى<br/>
✔ الميزة الثانية<br/>
✔ الميزة الثالثة<br/>
✔ الميزة الرابعة<br/>
✔ الميزة الخامسة`
        },
        second_plan_short_description: {
          default: "This paragraph to explain how your pricing model works and what are the benefits your customer will have. Should be straight to the point and not a  long paragraph",
          ar: "هذا النص هو مثال لمساعدتك في توضيح أسعارك والفوائد والمميزات التي سيحصل عليها العملاء مقابل هذه الأسعار، حاول أن يكون النص مباشرًا وواضحًا ومختصرًا قدر الإمكان. "
        },
        second_plan_button: {
          default: L,
          ar: O
        }
      },
      {
        first_plan_name: {
          default: "Business",
          ar: "شركات"
        },
        first_plan_price: {
          default: "$150",
          ar: "$150 "
        },
        first_plan_image: {
          default: "https://images.unsplash.com/photo-1451933371645-a3029668b979?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=6b5c99388f5b9a4cdc908bc781490e33&auto=format&fit=crop&w=3150&q=80"
        },
        first_plan_icon: {
          default: "briefcase"
        },
        first_plan_features_header: {
          default: "features",
          ar: "سوف تحصل على:"
        },
        first_plan_features: {
          default: `✔ Feature One<br/>
✔ Feature Two<br/>
✔ Feature Three`,
          ar: `✔ الميزة الاولى<br/>
✔ الميزة الثانية<br/>
✔ الميزة الثالثة`
        },
        first_plan_short_description: {
          default: "This paragraph to explain how your pricing model works and what are the benefits your customer will have. Should be straight to the point and not a  long paragraph",
          ar: "هذا النص هو مثال لمساعدتك في توضيح أسعارك والفوائد والمميزات التي سيحصل عليها العملاء مقابل هذه الأسعار، حاول أن يكون النص مباشرًا وواضحًا ومختصرًا قدر الإمكان. "
        },
        first_plan_button: {
          default: L,
          ar: O
        },
        second_plan_name: {
          default: "Business",
          ar: "شركات"
        },
        second_plan_price: {
          default: "$150",
          ar: "$150 "
        },
        second_plan_image: {
          default: "https://images.unsplash.com/photo-1451933371645-a3029668b979?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=6b5c99388f5b9a4cdc908bc781490e33&auto=format&fit=crop&w=3150&q=80"
        },
        second_plan_icon: {
          default: "briefcase"
        },
        second_plan_features_header: {
          default: "features",
          ar: " سوف تحصل على: "
        },
        second_plan_features: {
          default: `✔ Feature One
✔ Feature Two
✔ Feature Three`,
          ar: `✔ الميزة الاولى<br/>
✔ الميزة الثانية<br/>
✔ الميزة الثالثة`
        },
        second_plan_short_description: {
          default: "This paragraph to explain how your pricing model works and what are the benefits your customer will have. Should be straight to the point and not a  long paragraph",
          ar: "هذا النص هو مثال لمساعدتك في توضيح أسعارك والفوائد والمميزات التي سيحصل عليها العملاء مقابل هذه الأسعار، حاول أن يكون النص مباشرًا وواضحًا ومختصرًا قدر الإمكان. "
        },
        second_plan_button: {
          default: L,
          ar: O
        }
      },
      {
        first_plan_name: {
          default: "Premium",
          ar: "مميز"
        },
        first_plan_price: {
          default: "Free",
          ar: "مجانًا"
        },
        first_plan_image: {
          default: "https://images.unsplash.com/photo-1503032837158-6a350e21ac22?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=51bae5180290942876c0bc137d26d600&auto=format&fit=crop&w=1663&q=80"
        },
        first_plan_icon: {
          default: "asterisk"
        },
        first_plan_features_header: {
          default: "features",
          ar: "سوف تحصل على:"
        },
        first_plan_features: {
          default: `✔ Feature One<br/>
✔ Feature Two`,
          ar: `✔ الميزة الاولى<br/>
✔ الميزة الثانية`
        },
        first_plan_short_description: {
          default: "This paragraph to explain how your pricing model works and what are the benefits your customer will have. Should be straight to the point and not a  long paragraph",
          ar: " هذا النص هو مثال لمساعدتك في توضيح أسعارك والفوائد والمميزات التي سيحصل عليها العملاء مقابل هذه الأسعار، حاول أن يكون النص مباشرًا وواضحًا ومختصرًا قدر الإمكان."
        },
        first_plan_button: {
          default: L,
          ar: O
        },
        second_plan_name: {
          default: "Premium",
          ar: "مميز"
        },
        second_plan_price: {
          default: "$200",
          ar: "$200"
        },
        second_plan_image: {
          default: "https://images.unsplash.com/photo-1503032837158-6a350e21ac22?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=51bae5180290942876c0bc137d26d600&auto=format&fit=crop&w=1663&q=80"
        },
        second_plan_icon: {
          default: "asterisk"
        },
        second_plan_features_header: {
          default: "features",
          ar: "سوف تحصل على:"
        },
        second_plan_features: {
          default: `✔ Feature One<br/>
✔ Feature Two`,
          ar: `✔ الميزة الاولى<br/>
✔ الميزة الثانية`
        },
        second_plan_short_description: {
          default: "This paragraph to explain how your pricing model works and what are the benefits your customer will have. Should be straight to the point and not a  long paragraph",
          ar: " هذا النص هو مثال لمساعدتك في توضيح أسعارك والفوائد والمميزات التي سيحصل عليها العملاء مقابل هذه الأسعار، حاول أن يكون النص مباشرًا وواضحًا ومختصرًا قدر الإمكان."
        },
        second_plan_button: {
          default: L,
          ar: O
        }
      }
    ],
    values: {
      first_plan_name: {
        type: d.TEXT,
        fieldId: 240
      },
      first_plan_price: {
        type: d.TEXT,
        fieldId: 241
      },
      first_plan_image: {
        type: d.IMAGE,
        fieldId: 242
      },
      first_plan_icon: {
        type: d.ICON,
        fieldId: 243
      },
      first_plan_features_header: {
        type: d.TEXT,
        fieldId: 244
      },
      first_plan_features: {
        type: d.TEXT,
        fieldId: 245
      },
      first_plan_short_description: {
        type: d.TEXT,
        fieldId: 246
      },
      first_plan_button: {
        type: d.LINK,
        fieldId: 247
      },
      second_plan_name: {
        type: d.TEXT,
        fieldId: 248
      },
      second_plan_price: {
        type: d.TEXT,
        fieldId: 249
      },
      second_plan_image: {
        type: d.IMAGE,
        fieldId: 250
      },
      second_plan_icon: {
        type: d.ICON,
        fieldId: 251
      },
      second_plan_features_header: {
        type: d.TEXT,
        fieldId: 252
      },
      second_plan_features: {
        type: d.TEXT,
        fieldId: 253
      },
      second_plan_short_description: {
        type: d.TEXT,
        fieldId: 254
      },
      second_plan_button: {
        type: d.LINK,
        fieldId: 255
      }
    }
  }
}, N9 = ({
  Elements: { Text: n, Icon: o, Button: t },
  classes: a,
  first_plan_name: i,
  first_plan_price: r,
  first_plan_features_header: c,
  first_plan_icon: s,
  first_plan_features: _,
  isActive: m,
  first_plan_button: p
}) => /* @__PURE__ */ e("div", { className: "col-md-6 py-3 mb-4", children: /* @__PURE__ */ l("div", { className: `${a.pricingItem} ${m ? a.active : ""}`, children: [
  /* @__PURE__ */ l("div", { children: [
    /* @__PURE__ */ l("div", { className: a.itemHeader, children: [
      /* @__PURE__ */ l("div", { className: a.itemHeaderText, children: [
        /* @__PURE__ */ e(n, { tag: "h6", value: i }),
        /* @__PURE__ */ e(n, { tag: "h3", value: r })
      ] }),
      /* @__PURE__ */ e("div", { className: a.itemHeaderIcon, children: /* @__PURE__ */ e(o, { value: s, alt: "" }) })
    ] }),
    /* @__PURE__ */ l("div", { className: a.itemText, children: [
      /* @__PURE__ */ e(n, { tag: "h5", value: c }),
      /* @__PURE__ */ e(n, { tag: "p", value: _ })
    ] })
  ] }),
  /* @__PURE__ */ e("div", { className: a.itemFooter, children: /* @__PURE__ */ e(
    t,
    {
      value: p,
      type: m ? "Primary" : "Secondary"
    }
  ) })
] }) }), C9 = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_short_description: i,
  plans: r
}) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: t.sectionContainer, children: [
  /* @__PURE__ */ l("div", { className: t.sectionHeader, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: N9,
      value: r
    }
  ) })
] }) }), x9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: C9,
  meta: q,
  styles: $9
}, Symbol.toStringTag, { value: "Module" })), I9 = "_buttonsWrapper_1askm_132", A9 = "_sectionContainer_1askm_165", S9 = "_pricingItem_1askm_169", k9 = "_itemHeader_1askm_180", j9 = "_itemContent_1askm_218", w9 = "_itemFooter_1askm_238", M9 = "_btn_1askm_243", W9 = "_activeBtn_1askm_253", E9 = {
  buttonsWrapper: I9,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1askm_138",
  "spaceAfter--small": "_spaceAfter--small_1askm_141",
  "spaceAfter--medium": "_spaceAfter--medium_1askm_144",
  sectionContainer: A9,
  pricingItem: S9,
  itemHeader: k9,
  itemContent: j9,
  itemFooter: w9,
  btn: M9,
  activeBtn: W9
}, T9 = ({
  Elements: { Text: n, Button: o },
  classes: t,
  first_plan_name: a,
  first_plan_price: i,
  first_plan_short_description: r,
  first_plan_button: c
}) => /* @__PURE__ */ e("div", { className: "col-md-6 mb-4", children: /* @__PURE__ */ l("div", { className: t.pricingItem, children: [
  /* @__PURE__ */ l("div", { children: [
    /* @__PURE__ */ l("div", { className: t.itemHeader, children: [
      /* @__PURE__ */ e(n, { tag: "h6", value: a }),
      /* @__PURE__ */ e(n, { tag: "h3", value: i })
    ] }),
    /* @__PURE__ */ e("div", { className: t.itemContent, children: /* @__PURE__ */ e(n, { tag: "p", value: r }) })
  ] }),
  /* @__PURE__ */ e("div", { className: t.itemFooter, children: /* @__PURE__ */ e(o, { type: "Primary", value: c }) })
] }) }), L9 = ({ Elements: { RepeatedItems: n }, classes: o, plans: t }) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: o.sectionContainer, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
  n,
  {
    classes: o,
    Component: T9,
    value: t
  }
) }) }) }), O9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: L9,
  meta: q,
  styles: E9
}, Symbol.toStringTag, { value: "Module" })), z9 = "_sectionContainer_1xlpv_1", P9 = "_pricingItem_1xlpv_5", B9 = "_itemHeader_1xlpv_16", q9 = "_itemContent_1xlpv_26", H9 = "_itemFooter_1xlpv_32", V9 = "_btn_1xlpv_32", F9 = "_activeBtn_1xlpv_44", D9 = "_active_1xlpv_44", X9 = {
  sectionContainer: z9,
  pricingItem: P9,
  itemHeader: B9,
  itemContent: q9,
  itemFooter: H9,
  btn: V9,
  activeBtn: F9,
  active: D9
}, R9 = ({
  Elements: { Text: n, Button: o },
  classes: t,
  first_plan_name: a,
  first_plan_price: i,
  first_plan_features: r,
  first_plan_button: c,
  isActive: s
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 py-3 mb-4", children: /* @__PURE__ */ l("div", { className: `${t.pricingItem} ${s ? t.active : ""}`, children: [
  /* @__PURE__ */ l("div", { children: [
    /* @__PURE__ */ l("div", { className: t.itemHeader, children: [
      /* @__PURE__ */ e(n, { tag: "h6", value: a }),
      /* @__PURE__ */ e(n, { tag: "h3", value: i })
    ] }),
    /* @__PURE__ */ e("div", { className: t.itemContent, children: /* @__PURE__ */ e(n, { tag: "p", value: r }) })
  ] }),
  /* @__PURE__ */ e("div", { className: t.itemFooter, children: /* @__PURE__ */ e(
    o,
    {
      value: c,
      type: s ? "Primary" : "Secondary"
    }
  ) })
] }) }), G9 = ({ Elements: { RepeatedItems: n }, classes: o, plans: t }) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: o.sectionContainer, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
  n,
  {
    classes: o,
    Component: R9,
    value: t
  }
) }) }) }), U9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: G9,
  meta: q,
  styles: X9
}, Symbol.toStringTag, { value: "Module" })), J9 = "_sectionContainer_1j15k_1", Q9 = "_pricingItem_1j15k_5", K9 = "_itemHeader_1j15k_15", Z9 = "_itemIcon_1j15k_20", Y9 = "_itemContent_1j15k_48", e7 = "_itemFooter_1j15k_54", t7 = "_btn_1j15k_58", a7 = "_activeBtn_1j15k_69", n7 = {
  sectionContainer: J9,
  pricingItem: Q9,
  itemHeader: K9,
  itemIcon: Z9,
  itemContent: Y9,
  itemFooter: e7,
  btn: t7,
  activeBtn: a7
}, o7 = ({
  Elements: { Text: n, Icon: o, Button: t },
  classes: a,
  first_plan_icon: i,
  first_plan_name: r,
  first_plan_price: c,
  first_plan_short_description: s,
  first_plan_button: _
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 py-3 mb-4", children: /* @__PURE__ */ l("div", { className: a.pricingItem, children: [
  /* @__PURE__ */ l("div", { children: [
    /* @__PURE__ */ l("div", { className: a.itemHeader, children: [
      /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(n, { tag: "h6", value: r }) }),
      /* @__PURE__ */ e("div", { className: a.itemIcon, children: /* @__PURE__ */ e(o, { value: i, alt: "" }) })
    ] }),
    /* @__PURE__ */ e("div", { className: a.itemContent, children: /* @__PURE__ */ e(n, { tag: "p", value: s }) })
  ] }),
  /* @__PURE__ */ l("div", { className: a.itemFooter, children: [
    /* @__PURE__ */ e(n, { tag: "h3", value: c }),
    /* @__PURE__ */ e(t, { type: "Primary", value: _ })
  ] })
] }) }), i7 = ({ Elements: { RepeatedItems: n }, classes: o, plans: t }) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: o.sectionContainer, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
  n,
  {
    classes: o,
    Component: o7,
    value: t
  }
) }) }) }), l7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: i7,
  meta: q,
  styles: n7
}, Symbol.toStringTag, { value: "Module" })), r7 = "_buttonsWrapper_7ucz5_132", c7 = "_sectionContainer_7ucz5_165", s7 = "_sectionHeader_7ucz5_168", d7 = "_pricingItem_7ucz5_182", _7 = "_imageContainer_7ucz5_189", m7 = "_itemHeader_7ucz5_198", u7 = "_itemText_7ucz5_205", p7 = "_itemFooter_7ucz5_214", v7 = "_btn_7ucz5_221", f7 = "_activeBtn_7ucz5_232", g7 = "_active_7ucz5_232", h7 = {
  buttonsWrapper: r7,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_7ucz5_138",
  "spaceAfter--small": "_spaceAfter--small_7ucz5_141",
  "spaceAfter--medium": "_spaceAfter--medium_7ucz5_144",
  sectionContainer: c7,
  sectionHeader: s7,
  pricingItem: d7,
  imageContainer: _7,
  itemHeader: m7,
  itemText: u7,
  itemFooter: p7,
  btn: v7,
  activeBtn: f7,
  active: g7
}, b7 = ({
  Elements: { Text: n, Image: o, Button: t },
  classes: a,
  first_plan_name: i,
  first_plan_price: r,
  first_plan_short_description: c,
  first_plan_button: s,
  first_plan_image: _,
  isActive: m
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 py-3 mb-4", children: /* @__PURE__ */ l("div", { className: `${a.pricingItem} ${m ? a.active : ""}`, children: [
  /* @__PURE__ */ e("div", { className: a.imageContainer, children: /* @__PURE__ */ e(o, { value: _ }) }),
  /* @__PURE__ */ e("div", { className: a.itemHeader, children: /* @__PURE__ */ e(n, { tag: "h5", value: i }) }),
  /* @__PURE__ */ e("div", { className: a.itemText, children: /* @__PURE__ */ e(n, { tag: "p", value: c }) }),
  /* @__PURE__ */ l("div", { className: a.itemFooter, children: [
    /* @__PURE__ */ e(n, { tag: "h3", value: r }),
    /* @__PURE__ */ e(
      t,
      {
        value: s,
        type: m ? "Primary" : "Secondary"
      }
    )
  ] })
] }) }), y7 = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_short_description: i,
  plans: r
}) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: t.sectionContainer, children: [
  /* @__PURE__ */ l("div", { className: t.sectionHeader, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: b7,
      value: r
    }
  ) })
] }) }), $7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: y7,
  meta: q,
  styles: h7
}, Symbol.toStringTag, { value: "Module" })), N7 = "_sectionContainer_eqm6j_1", C7 = "_paymentTab_eqm6j_4", x7 = "_activeTab_eqm6j_16", I7 = "_pricingItem_eqm6j_22", A7 = "_itemHeader_eqm6j_31", S7 = "_itemText_eqm6j_48", k7 = "_itemFooter_eqm6j_57", j7 = "_btn_eqm6j_57", w7 = "_activeBtn_eqm6j_69", M7 = "_active_eqm6j_16", W7 = {
  sectionContainer: N7,
  paymentTab: C7,
  activeTab: x7,
  pricingItem: I7,
  itemHeader: A7,
  itemText: S7,
  itemFooter: k7,
  btn: j7,
  activeBtn: w7,
  active: M7
}, E7 = ({
  Elements: { Text: n, Button: o },
  classes: t,
  first_plan_name: a,
  first_plan_price: i,
  first_plan_features: r,
  first_plan_button: c,
  isActive: s
}) => /* @__PURE__ */ e("div", { className: "col-lg-3 col-md-6 py-3 mb-4", children: /* @__PURE__ */ l("div", { className: `${t.pricingItem} ${s ? t.active : ""}`, children: [
  /* @__PURE__ */ l("div", { children: [
    /* @__PURE__ */ l("div", { className: t.itemHeader, children: [
      /* @__PURE__ */ e(n, { tag: "h6", value: a }),
      /* @__PURE__ */ e(n, { tag: "h3", value: i })
    ] }),
    /* @__PURE__ */ e("div", { className: t.itemText, children: /* @__PURE__ */ e(n, { tag: "p", value: r }) })
  ] }),
  /* @__PURE__ */ e("div", { className: t.itemFooter, children: /* @__PURE__ */ e(
    o,
    {
      value: c,
      type: s ? "Primary" : "Secondary"
    }
  ) })
] }) }), T7 = ({
  Elements: { Text: n, Button: o },
  classes: t,
  second_plan_name: a,
  second_plan_price: i,
  second_plan_features: r,
  second_plan_button: c,
  isActive: s
}) => /* @__PURE__ */ e("div", { className: "col-lg-3 col-md-6 py-3 mb-4", children: /* @__PURE__ */ l("div", { className: `${t.pricingItem} ${s ? t.active : ""}`, children: [
  /* @__PURE__ */ l("div", { children: [
    /* @__PURE__ */ l("div", { className: t.itemHeader, children: [
      /* @__PURE__ */ e(n, { tag: "h6", value: a }),
      /* @__PURE__ */ e(n, { tag: "h3", value: i })
    ] }),
    /* @__PURE__ */ e("div", { className: t.itemText, children: /* @__PURE__ */ e(n, { tag: "p", value: r }) })
  ] }),
  /* @__PURE__ */ e("div", { className: t.itemFooter, children: /* @__PURE__ */ e(
    o,
    {
      value: c,
      className: `${t.btn} ${s ? t.activeBtn : ""}`
    }
  ) })
] }) }), L7 = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  plan_type_one: a,
  plan_type_two: i,
  plans: r
}) => {
  const [c, s] = z(!0), [_, m] = z(!1);
  return /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: t.sectionContainer, children: [
    /* @__PURE__ */ l("div", { className: t.paymentTab, children: [
      /* @__PURE__ */ e(
        "div",
        {
          className: `px-3 ${c && t.activeTab}`,
          onClick: () => {
            s(!0), m(!1);
          },
          children: /* @__PURE__ */ e(o, { tag: "h3", value: a })
        }
      ),
      /* @__PURE__ */ e(
        "div",
        {
          className: `px-3 ${!c && t.activeTab}`,
          onClick: () => {
            s(!1), m(!0);
          },
          children: /* @__PURE__ */ e(o, { tag: "h3", value: i })
        }
      )
    ] }),
    /* @__PURE__ */ l("div", { className: "row", children: [
      c && /* @__PURE__ */ e(
        n,
        {
          classes: t,
          Component: E7,
          value: r
        }
      ),
      _ && /* @__PURE__ */ e(
        n,
        {
          classes: t,
          Component: T7,
          value: r
        }
      )
    ] })
  ] }) });
}, O7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: L7,
  meta: q,
  styles: W7
}, Symbol.toStringTag, { value: "Module" })), z7 = "_buttonsWrapper_1v7xn_132", P7 = "_body_1v7xn_165", B7 = "_container_1v7xn_171", q7 = "_text_container_1v7xn_186", H7 = "_sectionContainer_1v7xn_203", V7 = "_paymentTab_1v7xn_206", F7 = "_activeTab_1v7xn_230", D7 = "_pricingItem_1v7xn_242", X7 = "_itemHeader_1v7xn_252", R7 = "_button_row_1v7xn_267", G7 = "_margin_top_1v7xn_282", U7 = "_is_button_row_center_1v7xn_287", J7 = "_margin_medium_1v7xn_293", Q7 = "_itemText_1v7xn_299", K7 = "_btn_1v7xn_308", Z7 = "_heading_medium_span_1v7xn_321", Y7 = "_divider_1v7xn_327", ej = "_pricing25_divider_1v7xn_335", tj = {
  buttonsWrapper: z7,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1v7xn_138",
  "spaceAfter--small": "_spaceAfter--small_1v7xn_141",
  "spaceAfter--medium": "_spaceAfter--medium_1v7xn_144",
  body: P7,
  container: B7,
  text_container: q7,
  sectionContainer: H7,
  paymentTab: V7,
  activeTab: F7,
  pricingItem: D7,
  itemHeader: X7,
  button_row: R7,
  margin_top: G7,
  is_button_row_center: U7,
  margin_medium: J7,
  itemText: Q7,
  btn: K7,
  heading_medium_span: Z7,
  divider: Y7,
  pricing25_divider: ej
}, aj = ({
  Elements: { Text: n, Button: o },
  classes: t,
  first_plan_name: a,
  first_plan_short_description: i,
  first_plan_price: r,
  first_plan_features: c,
  first_plan_button: s
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 col-12 py-3 mb-4", children: /* @__PURE__ */ l("div", { className: `${t.pricingItem}`, children: [
  /* @__PURE__ */ l("div", { className: t.itemHeader, children: [
    /* @__PURE__ */ l("div", { children: [
      /* @__PURE__ */ e(n, { tag: "h6", value: a }),
      /* @__PURE__ */ e(n, { tag: "p", value: i })
    ] }),
    /* @__PURE__ */ e("div", { className: t.pricing25_divider })
  ] }),
  /* @__PURE__ */ l("div", { className: t.itemText, children: [
    /* @__PURE__ */ e(n, { tag: "h3", value: r }),
    /* @__PURE__ */ e(
      "div",
      {
        className: `${t.button_row} ${t.margin_top} ${t.is_button_row_center} ${t.margin_medium}}`,
        children: /* @__PURE__ */ e(o, { type: "Primary", value: s })
      }
    )
  ] }),
  /* @__PURE__ */ e("hr", { className: t.divider }),
  /* @__PURE__ */ e("div", { className: t.itemFooter, children: /* @__PURE__ */ e(n, { tag: "p", value: c }) })
] }) }), nj = ({
  Elements: { Text: n, Button: o },
  classes: t,
  second_plan_name: a,
  second_plan_short_description: i,
  second_plan_price: r,
  second_plan_features: c,
  second_plan_button: s
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 col-12 py-3 mb-4", children: /* @__PURE__ */ l("div", { className: `${t.pricingItem}`, children: [
  /* @__PURE__ */ l("div", { children: [
    /* @__PURE__ */ l("div", { className: t.itemHeader, children: [
      /* @__PURE__ */ l("div", { children: [
        /* @__PURE__ */ e(n, { tag: "h6", value: a }),
        /* @__PURE__ */ e(n, { tag: "p", value: i })
      ] }),
      /* @__PURE__ */ e("div", { className: t.pricing25_divider })
    ] }),
    /* @__PURE__ */ l("div", { className: t.itemText, children: [
      /* @__PURE__ */ e(n, { tag: "h3", value: r }),
      /* @__PURE__ */ e(
        "div",
        {
          className: `${t.button_row} ${t.margin_top} ${t.is_button_row_center} ${t.margin_medium}}`,
          children: /* @__PURE__ */ e(o, { type: "Primary", value: s })
        }
      )
    ] })
  ] }),
  /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e("hr", { className: t.divider }) }),
  /* @__PURE__ */ e("div", { className: t.itemFooter, children: /* @__PURE__ */ e(n, { tag: "p", value: c }) })
] }) }), oj = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  plan_type_one: a,
  plan_type_two: i,
  section_title: r,
  section_short_description: c,
  plans: s
}) => {
  const [_, m] = z(!0), [p, u] = z(!1);
  return /* @__PURE__ */ e("div", { className: `${t.body} ${t.container} container`, children: /* @__PURE__ */ l("div", { className: t.sectionContainer, children: [
    /* @__PURE__ */ l("div", { className: t.text_container, children: [
      /* @__PURE__ */ e(o, { tag: "h2", value: r }),
      /* @__PURE__ */ e(o, { tag: "p", value: c })
    ] }),
    /* @__PURE__ */ l("div", { className: t.paymentTab, children: [
      /* @__PURE__ */ e(
        "div",
        {
          className: `${_ && t.activeTab}`,
          onClick: () => {
            m(!0), u(!1);
          },
          children: /* @__PURE__ */ e(o, { tag: "h3", value: a })
        }
      ),
      /* @__PURE__ */ e(
        "div",
        {
          className: ` ${!_ && t.activeTab}`,
          onClick: () => {
            m(!1), u(!0);
          },
          children: /* @__PURE__ */ e(o, { tag: "h3", value: i })
        }
      )
    ] }),
    /* @__PURE__ */ l("div", { className: "row", children: [
      _ && /* @__PURE__ */ e(
        n,
        {
          classes: t,
          Component: aj,
          value: s
        }
      ),
      p && /* @__PURE__ */ e(
        n,
        {
          classes: t,
          Component: nj,
          value: s
        }
      )
    ] })
  ] }) });
}, ij = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: oj,
  meta: q,
  styles: tj
}, Symbol.toStringTag, { value: "Module" })), ke = /* @__PURE__ */ Object.assign({ "./0001/index.jsx": x9, "./0002/index.jsx": O9, "./0003/index.jsx": U9, "./0004/index.jsx": l7, "./0005/index.jsx": $7, "./0006/index.jsx": O7, "./0007/index.jsx": ij }), lj = Object.keys(ke).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: ke[o] }),
  {}
), rj = "_buttonsWrapper_fd1m7_132", cj = "_servicesContainer_fd1m7_165", sj = "_imageContainer_fd1m7_169", dj = "_item_fd1m7_173", _j = "_itemImage_fd1m7_177", mj = "_imageWrapper_fd1m7_177", uj = "_itemInfo_fd1m7_187", pj = "_servicesTitle_fd1m7_200", vj = {
  buttonsWrapper: rj,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_fd1m7_138",
  "spaceAfter--small": "_spaceAfter--small_fd1m7_141",
  "spaceAfter--medium": "_spaceAfter--medium_fd1m7_144",
  servicesContainer: cj,
  imageContainer: sj,
  item: dj,
  itemImage: _j,
  imageWrapper: mj,
  itemInfo: uj,
  servicesTitle: pj
}, ne = {
  destination: "external",
  // 'internal'
  target: "current",
  // 'new'
  text: "READ MORE",
  pageId: "",
  href: "#"
}, oe = {
  destination: "external",
  target: "current",
  text: "المزيد",
  pageId: "",
  href: "#"
}, x = {
  section_title: {
    type: d.TEXT,
    fieldId: 8,
    defaultValue: {
      default: "Our Services",
      ar: "خدماتُنا"
    }
  },
  section_short_description: {
    type: d.TEXT,
    fieldId: 9,
    defaultValue: {
      default: "We offer top-notch services based on countless years of experience.",
      ar: "نمتلك خبرة طويلة في مجالنا، ولذلك نستطيع تقديم خدمات متميّزة لك."
    }
  },
  section_image: {
    type: d.IMAGE,
    fieldId: 97,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1537646692914-61d73c4d6bad?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=b6e4b4359e874b7537c33c6ec1fe1a4d&auto=format&fit=crop&w=1500&q=80"
    }
  },
  services: {
    type: d.GROUP,
    values: {
      service_icon: { type: d.ICON, fieldId: 45 },
      service_image: { type: d.IMAGE, fieldId: 20 },
      service_title: { type: d.TEXT, fieldId: 10 },
      service_short_description: {
        type: d.TEXT,
        fieldId: 11
      },
      service_details_link: {
        type: d.LINK,
        fieldId: 28
      }
    },
    defaultValue: [
      {
        service_title: {
          default: "SEM Marketing",
          ar: "التسويق عبر محركات البحث"
        },
        service_image: {
          default: "https://images.unsplash.com/photo-1516728043722-b394cb2f689e?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=c82882f6f384a30402cc75029d9e7b11&auto=format&fit=crop&w=550&q=80"
        },
        service_icon: {
          default: "rocket"
        },
        service_short_description: {
          default: "We develop comprehensive PPC and SEO strategies. We’ll provide your AdWords account with continuous PPC support that is monitored to adapt to the evolving industry."
        },
        service_details_link: {
          default: ne,
          ar: oe
        }
      },
      {
        service_title: {
          default: "Content Marketing",
          ar: "تسويق المحتوى"
        },
        service_icon: {
          default: "glass"
        },
        service_image: {
          default: "https://images.unsplash.com/photo-1496902526517-c0f2cb8fdb6a?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=8a8623f526569e949b73c4c7360d4532&auto=format&fit=crop&w=550&q=80"
        },
        service_short_description: {
          default: "Our writers are wordsmiths trained in creating quality content for all aspects of your brand. We’ll take care of your website copy, SEO articles, blog posts, whitepapers and more.",
          ar: ""
        },
        service_details_link: {
          default: ne,
          ar: oe
        }
      },
      {
        service_title: {
          default: "Social Media Marketing",
          ar: "التسويق عبر وسائل التواصل الاجتماعي"
        },
        service_image: {
          default: "https://images.unsplash.com/photo-1519120126473-8be7aedcd6c6?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=a55332dfc236b13f118ef77a36b4052f&auto=format&fit=crop&w=550&q=80"
        },
        service_icon: {
          default: "tv"
        },
        service_short_description: {
          default: "Our team works to expand your social media presence by creating compelling content designed for you. boost your social media audience and develop a strong community around your brand."
        },
        service_details_link: {
          default: ne,
          ar: oe
        }
      }
    ]
  }
}, fj = ({
  Elements: { Text: n, Image: o, Button: t },
  classes: a,
  service_image: i,
  service_title: r,
  service_short_description: c,
  service_details_link: s
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 col-md-6", children: /* @__PURE__ */ l("div", { className: a.item, children: [
  /* @__PURE__ */ e("div", { className: a.imageContainer, children: /* @__PURE__ */ e("div", { className: a.itemImage, children: /* @__PURE__ */ e(o, { className: a.imageWrapper, value: i, small: !0 }) }) }),
  /* @__PURE__ */ l("div", { className: a.itemInfo, children: [
    /* @__PURE__ */ e(n, { className: a.headertext, tag: "h4", value: r }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(
      n,
      {
        className: a.itemdesc,
        tag: "p",
        value: c
      }
    ),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
    /* @__PURE__ */ e(t, { type: "Link", value: s })
  ] })
] }) }), gj = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_short_description: i,
  services: r
}) => /* @__PURE__ */ e("div", { className: t.servicesContainer, children: /* @__PURE__ */ e("div", { className: t.body, children: /* @__PURE__ */ l("div", { className: `${t.container} container text-center `, children: [
  /* @__PURE__ */ l("div", { className: t.servicesTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: t.services, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: fj,
      value: r
    }
  ) }) })
] }) }) }), hj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gj,
  meta: x,
  styles: vj
}, Symbol.toStringTag, { value: "Module" })), bj = "_buttonsWrapper_bznzu_132", yj = "_body_bznzu_165", $j = "_itemCol_bznzu_169", Nj = "_item_bznzu_169", Cj = "_itemImage_bznzu_182", xj = "_itemInfo_bznzu_205", Ij = "_servicesTitle_bznzu_220", Aj = {
  buttonsWrapper: bj,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_bznzu_138",
  "spaceAfter--small": "_spaceAfter--small_bznzu_141",
  "spaceAfter--medium": "_spaceAfter--medium_bznzu_144",
  body: yj,
  itemCol: $j,
  item: Nj,
  itemImage: Cj,
  itemInfo: xj,
  servicesTitle: Ij
}, Sj = ({
  Elements: { Text: n, Image: o, Button: t },
  classes: a,
  service_image: i,
  service_title: r,
  service_short_description: c,
  service_details_link: s
}) => /* @__PURE__ */ e("div", { className: `col-lg-4 col-md-6 ${a.itemCol}`, children: /* @__PURE__ */ l("div", { className: a.item, children: [
  /* @__PURE__ */ e("div", { className: a.itemImage, children: /* @__PURE__ */ e(o, { value: i }) }),
  /* @__PURE__ */ l("div", { className: a.itemInfo, children: [
    /* @__PURE__ */ e(n, { tag: "h4", value: r }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(
      n,
      {
        className: a.itemdesc,
        tag: "p",
        value: c
      }
    ),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
    /* @__PURE__ */ e(t, { type: "Secondary", value: s })
  ] })
] }) }), kj = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_short_description: i,
  services: r
}) => /* @__PURE__ */ e("div", { className: t.body, children: /* @__PURE__ */ l("div", { className: `${t.container} container `, children: [
  /* @__PURE__ */ l("div", { className: t.servicesTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(o, { tag: "p", value: i }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--medium"] })
  ] }),
  /* @__PURE__ */ e("div", { className: t.services, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: Sj,
      value: r
    }
  ) }) })
] }) }), jj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kj,
  meta: x,
  styles: Aj
}, Symbol.toStringTag, { value: "Module" })), wj = "_buttonsWrapper_1gzxp_132", Mj = "_servicesContainer_1gzxp_165", Wj = "_styleitem_1gzxp_169", Ej = "_item_1gzxp_179", Tj = "_itemImage_1gzxp_183", Lj = "_itemInfo_1gzxp_197", Oj = "_service_1gzxp_165", zj = {
  buttonsWrapper: wj,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1gzxp_138",
  "spaceAfter--small": "_spaceAfter--small_1gzxp_141",
  "spaceAfter--medium": "_spaceAfter--medium_1gzxp_144",
  servicesContainer: Mj,
  styleitem: Wj,
  item: Ej,
  itemImage: Tj,
  itemInfo: Lj,
  service: Oj
}, Pj = ({
  Elements: { Text: n, Icon: o, Button: t },
  classes: a,
  service_icon: i,
  service_title: r,
  service_short_description: c,
  service_details_link: s
}) => /* @__PURE__ */ e("div", { className: a.item, children: /* @__PURE__ */ l("div", { className: `${a.styleitem} row`, children: [
  /* @__PURE__ */ e("div", { className: "col-lg-2 col-sm-12", children: /* @__PURE__ */ e("div", { className: a.itemImage, children: /* @__PURE__ */ e(o, { value: i, alt: "" }) }) }),
  /* @__PURE__ */ e("div", { className: "col-lg-10 col-sm-12", children: /* @__PURE__ */ l("div", { className: a.itemInfo, children: [
    /* @__PURE__ */ e(n, { className: a.headertext, tag: "h4", value: r }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(
      n,
      {
        className: a.itemdesc,
        tag: "p",
        value: c
      }
    ),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
    /* @__PURE__ */ e(t, { type: "Link", value: s })
  ] }) })
] }) }), Bj = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_short_description: i,
  services: r
}) => /* @__PURE__ */ e("div", { className: t.servicesContainer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-lg-6", children: /* @__PURE__ */ l("div", { className: t.service, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(o, { tag: "p", value: i }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--medium"] })
  ] }) }),
  /* @__PURE__ */ e("div", { className: "col-lg-6", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: Pj,
      value: r
    }
  ) })
] }) }) }), qj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Bj,
  meta: x,
  styles: zj
}, Symbol.toStringTag, { value: "Module" })), Hj = "_buttonsWrapper_1fswf_132", Vj = "_body_1fswf_165", Fj = "_servicesTitle_1fswf_169", Dj = "_styleColumn_1fswf_193", Xj = "_item_1fswf_199", Rj = "_itemImage_1fswf_205", Gj = "_itemInfo_1fswf_223", Uj = "_btnread_1fswf_246", Jj = {
  buttonsWrapper: Hj,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1fswf_138",
  "spaceAfter--small": "_spaceAfter--small_1fswf_141",
  "spaceAfter--medium": "_spaceAfter--medium_1fswf_144",
  body: Vj,
  servicesTitle: Fj,
  styleColumn: Dj,
  item: Xj,
  itemImage: Rj,
  itemInfo: Gj,
  btnread: Uj
}, Qj = ({
  Elements: { Text: n, Image: o, Button: t },
  classes: a,
  service_image: i,
  service_title: r,
  service_short_description: c,
  service_details_link: s
}) => /* @__PURE__ */ e("div", { className: `${a.styleColumn} col-lg-4 col-md-6`, children: /* @__PURE__ */ l("div", { className: a.item, children: [
  /* @__PURE__ */ e("div", { className: a.itemImage, children: /* @__PURE__ */ e(o, { value: i, alt: "" }) }),
  /* @__PURE__ */ l("div", { className: a.itemInfo, children: [
    /* @__PURE__ */ e(n, { className: a.headerText, tag: "h4", value: r }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(
      n,
      {
        className: a.itemdesc,
        tag: "p",
        value: c
      }
    ),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
    /* @__PURE__ */ e(t, { type: "Link", value: s })
  ] })
] }) }), Kj = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_short_description: i,
  services: r
}) => /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e("div", { className: t.body, children: /* @__PURE__ */ l("div", { className: `${t.container} container `, children: [
  /* @__PURE__ */ l("div", { className: t.servicesTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: t.services, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: Qj,
      value: r
    }
  ) }) })
] }) }) }), Zj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Kj,
  meta: x,
  styles: Jj
}, Symbol.toStringTag, { value: "Module" })), Yj = "_buttonsWrapper_1ix44_132", ew = "_body_1ix44_165", tw = "_item_1ix44_169", aw = "_itemInfoCol_1ix44_178", nw = "_itemImageCol_1ix44_205", ow = "_image_1ix44_225", iw = "_itemInfo_1ix44_178", lw = "_itemImage_1ix44_205", rw = "_servicesTitle_1ix44_265", cw = {
  buttonsWrapper: Yj,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1ix44_138",
  "spaceAfter--small": "_spaceAfter--small_1ix44_141",
  "spaceAfter--medium": "_spaceAfter--medium_1ix44_144",
  body: ew,
  item: tw,
  itemInfoCol: aw,
  itemImageCol: nw,
  image: ow,
  itemInfo: iw,
  itemImage: lw,
  servicesTitle: rw
}, sw = ({
  Elements: { Text: n, Image: o, Button: t },
  classes: a,
  service_image: i,
  service_title: r,
  service_short_description: c,
  service_details_link: s
}) => /* @__PURE__ */ e("div", { className: a.item, children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: `${a.itemImageCol} col-lg-5 col-md-6`, children: /* @__PURE__ */ e(o, { className: a.image, value: i }) }),
  /* @__PURE__ */ e("div", { className: `${a.itemInfoCol} col-lg-7 col-md-7`, children: /* @__PURE__ */ l("div", { className: a.itemInfo, children: [
    /* @__PURE__ */ e(n, { tag: "h4", value: r }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { tag: "p", value: c }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
    /* @__PURE__ */ e(t, { type: "Secondary", value: s })
  ] }) })
] }) }), dw = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_short_description: i,
  services: r
}) => /* @__PURE__ */ l("div", { className: `${t.body} container`, children: [
  /* @__PURE__ */ l("div", { className: t.servicesTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: `${t.services} container`, children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: sw,
      value: r
    }
  ) })
] }), _w = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dw,
  meta: x,
  styles: cw
}, Symbol.toStringTag, { value: "Module" })), mw = "_buttonsWrapper_1leu6_132", uw = "_servicesContainer_1leu6_165", pw = "_body_1leu6_172", vw = "_servicesTitle_1leu6_176", fw = "_item_1leu6_192", gw = "_fadeIn_1leu6_1", hw = "_overlay_1leu6_204", bw = "_itemInfo_1leu6_220", yw = "_fadein_1leu6_1", $w = "_button_1leu6_132", Nw = {
  buttonsWrapper: mw,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1leu6_138",
  "spaceAfter--small": "_spaceAfter--small_1leu6_141",
  "spaceAfter--medium": "_spaceAfter--medium_1leu6_144",
  servicesContainer: uw,
  body: pw,
  servicesTitle: vw,
  item: fw,
  fadeIn: gw,
  overlay: hw,
  itemInfo: bw,
  fadein: yw,
  button: $w
}, Cw = ({
  Elements: { Image: n, Text: o, Button: t },
  classes: a,
  service_image: i,
  service_short_description: r,
  service_title: c,
  service_details_link: s
}) => {
  const [_, m] = z(!1);
  return /* @__PURE__ */ e("div", { className: "col-md-6 col-lg-4", children: /* @__PURE__ */ e(
    "div",
    {
      className: a.item,
      onMouseEnter: () => {
        m(!0);
      },
      onMouseLeave: () => {
        m(!1);
      },
      children: /* @__PURE__ */ l("div", { className: a.itemImage, children: [
        /* @__PURE__ */ e(n, { value: i, selected: _ }),
        /* @__PURE__ */ l("div", { className: a.itemInfo, children: [
          /* @__PURE__ */ e(o, { tag: "h4", value: c }),
          /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
          /* @__PURE__ */ e(o, { tag: "p", value: r }),
          /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
          /* @__PURE__ */ e(
            t,
            {
              type: "Link",
              value: s,
              className: a.button
            }
          )
        ] })
      ] })
    }
  ) });
}, xw = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_short_description: i,
  services: r
}) => /* @__PURE__ */ l("div", { className: t.servicesContainer, children: [
  /* @__PURE__ */ e("div", { className: t.overlay }),
  /* @__PURE__ */ e("div", { className: t.body, children: /* @__PURE__ */ l("div", { className: `${t.container} container `, children: [
    /* @__PURE__ */ l("div", { className: t.servicesTitle, children: [
      /* @__PURE__ */ e(o, { tag: "h2", value: a }),
      /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
      /* @__PURE__ */ e(o, { tag: "p", value: i })
    ] }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--medium"] }),
    /* @__PURE__ */ e("div", { className: t.services, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
      n,
      {
        classes: t,
        Component: Cw,
        value: r
      }
    ) }) })
  ] }) })
] }), Iw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xw,
  meta: x,
  styles: Nw
}, Symbol.toStringTag, { value: "Module" })), Aw = "_buttonsWrapper_dfr23_132", Sw = "_section_dfr23_165", kw = "_intro_dfr23_169", jw = "_servicesContainer_dfr23_180", ww = "_itemContainer_dfr23_187", Mw = "_itemTitle_dfr23_199", Ww = "_item_dfr23_187", Ew = "_serviceIcon_dfr23_207", Tw = "_itemInfo_dfr23_226", Lw = {
  buttonsWrapper: Aw,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_dfr23_138",
  "spaceAfter--small": "_spaceAfter--small_dfr23_141",
  "spaceAfter--medium": "_spaceAfter--medium_dfr23_144",
  section: Sw,
  intro: kw,
  servicesContainer: jw,
  itemContainer: ww,
  itemTitle: Mw,
  item: Ww,
  serviceIcon: Ew,
  itemInfo: Tw
}, Ow = ({
  Elements: { Text: n, Icon: o },
  classes: t,
  service_icon: a,
  service_title: i,
  service_short_description: r
}) => /* @__PURE__ */ e("div", { className: t.itemContainer, children: /* @__PURE__ */ l("div", { className: t.item, children: [
  /* @__PURE__ */ e(o, { className: t.serviceIcon, value: a, alt: "" }),
  /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
  /* @__PURE__ */ l("div", { className: t.itemInfo, children: [
    /* @__PURE__ */ e(n, { className: t.itemTitle, tag: "h4", value: i }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { tag: "p", value: r })
  ] })
] }) }), zw = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_short_description: i,
  services: r
}) => /* @__PURE__ */ e("div", { className: t.section, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-md-12", children: /* @__PURE__ */ l("div", { className: t.intro, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }) }),
  /* @__PURE__ */ e("div", { className: t["spaceAfter--medium"] }),
  /* @__PURE__ */ e("div", { className: t.servicesContainer, children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: Ow,
      value: r
    }
  ) })
] }) }) }), Pw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zw,
  meta: x,
  styles: Lw
}, Symbol.toStringTag, { value: "Module" })), Bw = "_buttonsWrapper_fel7w_132", qw = "_section_fel7w_165", Hw = "_intro_fel7w_169", Vw = "_servicesContainer_fel7w_181", Fw = "_itemContainer_fel7w_188", Dw = "_item_fel7w_188", Xw = "_curve_fel7w_206", Rw = "_infoContainer_fel7w_212", Gw = "_itemInfo_fel7w_216", Uw = "_btnLink_fel7w_230", Jw = "_itemTitle_fel7w_245", Qw = "_serviceIcon_fel7w_249", Kw = {
  buttonsWrapper: Bw,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_fel7w_138",
  "spaceAfter--small": "_spaceAfter--small_fel7w_141",
  "spaceAfter--medium": "_spaceAfter--medium_fel7w_144",
  section: qw,
  intro: Hw,
  servicesContainer: Vw,
  itemContainer: Fw,
  item: Dw,
  curve: Xw,
  infoContainer: Rw,
  itemInfo: Gw,
  btnLink: Uw,
  itemTitle: Jw,
  serviceIcon: Qw
}, Zw = ({
  Elements: { Button: n, Image: o, Text: t },
  classes: a,
  service_image: i,
  service_title: r,
  service_short_description: c,
  service_details_link: s
}) => /* @__PURE__ */ e("div", { className: a.itemContainer, children: /* @__PURE__ */ l("div", { className: a.item, children: [
  /* @__PURE__ */ e(o, { value: i }),
  /* @__PURE__ */ l("div", { className: a.infoContainer, children: [
    /* @__PURE__ */ e("svg", { className: a.curve, viewBox: "0 0 392 56", children: /* @__PURE__ */ e("g", { transform: "translate(0, -216)", fill: "#FFFFFF", children: /* @__PURE__ */ e("path", { d: "M-20,241.204301 C84.6836742,207.598566 172.236174,207.598566 242.657498,241.204301 C293.076652,265.264808 342.857486,265.264808 392,241.204301 L392,272 L-20,272 L-20,241.204301 Z" }) }) }),
    /* @__PURE__ */ l("div", { className: a.itemInfo, children: [
      /* @__PURE__ */ e(t, { className: a.itemTitle, tag: "h4", value: r }),
      /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
      /* @__PURE__ */ e(t, { tag: "p", value: c }),
      /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
      /* @__PURE__ */ e(n, { type: "Link", value: s })
    ] })
  ] })
] }) }), Yw = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_short_description: i,
  services: r
}) => /* @__PURE__ */ e("div", { className: t.section, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ l("div", { className: "col-md-12", children: [
    /* @__PURE__ */ l("div", { className: t.intro, children: [
      /* @__PURE__ */ e(o, { tag: "h2", value: a }),
      /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
      /* @__PURE__ */ e(o, { tag: "p", value: i })
    ] }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--medium"] })
  ] }),
  /* @__PURE__ */ e("div", { className: t.servicesContainer, children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: Zw,
      value: r
    }
  ) })
] }) }) }), eM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Yw,
  meta: x,
  styles: Kw
}, Symbol.toStringTag, { value: "Module" })), tM = "_buttonsWrapper_we9wg_132", aM = "_servicesContainer_we9wg_166", nM = "_itemImage_we9wg_171", oM = "_itemInfo_we9wg_183", iM = "_styleitem_we9wg_190", lM = "_service_we9wg_166", rM = "_btnread_we9wg_221", cM = {
  buttonsWrapper: tM,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_we9wg_138",
  "spaceAfter--small": "_spaceAfter--small_we9wg_141",
  "spaceAfter--medium": "_spaceAfter--medium_we9wg_144",
  servicesContainer: aM,
  itemImage: nM,
  itemInfo: oM,
  styleitem: iM,
  service: lM,
  btnread: rM
}, sM = ({
  Elements: { Text: n, Icon: o, Button: t },
  classes: a,
  service_icon: i,
  service_title: r,
  service_short_description: c,
  service_details_link: s
}) => /* @__PURE__ */ e("div", { className: a.item, children: /* @__PURE__ */ l("div", { className: `${a.styleitem} row`, children: [
  /* @__PURE__ */ e("div", { className: "col-md-2 col-xs-6 col-sm-6", children: /* @__PURE__ */ e("div", { className: a.itemImage, children: /* @__PURE__ */ e(o, { value: i }) }) }),
  /* @__PURE__ */ e("div", { className: "col-md-10 col-xs-6 col-sm-6", children: /* @__PURE__ */ l("div", { className: a.itemInfo, children: [
    /* @__PURE__ */ e(n, { className: a.headertext, tag: "h4", value: r }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(
      n,
      {
        className: a.itemdesc,
        tag: "p",
        value: c
      }
    ),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
    /* @__PURE__ */ e(t, { type: "Link", value: s })
  ] }) })
] }) }), dM = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_short_description: i,
  services: r
}) => /* @__PURE__ */ e("div", { className: t.servicesContainer, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ l("div", { className: "col-md-6", children: [
    /* @__PURE__ */ l("div", { className: t.service, children: [
      /* @__PURE__ */ e(o, { tag: "h2", value: a }),
      /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
      /* @__PURE__ */ e(o, { tag: "p", value: i })
    ] }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--medium"] })
  ] }),
  /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: sM,
      value: r
    }
  ) })
] }) }) }), _M = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dM,
  meta: x,
  styles: cM
}, Symbol.toStringTag, { value: "Module" })), mM = "_buttonsWrapper_1xqqe_132", uM = "_section_1xqqe_165", pM = "_intro_1xqqe_170", vM = "_servicesContainer_1xqqe_193", fM = "_itemContainer_1xqqe_200", gM = "_item_1xqqe_200", hM = "_itemInfo_1xqqe_227", bM = "_numbStyle_1xqqe_230", yM = "_itemTitle_1xqqe_236", $M = "_seprator_1xqqe_240", NM = "_itemDesc_1xqqe_248", CM = {
  buttonsWrapper: mM,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1xqqe_138",
  "spaceAfter--small": "_spaceAfter--small_1xqqe_141",
  "spaceAfter--medium": "_spaceAfter--medium_1xqqe_144",
  section: uM,
  intro: pM,
  servicesContainer: vM,
  itemContainer: fM,
  item: gM,
  itemInfo: hM,
  numbStyle: bM,
  itemTitle: yM,
  seprator: $M,
  itemDesc: NM
}, xM = (n) => (n < 10 ? "0" : "") + n, IM = ({
  Elements: { Text: n },
  number: o,
  classes: t,
  service_title: a,
  service_short_description: i
}) => /* @__PURE__ */ e("div", { className: t.itemContainer, children: /* @__PURE__ */ e("div", { className: t.item, children: /* @__PURE__ */ l("div", { className: t.itemInfo, children: [
  /* @__PURE__ */ e("p", { className: t.numbStyle, children: xM(o) }),
  /* @__PURE__ */ e(n, { className: t.itemTitle, tag: "h4", value: a }),
  /* @__PURE__ */ e("div", { className: t.seprator }),
  /* @__PURE__ */ e(
    n,
    {
      tag: "p",
      className: t.itemDesc,
      value: i
    }
  )
] }) }) }), AM = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_short_description: i,
  services: r
}) => /* @__PURE__ */ e("div", { className: t.section, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-md-12", children: /* @__PURE__ */ l("div", { className: t.intro, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }) }),
  /* @__PURE__ */ e("div", { className: t.servicesContainer, children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: IM,
      value: r
    }
  ) })
] }) }) }), SM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: AM,
  meta: x,
  styles: CM
}, Symbol.toStringTag, { value: "Module" })), kM = "_buttonsWrapper_hf70b_132", jM = "_outerContainer_hf70b_165", wM = "_splitBackground_hf70b_170", MM = "_imgWrapper_hf70b_183", WM = "_background_hf70b_199", EM = "_rowStyle_hf70b_208", TM = "_content_hf70b_212", LM = "_serviceTitle_hf70b_216", OM = "_serviceDesc_hf70b_219", zM = "_item_hf70b_222", PM = {
  buttonsWrapper: kM,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_hf70b_138",
  "spaceAfter--small": "_spaceAfter--small_hf70b_141",
  "spaceAfter--medium": "_spaceAfter--medium_hf70b_144",
  outerContainer: jM,
  splitBackground: wM,
  imgWrapper: MM,
  background: WM,
  rowStyle: EM,
  content: TM,
  serviceTitle: LM,
  serviceDesc: OM,
  item: zM
}, BM = ({
  Elements: { Text: n, Icon: o, Button: t },
  classes: a,
  service_title: i,
  service_short_description: r,
  service_icon: c,
  service_details_link: s
}) => /* @__PURE__ */ e("div", { className: "col-lg-6 col-md-12 col-xs-12 col-sm-12", children: /* @__PURE__ */ e("div", { className: a.item, children: /* @__PURE__ */ l("div", { className: a.itemInfo, children: [
  /* @__PURE__ */ e(o, { value: c, className: a.iconStyle }),
  /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
  /* @__PURE__ */ e(n, { className: a.itemTitle, tag: "h4", value: i }),
  /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
  /* @__PURE__ */ e(
    n,
    {
      tag: "p",
      className: a.itemDesc,
      value: r
    }
  ),
  /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
  /* @__PURE__ */ e(t, { type: "Link", value: s })
] }) }) }), qM = ({
  Elements: { RepeatedItems: n, Text: o, Image: t },
  classes: a,
  section_title: i,
  section_short_description: r,
  section_image: c,
  services: s
}) => /* @__PURE__ */ l("div", { className: a.outerContainer, children: [
  /* @__PURE__ */ e("div", { className: a.splitBackground, children: /* @__PURE__ */ e("div", { className: a.background, children: /* @__PURE__ */ e(t, { value: c, className: a.imgWrapper }) }) }),
  /* @__PURE__ */ e("div", { className: `${a.container} container`, children: /* @__PURE__ */ e("div", { className: `${a.rowStyle} row`, children: /* @__PURE__ */ l("div", { className: `${a.content} col-md-7`, children: [
    /* @__PURE__ */ e(
      o,
      {
        className: a.serviceTitle,
        tag: "h2",
        value: i
      }
    ),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(
      o,
      {
        className: a.serviceDesc,
        tag: "p",
        value: r
      }
    ),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--medium"] }),
    /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
      n,
      {
        classes: a,
        Component: BM,
        value: s
      }
    ) })
  ] }) }) })
] }), HM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qM,
  meta: x,
  styles: PM
}, Symbol.toStringTag, { value: "Module" })), VM = "_containerImage_18423_1", FM = "_overlay_18423_5", DM = "_intro_18423_14", XM = "_itemContainer_18423_34", RM = "_itemTitle_18423_39", GM = "_item_18423_34", UM = "_serviceIcon_18423_49", JM = "_itemsRow_18423_55", QM = "_itemInfo_18423_59", KM = "_items_18423_55", ZM = {
  containerImage: VM,
  overlay: FM,
  intro: DM,
  itemContainer: XM,
  itemTitle: RM,
  item: GM,
  serviceIcon: UM,
  itemsRow: JM,
  itemInfo: QM,
  items: KM
}, YM = ({
  Elements: { Text: n, Icon: o },
  classes: t,
  service_icon: a,
  service_title: i,
  service_short_description: r
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 col-md-6 col-sm-6 col-xs-12", children: /* @__PURE__ */ e("div", { className: t.itemContainer, children: /* @__PURE__ */ l("div", { className: t.item, children: [
  /* @__PURE__ */ e(o, { className: t.serviceIcon, value: a, alt: "" }),
  /* @__PURE__ */ l("div", { className: t.itemInfo, children: [
    /* @__PURE__ */ e(n, { className: t.itemTitle, tag: "h4", value: i }),
    /* @__PURE__ */ e(n, { tag: "p", value: r })
  ] })
] }) }) }), eW = ({
  Elements: { RepeatedItems: n, Text: o, BackgroundContainer: t },
  classes: a,
  section_title: i,
  section_short_description: r,
  services: c,
  section_image: s
}) => /* @__PURE__ */ l("section", { children: [
  /* @__PURE__ */ l(
    t,
    {
      value: s,
      className: a.containerImage,
      children: [
        /* @__PURE__ */ e("div", { className: a.overlay }),
        /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: a.intro, children: [
          /* @__PURE__ */ e(o, { tag: "h2", value: i }),
          /* @__PURE__ */ e(o, { tag: "p", value: r })
        ] }) })
      ]
    }
  ),
  /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: a.items, children: /* @__PURE__ */ e("div", { className: `row ${a.itemsRow}`, children: /* @__PURE__ */ e(
    n,
    {
      classes: a,
      Component: YM,
      value: c
    }
  ) }) }) })
] }), tW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: eW,
  meta: x,
  styles: ZM
}, Symbol.toStringTag, { value: "Module" })), aW = "_buttonsWrapper_mm23z_132", nW = "_section_mm23z_165", oW = "_sectionContent_mm23z_169", iW = "_itemPreview_mm23z_179", lW = "_itemDetails_mm23z_190", rW = {
  buttonsWrapper: aW,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_mm23z_138",
  "spaceAfter--small": "_spaceAfter--small_mm23z_141",
  "spaceAfter--medium": "_spaceAfter--medium_mm23z_144",
  section: nW,
  sectionContent: oW,
  itemPreview: iW,
  itemDetails: lW
}, cW = ({
  Elements: { Button: n, Image: o, Text: t },
  classes: a,
  service_image: i,
  service_title: r,
  service_short_description: c,
  service_details_link: s
}) => /* @__PURE__ */ e("div", { className: "col-md-6 col-sm-6  col-xl-3", children: /* @__PURE__ */ l("div", { className: a.itemPreview, children: [
  /* @__PURE__ */ e(o, { value: i }),
  /* @__PURE__ */ l("div", { className: a.itemDetails, children: [
    /* @__PURE__ */ e(t, { tag: "h5", value: r }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(t, { tag: "p", value: c }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { type: "Link", value: s })
  ] })
] }) }), sW = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_short_description: i,
  services: r
}) => /* @__PURE__ */ e("div", { className: t.section, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-lg-6 col-md-12 col-sm-12", children: /* @__PURE__ */ l("div", { className: t.sectionContent, children: [
    " ",
    /* @__PURE__ */ e(
      o,
      {
        tag: "h2",
        value: a,
        className: t.headlineFont
      }
    ),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }) }),
  /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: cW,
      value: r
    }
  )
] }) }) }), dW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sW,
  meta: x,
  styles: rW
}, Symbol.toStringTag, { value: "Module" })), _W = "_buttonsWrapper_17wic_132", mW = "_section_17wic_165", uW = "_align_center_17wic_169", pW = "_expandedHeadlineContent_17wic_173", vW = "_expandedItem_17wic_181", fW = "_prevImg_17wic_188", gW = {
  buttonsWrapper: _W,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_17wic_138",
  "spaceAfter--small": "_spaceAfter--small_17wic_141",
  "spaceAfter--medium": "_spaceAfter--medium_17wic_144",
  section: mW,
  align_center: uW,
  expandedHeadlineContent: pW,
  expandedItem: vW,
  prevImg: fW
}, hW = ({
  Elements: { Button: n, Image: o, Text: t },
  classes: a,
  service_image: i,
  service_title: r,
  service_short_description: c,
  service_details_link: s
}) => /* @__PURE__ */ e("div", { className: "col-md-6 col-sm-6 col-lg-4", children: /* @__PURE__ */ l("div", { className: a.expandedItem, children: [
  /* @__PURE__ */ e(o, { value: i, className: a.prevImg }),
  /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
  /* @__PURE__ */ e(t, { tag: "h4", value: r }),
  /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
  /* @__PURE__ */ e(t, { tag: "p", value: c }),
  /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
  /* @__PURE__ */ e(n, { type: "Secondary", value: s })
] }) }), bW = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_short_description: i,
  services: r
}) => /* @__PURE__ */ e("div", { className: t.section, children: /* @__PURE__ */ l("div", { className: "container", children: [
  /* @__PURE__ */ l("div", { className: `${t.align_center} row`, children: [
    /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ l("div", { className: t.expandedHeadlineContent, children: [
      /* @__PURE__ */ e(
        o,
        {
          tag: "h2",
          value: a,
          className: t.headlineFont
        }
      ),
      /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
      /* @__PURE__ */ e(o, { tag: "p", value: i })
    ] }) }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--medium"] })
  ] }),
  /* @__PURE__ */ e("div", { className: t.itemsGridPreview, children: /* @__PURE__ */ e("div", { className: `${t.align_center} row`, children: /* @__PURE__ */ e("div", { className: "col-md-10", children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: hW,
      value: r
    }
  ) }) }) }) })
] }) }), yW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bW,
  meta: x,
  styles: gW
}, Symbol.toStringTag, { value: "Module" })), $W = "_buttonsWrapper_8uga3_132", NW = "_body_8uga3_165", CW = "_servicesTitle_8uga3_169", xW = "_item_8uga3_183", IW = "_overlay_8uga3_193", AW = "_itemInfo_8uga3_204", SW = "_wlayoutgrid_8uga3_231", kW = "_section_8uga3_243", jW = "_cont_8uga3_247", wW = "_servicesgrid_8uga3_253", MW = "_serviceBackground_8uga3_257", WW = "_serviceWrapper_8uga3_268", EW = "_serviceTitle_8uga3_284", TW = "_serviceDesc_8uga3_288", LW = "_itemPreview_8uga3_293", OW = {
  buttonsWrapper: $W,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_8uga3_138",
  "spaceAfter--small": "_spaceAfter--small_8uga3_141",
  "spaceAfter--medium": "_spaceAfter--medium_8uga3_144",
  body: NW,
  servicesTitle: CW,
  item: xW,
  overlay: IW,
  itemInfo: AW,
  wlayoutgrid: SW,
  section: kW,
  cont: jW,
  servicesgrid: wW,
  serviceBackground: MW,
  serviceWrapper: WW,
  serviceTitle: EW,
  serviceDesc: TW,
  itemPreview: LW
}, zW = ({
  Elements: { Text: n, Image: o },
  classes: t,
  service_image: a,
  service_short_description: i,
  service_title: r
}) => /* @__PURE__ */ e("div", { children: /* @__PURE__ */ l("div", { className: t.itemPreview, children: [
  /* @__PURE__ */ e(o, { value: a }),
  /* @__PURE__ */ l("div", { className: t.serviceWrapper, children: [
    /* @__PURE__ */ e(n, { tag: "h4", value: r, className: t.serviceTitle }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(
      n,
      {
        tag: "p",
        value: i,
        className: t.serviceDesc
      }
    )
  ] })
] }) }), PW = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_short_description: i,
  services: r
}) => /* @__PURE__ */ e("div", { className: t.section, children: /* @__PURE__ */ l("div", { className: t.cont, children: [
  /* @__PURE__ */ l("div", { className: t.servicesTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: t["spaceAfter--medium"] }),
  /* @__PURE__ */ e("div", { className: `${t.wlayoutgrid} ${t.servicesgrid}`, children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: zW,
      value: r
    }
  ) })
] }) }), BW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: PW,
  meta: x,
  styles: OW
}, Symbol.toStringTag, { value: "Module" })), qW = "_buttonsWrapper_flh69_132", HW = "_servicesContainer_flh69_165", VW = "_serviceItem_flh69_168", FW = "_serviceImage_flh69_174", DW = {
  buttonsWrapper: qW,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_flh69_138",
  "spaceAfter--small": "_spaceAfter--small_flh69_141",
  "spaceAfter--medium": "_spaceAfter--medium_flh69_144",
  servicesContainer: HW,
  serviceItem: VW,
  serviceImage: FW
}, XW = ({
  Elements: { Text: n, Image: o, Button: t },
  classes: a,
  service_image: i,
  service_short_description: r,
  service_title: c,
  service_details_link: s
}) => /* @__PURE__ */ e("div", { className: "col-lg-6 mb-4 py-3", children: /* @__PURE__ */ l("div", { className: a.serviceItem, children: [
  /* @__PURE__ */ e("div", { className: a.serviceImage, children: /* @__PURE__ */ e(o, { value: i }) }),
  /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
  /* @__PURE__ */ l("div", { className: a.serviceText, children: [
    /* @__PURE__ */ e(n, { tag: "h4", value: c }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { tag: "p", value: r }),
    " ",
    /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] })
  ] }),
  /* @__PURE__ */ e("div", { className: "mt-auto", children: /* @__PURE__ */ e(t, { type: "Primary", value: s }) })
] }) }), RW = ({ Elements: { RepeatedItems: n }, classes: o, services: t }) => /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: o.servicesContainer, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
  n,
  {
    classes: o,
    Component: XW,
    value: t
  }
) }) }) }) }), GW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: RW,
  meta: x,
  styles: DW
}, Symbol.toStringTag, { value: "Module" })), UW = "_buttonsWrapper_1tdvc_132", JW = "_servicesContainer_1tdvc_165", QW = "_sectionHeader_1tdvc_168", KW = "_serviceItem_1tdvc_171", ZW = "_serviceImage_1tdvc_176", YW = {
  buttonsWrapper: UW,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1tdvc_138",
  "spaceAfter--small": "_spaceAfter--small_1tdvc_141",
  "spaceAfter--medium": "_spaceAfter--medium_1tdvc_144",
  servicesContainer: JW,
  sectionHeader: QW,
  serviceItem: KW,
  serviceImage: ZW
}, eE = ({
  Elements: { Text: n, Image: o, Button: t },
  classes: a,
  service_image: i,
  service_short_description: r,
  service_title: c,
  service_details_link: s
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 mb-4 py-3", children: /* @__PURE__ */ l("div", { className: a.serviceItem, children: [
  /* @__PURE__ */ e("div", { className: a.serviceImage, children: /* @__PURE__ */ e(o, { value: i }) }),
  /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
  /* @__PURE__ */ e(n, { tag: "h4", value: c }),
  /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
  /* @__PURE__ */ e(n, { tag: "p", value: r }),
  /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
  /* @__PURE__ */ e("div", { className: "mt-auto", children: /* @__PURE__ */ e(t, { type: "Link", value: s }) })
] }) }), tE = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_short_description: i,
  services: r
}) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: t.servicesContainer, children: [
  /* @__PURE__ */ l("div", { className: t.sectionHeader, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(o, { tag: "p", value: i }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--medium"] })
  ] }),
  /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: eE,
      value: r
    }
  ) })
] }) }), aE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tE,
  meta: x,
  styles: YW
}, Symbol.toStringTag, { value: "Module" })), nE = "_buttonsWrapper_17f79_132", oE = "_servicesContainer_17f79_165", iE = "_sectionHeader_17f79_168", lE = "_serviceItem_17f79_172", rE = "_serviceIcon_17f79_183", cE = {
  buttonsWrapper: nE,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_17f79_138",
  "spaceAfter--small": "_spaceAfter--small_17f79_141",
  "spaceAfter--medium": "_spaceAfter--medium_17f79_144",
  servicesContainer: oE,
  sectionHeader: iE,
  serviceItem: lE,
  serviceIcon: rE
}, sE = ({
  Elements: { Text: n, Icon: o, Button: t },
  classes: a,
  service_icon: i,
  service_short_description: r,
  service_title: c,
  service_details_link: s
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 mb-4 py-3", children: /* @__PURE__ */ l("div", { className: a.serviceItem, children: [
  /* @__PURE__ */ e("div", { className: a.serviceIcon, children: /* @__PURE__ */ e(o, { value: i }) }),
  /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
  /* @__PURE__ */ e(n, { tag: "h4", value: c }),
  /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
  /* @__PURE__ */ e(n, { tag: "p", value: r }),
  /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
  /* @__PURE__ */ e("div", { className: "mt-auto", children: /* @__PURE__ */ e(t, { type: "Link", value: s }) })
] }) }), dE = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_short_description: i,
  services: r
}) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: t.servicesContainer, children: [
  /* @__PURE__ */ l("div", { className: t.sectionHeader, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(o, { tag: "p", value: i }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--medium"] })
  ] }),
  /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: sE,
      value: r
    }
  ) })
] }) }), _E = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dE,
  meta: x,
  styles: cE
}, Symbol.toStringTag, { value: "Module" })), mE = "_buttonsWrapper_1ozm0_132", uE = "_servicesContainer_1ozm0_165", pE = "_sectionHeader_1ozm0_168", vE = "_serviceItem_1ozm0_190", fE = "_serviceImage_1ozm0_195", gE = "_serviceBtn_1ozm0_205", hE = {
  buttonsWrapper: mE,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1ozm0_138",
  "spaceAfter--small": "_spaceAfter--small_1ozm0_141",
  "spaceAfter--medium": "_spaceAfter--medium_1ozm0_144",
  servicesContainer: uE,
  sectionHeader: pE,
  serviceItem: vE,
  serviceImage: fE,
  serviceBtn: gE
}, bE = ({
  Elements: { Text: n, Image: o, Button: t },
  classes: a,
  service_image: i,
  service_short_description: r,
  service_title: c,
  service_details_link: s
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 mb-4 py-3", children: /* @__PURE__ */ l("div", { className: a.serviceItem, children: [
  /* @__PURE__ */ e("div", { className: a.serviceImage, children: /* @__PURE__ */ e(o, { value: i }) }),
  /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
  /* @__PURE__ */ e(n, { tag: "h4", value: c }),
  /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
  /* @__PURE__ */ e(n, { tag: "p", value: r }),
  /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
  /* @__PURE__ */ e("div", { className: "mt-auto", children: /* @__PURE__ */ e(t, { type: "Link", value: s }) })
] }) }), yE = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_short_description: i,
  services: r
}) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: t.servicesContainer, children: [
  /* @__PURE__ */ l("div", { className: `row mx-0 ${t.sectionHeader}`, children: [
    /* @__PURE__ */ e("div", { className: "col-lg-6", children: /* @__PURE__ */ e(o, { tag: "h2", value: a }) }),
    /* @__PURE__ */ e("div", { className: "col-lg-6", children: /* @__PURE__ */ e(o, { tag: "p", value: i }) })
  ] }),
  /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: bE,
      value: r
    }
  ) })
] }) }), $E = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yE,
  meta: x,
  styles: hE
}, Symbol.toStringTag, { value: "Module" })), NE = "_buttonsWrapper_15fs9_132", CE = "_servicesContainer_15fs9_165", xE = "_sectionHeader_15fs9_168", IE = "_serviceItem_15fs9_205", AE = "_serviceImage_15fs9_210", SE = {
  buttonsWrapper: NE,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_15fs9_138",
  "spaceAfter--small": "_spaceAfter--small_15fs9_141",
  "spaceAfter--medium": "_spaceAfter--medium_15fs9_144",
  servicesContainer: CE,
  sectionHeader: xE,
  serviceItem: IE,
  serviceImage: AE
}, kE = ({
  Elements: { Text: n, Image: o, Button: t },
  classes: a,
  service_image: i,
  service_short_description: r,
  service_title: c,
  service_details_link: s
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 mb-4 py-3", children: /* @__PURE__ */ l("div", { className: a.serviceItem, children: [
  /* @__PURE__ */ e("div", { className: a.serviceImage, children: /* @__PURE__ */ e(o, { value: i }) }),
  /* @__PURE__ */ e(n, { tag: "h4", value: c }),
  /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
  /* @__PURE__ */ e(n, { tag: "p", value: r }),
  /* @__PURE__ */ e("div", { className: a["spaceAfter--small"] }),
  /* @__PURE__ */ e("div", { className: "mt-auto", children: /* @__PURE__ */ e(t, { type: "Link", value: s }) })
] }) }), jE = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_short_description: i,
  services: r
}) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: t.servicesContainer, children: [
  /* @__PURE__ */ l("div", { className: `row mx-0 ${t.sectionHeader}`, children: [
    /* @__PURE__ */ e("div", { className: "col-lg-6", children: /* @__PURE__ */ e(o, { tag: "h2", value: a }) }),
    /* @__PURE__ */ e("div", { className: "col-lg-6", children: /* @__PURE__ */ e(o, { tag: "p", value: i }) })
  ] }),
  /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: kE,
      value: r
    }
  ) })
] }) }), wE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jE,
  meta: x,
  styles: SE
}, Symbol.toStringTag, { value: "Module" })), je = /* @__PURE__ */ Object.assign({ "./0001/index.jsx": hj, "./0002/index.jsx": jj, "./0003/index.jsx": qj, "./0004/index.jsx": Zj, "./0008/index.jsx": _w, "./0009/index.jsx": Iw, "./0010/index.jsx": Pw, "./0011/index.jsx": eM, "./0012/index.jsx": _M, "./0013/index.jsx": SM, "./0014/index.jsx": HM, "./0016/index.jsx": tW, "./0018/index.jsx": dW, "./0019/index.jsx": yW, "./0020/index.jsx": BW, "./0021/index.jsx": GW, "./0022/index.jsx": aE, "./0023/index.jsx": _E, "./0024/index.jsx": $E, "./0025/index.jsx": wE }), ME = Object.keys(je).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: je[o] }),
  {}
), WE = "_buttonsWrapper_1rvor_132", EE = "_teamContainer_1rvor_165", TE = "_imgContainer_1rvor_169", LE = "_imageWrapper_1rvor_174", OE = "_teamTitle_1rvor_181", zE = "_item_1rvor_193", PE = "_itemInfo_1rvor_197", BE = {
  buttonsWrapper: WE,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1rvor_138",
  "spaceAfter--small": "_spaceAfter--small_1rvor_141",
  "spaceAfter--medium": "_spaceAfter--medium_1rvor_144",
  teamContainer: EE,
  imgContainer: TE,
  imageWrapper: LE,
  teamTitle: OE,
  item: zE,
  itemInfo: PE
}, J = {
  facebook: "#",
  twitter: "#",
  linkedin: "#"
}, P = {
  section_title: {
    type: d.TEXT,
    fieldId: 33,
    defaultValue: {
      default: "Our Team",
      ar: "فريقنا"
    }
  },
  section_subtitle: {
    type: d.TEXT,
    fieldId: 34,
    defaultValue: {
      default: "We’re led by a team who is always thinking, always creating, and always pushing forward.",
      ar: "يقودنا فريق لا يتوقف عن التفكير والإبداع. ويحرص دومًا على دفعنا إلى الأمام."
    }
  },
  members: {
    type: d.GROUP,
    values: {
      name: {
        type: d.TEXT,
        fieldId: 35
      },
      role: {
        type: d.TEXT,
        fieldId: 37
      },
      image: {
        type: d.IMAGE,
        fieldId: 38
      },
      body: {
        type: d.TEXT,
        fieldId: 36
      },
      socialLinks: {
        type: d.SOCIAL_LINKS,
        fieldId: 39
      }
    },
    defaultValue: [
      {
        name: {
          default: "Angelica Johnson",
          ar: "منير محمود"
        },
        role: {
          default: "Founder & CEO",
          ar: "المؤسس والرئيس التنفيذي"
        },
        body: {
          default: "Angelica Johnson studied business at University of Southern California. She has lead multiple startups including Culdin, Mifi, and Purity.",
          ar: "درس إدارة الأعمال في الجامعة الأمريكية بالقاهرة، ويمتلك خبرة كبيرة في مجال الإدارة، لا سيما وأنه قاد العديد من الشركات الناشئة خلال الأعوام الماضية."
        },
        image: {
          default: "https://assets.wuiltsite.com/defaults/angelika-johnson.jpg",
          ar: "https://assets.wuiltsite.com/defaults/mouneer-mahmoud.jpg"
        },
        socialLinks: {
          default: J
        }
      },
      {
        name: {
          default: "Peter Thomas",
          ar: "رامي هارون"
        },
        role: {
          default: "Chief Finance Officer",
          ar: "المدير المالي"
        },
        body: {
          default: "Peter Thomas is the author of four books, including the New York Times bestseller, “Walking Down Wall Street,” inspired by 10 years of working on Wall Street.",
          ar: "يعد أحد أبرز الخبراء الماليين في المنطقة العربية، حيث صدرت له عدد من المؤلفات، وقد أسس العديد من الإدارات المالية في أكثر من مؤسسة محلية ودولية."
        },
        image: {
          default: "https://assets.wuiltsite.com/defaults/peter.jpg",
          ar: "https://assets.wuiltsite.com/defaults/ramy-haroun.jpg"
        },
        socialLinks: {
          default: J
        }
      },
      {
        name: {
          default: "Maria Rodriguez",
          ar: "أميرة الوزير"
        },
        role: {
          default: "Marketing Director",
          ar: "مسؤولة الموارد البشرية"
        },
        body: {
          default: "Maria Rodriquez is best known for co-founding Cherry Innovation, a marketing strategy firm. She has written for the Wall Street Journal, The New York Times, and The Atlantic.",
          ar: "ساهمت في تأسيس أكثر من مؤسسة خلال الأعوام القليلة الماضية، وتعتبر واحدة من أهم المسؤولين في الفريق، وتستطيع بخبرتها تخطي كل العقبات التي نتصادف بها أثناء العمل."
        },
        image: {
          default: "https://assets.wuiltsite.com/defaults/maria.jpg",
          ar: "https://assets.wuiltsite.com/defaults/amira-el-wazeer.jpg"
        },
        socialLinks: {
          default: J
        }
      },
      {
        name: {
          default: "Bradley Hanson",
          ar: "مايا بن منصور"
        },
        role: {
          default: "Senior Vice President of Design",
          ar: "مديرة الشؤون القانونيّة"
        },
        body: {
          default: "Bradley Hanson grew up in Newton, Massachusetts, and graduated from the University of Massachusetts at Amherst with a degree in Graphic Design.",
          ar: "درست القانون في كلية هارفارد بالولايات المتحدة، وتدرجت إلى منصبها الحالي بعد سنواتٍ من الخبرة، اكتسبتها في أكثر من مؤسسة محلية ودولية."
        },
        image: {
          default: "https://assets.wuiltsite.com/defaults/bradely.jpg",
          ar: "https://assets.wuiltsite.com/defaults/maya-mansour.jpg"
        },
        socialLinks: {
          default: J
        }
      }
    ]
  }
}, qE = ({
  Elements: { Text: n, Image: o },
  classes: t,
  body: a,
  name: i,
  role: r,
  image: c
}) => /* @__PURE__ */ e("div", { className: "col-lg-3 col-md-6 col-sm-6", children: /* @__PURE__ */ l("div", { className: t.item, children: [
  /* @__PURE__ */ e("div", { className: t.imgContainer, children: /* @__PURE__ */ e(o, { className: t.imageWrapper, value: c, small: !0 }) }),
  /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
  /* @__PURE__ */ l("div", { className: t.itemInfo, children: [
    /* @__PURE__ */ e(n, { className: t.headertext, tag: "h4", value: i }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { className: t.headertext, tag: "h6", value: r }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { className: t.itemdesc, tag: "p", value: a })
  ] })
] }) }), HE = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_subtitle: i,
  members: r
}) => /* @__PURE__ */ e("div", { className: t.teamContainer, children: /* @__PURE__ */ l("div", { className: `${t.container} container `, children: [
  /* @__PURE__ */ l("div", { className: t.teamTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(o, { tag: "p", value: i }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--medium"] })
  ] }),
  /* @__PURE__ */ e("div", { className: t.services, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: qE,
      value: r
    }
  ) }) })
] }) }), VE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: HE,
  meta: P,
  styles: BE
}, Symbol.toStringTag, { value: "Module" })), FE = "_buttonsWrapper_11k18_132", DE = "_servicesContainer_11k18_165", XE = "_imgContainer_11k18_169", RE = "_teamTitle_11k18_179", GE = "_item_11k18_191", UE = "_itemInfo_11k18_199", JE = "_social_11k18_219", QE = "_socialItem_11k18_231", KE = {
  buttonsWrapper: FE,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_11k18_138",
  "spaceAfter--small": "_spaceAfter--small_11k18_141",
  "spaceAfter--medium": "_spaceAfter--medium_11k18_144",
  servicesContainer: DE,
  imgContainer: XE,
  teamTitle: RE,
  item: GE,
  itemInfo: UE,
  social: JE,
  socialItem: QE
}, ZE = ({
  Elements: { Text: n, Image: o, SocialLinks: t },
  classes: a,
  name: i,
  role: r,
  image: c,
  socialLinks: s
}) => /* @__PURE__ */ e("div", { className: "col-lg-3 co-md-4 col-sm-6", children: /* @__PURE__ */ l("div", { className: a.item, children: [
  /* @__PURE__ */ e("div", { className: a.imgContainer, children: /* @__PURE__ */ e(o, { value: c, small: !0 }) }),
  /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
  /* @__PURE__ */ l("div", { className: a.itemInfo, children: [
    /* @__PURE__ */ e(n, { className: a.headertext, tag: "h4", value: i }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { className: a.headertext, tag: "h6", value: r }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(
      t,
      {
        listClass: a.social,
        itemClass: a.socialItem,
        value: s
      }
    )
  ] })
] }) }), YE = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_subtitle: i,
  members: r
}) => /* @__PURE__ */ e("div", { className: t.servicesContainer, children: /* @__PURE__ */ l("div", { className: "container", children: [
  /* @__PURE__ */ l("div", { className: t.teamTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(o, { tag: "p", value: i }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] })
  ] }),
  /* @__PURE__ */ e("div", { className: t.services, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: ZE,
      value: r
    }
  ) }) })
] }) }), eT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: YE,
  meta: P,
  styles: KE
}, Symbol.toStringTag, { value: "Module" })), tT = "_buttonsWrapper_wtgtw_132", aT = "_space_wtgtw_138", nT = "_teamContainer_wtgtw_170", oT = "_imgContainer_wtgtw_174", iT = "_imageWrapper_wtgtw_180", lT = "_teamTitle_wtgtw_187", rT = "_item_wtgtw_196", cT = "_itemInfo_wtgtw_205", sT = "_social_wtgtw_218", dT = "_socialItem_wtgtw_229", _T = {
  buttonsWrapper: tT,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_wtgtw_138",
  "spaceAfter--small": "_spaceAfter--small_wtgtw_141",
  "spaceAfter--medium": "_spaceAfter--medium_wtgtw_144",
  space: aT,
  teamContainer: nT,
  imgContainer: oT,
  imageWrapper: iT,
  teamTitle: lT,
  item: rT,
  itemInfo: cT,
  social: sT,
  socialItem: dT
}, mT = ({
  Elements: { Text: n, Image: o, SocialLinks: t },
  classes: a,
  name: i,
  role: r,
  image: c,
  socialLinks: s
}) => /* @__PURE__ */ e("div", { className: `${a.space} col-lg-4 col-md-6 col-sm-6`, children: /* @__PURE__ */ l("div", { className: a.item, children: [
  /* @__PURE__ */ e("div", { className: a.imgContainer, children: /* @__PURE__ */ e(o, { className: a.imageWrapper, value: c, small: !0 }) }),
  /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
  /* @__PURE__ */ l("div", { className: a.itemInfo, children: [
    /* @__PURE__ */ e(n, { className: a.headertext, tag: "h4", value: i }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { className: a.headertext, tag: "h6", value: r }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(
      t,
      {
        value: s,
        listClass: a.social,
        itemClass: a.socialItem
      }
    )
  ] })
] }) }), uT = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_subtitle: i,
  members: r
}) => /* @__PURE__ */ e("div", { className: t.teamContainer, children: /* @__PURE__ */ l("div", { className: `${t.container} container `, children: [
  /* @__PURE__ */ l("div", { className: t.teamTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
  /* @__PURE__ */ e("div", { className: t.services, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: mT,
      value: r
    }
  ) }) })
] }) }), pT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: uT,
  meta: P,
  styles: _T
}, Symbol.toStringTag, { value: "Module" })), vT = "_buttonsWrapper_1fmb7_132", fT = "_space_1fmb7_138", gT = "_teamContainer_1fmb7_169", hT = "_imgContainer_1fmb7_173", bT = "_teamTitle_1fmb7_180", yT = "_item_1fmb7_192", $T = "_itemInfo_1fmb7_195", NT = {
  buttonsWrapper: vT,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1fmb7_138",
  "spaceAfter--small": "_spaceAfter--small_1fmb7_141",
  "spaceAfter--medium": "_spaceAfter--medium_1fmb7_144",
  space: fT,
  teamContainer: gT,
  imgContainer: hT,
  teamTitle: bT,
  item: yT,
  itemInfo: $T
}, CT = ({
  Elements: { Text: n, Image: o },
  classes: t,
  name: a,
  role: i,
  image: r
}) => /* @__PURE__ */ e("div", { className: `${t.space} col-md-4`, children: /* @__PURE__ */ l("div", { className: t.item, children: [
  /* @__PURE__ */ e("div", { className: t.imgContainer, children: /* @__PURE__ */ e(o, { value: r, small: !0 }) }),
  /* @__PURE__ */ l("div", { className: t.itemInfo, children: [
    /* @__PURE__ */ e(n, { tag: "h4", value: a }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { tag: "h6", value: i })
  ] })
] }) }), xT = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_subtitle: i,
  members: r
}) => /* @__PURE__ */ e("div", { className: t.teamContainer, children: /* @__PURE__ */ l("div", { className: "container", children: [
  /* @__PURE__ */ l("div", { className: t.teamTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
  /* @__PURE__ */ e("div", { className: t.services, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: CT,
      value: r
    }
  ) }) })
] }) }), IT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xT,
  meta: P,
  styles: NT
}, Symbol.toStringTag, { value: "Module" })), AT = "_buttonsWrapper_1d8ed_132", ST = "_teamsContainer_1d8ed_165", kT = "_item_1d8ed_172", jT = "_itemInfo_1d8ed_176", wT = "_social_1d8ed_184", MT = {
  buttonsWrapper: AT,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1d8ed_138",
  "spaceAfter--small": "_spaceAfter--small_1d8ed_141",
  "spaceAfter--medium": "_spaceAfter--medium_1d8ed_144",
  teamsContainer: ST,
  item: kT,
  itemInfo: jT,
  social: wT
}, WT = ({
  Elements: { Text: n, Image: o, SocialLinks: t },
  classes: a,
  name: i,
  role: r,
  image: c,
  body: s,
  socialLinks: _
}) => /* @__PURE__ */ e("div", { className: "col-md-6 d-flex justify-content-center mb-4", children: /* @__PURE__ */ l("div", { className: a.item, children: [
  /* @__PURE__ */ e("div", { className: a.imgContainer, children: /* @__PURE__ */ e(o, { value: c, small: !0 }) }),
  /* @__PURE__ */ l("div", { className: a.itemInfo, children: [
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { tag: "h3", value: i }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ l("div", { className: "d-flex w-100 justify-content-between align-items-center", children: [
      /* @__PURE__ */ e(n, { tag: "h6", value: r }),
      /* @__PURE__ */ e(
        t,
        {
          listClass: a.social,
          itemClass: a.socialItem,
          value: _
        }
      )
    ] }),
    /* @__PURE__ */ e("hr", {}),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { tag: "p", value: s })
  ] })
] }) }), ET = ({ Elements: { RepeatedItems: n }, classes: o, members: t }) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: o.teamsContainer, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(n, { classes: o, Component: WT, value: t }) }) }) }), TT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ET,
  meta: P,
  styles: MT
}, Symbol.toStringTag, { value: "Module" })), LT = "_buttonsWrapper_w826x_132", OT = "_teamContainer_w826x_165", zT = "_item_w826x_169", PT = "_imgContainer_w826x_172", BT = "_imageWrapper_w826x_176", qT = {
  buttonsWrapper: LT,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_w826x_138",
  "spaceAfter--small": "_spaceAfter--small_w826x_141",
  "spaceAfter--medium": "_spaceAfter--medium_w826x_144",
  teamContainer: OT,
  item: zT,
  imgContainer: PT,
  imageWrapper: BT
}, HT = ({
  Elements: { Text: n, Image: o },
  classes: t,
  body: a,
  name: i,
  role: r,
  image: c
}) => /* @__PURE__ */ e("div", { className: "col-lg-3 col-md-6 mb-4", children: /* @__PURE__ */ l("div", { className: t.item, children: [
  /* @__PURE__ */ e("div", { className: t.imgContainer, children: /* @__PURE__ */ e(o, { className: t.imageWrapper, value: c, small: !0 }) }),
  /* @__PURE__ */ l("div", { className: t.itemInfo, children: [
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { className: t.headertext, tag: "h4", value: i }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { className: t.headertext, tag: "h6", value: r }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { className: t.itemdesc, tag: "p", value: a })
  ] })
] }) }), VT = ({ Elements: { RepeatedItems: n }, classes: o, members: t }) => /* @__PURE__ */ e("div", { className: o.teamContainer, children: /* @__PURE__ */ e("div", { className: `${o.container} container `, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(n, { classes: o, Component: HT, value: t }) }) }) }), FT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: VT,
  meta: P,
  styles: qT
}, Symbol.toStringTag, { value: "Module" })), DT = "_buttonsWrapper_r5o71_132", XT = "_teamContainer_r5o71_165", RT = "_teamHeader_r5o71_169", GT = "_item_r5o71_182", UT = "_itemInfo_r5o71_185", JT = "_social_r5o71_193", QT = "_imgContainer_r5o71_201", KT = {
  buttonsWrapper: DT,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_r5o71_138",
  "spaceAfter--small": "_spaceAfter--small_r5o71_141",
  "spaceAfter--medium": "_spaceAfter--medium_r5o71_144",
  teamContainer: XT,
  teamHeader: RT,
  item: GT,
  itemInfo: UT,
  social: JT,
  imgContainer: QT
}, ZT = ({
  Elements: { Text: n, Image: o, SocialLinks: t },
  classes: a,
  socialLinks: i,
  name: r,
  role: c,
  image: s
}) => /* @__PURE__ */ e("div", { className: "col-lg-3  col-md-6 mb-4", children: /* @__PURE__ */ l("div", { className: a.item, children: [
  /* @__PURE__ */ e("div", { className: a.imgContainer, children: /* @__PURE__ */ e(o, { value: s, small: !0 }) }),
  /* @__PURE__ */ l("div", { className: a.itemInfo, children: [
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { tag: "h4", value: r }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { tag: "h6", value: c }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(
      t,
      {
        listClass: a.social,
        itemClass: a.socialItem,
        value: i
      }
    )
  ] })
] }) }), YT = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_subtitle: i,
  members: r
}) => /* @__PURE__ */ e("div", { className: t.teamContainer, children: /* @__PURE__ */ l("div", { className: `${t.container} container `, children: [
  /* @__PURE__ */ e("div", { className: t.teamHeader, children: /* @__PURE__ */ l("div", { className: t.teamTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(o, { tag: "p", value: i }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] })
  ] }) }),
  /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(n, { classes: t, Component: ZT, value: r }) })
] }) }), eL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: YT,
  meta: P,
  styles: KT
}, Symbol.toStringTag, { value: "Module" })), tL = "_buttonsWrapper_1rfpx_132", aL = "_teamContainer_1rfpx_165", nL = "_teamHeader_1rfpx_169", oL = "_item_1rfpx_182", iL = "_itemInfo_1rfpx_185", lL = "_social_1rfpx_196", rL = "_imgContainer_1rfpx_204", cL = {
  buttonsWrapper: tL,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1rfpx_138",
  "spaceAfter--small": "_spaceAfter--small_1rfpx_141",
  "spaceAfter--medium": "_spaceAfter--medium_1rfpx_144",
  teamContainer: aL,
  teamHeader: nL,
  item: oL,
  itemInfo: iL,
  social: lL,
  imgContainer: rL
}, sL = ({
  Elements: { Text: n, Image: o, SocialLinks: t },
  classes: a,
  socialLinks: i,
  name: r,
  role: c,
  image: s,
  body: _
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 col-md-6 mb-4", children: /* @__PURE__ */ l("div", { className: a.item, children: [
  /* @__PURE__ */ e("div", { className: a.imgContainer, children: /* @__PURE__ */ e(o, { value: s, small: !0 }) }),
  /* @__PURE__ */ l("div", { className: a.itemInfo, children: [
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { tag: "h4", value: r }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { tag: "h6", value: c }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { tag: "p", value: _ }),
    /* @__PURE__ */ e("div", { className: a["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(
      t,
      {
        listClass: a.social,
        itemClass: a.socialItem,
        value: i
      }
    )
  ] })
] }) }), dL = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  section_title: a,
  section_subtitle: i,
  members: r
}) => /* @__PURE__ */ e("div", { className: t.teamContainer, children: /* @__PURE__ */ l("div", { className: `${t.container} container `, children: [
  /* @__PURE__ */ e("div", { className: t.teamHeader, children: /* @__PURE__ */ l("div", { className: t.teamTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }) }),
  /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(n, { classes: t, Component: sL, value: r }) })
] }) }), _L = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dL,
  meta: P,
  styles: cL
}, Symbol.toStringTag, { value: "Module" })), we = /* @__PURE__ */ Object.assign({ "./0001/index.jsx": VE, "./0002/index.jsx": eT, "./0003/index.jsx": pT, "./0004/index.jsx": IT, "./0005/index.jsx": TT, "./0006/index.jsx": FT, "./0007/index.jsx": eL, "./0008/index.jsx": _L }), mL = Object.keys(we).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: we[o] }),
  {}
), uL = "_buttonsWrapper_p6lyt_132", pL = "_imgContainer_p6lyt_165", vL = "_imageWrapper_p6lyt_174", fL = "_container_p6lyt_181", gL = "_testmonilsTitle_p6lyt_185", hL = "_item_p6lyt_194", bL = "_itemInfo_p6lyt_197", yL = {
  buttonsWrapper: uL,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_p6lyt_138",
  "spaceAfter--small": "_spaceAfter--small_p6lyt_141",
  "spaceAfter--medium": "_spaceAfter--medium_p6lyt_144",
  imgContainer: pL,
  imageWrapper: vL,
  container: fL,
  testmonilsTitle: gL,
  item: hL,
  itemInfo: bL
}, A = {
  block_title: {
    type: d.TEXT,
    fieldId: 6,
    defaultValue: {
      default: "What Our Clients Say",
      ar: "ماذا يقول عملاؤنا"
    }
  },
  block_subtitle: {
    type: d.TEXT,
    fieldId: 7,
    defaultValue: {
      default: "Hundreds of customers rely on our services. See what they have to say.",
      ar: "مئات العملاء يعتمدون على خداماتنا.. وإليك بعض مما قالوه عن خداماتنا:"
    }
  },
  section_image: {
    type: d.IMAGE,
    fieldId: 31,
    defaultValue: {
      default: "https://images.unsplash.com/photo-1501428291079-b42d45fc7455?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=7e761e6c5b31e6eb15ac816ceb38d4f4&auto=format&fit=crop&w=1050&q=80"
    }
  },
  testimonials: {
    type: d.GROUP,
    values: {
      testimonial_body: {
        type: d.TEXT,
        fieldId: 4
      },
      testimonial_author: {
        type: d.TEXT,
        fieldId: 5
      },
      testimonial_author_role: {
        type: d.TEXT,
        fieldId: 29
      },
      testimonial_author_image: {
        type: d.IMAGE,
        fieldId: 30
      }
    },
    defaultValue: [
      {
        testimonial_body: {
          default: "“Avivo has been wonderful. They have the best customer service and always go above and beyond to answer my questions and make sure my needs are met.”",
          ar: '“كانت Avivo رائعة. لديهم أفضل خدمة عملاء ودائما ما يتجاوزون الإجابة على أسئلتي والتأكد من تلبية احتياجاتي "'
        },
        testimonial_author: {
          default: "Charlie Mendoza",
          ar: "كارا"
        },
        testimonial_author_role: {
          default: "Co-Founder / Beeply",
          ar: "مؤسس مشارك / بيبلي"
        },
        testimonial_author_image: {
          default: "https://images.unsplash.com/photo-1516486609688-38da8f268743?ixlib=rb-0.3.5&s=9d6987c2bf554dc4c0de1209c6e08b1c&auto=format&fit=crop&w=500&q=80"
        }
      },
      {
        testimonial_body: {
          default: "“I honestly could not be more pleased with this product. So creative and helpful.”",
          ar: '"بصراحة لا يمكن أن أكون أكثر سعادة بهذا المنتج. مبدعة ومفيدة للغاية. "'
        },
        testimonial_author: {
          default: "Salma",
          ar: "سلمى"
        },
        testimonial_author_role: {
          default: "CEO / Newzify",
          ar: "الرئيس التنفيذي / Newzify"
        },
        testimonial_author_image: {
          default: "https://images.unsplash.com/photo-1486314547704-d16929b8a2af?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=c2d5d9be0196706bc93d37ecd2217c11&auto=format&fit=crop&w=500&q=80"
        }
      },
      {
        testimonial_body: {
          default: "“I’ve never been more impressed with any other product before. I’ve tried so many of the other ones, and this is truly the one that stands out the most.”",
          ar: '"لم أكن أبدًا معجبًا بأي منتج آخر من قبل. لقد حاولت العديد جدا من بعضها الآخر، وهذا هو حقا واحد هو الذي يبرز أكثر "'
        },
        testimonial_author: {
          default: "Chris",
          ar: "كريس"
        },
        testimonial_author_role: {
          default: "Art Director / Boomerangs",
          ar: "مدير فني / بوميرانج"
        },
        testimonial_author_image: {
          default: "https://images.unsplash.com/photo-1511079727166-22288ec84472?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=fd72794d86c3e3559e56e0a6706a4599&auto=format&fit=crop&w=500&q=80"
        }
      },
      {
        testimonial_body: {
          default: "“Avivo has been wonderful. They have the best customer service and always go above and beyond to answer my questions and make sure my needs are met.”",
          ar: '“كانت Avivo رائعة. لديهم أفضل خدمة عملاء ودائما ما يتجاوزون الإجابة على أسئلتي والتأكد من تلبية احتياجاتي "'
        },
        testimonial_author: {
          default: "Cara",
          ar: "كارا"
        },
        testimonial_author_role: {
          default: "Co-Founder / Beeply",
          ar: "مؤسس مشارك / بيبلي"
        },
        testimonial_author_image: {
          default: "https://images.unsplash.com/photo-1516486609688-38da8f268743?ixlib=rb-0.3.5&s=9d6987c2bf554dc4c0de1209c6e08b1c&auto=format&fit=crop&w=500&q=80"
        }
      }
    ]
  }
}, $L = ({
  Elements: { Text: n, Image: o },
  classes: t,
  testimonial_body: a,
  testimonial_author: i,
  testimonial_author_role: r,
  testimonial_author_image: c
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 col-md-6 col-sm-6 col-xs-12", children: /* @__PURE__ */ l("div", { className: t.item, children: [
  /* @__PURE__ */ e("div", { className: t.imgContainer, children: /* @__PURE__ */ e(
    o,
    {
      className: t.imageWrapper,
      small: !0,
      value: c
    }
  ) }),
  /* @__PURE__ */ l("div", { className: t.itemInfo, children: [
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(
      n,
      {
        className: t.headertext,
        tag: "h4",
        value: i
      }
    ),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(
      n,
      {
        className: t.headertext,
        tag: "h6",
        value: r
      }
    ),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(n, { className: t.itemdesc, tag: "p", value: a })
  ] })
] }) }), NL = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  block_title: a,
  block_subtitle: i,
  testimonials: r
}) => /* @__PURE__ */ e("div", { className: t.container, children: /* @__PURE__ */ e("div", { className: t.body, children: /* @__PURE__ */ l("div", { className: "container ", children: [
  /* @__PURE__ */ l("div", { className: t.testmonilsTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e("div", { className: t["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: t.testmonils, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: $L,
      value: r
    }
  ) }) })
] }) }) }), CL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NL,
  meta: A,
  styles: yL
}, Symbol.toStringTag, { value: "Module" })), xL = "_buttonsWrapper_ksioh_132", IL = "_container_ksioh_165", AL = "_imgContainer_ksioh_169", SL = "_imageWrapper_ksioh_177", kL = "_auther_ksioh_184", jL = "_testmonilsTitle_ksioh_196", wL = "_item_ksioh_212", ML = "_itemInfo_ksioh_215", WL = "_columnStyle_ksioh_229", EL = {
  buttonsWrapper: xL,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_ksioh_138",
  "spaceAfter--small": "_spaceAfter--small_ksioh_141",
  "spaceAfter--medium": "_spaceAfter--medium_ksioh_144",
  container: IL,
  imgContainer: AL,
  imageWrapper: SL,
  auther: kL,
  testmonilsTitle: jL,
  item: wL,
  itemInfo: ML,
  columnStyle: WL
}, TL = ({
  Elements: { Text: n, Image: o },
  classes: t,
  testimonial_body: a,
  testimonial_author: i,
  testimonial_author_role: r,
  testimonial_author_image: c
}) => /* @__PURE__ */ e(
  "div",
  {
    className: `${t.columnStyle} col-lg-4 col-md-6 col-sm-6 col-xs-12`,
    children: /* @__PURE__ */ l("div", { className: t.item, children: [
      /* @__PURE__ */ e("div", { className: t.itemInfo, children: /* @__PURE__ */ e(n, { className: t.itemdesc, tag: "p", value: a }) }),
      /* @__PURE__ */ l("div", { className: t.auther, children: [
        /* @__PURE__ */ e("div", { className: t.imgContainer, children: /* @__PURE__ */ e(
          o,
          {
            className: t.imageWrapper,
            small: !0,
            value: c
          }
        ) }),
        /* @__PURE__ */ e(
          n,
          {
            className: t.headertext,
            tag: "h4",
            value: i
          }
        ),
        /* @__PURE__ */ e(
          n,
          {
            className: t.headertext,
            tag: "h6",
            value: r
          }
        )
      ] })
    ] })
  }
), LL = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  block_title: a,
  block_subtitle: i,
  testimonials: r
}) => /* @__PURE__ */ e("div", { className: t.container, children: /* @__PURE__ */ e("div", { className: t.body, children: /* @__PURE__ */ l("div", { className: "container ", children: [
  /* @__PURE__ */ l("div", { className: t.testmonilsTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: t.testmonils, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: TL,
      value: r
    }
  ) }) })
] }) }) }), OL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: LL,
  meta: A,
  styles: EL
}, Symbol.toStringTag, { value: "Module" })), zL = "_buttonsWrapper_xlmla_132", PL = "_imgContainer_xlmla_165", BL = "_imageWrapper_xlmla_183", qL = "_container_xlmla_190", HL = "_testmonilsTitle_xlmla_194", VL = "_item_xlmla_210", FL = "_itemInfo_xlmla_214", DL = {
  buttonsWrapper: zL,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_xlmla_138",
  "spaceAfter--small": "_spaceAfter--small_xlmla_141",
  "spaceAfter--medium": "_spaceAfter--medium_xlmla_144",
  imgContainer: PL,
  imageWrapper: BL,
  container: qL,
  testmonilsTitle: HL,
  item: VL,
  itemInfo: FL
}, XL = ({
  Elements: { Text: n, Image: o },
  classes: t,
  testimonial_body: a,
  testimonial_author: i,
  testimonial_author_role: r,
  testimonial_author_image: c
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 col-md-6 col-sm-6 col-xs-12", children: /* @__PURE__ */ e("div", { className: t.item, children: /* @__PURE__ */ l("div", { className: t.itemInfo, children: [
  /* @__PURE__ */ e("div", { className: t.imgContainer, children: /* @__PURE__ */ e(
    o,
    {
      className: t.imageWrapper,
      small: !0,
      value: c
    }
  ) }),
  /* @__PURE__ */ e(
    n,
    {
      className: t.headertext,
      tag: "h4",
      value: i
    }
  ),
  /* @__PURE__ */ e(
    n,
    {
      className: t.headertext,
      tag: "h6",
      value: r
    }
  ),
  /* @__PURE__ */ e(n, { className: t.itemdesc, tag: "p", value: a })
] }) }) }), RL = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  block_title: a,
  block_subtitle: i,
  testimonials: r
}) => /* @__PURE__ */ e("div", { className: t.container, children: /* @__PURE__ */ e("div", { className: t.body, children: /* @__PURE__ */ l("div", { className: "container ", children: [
  /* @__PURE__ */ l("div", { className: t.testmonilsTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: t.testmonils, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: XL,
      value: r
    }
  ) }) })
] }) }) }), GL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: RL,
  meta: A,
  styles: DL
}, Symbol.toStringTag, { value: "Module" })), UL = "_buttonsWrapper_onfgf_132", JL = "_imgContainer_onfgf_165", QL = "_imageWrapper_onfgf_170", KL = "_container_onfgf_177", ZL = "_testmonilsTitle_onfgf_181", YL = "_item_onfgf_197", eO = "_itemInfo_onfgf_201", tO = "_seprator_onfgf_225", aO = "_contentLine_onfgf_234", nO = {
  buttonsWrapper: UL,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_onfgf_138",
  "spaceAfter--small": "_spaceAfter--small_onfgf_141",
  "spaceAfter--medium": "_spaceAfter--medium_onfgf_144",
  imgContainer: JL,
  imageWrapper: QL,
  container: KL,
  testmonilsTitle: ZL,
  item: YL,
  itemInfo: eO,
  seprator: tO,
  contentLine: aO
}, oO = ({
  Elements: { Text: n, Image: o },
  classes: t,
  testimonial_body: a,
  testimonial_author: i,
  testimonial_author_role: r,
  testimonial_author_image: c
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 col-md-6 col-sm-6 col-xs-12", children: /* @__PURE__ */ e("div", { className: t.item, children: /* @__PURE__ */ l("div", { className: t.itemInfo, children: [
  /* @__PURE__ */ e(n, { className: t.itemdesc, tag: "p", value: a }),
  /* @__PURE__ */ e("div", { className: t.seprator }),
  /* @__PURE__ */ l("div", { className: t.contentLine, children: [
    /* @__PURE__ */ e("div", { className: t.imgContainer, children: /* @__PURE__ */ e(
      o,
      {
        className: t.imageWrapper,
        small: !0,
        value: c
      }
    ) }),
    /* @__PURE__ */ e(
      n,
      {
        className: t.headertext,
        tag: "h4",
        value: i
      }
    ),
    /* @__PURE__ */ e(
      n,
      {
        className: t.headertext,
        tag: "h6",
        value: r
      }
    )
  ] })
] }) }) }), iO = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  block_title: a,
  block_subtitle: i,
  testimonials: r
}) => /* @__PURE__ */ e("div", { className: t.container, children: /* @__PURE__ */ e("div", { className: t.body, children: /* @__PURE__ */ l("div", { className: "container ", children: [
  /* @__PURE__ */ l("div", { className: t.testmonilsTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: t.testmonils, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: oO,
      value: r
    }
  ) }) })
] }) }) }), lO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: iO,
  meta: A,
  styles: nO
}, Symbol.toStringTag, { value: "Module" })), rO = "_buttonsWrapper_1xwhw_132", cO = "_imgContainer_1xwhw_165", sO = "_imageWrapper_1xwhw_169", dO = "_testmonilsContainer_1xwhw_176", _O = "_testmonils_1xwhw_176", mO = "_testmonilsTitle_1xwhw_185", uO = "_item_1xwhw_203", pO = "_itemInfo_1xwhw_209", vO = "_contentLine_1xwhw_247", fO = {
  buttonsWrapper: rO,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1xwhw_138",
  "spaceAfter--small": "_spaceAfter--small_1xwhw_141",
  "spaceAfter--medium": "_spaceAfter--medium_1xwhw_144",
  imgContainer: cO,
  imageWrapper: sO,
  testmonilsContainer: dO,
  testmonils: _O,
  testmonilsTitle: mO,
  item: uO,
  itemInfo: pO,
  contentLine: vO
}, gO = ({
  Elements: { Text: n, Image: o },
  classes: t,
  testimonial_body: a,
  testimonial_author: i,
  testimonial_author_role: r,
  testimonial_author_image: c
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 col-md-6 col-sm-6 col-xs-12", children: /* @__PURE__ */ e("div", { className: t.item, children: /* @__PURE__ */ l("div", { className: t.itemInfo, children: [
  /* @__PURE__ */ e("i", { className: "la la-quote-right" }),
  /* @__PURE__ */ e(n, { className: t.itemdesc, tag: "p", value: a }),
  /* @__PURE__ */ e("div", { className: t.imgContainer, children: /* @__PURE__ */ e(
    o,
    {
      className: t.imageWrapper,
      small: !0,
      value: c
    }
  ) }),
  /* @__PURE__ */ l("div", { className: t.contentLine, children: [
    /* @__PURE__ */ e(
      n,
      {
        className: t.headertext,
        tag: "h4",
        value: i
      }
    ),
    /* @__PURE__ */ e(
      n,
      {
        className: t.headertext,
        tag: "h6",
        value: r
      }
    )
  ] })
] }) }) }), hO = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  block_title: a,
  block_subtitle: i,
  testimonials: r
}) => /* @__PURE__ */ l("div", { className: t.container, children: [
  /* @__PURE__ */ l("div", { className: t.testmonilsTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: t.testmonils, children: /* @__PURE__ */ e("div", { className: `${t.testmonilsContainer} container`, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: gO,
      value: r
    }
  ) }) }) })
] }), bO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hO,
  meta: A,
  styles: fO
}, Symbol.toStringTag, { value: "Module" })), yO = "_buttonsWrapper_1lr4g_132", $O = "_imgContainer_1lr4g_165", NO = "_imageWrapper_1lr4g_169", CO = "_container_1lr4g_176", xO = "_testmonilsTitle_1lr4g_181", IO = "_item_1lr4g_197", AO = "_overlay_1lr4g_204", SO = "_itemInfo_1lr4g_221", kO = "_contentLine_1lr4g_258", jO = {
  buttonsWrapper: yO,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1lr4g_138",
  "spaceAfter--small": "_spaceAfter--small_1lr4g_141",
  "spaceAfter--medium": "_spaceAfter--medium_1lr4g_144",
  imgContainer: $O,
  imageWrapper: NO,
  container: CO,
  testmonilsTitle: xO,
  item: IO,
  overlay: AO,
  itemInfo: SO,
  contentLine: kO
}, wO = ({
  Elements: { Text: n, Image: o },
  classes: t,
  testimonial_body: a,
  testimonial_author: i,
  testimonial_author_role: r,
  testimonial_author_image: c
}) => /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ l("div", { className: t.item, children: [
  /* @__PURE__ */ e("div", { className: t.overlay }),
  /* @__PURE__ */ l("div", { className: t.itemInfo, children: [
    /* @__PURE__ */ e("i", { className: "la la-quote-right" }),
    /* @__PURE__ */ e(n, { className: t.itemdesc, tag: "p", value: a }),
    /* @__PURE__ */ e("div", { className: t.imgContainer, children: /* @__PURE__ */ e(
      o,
      {
        className: t.imageWrapper,
        small: !0,
        value: c
      }
    ) }),
    /* @__PURE__ */ l("div", { className: t.contentLine, children: [
      /* @__PURE__ */ e(
        n,
        {
          className: t.headertext,
          tag: "h4",
          value: i
        }
      ),
      /* @__PURE__ */ e(
        n,
        {
          className: t.headertext,
          tag: "h6",
          value: r
        }
      )
    ] })
  ] })
] }) }), MO = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  block_title: a,
  block_subtitle: i,
  testimonials: r
}) => /* @__PURE__ */ e("div", { className: t.container, children: /* @__PURE__ */ e("div", { className: t.body, children: /* @__PURE__ */ l("div", { className: "container ", children: [
  /* @__PURE__ */ l("div", { className: t.testmonilsTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: wO,
      value: r
    }
  ) })
] }) }) }), WO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: MO,
  meta: A,
  styles: jO
}, Symbol.toStringTag, { value: "Module" })), EO = "_imgContainer_1uorz_1", TO = "_imageWrapper_1uorz_6", LO = "_container_1uorz_13", OO = "_testmonilsTitle_1uorz_18", zO = "_testmonilContainer_1uorz_35", PO = "_item_1uorz_43", BO = "_itemInfo_1uorz_49", qO = "_styleColumn_1uorz_82", HO = {
  imgContainer: EO,
  imageWrapper: TO,
  container: LO,
  testmonilsTitle: OO,
  testmonilContainer: zO,
  item: PO,
  itemInfo: BO,
  styleColumn: qO
}, VO = ({
  Elements: { Text: n, Image: o },
  classes: t,
  testimonial_body: a,
  testimonial_author: i,
  testimonial_author_role: r,
  testimonial_author_image: c
}) => /* @__PURE__ */ e("div", { className: t.item, children: /* @__PURE__ */ l("div", { className: t.itemInfo, children: [
  /* @__PURE__ */ e(n, { className: t.itemdesc, tag: "p", value: a }),
  /* @__PURE__ */ l("div", { className: "row", children: [
    /* @__PURE__ */ e("div", { className: t.imgContainer, children: /* @__PURE__ */ e(
      o,
      {
        className: t.imageWrapper,
        small: !0,
        value: c
      }
    ) }),
    /* @__PURE__ */ e(
      n,
      {
        className: t.headertext,
        tag: "h4",
        value: i
      }
    )
  ] }),
  /* @__PURE__ */ e(
    n,
    {
      className: t.headertext,
      tag: "h6",
      value: r
    }
  )
] }) }), FO = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  block_title: a,
  block_subtitle: i,
  testimonials: r
}) => /* @__PURE__ */ e("div", { className: t.container, children: /* @__PURE__ */ e("div", { className: t.body, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: `${t.styleColumn} col-lg-5  col-md-12`, children: /* @__PURE__ */ l("div", { className: t.testmonilsTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h1", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }) }),
  /* @__PURE__ */ e("div", { className: "col-lg-7 col-md-12", children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e("div", { className: t.testmonilContainer, children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: VO,
      value: r
    }
  ) }) }) })
] }) }) }) }), DO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FO,
  meta: A,
  styles: HO
}, Symbol.toStringTag, { value: "Module" })), XO = "_buttonsWrapper_c31aa_132", RO = "_testimonialsContainer_c31aa_165", GO = "_testmonilsTitle_c31aa_169", UO = "_item_c31aa_186", JO = "_itemInfo_c31aa_193", QO = "_contentLine_c31aa_229", KO = "_styleColumn_c31aa_236", ZO = {
  buttonsWrapper: XO,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_c31aa_138",
  "spaceAfter--small": "_spaceAfter--small_c31aa_141",
  "spaceAfter--medium": "_spaceAfter--medium_c31aa_144",
  testimonialsContainer: RO,
  testmonilsTitle: GO,
  item: UO,
  itemInfo: JO,
  contentLine: QO,
  styleColumn: KO
}, YO = ({
  Elements: { Text: n },
  classes: o,
  testimonial_body: t,
  testimonial_author: a,
  testimonial_author_role: i
}) => /* @__PURE__ */ e(
  "div",
  {
    className: `${o.styleColumn} col-lg-4 col-md-6 col-sm-6 col-xs-12`,
    children: /* @__PURE__ */ e("div", { className: o.item, children: /* @__PURE__ */ l("div", { className: o.itemInfo, children: [
      /* @__PURE__ */ e("i", { className: "la la-quote-right" }),
      /* @__PURE__ */ e(n, { className: o.itemdesc, tag: "p", value: t }),
      /* @__PURE__ */ l("div", { className: o.contentLine, children: [
        /* @__PURE__ */ e(
          n,
          {
            className: o.headertext,
            tag: "h4",
            value: a
          }
        ),
        /* @__PURE__ */ e(
          n,
          {
            className: o.headertext,
            tag: "h6",
            value: i
          }
        )
      ] })
    ] }) })
  }
), ez = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  block_title: a,
  block_subtitle: i,
  testimonials: r
}) => /* @__PURE__ */ e("div", { className: t.testimonialsContainer, children: /* @__PURE__ */ e("div", { className: t.body, children: /* @__PURE__ */ l("div", { className: "container ", children: [
  /* @__PURE__ */ l("div", { className: t.testmonilsTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: t.testmonils, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: YO,
      value: r
    }
  ) }) })
] }) }) }), tz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ez,
  meta: A,
  styles: ZO
}, Symbol.toStringTag, { value: "Module" })), az = "_buttonsWrapper_1imvp_132", nz = "_testimonialsContainer_1imvp_165", oz = "_sectionHeader_1imvp_169", iz = "_item_1imvp_182", lz = "_imageContainer_1imvp_198", rz = {
  buttonsWrapper: az,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1imvp_138",
  "spaceAfter--small": "_spaceAfter--small_1imvp_141",
  "spaceAfter--medium": "_spaceAfter--medium_1imvp_144",
  testimonialsContainer: nz,
  sectionHeader: oz,
  item: iz,
  imageContainer: lz
}, cz = ({
  Elements: { Text: n, Image: o },
  classes: t,
  testimonial_body: a,
  testimonial_author: i,
  testimonial_author_role: r,
  testimonial_author_image: c
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 col-sm-6 mb-4", children: /* @__PURE__ */ l("div", { className: t.item, children: [
  /* @__PURE__ */ e("i", { className: "la la-quote-right" }),
  /* @__PURE__ */ e(n, { tag: "p", value: a }),
  /* @__PURE__ */ e("div", { className: t.imageContainer, children: /* @__PURE__ */ e(o, { value: c, small: !0 }) }),
  /* @__PURE__ */ e(n, { tag: "h4", value: i }),
  /* @__PURE__ */ e(n, { tag: "h6", value: r })
] }) }), sz = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  block_title: a,
  block_subtitle: i,
  testimonials: r
}) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: t.testimonialsContainer, children: [
  /* @__PURE__ */ l("div", { className: t.sectionHeader, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: cz,
      value: r
    }
  ) })
] }) }), dz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sz,
  meta: A,
  styles: rz
}, Symbol.toStringTag, { value: "Module" })), _z = "_buttonsWrapper_anh0n_132", mz = "_sectionContainer_anh0n_165", uz = "_sectionHeader_anh0n_168", pz = "_item_anh0n_181", vz = {
  buttonsWrapper: _z,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_anh0n_138",
  "spaceAfter--small": "_spaceAfter--small_anh0n_141",
  "spaceAfter--medium": "_spaceAfter--medium_anh0n_144",
  sectionContainer: mz,
  sectionHeader: uz,
  item: pz
}, fz = ({
  Elements: { Text: n },
  classes: o,
  testimonial_body: t,
  testimonial_author: a,
  testimonial_author_role: i
}) => /* @__PURE__ */ e("div", { className: "col-md-6 mb-4", children: /* @__PURE__ */ l("div", { className: o.item, children: [
  /* @__PURE__ */ e("i", { className: "la la-quote-right" }),
  /* @__PURE__ */ e(n, { tag: "p", value: t }),
  /* @__PURE__ */ l("div", { children: [
    /* @__PURE__ */ e(n, { tag: "h4", value: a }),
    /* @__PURE__ */ e(n, { tag: "h6", value: i })
  ] })
] }) }), gz = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  block_title: a,
  block_subtitle: i,
  testimonials: r
}) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: t.sectionContainer, children: [
  /* @__PURE__ */ l("div", { className: t.sectionHeader, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: `row ${t.itemsContainer}`, children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: fz,
      value: r
    }
  ) })
] }) }), hz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gz,
  meta: A,
  styles: vz
}, Symbol.toStringTag, { value: "Module" })), bz = "_buttonsWrapper_117hk_132", yz = "_testimonialsContainer_117hk_165", $z = "_sectionHeader_117hk_168", Nz = "_itemContainer_117hk_181", Cz = "_item_117hk_181", xz = "_itemHeader_117hk_194", Iz = "_itemFooter_117hk_198", Az = "_imgContainer_117hk_201", Sz = "_imageWrapper_117hk_206", kz = "_footerContent_117hk_212", jz = {
  buttonsWrapper: bz,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_117hk_138",
  "spaceAfter--small": "_spaceAfter--small_117hk_141",
  "spaceAfter--medium": "_spaceAfter--medium_117hk_144",
  testimonialsContainer: yz,
  sectionHeader: $z,
  itemContainer: Nz,
  item: Cz,
  itemHeader: xz,
  itemFooter: Iz,
  imgContainer: Az,
  imageWrapper: Sz,
  footerContent: kz
}, wz = ({
  Elements: { Text: n, Image: o },
  classes: t,
  testimonial_body: a,
  testimonial_author: i,
  testimonial_author_role: r,
  testimonial_author_image: c
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 col-sm-6 mb-4", children: /* @__PURE__ */ e("div", { className: t.itemContainer, children: /* @__PURE__ */ l("div", { className: t.item, children: [
  /* @__PURE__ */ e("div", { className: t.itemHeader, children: /* @__PURE__ */ e(n, { tag: "p", value: a }) }),
  /* @__PURE__ */ l("div", { className: t.itemFooter, children: [
    /* @__PURE__ */ e("div", { className: t.imgContainer, children: /* @__PURE__ */ e(
      o,
      {
        className: t.imageWrapper,
        small: !0,
        value: c
      }
    ) }),
    /* @__PURE__ */ l("div", { className: t.footerContent, children: [
      /* @__PURE__ */ e(n, { tag: "h4", value: i }),
      /* @__PURE__ */ e(n, { tag: "h6", value: r })
    ] })
  ] })
] }) }) }), Mz = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  block_title: a,
  block_subtitle: i,
  testimonials: r
}) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: t.testimonialsContainer, children: [
  /* @__PURE__ */ l("div", { className: t.sectionHeader, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: wz,
      value: r
    }
  ) })
] }) }), Wz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mz,
  meta: A,
  styles: jz
}, Symbol.toStringTag, { value: "Module" })), Ez = "_buttonsWrapper_1jqrd_132", Tz = "_testimonialsContainer_1jqrd_165", Lz = "_sectionHeader_1jqrd_169", Oz = "_itemContainer_1jqrd_182", zz = "_item_1jqrd_182", Pz = "_imgContainer_1jqrd_192", Bz = "_imageWrapper_1jqrd_197", qz = {
  buttonsWrapper: Ez,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_1jqrd_138",
  "spaceAfter--small": "_spaceAfter--small_1jqrd_141",
  "spaceAfter--medium": "_spaceAfter--medium_1jqrd_144",
  testimonialsContainer: Tz,
  sectionHeader: Lz,
  itemContainer: Oz,
  item: zz,
  imgContainer: Pz,
  imageWrapper: Bz
}, Hz = ({
  Elements: { Text: n, Image: o },
  classes: t,
  testimonial_body: a,
  testimonial_author: i,
  testimonial_author_role: r,
  testimonial_author_image: c
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 col-sm-6 mb-4", children: /* @__PURE__ */ e("div", { className: t.itemContainer, children: /* @__PURE__ */ l("div", { className: t.item, children: [
  /* @__PURE__ */ e("div", { className: t.imgContainer, children: /* @__PURE__ */ e(
    o,
    {
      className: t.imageWrapper,
      small: !0,
      value: c
    }
  ) }),
  /* @__PURE__ */ e(n, { tag: "h4", value: i }),
  /* @__PURE__ */ e(n, { tag: "h6", value: r }),
  /* @__PURE__ */ e("hr", { className: "my-4" }),
  /* @__PURE__ */ e(n, { tag: "p", value: a })
] }) }) }), Vz = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  testimonials: a,
  block_title: i,
  block_subtitle: r
}) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: t.testimonialsContainer, children: [
  /* @__PURE__ */ l("div", { className: t.sectionHeader, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: i }),
    /* @__PURE__ */ e(o, { tag: "p", value: r })
  ] }),
  /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: Hz,
      value: a
    }
  ) })
] }) }), Fz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vz,
  meta: A,
  styles: qz
}, Symbol.toStringTag, { value: "Module" })), Dz = "_buttonsWrapper_iya2i_132", Xz = "_testimonialsContainer_iya2i_165", Rz = "_sectionHeader_iya2i_169", Gz = "_itemContainer_iya2i_182", Uz = "_item_iya2i_182", Jz = {
  buttonsWrapper: Dz,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_iya2i_138",
  "spaceAfter--small": "_spaceAfter--small_iya2i_141",
  "spaceAfter--medium": "_spaceAfter--medium_iya2i_144",
  testimonialsContainer: Xz,
  sectionHeader: Rz,
  itemContainer: Gz,
  item: Uz
}, Qz = ({
  Elements: { Text: n },
  classes: o,
  testimonial_body: t,
  testimonial_author: a,
  testimonial_author_role: i
}) => /* @__PURE__ */ e("div", { className: "col-lg-4 col-sm-6 mb-4", children: /* @__PURE__ */ e("div", { className: o.itemContainer, children: /* @__PURE__ */ l("div", { className: o.item, children: [
  /* @__PURE__ */ e(n, { tag: "h4", value: a }),
  /* @__PURE__ */ e(n, { tag: "h6", value: i }),
  /* @__PURE__ */ e("hr", { className: "my-4" }),
  /* @__PURE__ */ e(n, { tag: "p", value: t })
] }) }) }), Kz = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  block_title: a,
  block_subtitle: i,
  testimonials: r
}) => /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: t.testimonialsContainer, children: [
  /* @__PURE__ */ l("div", { className: t.sectionHeader, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: Qz,
      value: r
    }
  ) })
] }) }), Zz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Kz,
  meta: A,
  styles: Jz
}, Symbol.toStringTag, { value: "Module" })), Yz = "_buttonsWrapper_exyv6_132", eP = "_testimonialsContainer_exyv6_165", tP = "_sectionHeader_exyv6_168", aP = "_itemContainer_exyv6_180", nP = "_item_exyv6_180", oP = {
  buttonsWrapper: Yz,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_exyv6_138",
  "spaceAfter--small": "_spaceAfter--small_exyv6_141",
  "spaceAfter--medium": "_spaceAfter--medium_exyv6_144",
  testimonialsContainer: eP,
  sectionHeader: tP,
  itemContainer: aP,
  item: nP
}, iP = ({
  Elements: { Text: n },
  classes: o,
  testimonial_body: t,
  testimonial_author: a,
  testimonial_author_role: i
}) => /* @__PURE__ */ l("div", { className: o.item, children: [
  /* @__PURE__ */ e("i", { className: "la la-quote-right" }),
  /* @__PURE__ */ e(n, { tag: "p", value: t }),
  /* @__PURE__ */ l("div", { children: [
    /* @__PURE__ */ e(n, { tag: "h4", value: a }),
    /* @__PURE__ */ e(n, { tag: "h6", value: i })
  ] })
] }), lP = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  block_title: a,
  block_subtitle: i,
  testimonials: r
}) => /* @__PURE__ */ e("div", { className: "container mb-4", children: /* @__PURE__ */ l("div", { className: t.testimonialsContainer, children: [
  /* @__PURE__ */ l("div", { className: t.sectionHeader, children: [
    /* @__PURE__ */ e(o, { tag: "h2", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: `row ${t.itemsContainer}`, children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: iP,
      value: r
    }
  ) })
] }) }), rP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lP,
  meta: A,
  styles: oP
}, Symbol.toStringTag, { value: "Module" })), cP = "_imgContainer_10u7q_1", sP = "_autherImage_10u7q_8", dP = "_container_10u7q_12", _P = "_testmonilsTitle_10u7q_17", mP = "_item_10u7q_30", uP = "_itemInfo_10u7q_42", pP = {
  imgContainer: cP,
  autherImage: sP,
  container: dP,
  testmonilsTitle: _P,
  item: mP,
  itemInfo: uP
}, vP = ({
  Elements: { Text: n, Image: o },
  classes: t,
  testimonial_body: a,
  testimonial_author: i,
  testimonial_author_role: r,
  testimonial_author_image: c
}) => /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ e("div", { className: t.item, children: /* @__PURE__ */ l("div", { className: "row", children: [
  /* @__PURE__ */ e("div", { className: "col-md-3", children: /* @__PURE__ */ e("div", { className: t.imgContainer, children: /* @__PURE__ */ e(
    o,
    {
      aspectRatio: "1:1",
      className: t.autherImage,
      small: !0,
      value: c
    }
  ) }) }),
  /* @__PURE__ */ e("div", { className: "col-md-9", children: /* @__PURE__ */ l("div", { className: t.itemInfo, children: [
    /* @__PURE__ */ e(
      n,
      {
        className: t.itemdesc,
        tag: "p",
        value: a
      }
    ),
    /* @__PURE__ */ e(
      n,
      {
        className: t.headertext,
        tag: "h4",
        value: i
      }
    ),
    /* @__PURE__ */ e(
      n,
      {
        className: t.headertext,
        tag: "h6",
        value: r
      }
    )
  ] }) })
] }) }) }), fP = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  block_title: a,
  block_subtitle: i,
  testimonials: r
}) => /* @__PURE__ */ e("div", { className: t.container, children: /* @__PURE__ */ e("div", { className: t.body, children: /* @__PURE__ */ l("div", { className: "container ", children: [
  /* @__PURE__ */ l("div", { className: t.testmonilsTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h1", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: t.testmonils, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: vP,
      value: r
    }
  ) }) })
] }) }) }), gP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fP,
  meta: A,
  styles: pP
}, Symbol.toStringTag, { value: "Module" })), hP = "_auther_1pgdt_1", bP = "_imgContainer_1pgdt_4", yP = "_autherImage_1pgdt_10", $P = "_container_1pgdt_31", NP = "_testmonilsTitle_1pgdt_36", CP = "_item_1pgdt_49", xP = "_itemInfo_1pgdt_60", IP = {
  auther: hP,
  imgContainer: bP,
  autherImage: yP,
  container: $P,
  testmonilsTitle: NP,
  item: CP,
  itemInfo: xP
}, AP = ({
  Elements: { Text: n, Image: o },
  classes: t,
  testimonial_body: a,
  testimonial_author: i,
  testimonial_author_role: r,
  testimonial_author_image: c
}) => /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ l("div", { className: t.item, children: [
  /* @__PURE__ */ e("div", { className: t.itemInfo, children: /* @__PURE__ */ e(n, { className: t.itemdesc, tag: "p", value: a }) }),
  /* @__PURE__ */ l("div", { className: t.auther, children: [
    /* @__PURE__ */ e("div", { className: t.imgContainer, children: /* @__PURE__ */ e(
      o,
      {
        aspectRatio: "1:1",
        className: t.autherImage,
        small: !0,
        value: c
      }
    ) }),
    /* @__PURE__ */ e(
      n,
      {
        className: t.headertext,
        tag: "h4",
        value: i
      }
    ),
    /* @__PURE__ */ e(
      n,
      {
        className: t.headertext,
        tag: "h6",
        value: r
      }
    )
  ] })
] }) }), SP = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  block_title: a,
  block_subtitle: i,
  testimonials: r
}) => /* @__PURE__ */ e("div", { className: t.container, children: /* @__PURE__ */ e("div", { className: t.body, children: /* @__PURE__ */ l("div", { className: "container ", children: [
  /* @__PURE__ */ l("div", { className: t.testmonilsTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h1", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: t.testmonils, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: AP,
      value: r
    }
  ) }) })
] }) }) }), kP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: SP,
  meta: A,
  styles: IP
}, Symbol.toStringTag, { value: "Module" })), jP = "_auther_1jogr_1", wP = "_imgContainer_1jogr_4", MP = "_autherImage_1jogr_10", WP = "_container_1jogr_23", EP = "_testmonilsTitle_1jogr_28", TP = "_item_1jogr_43", LP = "_itemInfo_1jogr_47", OP = {
  auther: jP,
  imgContainer: wP,
  autherImage: MP,
  container: WP,
  testmonilsTitle: EP,
  item: TP,
  itemInfo: LP
}, zP = ({
  Elements: { Text: n, Image: o },
  classes: t,
  testimonial_body: a,
  testimonial_author: i,
  testimonial_author_role: r,
  testimonial_author_image: c
}) => /* @__PURE__ */ e("div", { className: "col-md-6", children: /* @__PURE__ */ l("div", { className: t.item, children: [
  /* @__PURE__ */ e("div", { className: t.itemInfo, children: /* @__PURE__ */ e(n, { className: t.itemdesc, tag: "p", value: a }) }),
  /* @__PURE__ */ l("div", { className: t.auther, children: [
    /* @__PURE__ */ e("div", { className: t.imgContainer, children: /* @__PURE__ */ e(
      o,
      {
        aspectRatio: "1:1",
        className: t.autherImage,
        small: !0,
        value: c
      }
    ) }),
    /* @__PURE__ */ e(
      n,
      {
        className: t.headertext,
        tag: "h4",
        value: i
      }
    ),
    /* @__PURE__ */ e(
      n,
      {
        className: t.headertext,
        tag: "h6",
        value: r
      }
    )
  ] })
] }) }), PP = ({
  Elements: { RepeatedItems: n, Text: o },
  classes: t,
  block_title: a,
  block_subtitle: i,
  testimonials: r
}) => /* @__PURE__ */ e("div", { className: t.container, children: /* @__PURE__ */ e("div", { className: t.body, children: /* @__PURE__ */ l("div", { className: "container ", children: [
  /* @__PURE__ */ l("div", { className: t.testmonilsTitle, children: [
    /* @__PURE__ */ e(o, { tag: "h1", value: a }),
    /* @__PURE__ */ e(o, { tag: "p", value: i })
  ] }),
  /* @__PURE__ */ e("div", { className: t.testmonils, children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
    n,
    {
      classes: t,
      Component: zP,
      value: r
    }
  ) }) })
] }) }) }), BP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: PP,
  meta: A,
  styles: OP
}, Symbol.toStringTag, { value: "Module" })), qP = "_sectionBody_1sft3_1", HP = "_section_1sft3_1", VP = "_infoDiv_1sft3_10", FP = {
  sectionBody: qP,
  section: HP,
  infoDiv: VP
}, DP = ({
  Elements: { Text: n, BackgroundContainer: o },
  classes: t,
  block_title: a,
  block_subtitle: i,
  section_image: r
  // testimonial_body,
  // testimonial_author,
  // testimonial_author_role,
  // testimonial_author_image,
}) => /* @__PURE__ */ e("div", { className: t.sectionBody, children: /* @__PURE__ */ e(o, { className: t.section, value: r, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: t.infoDiv, children: [
  /* @__PURE__ */ e(n, { tag: "h1", value: a }),
  /* @__PURE__ */ e(n, { tag: "p", value: i })
] }) }) }) }), XP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: DP,
  meta: A,
  styles: FP
}, Symbol.toStringTag, { value: "Module" })), Me = /* @__PURE__ */ Object.assign({ "./0003/index.jsx": CL, "./0005/index.jsx": OL, "./0007/index.jsx": GL, "./0008/index.jsx": lO, "./0009/index.jsx": bO, "./0010/index.jsx": WO, "./0011/index.jsx": DO, "./0012/index.jsx": tz, "./0013/index.jsx": dz, "./0014/index.jsx": hz, "./0015/index.jsx": Wz, "./0016/index.jsx": Fz, "./0017/index.jsx": Zz, "./0018/index.jsx": rP, "./_0001/index.jsx": gP, "./_0002/index.jsx": kP, "./_0004/index.jsx": BP, "./_0006/index.jsx": XP }), RP = Object.keys(Me).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: Me[o] }),
  {}
), GP = "_buttonsWrapper_x7vbr_132", UP = "_section_x7vbr_165", JP = "_video_x7vbr_169", QP = "_contentCol_x7vbr_174", KP = "_videoItemCol_x7vbr_181", ZP = "_button_x7vbr_132", YP = {
  buttonsWrapper: GP,
  "spaceAfter--xSmall": "_spaceAfter--xSmall_x7vbr_138",
  "spaceAfter--small": "_spaceAfter--small_x7vbr_141",
  "spaceAfter--medium": "_spaceAfter--medium_x7vbr_144",
  section: UP,
  video: JP,
  contentCol: QP,
  videoItemCol: KP,
  button: ZP
}, Q = {
  destination: "external",
  // 'internal'
  target: "current",
  // 'new'
  text: "WATCH MORE",
  pageId: "",
  href: "#"
}, S = {
  section_title: {
    type: d.TEXT,
    fieldId: 124,
    defaultValue: {
      default: "Show Your Work",
      ar: "اظهر اعمالك"
    }
  },
  section_text: {
    type: d.TEXT,
    fieldId: 125,
    defaultValue: {
      default: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur."
    }
  },
  section_button: {
    type: d.LINK,
    fieldId: 127,
    defaultValue: {
      default: Q
    }
  },
  section_video: {
    type: d.VIDEO,
    fieldId: 126,
    defaultValue: {
      default: {
        url: "https://www.youtube.com/watch?v=gmdvlKMrrX4",
        aspectRatio: 1.75
      }
    }
  },
  videos: {
    type: d.GROUP,
    values: {
      video_title: {
        type: d.TEXT,
        fieldId: 128
      },
      video_text: {
        type: d.TEXT,
        fieldId: 129
      },
      video_button: {
        type: d.LINK,
        fieldId: 130
      },
      video_video: {
        type: d.VIDEO,
        fieldId: 131
      }
    },
    defaultValue: [
      {
        video_title: {
          default: "Video Title"
        },
        video_text: {
          default: "A small brief product description is just a bunch of text explaining"
        },
        video_button: {
          default: Q
        },
        video_video: {
          default: {
            url: "https://www.youtube.com/watch?v=gmdvlKMrrX4",
            aspectRatio: 1.75
          }
        }
      },
      {
        video_title: {
          default: "Video Title"
        },
        video_text: {
          default: "A small brief product description is just a bunch of text explaining"
        },
        video_button: {
          default: Q
        },
        video_video: {
          default: {
            url: "https://www.youtube.com/watch?v=gmdvlKMrrX4",
            aspectRatio: 1.75
          }
        }
      },
      {
        video_title: {
          default: "Video Title"
        },
        video_text: {
          default: "A small brief product description is just a bunch of text explaining"
        },
        video_button: {
          default: Q
        },
        video_video: {
          default: {
            url: "https://www.youtube.com/watch?v=gmdvlKMrrX4",
            aspectRatio: 1.75
          }
        }
      }
    ]
  }
};
function eB(n) {
  const {
    Elements: { Text: o, Button: t, Video: a },
    classes: i,
    video_title: r,
    video_text: c,
    video_button: s,
    video_video: _
  } = n;
  return /* @__PURE__ */ l("div", { className: `col-12 col-md-4 ${i.videoItemCol}`, children: [
    /* @__PURE__ */ e(a, { value: _ }),
    /* @__PURE__ */ e("div", { className: i["spaceAfter--small"] }),
    /* @__PURE__ */ e(o, { tag: "h3", value: r }),
    /* @__PURE__ */ e("div", { className: i["spaceAfter--xSmall"] }),
    /* @__PURE__ */ e(o, { tag: "p", value: c }),
    /* @__PURE__ */ e("div", { className: i["spaceAfter--small"] }),
    /* @__PURE__ */ e(
      t,
      {
        className: le(
          i.button,
          i.secondary,
          i.medium
        ),
        value: s
      }
    )
  ] });
}
function tB(n) {
  const {
    Elements: { Video: o, Text: t, Button: a, RepeatedItems: i },
    classes: r,
    section_title: c,
    section_text: s,
    section_video: _,
    section_button: m,
    videos: p
  } = n;
  return /* @__PURE__ */ e("section", { className: r.section, children: /* @__PURE__ */ l("div", { className: "container", children: [
    /* @__PURE__ */ l("div", { className: "row", children: [
      /* @__PURE__ */ e("div", { className: "col-12 col-md-6", children: /* @__PURE__ */ l("div", { className: r.video, children: [
        /* @__PURE__ */ e(o, { value: _ }),
        /* @__PURE__ */ e("div", { className: r["spaceAfter--small"] })
      ] }) }),
      /* @__PURE__ */ e(
        "div",
        {
          className: `col-11 col-md-5 align-self-center ${r.contentCol}`,
          children: /* @__PURE__ */ l("div", { children: [
            /* @__PURE__ */ e(t, { tag: "h2", value: c }),
            /* @__PURE__ */ e("div", { className: r["spaceAfter--xSmall"] }),
            /* @__PURE__ */ e(t, { tag: "p", value: s }),
            /* @__PURE__ */ e("div", { className: r["spaceAfter--small"] }),
            /* @__PURE__ */ e(a, { type: "Primary", value: m })
          ] })
        }
      )
    ] }),
    /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
      i,
      {
        classes: r,
        Component: eB,
        value: p
      }
    ) })
  ] }) });
}
const aB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tB,
  meta: S,
  styles: YP
}, Symbol.toStringTag, { value: "Module" })), nB = "_video_section_pnnfs_1", oB = "_section_header_pnnfs_5", iB = "_videos_container_pnnfs_20", lB = "_video_pnnfs_1", rB = "_section_cta_pnnfs_30", cB = "_button_pnnfs_34", sB = {
  video_section: nB,
  section_header: oB,
  videos_container: iB,
  video: lB,
  section_cta: rB,
  button: cB
}, dB = y(b({}, S), {
  videos: y(b({}, S.videos), {
    defaultValue: S.videos.defaultValue.slice(0, 2)
  })
});
function _B(n) {
  const {
    Elements: { Video: o },
    classes: t,
    video_video: a
  } = n;
  return /* @__PURE__ */ e("div", { className: "col-12 col-lg-6 col-md-6", children: /* @__PURE__ */ e("div", { className: t.video, children: /* @__PURE__ */ e(o, { value: a }) }) });
}
function mB(n) {
  const {
    Elements: { Text: o, Button: t, RepeatedItems: a },
    classes: i,
    section_title: r,
    section_text: c,
    section_button: s,
    videos: _
  } = n;
  return /* @__PURE__ */ e("section", { className: i.video_section, children: /* @__PURE__ */ l("div", { className: "container", children: [
    /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e("div", { className: "col-12 col-md-12", children: /* @__PURE__ */ l("div", { className: i.section_header, children: [
      /* @__PURE__ */ e(o, { tag: "h2", value: r }),
      /* @__PURE__ */ e(o, { tag: "p", value: c })
    ] }) }) }),
    /* @__PURE__ */ e("div", { className: `row ${i.videos_container}`, children: /* @__PURE__ */ e(
      a,
      {
        classes: i,
        Component: _B,
        value: _
      }
    ) }),
    /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e("div", { className: `col-12 ${i.section_cta}`, children: /* @__PURE__ */ e(t, { type: "Primary", value: s }) }) })
  ] }) });
}
const uB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mB,
  meta: dB,
  styles: sB
}, Symbol.toStringTag, { value: "Module" })), pB = "_video_section_vmy6f_1", vB = "_section_header_vmy6f_5", fB = "_video_vmy6f_1", gB = "_button_vmy6f_25", hB = {
  video_section: pB,
  section_header: vB,
  video: fB,
  button: gB
};
function bB(n) {
  const {
    Elements: { Video: o, Text: t, Button: a },
    classes: i,
    section_title: r,
    section_text: c,
    section_video: s,
    section_button: _
  } = n;
  return /* @__PURE__ */ e("section", { className: i.video_section, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
    /* @__PURE__ */ l(
      "div",
      {
        className: `col-11 col-md-5 align-self-center ${i.section_header}`,
        children: [
          /* @__PURE__ */ e(t, { tag: "h2", value: r }),
          /* @__PURE__ */ e(t, { tag: "p", value: c }),
          /* @__PURE__ */ e(a, { type: "Primary", value: _ })
        ]
      }
    ),
    /* @__PURE__ */ e("div", { className: "col-12 col-md-6", children: /* @__PURE__ */ e("div", { className: i.video, children: /* @__PURE__ */ e(o, { value: s }) }) })
  ] }) }) });
}
const yB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bB,
  meta: S,
  styles: hB
}, Symbol.toStringTag, { value: "Module" })), $B = "_video_section_1cy7j_1", NB = "_section_header_1cy7j_5", CB = "_video_card_1cy7j_20", xB = "_video_1cy7j_1", IB = {
  video_section: $B,
  section_header: NB,
  video_card: CB,
  video: xB
};
function AB(n) {
  const {
    Elements: { Text: o, Video: t },
    classes: a,
    video_title: i,
    video_text: r,
    video_video: c
  } = n;
  return /* @__PURE__ */ e("div", { className: "col-12 col-lg-4 col-md-6", children: /* @__PURE__ */ l("div", { className: a.video_card, children: [
    /* @__PURE__ */ e("div", { className: a.video, children: /* @__PURE__ */ e(t, { value: c }) }),
    /* @__PURE__ */ e(o, { tag: "h3", value: i }),
    /* @__PURE__ */ e(o, { tag: "p", value: r })
  ] }) });
}
function SB(n) {
  const {
    Elements: { Text: o, RepeatedItems: t },
    classes: a,
    section_title: i,
    section_text: r,
    videos: c
  } = n;
  return /* @__PURE__ */ e("section", { className: a.video_section, children: /* @__PURE__ */ l("div", { className: "container", children: [
    /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e("div", { className: "col-12 col-md-12", children: /* @__PURE__ */ l("div", { className: a.section_header, children: [
      /* @__PURE__ */ e(o, { tag: "h2", value: i }),
      /* @__PURE__ */ e(o, { tag: "p", value: r })
    ] }) }) }),
    /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
      t,
      {
        classes: a,
        Component: AB,
        value: c
      }
    ) })
  ] }) });
}
const kB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: SB,
  meta: S,
  styles: IB
}, Symbol.toStringTag, { value: "Module" })), jB = "_video_section_dn1bt_1", wB = "_section_header_dn1bt_5", MB = "_video_dn1bt_1", WB = "_button_dn1bt_30", EB = {
  video_section: jB,
  section_header: wB,
  video: MB,
  button: WB
};
function TB(n) {
  const {
    Elements: { Video: o, Text: t, Button: a },
    classes: i,
    section_title: r,
    section_text: c,
    section_video: s,
    section_button: _
  } = n;
  return /* @__PURE__ */ e("section", { className: i.video_section, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ l("div", { className: "row", children: [
    /* @__PURE__ */ e("div", { className: "col-12 col-md-6", children: /* @__PURE__ */ e("div", { className: i.video, children: /* @__PURE__ */ e(o, { value: s }) }) }),
    /* @__PURE__ */ l(
      "div",
      {
        className: `col-11 col-md-5 align-self-center ${i.section_header}`,
        children: [
          /* @__PURE__ */ e(t, { tag: "h2", value: r }),
          /* @__PURE__ */ e(t, { tag: "p", value: c }),
          /* @__PURE__ */ e(a, { type: "Primary", value: _ })
        ]
      }
    )
  ] }) }) });
}
const LB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: TB,
  meta: S,
  styles: EB
}, Symbol.toStringTag, { value: "Module" })), OB = "_video_section_ybjli_1", zB = "_video_ybjli_1", PB = "_video_section_content_ybjli_12", BB = "_button_ybjli_27", qB = {
  video_section: OB,
  video: zB,
  video_section_content: PB,
  button: BB
};
function HB(n) {
  const {
    Elements: { Video: o, Text: t, Button: a },
    classes: i,
    section_title: r,
    section_text: c,
    section_video: s,
    section_button: _
  } = n;
  return /* @__PURE__ */ e("section", { className: i.video_section, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ l(
    "div",
    {
      className: `col-12 col-md-10 col-sm-12 align-self-center ${i.video_section_content}`,
      children: [
        /* @__PURE__ */ e("div", { className: i.video, children: /* @__PURE__ */ e(o, { value: s }) }),
        /* @__PURE__ */ e(t, { tag: "h2", value: r }),
        /* @__PURE__ */ e(t, { tag: "p", value: c }),
        /* @__PURE__ */ e(a, { type: "Primary", value: _ })
      ]
    }
  ) }) }) });
}
const VB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: HB,
  meta: S,
  styles: qB
}, Symbol.toStringTag, { value: "Module" })), FB = "_video_section_1e5q5_1", DB = "_video_1e5q5_1", XB = "_video_section_content_1e5q5_12", RB = "_section_header_1e5q5_16", GB = "_button_1e5q5_42", UB = {
  video_section: FB,
  video: DB,
  video_section_content: XB,
  section_header: RB,
  button: GB
};
function JB(n) {
  const {
    Elements: { Video: o, Text: t, Button: a },
    classes: i,
    section_title: r,
    section_text: c,
    section_video: s,
    section_button: _
  } = n;
  return /* @__PURE__ */ e("section", { className: i.video_section, children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ l(
    "div",
    {
      className: `col-12 col-md-10 col-sm-12 align-self-center ${i.video_section_content}`,
      children: [
        /* @__PURE__ */ l("div", { className: i.section_header, children: [
          /* @__PURE__ */ e(t, { tag: "h2", value: r }),
          /* @__PURE__ */ e(t, { tag: "p", value: c })
        ] }),
        /* @__PURE__ */ e("div", { className: i.video, children: /* @__PURE__ */ e(o, { value: s }) }),
        /* @__PURE__ */ e(a, { type: "Primary", value: _ })
      ]
    }
  ) }) }) });
}
const QB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JB,
  meta: S,
  styles: UB
}, Symbol.toStringTag, { value: "Module" })), KB = "_video_section_c09bf_1", ZB = "_section_header_c09bf_5", YB = "_video_c09bf_1", eq = "_section_cta_c09bf_26", tq = "_button_c09bf_30", aq = {
  video_section: KB,
  section_header: ZB,
  video: YB,
  section_cta: eq,
  button: tq
}, nq = y(b({}, S), {
  videos: y(b({}, S.videos), {
    defaultValue: [
      ...S.videos.defaultValue,
      ...S.videos.defaultValue.slice(0, 1)
    ]
  })
});
function oq(n) {
  const {
    Elements: { Video: o },
    classes: t,
    video_video: a
  } = n;
  return /* @__PURE__ */ e("div", { className: "col-12 col-lg-6 col-md-6", children: /* @__PURE__ */ e("div", { className: t.video, children: /* @__PURE__ */ e(o, { value: a }) }) });
}
function iq(n) {
  const {
    Elements: { Text: o, RepeatedItems: t },
    classes: a,
    section_title: i,
    section_text: r,
    videos: c
  } = n;
  return /* @__PURE__ */ e("section", { className: a.video_section, children: /* @__PURE__ */ l("div", { className: "container", children: [
    /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e("div", { className: "col-12 col-md-12", children: /* @__PURE__ */ l("div", { className: a.section_header, children: [
      /* @__PURE__ */ e(o, { tag: "h2", value: i }),
      /* @__PURE__ */ e(o, { tag: "p", value: r })
    ] }) }) }),
    /* @__PURE__ */ e("div", { className: `row ${a.videos_container}`, children: /* @__PURE__ */ e(
      t,
      {
        classes: a,
        Component: oq,
        value: c
      }
    ) })
  ] }) });
}
const lq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: iq,
  meta: nq,
  styles: aq
}, Symbol.toStringTag, { value: "Module" })), rq = "_video_section_1k4xu_1", cq = "_section_header_1k4xu_5", sq = "_video_card_1k4xu_31", dq = "_video_1k4xu_1", _q = {
  video_section: rq,
  section_header: cq,
  video_card: sq,
  video: dq
}, mq = y(b({}, S), {
  videos: y(b({}, S.videos), {
    defaultValue: [
      ...S.videos.defaultValue,
      ...S.videos.defaultValue
    ]
  })
});
function uq(n) {
  const {
    Elements: { Video: o },
    classes: t,
    video_video: a
  } = n;
  return /* @__PURE__ */ e("div", { className: "col-12 col-lg-4 col-md-6", children: /* @__PURE__ */ e("div", { className: t.video_card, children: /* @__PURE__ */ e("div", { className: t.video, children: /* @__PURE__ */ e(o, { value: a }) }) }) });
}
function pq(n) {
  const {
    Elements: { Text: o, RepeatedItems: t },
    classes: a,
    section_title: i,
    section_text: r,
    videos: c
  } = n;
  return /* @__PURE__ */ e("section", { className: a.video_section, children: /* @__PURE__ */ l("div", { className: "container", children: [
    /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e("div", { className: "col-12 col-md-12", children: /* @__PURE__ */ l("div", { className: a.section_header, children: [
      /* @__PURE__ */ e(o, { tag: "h2", value: i }),
      /* @__PURE__ */ e(o, { tag: "p", value: r })
    ] }) }) }),
    /* @__PURE__ */ e("div", { className: "row", children: /* @__PURE__ */ e(
      t,
      {
        classes: a,
        Component: uq,
        value: c
      }
    ) })
  ] }) });
}
const vq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pq,
  meta: mq,
  styles: _q
}, Symbol.toStringTag, { value: "Module" })), We = /* @__PURE__ */ Object.assign({ "./0001/index.jsx": aB, "./0002/index.jsx": uB, "./0003/index.jsx": yB, "./0004/index.jsx": kB, "./0005/index.jsx": LB, "./0006/index.jsx": VB, "./0007/index.jsx": QB, "./0008/index.jsx": lq, "./0009/index.jsx": vq }), fq = Object.keys(We).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: We[o] }),
  {}
), gq = {}, Ee = {
  id: "93e44d5e-faf7-4834-867b-bfc5ea5b2d45",
  elements: [],
  settings: {
    grid: {
      rowGap: 10,
      columnGap: 10,
      shouldFullWidth: !1,
      shouldSnapToGuides: !0,
      shouldKeepGridVisible: !0,
      breakpoints: {
        mobile: {
          rows: 15,
          columns: 8
        },
        tablet: {
          rows: 15,
          columns: 24
        },
        desktop: {
          rows: 15,
          columns: 24
        }
      }
    },
    styles: {
      padding: { top: 40, right: 0, bottom: 40, left: 0 },
      background: {
        type: "Color",
        color: {
          type: "Custom",
          theme: "#FFFFFF",
          custom: "#FFFFFF",
          gradient: {
            angle: 45,
            startColor: "#0000FF80",
            endColor: "#00FFAE80",
            startPosition: 0,
            endPosition: 100
          }
        },
        image: {
          src: "",
          size: "cover",
          position: "center center",
          repeat: "repeat",
          scrollEffect: "fixed",
          overlay: {
            isEnabled: !1,
            value: {
              type: "Custom",
              theme: "#FFFFFF80",
              custom: "#00000080",
              gradient: {
                angle: 45,
                startColor: "#0000FF80",
                endColor: "#00FFAE80",
                startPosition: 0,
                endPosition: 100
              }
            }
          }
        },
        video: {
          src: "",
          overlay: {
            isEnabled: !1,
            value: {
              type: "Custom",
              theme: "#FFFFFF80",
              custom: "#00000080",
              gradient: {
                angle: 45,
                startColor: "#0000FF80",
                endColor: "#00FFAE80",
                startPosition: 0,
                endPosition: 100
              }
            }
          }
        }
      }
    }
  }
};
function hq() {
  return {
    data: {
      type: d.FLUID_ELEMENT,
      fieldId: 274,
      defaultValue: {
        default: Ee,
        ar: Ee
      }
    }
  };
}
const bq = ({
  sectionId: n,
  activePage: o,
  Elements: { FluidElement: t },
  data: a,
  pageContext: i,
  pages: r
}) => /* @__PURE__ */ e(
  t,
  {
    value: a,
    sectionId: n,
    activePage: o,
    pageContext: i,
    pages: r
  }
), yq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bq,
  meta: hq,
  styles: gq
}, Symbol.toStringTag, { value: "Module" })), Te = /* @__PURE__ */ Object.assign({ "./0001/index.jsx": yq }), $q = Object.keys(Te).reduce(
  (n, o) => y(b({}, n), { [o.split("/")[1]]: Te[o] }),
  {}
), ie = {
  azzafahmy: fn,
  damas: Nl,
  about: Dc,
  cta: Ls,
  content: F_,
  contact: Zf,
  custom_section: n1,
  embed: y1,
  features: Mh,
  footer: Wb,
  gallery: t$,
  header: b$,
  header_home: NI,
  hero: i5,
  logos: e9,
  map: c9,
  pricing: lj,
  services: ME,
  team: mL,
  testimonials: RP,
  video: fq,
  fluid_section: $q
};
function Sq(n, o) {
  var a;
  if (!(ie[n] && ie[n][o]))
    return !1;
  const t = ie[n][o];
  return y(b({}, t), {
    component: t.default,
    meta: typeof t.meta == "function" ? (a = t.meta) == null ? void 0 : a.call(t) : t.meta,
    styles: t.styles
  });
}
export {
  w as SectionValueSources,
  d as SectionValueTypes,
  Sq as default,
  Sq as getSectionDesign,
  ie as sections
};
//# sourceMappingURL=main.es.js.map
